import styled from 'styled-components';
import React from 'react';

const Svg = styled.svg`
  display: block;
  fill: currentcolor;
`;

export const IconEmpty = (props) => <Svg {...props} viewBox="0 0 24 24"></Svg>;

export const IconPlayers = (props) => (
  <Svg {...props} viewBox="0 0 16 16">
    <g
      id="Tournament"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Tournament-Mobile-SCHED"
        transform="translate(-49.000000, -3133.000000)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g id="Group-6" transform="translate(46.000000, 3108.000000)">
          <g
            id="account_circle_white_24dp"
            transform="translate(2.000000, 24.000000)"
          >
            <path
              d="M9,1.5 C4.86,1.5 1.5,4.86 1.5,9 C1.5,13.14 4.86,16.5 9,16.5 C13.14,16.5 16.5,13.14 16.5,9 C16.5,4.86 13.14,1.5 9,1.5 Z M9,3.75 C10.245,3.75 11.25,4.755 11.25,6 C11.25,7.245 10.245,8.25 9,8.25 C7.755,8.25 6.75,7.245 6.75,6 C6.75,4.755 7.755,3.75 9,3.75 Z M9,14.4 C7.125,14.4 5.4675,13.44 4.5,11.985 C4.5225,10.4925 7.5,9.675 9,9.675 C10.4925,9.675 13.4775,10.4925 13.5,11.985 C12.5325,13.44 10.875,14.4 9,14.4 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconExclamation = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm.002 15.001h-.063a.999.999 0 1 1 .063 0zm.993-3.883a1 1 0 0 1-1.986 0l-.007-.117L11 8l.007-.116a1 1 0 0 1 1.986-.001L13 8l.002 5.001z"></path>
  </Svg>
);

export const IconEA = (props) => (
  <Svg {...props} viewBox="0 0 1000 486.30801">
    <g transform="translate(-175.12634,-267.07553)">
      <path
        d="m 867.91758,267.07575 -246.27934,389.28988 -269.90232,0 62.20107,-95.7643 167.90548,0 60.94743,-97.00005 -374.37103,0 -60.94734,97.00005 89.54963,0 -121.89482,192.78219 502.49835,0 190.29289,-303.46551 69.65166,110.68332 -59.71163,0 -60.92959,95.7643 181.58874,0 60.94724,97.01789 115.6623,0 -307.20872,-486.30777"
        fill="#FFF"
        fillOpacity={1}
        fillRule="evenodd"
        stroke="none"
      />
      <path
        d="m 787.07217,270.80081 -396.75834,0 -60.94753,97.01815 396.75835,-1.23496 60.94752,-95.78245"
        fill="#FFF"
        fillOpacity={1}
        fillRule="evenodd"
        stroke="none"
      />
    </g>
  </Svg>
);

export const IconRiot = (props) => (
  <Svg {...props} viewBox="0 0 34 35">
    <path
      d="M17.8 31.7l-1.6-4.1 15.3.8-.7 6.6zM21.4 0L0 10.2l3.3 15.3h4.4l-.8-11 .7-.2 2.6 11.2h4.6l-.2-13.4.7-.2 2.3 13.6h4.8l1.1-16.1.7-.2 1.2 16.3h6.4L34 3.1z"
      fill="#FFF"
    ></path>
  </Svg>
);

export const IconEpic = (props) => (
  <Svg {...props} viewBox="0 0 647.16699 750.97701">
    <g transform="matrix(1.3333333,0,0,-1.3333333,-278.05173,902.58312)">
      <g id="g14">
        <g id="g16" clipPath="url(#clipPath20)">
          <g id="g22" transform="translate(649.8358,676.9377)">
            <path
              d="m 0,0 -397.219,0 c -32.196,0 -44.078,-11.882 -44.078,-44.093 l 0,-388.676 c 0,-3.645 0.147,-7.031 0.469,-10.168 0.733,-7.031 0.871,-13.844 7.41,-21.601 0.639,-0.76 7.315,-5.728 7.315,-5.728 3.591,-1.761 6.043,-3.058 10.093,-4.688 l 195.596,-81.948 c 10.154,-4.655 14.4,-6.469 21.775,-6.323 l 0,-10e-4 c 0.01,0 0.019,0 0.029,0 0.01,0 0.019,0 0.029,0 l 0,10e-4 c 7.375,-0.146 11.621,1.668 21.776,6.323 l 195.595,81.948 c 4.051,1.63 6.502,2.927 10.094,4.688 0,0 6.676,4.968 7.314,5.728 6.539,7.757 6.677,14.57 7.41,21.601 0.322,3.137 0.47,6.523 0.47,10.168 l 0,388.676 C 44.078,-11.882 32.195,0 0,0"
              fill="#ffffff"
              fillOpacity={1}
              fillRule="evenodd"
              stroke="none"
              id="path24"
            />
          </g>
          <g id="g26" transform="translate(623.2303,286.175)">
            <path
              d="m 0,0 -0.09,-0.897 -0.089,-0.985 -0.18,-0.897 -0.268,-0.896 -0.174,-0.807 -0.27,-0.897 -0.358,-0.807 -0.359,-0.718 -0.353,-0.806 -0.448,-0.717 -0.448,-0.718 -0.533,-0.717 -0.449,-0.717 -0.532,-0.627 -0.628,-0.628 -0.533,-0.538 -0.716,-0.628 -0.623,-0.538 -0.717,-0.538 -0.712,-0.442 -0.712,-0.538 -0.807,-0.448 -0.802,-0.359 -0.801,-0.448 -0.897,-0.359 -0.891,-0.359 -0.891,-0.268 -0.891,-0.27 -0.807,-0.268 -0.891,-0.18 -0.802,-0.179 -0.801,-0.179 -0.897,-0.18 -0.892,-0.089 -0.801,-0.09 -0.897,-0.09 -0.98,-0.09 -0.892,-0.089 -0.891,0 -0.981,0 -0.986,0 -0.891,0 -0.892,0.089 -0.98,0 -0.892,0.09 -0.896,0.09 -0.981,0.09 -0.891,0.179 -0.891,0.09 -0.897,0.179 -0.892,0.179 -0.891,0.18 -0.891,0.179 -0.896,0.268 -0.802,0.18 -0.891,0.269 -0.892,0.269 -0.806,0.359 -0.891,0.269 -0.802,0.268 -0.892,0.359 -0.806,0.359 -0.802,0.359 -0.802,0.442 -0.806,0.359 -0.802,0.449 -0.712,0.447 -0.807,0.449 -0.712,0.448 -0.717,0.448 -0.712,0.538 -0.712,0.538 -0.717,0.538 -0.713,0.538 -0.627,0.538 -0.712,0.627 0.538,0.717 0.622,0.628 0.538,0.718 0.623,0.717 0.538,0.627 0.532,0.717 0.628,0.718 0.532,0.627 0.628,0.717 0.533,0.628 0.627,0.717 0.533,0.718 0.538,0.627 0.622,0.717 0.538,0.718 0.622,0.627 0.538,0.717 0.712,-0.538 0.802,-0.538 0.717,-0.538 0.802,-0.538 0.717,-0.448 0.802,-0.537 0.711,-0.449 0.808,-0.358 0.711,-0.449 0.802,-0.359 0.807,-0.358 0.801,-0.359 0.803,-0.269 0.806,-0.358 0.891,-0.269 0.892,-0.269 0.801,-0.269 0.897,-0.18 0.891,-0.179 0.891,-0.179 0.981,-0.09 0.896,-0.179 0.892,0 0.98,-0.089 0.892,0 1.07,0 0.981,0.089 0.897,0.179 0.801,0.18 0.802,0.179 0.717,0.269 0.623,0.358 0.717,0.538 0.532,0.628 0.359,0.718 0.27,0.806 0.088,0.897 0,0.179 -0.088,1.076 -0.359,0.897 -0.449,0.627 -0.622,0.538 -0.718,0.538 -0.712,0.358 -0.801,0.359 -0.897,0.359 -1.07,0.447 -0.623,0.18 -0.711,0.179 -0.807,0.27 -0.802,0.179 -0.891,0.269 -0.897,0.179 -0.98,0.269 -0.892,0.179 -0.981,0.269 -0.891,0.179 -0.897,0.269 -0.89,0.18 -0.892,0.269 -0.807,0.268 -0.89,0.18 -0.803,0.269 -0.801,0.269 -0.807,0.269 -0.981,0.359 -0.891,0.359 -0.892,0.358 -0.896,0.359 -0.801,0.448 -0.892,0.448 -0.717,0.448 -0.802,0.448 -0.712,0.538 -0.717,0.448 -0.622,0.539 -0.627,0.627 -0.623,0.628 -0.538,0.628 -0.532,0.627 -0.449,0.627 -0.443,0.718 -0.448,0.806 -0.359,0.622 -0.269,0.718 -0.263,0.807 -0.269,0.717 -0.18,0.897 -0.179,0.807 -0.09,0.896 -0.089,0.897 -0.09,0.985 0,0.987 0,0.179 0,0.897 0.09,0.896 0.089,0.807 0.09,0.897 0.179,0.806 0.18,0.807 0.269,0.808 0.179,0.806 0.353,0.807 0.359,0.807 0.358,0.806 0.444,0.808 0.447,0.806 0.533,0.718 0.539,0.717 0.622,0.717 0.627,0.627 0.623,0.718 0.717,0.628 0.622,0.448 0.717,0.538 0.713,0.538 0.711,0.448 0.807,0.448 0.802,0.359 0.801,0.448 0.807,0.358 0.891,0.27 0.891,0.358 0.807,0.269 0.712,0.18 0.803,0.179 0.806,0.179 0.891,0.179 0.802,0.18 0.891,0.089 0.897,0.09 0.891,0.09 0.891,0.089 0.891,0 0.986,0 0.982,0 0.98,0 0.981,-0.089 0.981,-0.09 0.891,0 0.986,-0.09 0.891,-0.179 0.981,-0.09 0.892,-0.179 0.807,-0.179 0.891,-0.179 0.891,-0.18 0.802,-0.179 0.896,-0.269 0.802,-0.269 0.802,-0.18 0.896,-0.358 0.802,-0.269 0.801,-0.358 0.802,-0.359 0.896,-0.359 0.802,-0.448 0.712,-0.359 0.807,-0.448 0.802,-0.448 0.712,-0.449 0.806,-0.538 0.713,-0.447 0.717,-0.539 0.712,-0.538 0.711,-0.537 L -2.32,39.083 -2.768,38.366 -3.301,37.649 -3.839,36.931 -4.371,36.125 -4.82,35.408 -5.358,34.69 -5.891,33.973 -6.338,33.256 -6.872,32.538 -7.409,31.821 -7.858,31.104 -8.39,30.297 -8.929,29.58 l -0.532,-0.717 -0.448,-0.717 -0.533,-0.717 -0.717,0.537 -0.801,0.449 -0.713,0.448 -0.717,0.538 -0.801,0.358 -0.718,0.449 -0.801,0.359 -0.712,0.358 -0.807,0.359 -0.712,0.358 -0.801,0.269 -0.717,0.359 -0.982,0.268 -0.891,0.27 -0.891,0.268 -0.897,0.18 -0.891,0.179 -0.891,0.18 -0.891,0.09 -0.897,0.089 -0.801,0.09 -0.892,0 -1.07,0 -0.981,-0.179 -0.897,-0.18 -0.801,-0.179 -0.712,-0.359 -0.628,-0.358 -0.802,-0.718 -0.538,-0.807 -0.352,-0.807 -0.091,-0.896 0,-0.18 0.091,-1.165 0.442,-0.986 0.359,-0.538 0.622,-0.628 0.807,-0.448 0.712,-0.448 0.891,-0.359 0.986,-0.359 1.071,-0.358 0.712,-0.179 0.712,-0.269 0.807,-0.179 0.801,-0.269 0.891,-0.18 0.987,-0.269 0.981,-0.268 0.981,-0.27 0.98,-0.179 0.891,-0.269 0.981,-0.269 0.897,-0.179 0.892,-0.269 0.891,-0.269 0.801,-0.269 0.897,-0.269 0.802,-0.269 0.801,-0.269 0.986,-0.353 0.891,-0.449 0.891,-0.358 0.892,-0.448 0.807,-0.449 0.802,-0.448 0.711,-0.448 0.717,-0.538 0.713,-0.448 0.712,-0.628 0.717,-0.627 0.622,-0.718 L -3.481,13 -2.948,12.282 -2.41,11.476 -1.967,10.759 -1.518,9.951 -1.16,9.234 -0.891,8.428 -0.627,7.621 -0.448,6.814 -0.269,5.917 -0.09,5.02 0,4.124 0.09,3.138 l 0,-0.986 0,-0.179 0,-0.987 z m -62.594,-17.926 -0.896,0 -0.891,0 -0.891,0 -0.891,0 -0.897,0 -0.892,0 -0.89,0 -0.892,0 -0.986,0 -0.891,0 -0.891,0 -0.891,0 -0.898,0 -0.89,0 -0.892,0 -0.891,0 -0.897,0 -0.891,0 -0.891,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.891,0 -0.892,0 -0.897,0 -0.891,0 -0.891,0 -0.981,0 -0.896,0 -0.892,0 -0.891,0 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.891,0 -0.892,0 -0.897,0 -0.89,0 -0.892,0 -0.891,0 -0.896,0 -0.892,0 -0.981,0 -0.891,0 -0.891,0 -0.897,0 -0.891,0 -0.892,0 -0.89,0 -0.896,0 -0.892,0 -0.891,0 0,0.897 0,0.897 0,0.896 0,0.892 0,0.897 0,0.896 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.896 0,0.897 0,0.807 0,0.897 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.892 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.807 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0.891,0 0.892,0 0.896,0 0.89,0 0.892,0 0.891,0 0.897,0 0.891,0 0.891,0 0.892,0 0.896,0 0.892,0 0.89,0 0.892,0 0.806,0 0.892,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.892,0 0.897,0 0.891,0 0.891,0 0.891,0 0.897,0 0.892,0 0.89,0 0.891,0 0.892,0 0.897,0 0.891,0 0.891,0 0.891,0 0.897,0 0.891,0 0.891,0 0.891,0 0.808,0 0.891,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.891,0 0.897,0 0.891,0 0.891,0 0.892,0 0.896,0 0.892,0 0.891,0 0,-0.897 0,-0.807 0,-0.896 0,-0.897 0,-0.896 0,-0.807 0,-0.897 0,-0.897 0,-0.806 0,-0.897 0,-0.896 0,-0.808 0,-0.896 0,-0.896 0,-0.897 0,-0.807 0,-0.897 -0.891,0 -0.892,0 -0.896,0 -0.892,0 -0.891,0 -0.891,0 -0.807,0 -0.891,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.892,0 -0.891,0 -0.897,0 -0.891,0 -0.891,0 -0.891,0 -0.897,0 -0.801,0 -0.892,0 -0.891,0 -0.897,0 -0.89,0 -0.892,0 -0.891,0 -0.897,0 -0.891,0 -0.891,0 -0.891,0 -0.897,0 -0.892,0 -0.801,0 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.892,0 -0.896,0 0,-0.896 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.807 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0.896,0 0.892,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.892,0 0.807,0 0.891,0 0.891,0 0.891,0 0.897,0 0.891,0 0.892,0 0.89,0 0.897,0 0.891,0 0.892,0 0.891,0 0.896,0 0.891,0 0.892,0 0.892,0 0.896,0 0.891,0 0.802,0 0.891,0 0.896,0 0.892,0 0.891,0 0.891,0 0.896,0 0.892,0 0.891,0 0,-0.896 0,-0.807 0,-0.892 0,-0.896 0,-0.807 0,-0.896 0,-0.897 0,-0.807 0,-0.897 0,-0.896 0,-0.897 0,-0.806 0,-0.896 0,-0.897 0,-0.808 0,-0.896 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.802,0 -0.891,0 -0.896,0 -0.892,0 -0.892,0 -0.891,0 -0.896,0 -0.891,0 -0.892,0 -0.891,0 -0.897,0 -0.89,0 -0.892,0 -0.891,0 -0.897,0 -0.891,0 -0.891,0 -0.891,0 -0.807,0 -0.892,0 -0.891,0 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.892,0 -0.896,0 0,-0.896 0,-0.987 0,-0.896 0,-0.897 0,-0.986 0,-0.897 0,-0.896 0,-0.986 0,-0.896 0,-0.897 0,-0.986 0,-0.896 0.896,0 0.892,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.892,0 0.896,0 0.981,0 0.891,0 0.891,0 0.897,0 0.892,0 0.891,0 0.891,0 0.896,0 0.892,0 0.891,0 0.891,0 0.891,0 0.897,0 0.891,0 0.892,0 0.89,0 0.898,0 0.891,0 0.891,0 0.891,0 0.986,0 0.892,0 0.89,0 0.892,0 0.897,0 0.891,0 0.891,0 0.891,0 0.896,0 0.892,0 0,-0.897 0,-0.807 0,-0.897 0,-0.896 0,-0.897 0,-0.807 0,-0.896 0,-0.896 0,-0.808 0,-0.896 0,-0.896 0,-0.808 0,-0.891 0,-0.896 0,-0.896 0,-0.808 0,-0.897 z m -65.214,0 -0.891,0 -0.892,0 -0.985,0 -0.891,0 -0.892,0 -0.891,0 -0.897,0 -0.891,0 -0.981,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.891,0 -0.981,0 -0.897,0 -0.891,0 -0.892,0 0,0.897 0,0.897 0,0.896 0,0.897 0,0.902 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.897 0,0.901 0,0.897 0,0.897 0,0.896 0,0.897 0,0.902 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.902 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.902 0,0.897 0,0.896 0,0.896 0,0.896 0,0.897 0,0.902 0,0.896 0,0.897 0,0.896 0,0.897 0,0.902 0,0.896 0,0.897 0,0.897 -0.447,-0.717 -0.533,-0.813 -0.449,-0.717 -0.532,-0.718 -0.448,-0.806 -0.539,-0.718 -0.442,-0.717 -0.449,-0.812 -0.532,-0.717 -0.449,-0.717 -0.537,-0.718 -0.443,-0.812 -0.538,-0.717 -0.443,-0.717 -0.449,-0.807 -0.538,-0.722 -0.443,-0.718 -0.538,-0.806 -0.442,-0.718 -0.538,-0.717 -0.443,-0.812 -0.449,-0.718 -0.537,-0.717 -0.443,-0.807 -0.538,-0.722 -0.443,-0.717 -0.538,-0.718 -0.449,-0.806 -0.443,-0.722 -0.537,-0.718 -0.443,-0.807 -0.538,-0.717 -0.448,-0.717 -0.533,-0.813 -0.448,-0.717 -0.354,0 -0.537,0.807 -0.449,0.723 -0.533,0.807 -0.448,0.717 -0.533,0.806 -0.448,0.723 -0.532,0.807 -0.449,0.718 -0.538,0.806 -0.443,0.717 -0.538,0.813 -0.442,0.717 -0.538,0.807 -0.449,0.717 -0.532,0.812 -0.449,0.717 -0.532,0.807 -0.538,0.717 -0.448,0.812 -0.533,0.717 -0.448,0.807 -0.533,0.717 -0.448,0.813 -0.533,0.717 -0.448,0.807 -0.538,0.717 -0.443,0.807 -0.538,0.723 -0.443,0.806 -0.538,0.718 -0.448,0.807 -0.532,0.716 -0.45,0.813 -0.532,0.717 0,-0.896 0,-0.897 0,-0.897 0,-0.901 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.901 0,-0.897 0,-0.807 0,-0.896 0,-0.897 0,-0.896 0,-0.902 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.901 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.902 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.901 0,-0.808 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.902 0,-0.897 0,-0.896 0,-0.897 0,-0.897 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.892,0 -0.891,0 -0.896,0 -0.891,0 -0.892,0 -0.892,0 -0.896,0 -0.891,0 0,0.897 0,0.897 0,0.896 0,0.892 0,0.897 0,0.896 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.896 0,0.897 0,0.807 0,0.897 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.892 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.807 0,0.896 0,0.897 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0,0.896 0,0.896 0,0.897 0,0.896 0,0.897 0,0.897 0.891,0 0.896,0 0.803,0 0.89,0 0.892,0 0.896,0 0.802,0 0.891,0 0.897,0 0.891,0 0.802,0 0.891,0 0.897,0 0.891,0 0.801,0 0.891,0 0.897,0 0.892,0 0.801,0 0.891,0 0.897,0 0.443,-0.718 0.448,-0.806 0.532,-0.712 0.449,-0.807 0.448,-0.717 0.443,-0.808 0.448,-0.711 0.534,-0.808 0.447,-0.717 0.449,-0.717 0.443,-0.801 0.448,-0.718 0.533,-0.806 0.448,-0.718 0.448,-0.801 0.443,-0.717 0.538,-0.717 0.449,-0.803 0.442,-0.716 0.448,-0.807 0.444,-0.718 0.538,-0.801 0.448,-0.718 0.442,-0.806 0.449,-0.712 0.443,-0.717 0.538,-0.807 0.448,-0.718 0.443,-0.807 0.448,-0.712 0.443,-0.807 0.539,-0.717 0.448,-0.801 0.443,-0.718 0.448,0.718 0.448,0.801 0.533,0.717 0.447,0.807 0.444,0.712 0.448,0.807 0.533,0.718 0.448,0.807 0.449,0.717 0.442,0.712 0.538,0.806 0.443,0.718 0.449,0.801 0.447,0.718 0.533,0.807 0.448,0.716 0.449,0.803 0.442,0.717 0.45,0.717 0.532,0.801 0.448,0.718 0.448,0.806 0.444,0.718 0.537,0.801 0.444,0.717 0.447,0.717 0.449,0.808 0.532,0.711 0.449,0.808 0.442,0.717 0.449,0.807 0.538,0.712 0.443,0.806 0.448,0.718 0.891,0 0.892,0 0.806,0 0.892,0 0.891,0 0.891,0 0.807,0 0.892,0 0.89,0 0.892,0 0.807,0 0.891,0 0.891,0 0.892,0 0.806,0 0.892,0 0.891,0 0.891,0 0.807,0 0.891,0 0.891,0 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.807 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.892 0,-0.896 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.896 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.807 0,-0.897 0,-0.896 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.896 0,-0.896 0,-0.897 0,-0.892 0,-0.896 0,-0.897 0,-0.897 z m -103.559,26.891 -0.269,0.812 -0.353,0.897 -0.359,0.807 -0.269,0.812 -0.353,0.807 -0.358,0.897 -0.27,0.812 -0.359,0.807 -0.352,0.806 -0.27,0.812 -0.359,0.897 -0.263,0.807 -0.359,0.812 -0.359,0.807 -0.268,0.807 -0.354,0.901 -0.358,0.808 -0.269,0.806 -0.359,0.812 -0.353,0.897 -0.269,0.812 -0.359,0.807 -0.353,-0.807 -0.268,-0.812 -0.359,-0.897 -0.359,-0.812 -0.264,-0.806 -0.358,-0.808 -0.359,-0.901 -0.353,-0.807 -0.27,-0.807 -0.358,-0.812 -0.359,-0.807 -0.264,-0.897 -0.358,-0.812 -0.359,-0.806 -0.268,-0.807 -0.354,-0.812 -0.359,-0.897 -0.358,-0.807 -0.263,-0.812 -0.359,-0.807 -0.359,-0.897 -0.269,-0.812 -0.353,-0.807 0.891,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.892,0 0.897,0 0.801,0 0.891,0 0.897,0 0.891,0 0.891,0 0.892,0 0.891,0 0.896,0 0.891,0 z m 28.03,-26.891 -0.896,0 -0.803,0 -0.89,0 -0.897,0 -0.891,0 -0.892,0 -0.801,0 -0.897,0 -0.891,0 -0.891,0 -0.892,0 -0.896,0 -0.802,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.802,0 -0.891,0 -0.896,0 -0.354,0.808 -0.269,0.807 -0.358,0.807 -0.359,0.896 -0.264,0.802 -0.358,0.806 -0.359,0.807 -0.264,0.807 -0.358,0.807 -0.359,0.807 -0.268,0.807 -0.354,0.896 -0.359,0.807 -0.269,0.807 -0.359,0.807 -0.891,0 -0.891,0 -0.891,0 -0.891,0 -0.807,0 -0.892,0 -0.891,0 -0.896,0 -0.891,0 -0.892,0 -0.891,0 -0.891,0 -0.897,0 -0.891,0 -0.801,0 -0.897,0 -0.892,0 -0.891,0 -0.891,0 -0.896,0 -0.892,0 -0.891,0 -0.891,0 -0.891,0 -0.808,0 -0.89,0 -0.892,0 -0.897,0 -0.891,0 -0.353,-0.807 -0.269,-0.807 -0.359,-0.807 -0.358,-0.896 -0.264,-0.807 -0.358,-0.807 -0.359,-0.807 -0.269,-0.807 -0.353,-0.807 -0.359,-0.806 -0.269,-0.802 -0.354,-0.896 -0.358,-0.807 -0.269,-0.807 -0.359,-0.808 -0.891,0 -0.891,0 -0.891,0 -0.897,0 -0.891,0 -0.981,0 -0.891,0 -0.892,0 -0.896,0 -0.891,0 -0.891,0 -0.892,0 -0.897,0 -0.89,0 -0.891,0 -0.981,0 -0.897,0 -0.891,0 -0.892,0 -0.891,0 0.353,0.808 0.359,0.807 0.358,0.807 0.354,0.896 0.269,0.802 0.359,0.806 0.358,0.807 0.353,0.807 0.359,0.807 0.359,0.897 0.353,0.807 0.359,0.806 0.268,0.807 0.359,0.807 0.353,0.807 0.359,0.896 0.358,0.807 0.354,0.808 0.359,0.806 0.358,0.807 0.269,0.807 0.353,0.897 0.359,0.806 0.359,0.807 0.353,0.807 0.359,0.807 0.359,0.807 0.353,0.897 0.269,0.806 0.359,0.807 0.358,0.807 0.354,0.807 0.358,0.807 0.358,0.896 0.354,0.807 0.358,0.807 0.269,0.807 0.359,0.806 0.353,0.807 0.359,0.897 0.359,0.807 0.353,0.807 0.358,0.807 0.359,0.806 0.269,0.808 0.354,0.801 0.358,0.897 0.358,0.806 0.354,0.808 0.358,0.807 0.359,0.806 0.353,0.807 0.269,0.897 0.359,0.806 0.358,0.807 0.354,0.807 0.359,0.807 0.358,0.807 0.354,0.897 0.358,0.806 0.269,0.807 0.358,0.807 0.354,0.807 0.358,0.807 0.359,0.896 0.353,0.807 0.359,0.807 0.359,0.807 0.263,0.806 0.359,0.808 0.359,0.896 0.359,0.807 0.353,0.807 0.359,0.807 0.358,0.807 0.353,0.806 0.27,0.897 0.358,0.807 0.359,0.807 0.353,0.807 0.891,0 0.807,0 0.891,0 0.891,0 0.897,0 0.801,0 0.891,0 0.892,0 0.897,0 0.802,0 0.89,0 0.892,0 0.896,0 0.802,0 0.891,0 0.891,0 0.897,0 0.801,0 0.892,0 0.358,-0.807 0.359,-0.807 0.354,-0.807 0.358,-0.897 0.269,-0.806 0.353,-0.807 0.359,-0.807 0.358,-0.807 0.359,-0.807 0.353,-0.896 0.359,-0.808 0.359,-0.806 0.263,-0.807 0.359,-0.807 0.359,-0.807 0.359,-0.896 0.353,-0.807 0.358,-0.807 0.359,-0.807 0.353,-0.807 0.269,-0.806 0.358,-0.897 0.354,-0.807 0.359,-0.807 0.358,-0.807 0.359,-0.807 0.353,-0.806 0.358,-0.897 0.27,-0.807 0.353,-0.806 0.358,-0.807 0.359,-0.808 0.359,-0.806 0.353,-0.897 0.359,-0.801 0.358,-0.808 0.264,-0.806 0.358,-0.807 0.359,-0.807 0.354,-0.807 0.358,-0.897 0.359,-0.807 0.359,-0.806 0.353,-0.807 0.269,-0.807 0.358,-0.807 0.354,-0.896 0.358,-0.807 0.359,-0.807 0.358,-0.807 0.354,-0.807 0.359,-0.806 0.268,-0.897 0.354,-0.807 0.358,-0.807 0.359,-0.807 0.353,-0.807 0.359,-0.806 0.359,-0.897 0.359,-0.807 0.263,-0.807 0.359,-0.806 0.359,-0.808 0.353,-0.807 0.358,-0.896 0.359,-0.807 0.358,-0.807 0.353,-0.807 0.27,-0.806 0.359,-0.807 0.353,-0.897 0.358,-0.807 0.358,-0.807 0.354,-0.807 0.358,-0.806 0.359,-0.802 0.27,-0.896 0.352,-0.807 0.359,-0.807 0.358,-0.808 z m -78.193,8.334 -0.717,-0.538 -0.623,-0.449 -0.717,-0.538 -0.712,-0.448 -0.712,-0.538 -0.717,-0.448 -0.712,-0.449 -0.807,-0.447 -0.802,-0.449 -0.802,-0.448 -0.806,-0.353 -0.802,-0.449 -0.891,-0.358 -0.801,-0.359 -0.897,-0.358 -0.801,-0.359 -0.803,-0.269 -0.806,-0.269 -0.802,-0.27 -0.891,-0.268 -0.801,-0.27 -0.897,-0.179 -0.802,-0.179 -0.891,-0.179 -0.896,-0.179 -0.892,-0.09 -0.981,-0.09 -0.891,-0.09 -0.981,-0.089 -0.897,-0.09 -0.98,-0.089 -0.981,0 -0.982,0 -0.98,0 -0.897,0 -0.891,0.089 -0.981,0.09 -0.891,0.089 -0.891,0.09 -0.897,0.09 -0.891,0.179 -0.892,0.18 -0.801,0.179 -0.896,0.179 -0.802,0.269 -0.891,0.179 -0.807,0.27 -0.802,0.358 -0.802,0.269 -0.89,0.359 -0.807,0.358 -0.802,0.358 -0.801,0.359 -0.808,0.448 -0.711,0.444 -0.802,0.448 -0.717,0.449 -0.712,0.447 -0.717,0.539 -0.712,0.537 -0.713,0.538 -0.627,0.538 -0.622,0.538 -0.628,0.628 -0.622,0.537 -0.628,0.628 -0.622,0.628 -0.538,0.627 -0.533,0.717 -0.538,0.628 -0.448,0.717 -0.533,0.718 -0.447,0.716 -0.444,0.718 -0.448,0.807 -0.448,0.717 -0.353,0.807 -0.359,0.807 -0.358,0.807 -0.354,0.806 -0.269,0.717 -0.359,0.808 -0.179,0.807 -0.264,0.806 -0.179,0.896 -0.269,0.808 -0.179,0.896 -0.09,0.807 -0.18,0.897 -0.088,0.806 -0.091,0.897 -0.084,0.897 -0.089,0.896 0,0.986 0,0.897 0,0.179 0,0.897 0.089,0.986 0,0.896 0.084,0.897 0.091,0.986 0.179,0.891 0.089,0.897 0.179,0.807 0.269,0.896 0.18,0.897 0.263,0.807 0.269,0.896 0.269,0.807 0.359,0.897 0.354,0.806 0.358,0.807 0.359,0.807 0.353,0.807 0.448,0.807 0.448,0.717 0.444,0.718 0.447,0.717 0.449,0.717 0.532,0.717 0.538,0.717 0.533,0.717 0.538,0.629 0.622,0.627 0.538,0.628 0.623,0.626 0.627,0.629 0.622,0.537 0.717,0.628 0.623,0.538 0.712,0.538 0.717,0.448 0.712,0.538 0.718,0.448 0.711,0.448 0.802,0.449 0.807,0.448 0.801,0.448 0.802,0.359 0.806,0.358 0.892,0.449 0.712,0.268 0.891,0.27 0.808,0.358 0.801,0.18 0.801,0.269 0.896,0.179 0.802,0.269 0.891,0.179 0.892,0.09 0.896,0.179 0.892,0.09 0.89,0.089 0.892,0.09 0.897,0.09 0.981,0 0.891,0 0.98,0 0.981,0 0.987,-0.09 0.981,-0.09 0.891,0 0.891,-0.089 0.981,-0.18 0.807,-0.089 0.891,-0.18 0.892,-0.179 0.806,-0.179 0.801,-0.179 0.803,-0.18 0.807,-0.269 0.801,-0.179 0.712,-0.269 0.807,-0.269 0.802,-0.358 0.801,-0.359 0.807,-0.359 0.802,-0.448 0.801,-0.359 0.718,-0.448 0.801,-0.448 0.712,-0.448 0.807,-0.449 0.712,-0.537 0.712,-0.449 0.717,-0.538 0.712,-0.538 0.717,-0.627 0.712,-0.538 -0.538,-0.718 -0.622,-0.627 -0.538,-0.717 -0.622,-0.717 -0.538,-0.718 -0.533,-0.627 -0.628,-0.717 -0.532,-0.717 -0.538,-0.629 -0.623,-0.717 -0.537,-0.717 -0.623,-0.717 -0.538,-0.628 -0.532,-0.717 -0.627,-0.717 -0.534,-0.717 -0.627,-0.628 -0.533,-0.717 -0.717,0.538 -0.712,0.627 -0.717,0.449 -0.712,0.538 -0.712,0.448 -0.717,0.449 -0.713,0.447 -0.801,0.449 -0.717,0.358 -0.712,0.359 -0.717,0.269 -0.802,0.269 -0.801,0.269 -0.807,0.179 -0.891,0.18 -0.891,0.179 -0.892,0.089 -0.981,0.09 -0.986,0.089 -0.981,0 -0.891,0 -0.891,-0.089 -0.807,-0.09 -0.891,-0.179 -0.802,-0.18 -0.807,-0.268 -0.801,-0.269 -0.802,-0.359 -0.802,-0.358 -0.717,-0.448 -0.711,-0.449 -0.718,-0.449 -0.622,-0.537 -0.628,-0.538 -0.622,-0.538 -0.538,-0.627 -0.622,-0.628 -0.538,-0.717 -0.444,-0.628 -0.448,-0.717 -0.442,-0.807 -0.449,-0.717 -0.358,-0.807 -0.269,-0.807 -0.354,-0.807 -0.269,-0.896 -0.179,-0.892 -0.179,-0.806 -0.18,-0.987 -0.089,-0.896 -0.084,-0.896 0,-0.987 0,-0.179 0,-0.897 0.084,-0.896 0.089,-0.807 0.09,-0.897 0.179,-0.806 0.18,-0.808 0.179,-0.806 0.269,-0.807 0.264,-0.717 0.359,-0.896 0.358,-0.808 0.443,-0.807 0.448,-0.717 0.448,-0.717 0.533,-0.718 0.538,-0.627 0.622,-0.628 0.539,-0.627 0.621,-0.538 0.718,-0.538 0.712,-0.538 0.711,-0.448 0.717,-0.448 0.803,-0.359 0.801,-0.359 0.806,-0.358 0.892,-0.269 0.891,-0.269 0.897,-0.18 0.891,-0.179 0.891,-0.089 0.981,-0.09 0.981,0 1.07,0 0.987,0.09 0.981,0.089 0.891,0.09 0.891,0.18 0.897,0.179 0.891,0.268 0.801,0.18 0.803,0.358 0.717,0.359 0.801,0.359 0.627,0.358 0.713,0.449 0,0.896 0,0.896 0,0.897 0,0.896 0,0.987 0,0.896 0,0.897 0,0.896 0,0.897 -0.892,0 -0.806,0 -0.892,0 -0.891,0 -0.891,0 -0.807,0 -0.892,0 -0.891,0 -0.891,0 -0.806,0 -0.892,0 -0.891,0 -0.892,0 -0.806,0 -0.892,0 0,0.896 0,0.807 0,0.897 0,0.896 0,0.897 0,0.807 0,0.896 0,0.897 0,0.896 0,0.808 0,0.896 0,0.896 0,0.897 0,0.807 0,0.891 0.892,0 0.896,0 0.892,0 0.89,0 0.892,0 0.891,0 0.897,0 0.891,0 0.891,0 0.892,0 0.896,0 0.891,0 0.891,0 0.891,0 0.897,0 0.892,0 0.891,0 0.891,0 0.896,0 0.892,0 0.891,0 0.891,0 0.896,0 0.892,0 0.891,0 0.891,0 0.897,0 0.891,0 0.892,0 0.891,0 0.896,0 0.891,0 0.892,0 0,-0.891 0,-0.896 0,-0.897 0,-0.807 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.897 0,-0.806 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.897 0,-0.806 0,-0.897 0,-0.897 0,-0.897 0,-0.896 0,-0.897 0,-0.896 0,-0.807 0,-0.896 0,-0.897 0,-0.897 0,-0.896 0,-0.896 0,-0.808 0,-0.896 0,-0.896 0,-0.897 z"
              fill="#2f2d2e"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              id="path28"
            />
          </g>
          <g id="g30" transform="translate(312.9946,481.1594)">
            <path
              d="m 0,0 38.683,0 0,29.922 -38.683,0 0,61.086 40.223,0 0,29.922 -73.072,0 0,-215.951 73.684,0 0,29.923 -40.835,0 z"
              fill="#2f2d2e"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              id="path32"
            />
          </g>
          <g id="g34" transform="translate(590.0699,474.6773)">
            <path
              d="m 0,0 0,-48.744 c 0,-8.639 -3.993,-12.647 -12.278,-12.647 l -6.144,0 c -8.595,0 -12.588,4.008 -12.588,12.647 l 0,136.362 c 0,8.638 3.993,12.646 12.588,12.646 l 5.527,0 c 8.29,0 12.283,-4.008 12.283,-12.646 l 0,-42.269 32.233,0 0,44.12 c 0,26.837 -12.895,39.795 -39.6,39.795 l -15.969,0 C -50.654,129.264 -63.86,116 -63.86,89.158 l 0,-139.442 c 0,-26.843 13.206,-40.106 39.912,-40.106 l 16.274,0 c 26.712,0 39.911,13.263 39.911,40.106 l 0,50.284 z"
              fill="#2f2d2e"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              id="path36"
            />
          </g>
          <path
            d="m 475.995,386.138 32.854,0 0,215.952 -32.854,0 z"
            fill="#2f2d2e"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            id="path38"
          />
          <g id="g40" transform="translate(428.3257,506.1461)">
            <path
              d="m 0,0 c 0,-8.639 -3.987,-12.652 -12.277,-12.652 l -13.511,0 0,79.596 13.511,0 C -3.987,66.944 0,62.935 0,54.298 Z m -7.061,95.944 -51.577,0 0,-215.952 32.85,0 0,78.362 18.727,0 c 26.711,0 39.911,13.263 39.911,40.1 l 0,57.384 c 0,26.842 -13.2,40.106 -39.911,40.106"
              fill="#2f2d2e"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              id="path42"
            />
          </g>
          <g id="g44" transform="translate(357.6425,190.8749)">
            <path
              d="M 0,0 188.054,0 92.068,-31.654 Z"
              fill="#2f2d2e"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              id="path46"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconActivision = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="P-1-2" transform="translate(-35.000000, -1328.000000)">
        <g id="Group-12-Copy-3" transform="translate(35.000000, 1328.000000)">
          <circle id="Oval" fill="#FFE600" cx="12" cy="12" r="12"></circle>
          <image
            id="Bitmap"
            x="4"
            y="3"
            width="16"
            height="16"
            xlinkHref="data:image/png;base64,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"
          ></image>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconSwitch = (props) => (
  <Svg
    {...props}
    viewBox="0 0 550.000000 550.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,550.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M1365 5154 c-481 -86 -868 -442 -990 -910 -44 -169 -47 -268 -42 -1579 3 -1204 4 -1232 24 -1325 111 -501 467 -858 973 -976 66 -15 150 -18 691 -21 560 -4 618 -3 633 12 15 15 16 208 16 2396 0 1622 -3 2386 -10 2400 -10 18 -27 19 -613 18 -476 -1 -619 -4 -682 -15z m905 -2400 l0 -2026 -407 5 c-375 4 -415 6 -490 25 -322 83 -561 331 -628 654 -22 101 -22 2589 -1 2688 60 281 255 514 518 619 132 53 193 59 621 60 l387 1 0 -2026z" />
      <path d="M1451 4169 c-63 -12 -159 -60 -210 -105 -105 -91 -157 -220 -149 -372 4 -79 9 -100 41 -164 47 -97 118 -168 215 -216 67 -33 84 -37 171 -40 79 -3 107 0 160 18 217 73 348 284 311 500 -43 257 -287 429 -539 379z" />
      <path d="M3157 5163 c-4 -3 -7 -1087 -7 -2409 0 -2181 1 -2402 16 -2408 27 -10 803 -6 899 4 406 46 764 293 959 660 25 47 58 126 75 175 63 188 61 138 61 1575 0 1147 -2 1318 -16 1391 -99 521 -496 914 -1018 1004 -70 12 -178 15 -526 15 -240 0 -440 -3 -443 -7z m1068 -2178 c156 -41 284 -160 336 -312 33 -94 32 -232 -1 -318 -61 -158 -181 -269 -335 -310 -250 -65 -516 86 -589 334 -22 76 -21 204 4 282 75 245 335 389 585 324z" />
    </g>
  </Svg>
);

export const IconXboxXS = (props) => (
  <Svg {...props} viewBox="0 0 23 11">
    <path
      d="M16.2 5.81132L17.2698 4.3066C16.9132 4.22877 16.5821 4.07311 16.2764 3.86557C15.9708 3.63208 15.8179 3.26887 15.8434 2.87972C15.8179 2.49057 16.0217 2.12736 16.3274 1.91981C16.7349 1.66038 17.2189 1.5566 17.7028 1.58255C19.5877 1.58255 20.0717 2.59434 20.4028 3.00943L21.4217 1.58255C21.2434 1.29717 21.0396 1.03774 20.7849 0.830189C20.0972 0.285377 19.0528 0 17.6774 0C16.4802 0 15.5377 0.259434 14.85 0.804245C14.1877 1.32311 13.8057 2.12736 13.8311 2.98349C13.8311 4.41038 14.6208 5.3184 16.2 5.81132ZM21.3962 5.73349C20.9123 5.29245 20.1991 4.98113 19.2057 4.7217L18.1104 6.25236C18.6708 6.35613 19.2057 6.58962 19.6896 6.92689C19.9953 7.13443 20.1736 7.49764 20.1481 7.88679C20.1736 8.32783 19.9698 8.76887 19.6132 9.0283C19.1547 9.31368 18.5943 9.46934 18.0594 9.41745C16.4802 9.41745 15.7415 8.89859 15.0028 7.49764L13.9075 9.00236C14.1113 9.41745 14.3915 9.75472 14.7226 10.0401C15.4868 10.6887 16.5821 11 17.983 11C19.3075 11 20.3264 10.7146 21.0651 10.1439C21.8038 9.57311 22.2113 8.69104 22.1604 7.75708C22.2623 7.00472 21.9566 6.25236 21.3962 5.73349ZM12.0736 10.7665H11.6151V0.23349H12.0736V10.7665ZM0 10.7665H2.24151L3.92264 8.40566L2.80189 6.84906L0 10.7665ZM9.78113 0.23349H7.53962L6.16415 2.17925L7.2849 3.73585L9.78113 0.23349ZM2.54717 0.23349H0.30566L7.87075 10.7665H10.1123L2.54717 0.23349Z"
      fill="white"
    />
  </Svg>
);

export const IconXbox = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <g clipPath="url(#clip0)">
      <path
        d="M11.0044 21.9585C9.46481 21.8119 7.90517 21.2589 6.56358 20.3839C5.44002 19.651 5.18638 19.3512 5.18638 18.7493C5.18638 17.5434 6.51463 15.4292 8.784 13.0218C10.0744 11.6537 11.8699 10.0503 12.0635 10.0925C12.4417 10.1769 15.4608 13.1217 16.5911 14.5053C18.3799 16.6995 19.2031 18.4939 18.7848 19.2935C18.4666 19.902 16.4976 21.0901 15.0515 21.5454C13.8589 21.9229 12.2926 22.0828 11.0044 21.9585ZM3.67125 17.4968C2.73903 16.0666 2.26736 14.6563 2.03819 12.6198C1.96255 11.9469 1.98925 11.5627 2.20951 10.1813C2.48317 8.46017 3.46211 6.47029 4.64129 5.24439C5.14411 4.72249 5.18861 4.70916 5.80045 4.9157C6.54355 5.16666 7.33561 5.71299 8.56596 6.82563L9.28459 7.47412L8.89302 7.95604C7.07085 10.1902 5.15079 13.3571 4.4277 15.3159C4.0339 16.3797 3.87594 17.4502 4.04503 17.8943C4.15849 18.1941 4.05393 18.0831 3.67125 17.4968ZM20.0463 17.7389C20.1375 17.2902 20.0218 16.4641 19.7482 15.6313C19.1586 13.828 17.1807 10.47 15.3652 8.18923L14.7934 7.47189L15.4119 6.90336C16.2195 6.1616 16.7802 5.71743 17.3853 5.3421C17.8637 5.04451 18.5445 4.78245 18.8382 4.78245C19.0184 4.78245 19.6547 5.44204 20.1687 6.16382C20.9652 7.27868 21.5503 8.6334 21.8462 10.0414C22.0375 10.952 22.0531 12.8996 21.8774 13.8057C21.7327 14.5497 21.4257 15.5158 21.1276 16.1732C20.9029 16.664 20.3466 17.6167 20.1019 17.9276C19.9773 18.0831 19.9773 18.0831 20.0463 17.7389ZM11.1691 4.44044C10.3303 4.01404 9.03763 3.55877 8.32345 3.4344C8.07204 3.3922 7.64709 3.36777 7.37343 3.3811C6.78384 3.40997 6.81054 3.3811 7.75611 2.93471C8.54149 2.56383 9.19782 2.34618 10.0878 2.15963C11.089 1.94865 12.969 1.94643 13.9546 2.15519C15.0181 2.3795 16.2707 2.84587 16.976 3.27894L17.1851 3.40775L16.7045 3.38332C15.7478 3.33446 14.3551 3.72089 12.8577 4.44932C12.4061 4.66919 12.0145 4.84463 11.9856 4.83797C11.9589 4.83353 11.5896 4.65364 11.1691 4.44044Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="103.869"
          height="103.869"
          fill="white"
          transform="scale(0.231061)"
        />
      </clipPath>
    </defs>
  </Svg>
);

export const IconSteam = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path
      d="M12.0041 2.00001C17.1763 2.00895 21.4906 5.95038 21.9587 11.0944C22.4268 16.2383 18.8947 20.8919 13.8088 21.8317C8.72289 22.7716 3.75714 19.6885 2.35093 14.7179L6.20594 16.3116C6.5198 17.7178 7.8363 18.6682 9.27188 18.5248C10.7075 18.3815 11.8094 17.1896 11.8382 15.7491V15.6241L15.2552 13.1868H15.3491C16.8821 13.1944 18.2684 12.278 18.8604 10.8657C19.4523 9.45349 19.133 7.82415 18.0517 6.7389C16.9704 5.65365 15.3404 5.32671 13.9233 5.91082C12.5062 6.49494 11.5817 7.8748 11.5817 9.40577V9.46827L9.1848 12.9368H9.02522C8.45433 12.9348 7.89684 13.1095 7.4294 13.4368L2.03802 11.2182C2.43122 6.01377 6.77779 1.9934 12.0041 2.00001ZM8.30554 17.1865L7.0852 16.6865C7.29931 17.1614 7.69311 17.5322 8.18037 17.7177C9.26649 18.1594 10.5059 17.643 10.9559 16.5616C11.1781 16.0427 11.1781 15.4555 10.9559 14.9367C10.5134 13.8748 9.31078 13.3508 8.23044 13.7492L9.51648 14.2804C9.90142 14.434 10.2081 14.7361 10.3671 15.1184C10.5261 15.5007 10.524 15.9308 10.3613 16.3116C10.0152 17.1067 9.10576 17.4914 8.29302 17.1865H8.30554ZM13.4591 9.40577C13.459 9.90903 13.6615 10.3912 14.0211 10.7438C14.3807 11.0964 14.8671 11.2899 15.371 11.2806C16.4135 11.2808 17.264 10.4468 17.2828 9.40577C17.2828 8.35132 16.4268 7.49652 15.371 7.49652C14.3151 7.49652 13.4591 8.35132 13.4591 9.40577ZM17.8398 9.43702C17.855 10.4668 17.2454 11.4037 16.2969 11.8081C15.3484 12.2125 14.2492 12.0042 13.515 11.2809C12.7807 10.5576 12.5572 9.46286 12.9491 8.51021C13.3411 7.55756 14.2708 6.93603 15.3021 6.93718C15.9737 6.92193 16.6228 7.17927 17.1011 7.6504C17.5794 8.12153 17.8459 8.76617 17.8398 9.43702Z"
      fill="white"
    />
  </Svg>
);

export const IconPC = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <g clip-path="url(#clip0_4413_64636)">
      <path
        d="M13.688 4.37815C14.4119 4.08581 15.2014 4.00744 15.9757 4C16.4906 4.00172 17.0098 4.04176 17.5098 4.17162C17.9117 4.27946 18.3047 4.44765 18.6276 4.7151C18.9077 4.94189 19.1281 5.23374 19.2695 5.56522C19.452 5.98713 19.5166 6.45195 19.5209 6.90732C19.5209 8.07838 19.5209 9.24952 19.5209 10.4208C18.4757 10.4225 17.4308 10.4208 16.3856 10.4222C16.3765 9.91447 16.3842 9.40618 16.3816 8.89846V6.90589C16.3873 6.73427 16.3788 6.54491 16.2641 6.40589C16.1554 6.27918 15.978 6.24142 15.8178 6.254C15.6717 6.25572 15.5161 6.31865 15.4374 6.44737C15.367 6.55235 15.3476 6.68249 15.3482 6.80692C15.3482 10.2737 15.3482 13.7407 15.3482 17.2077C15.3545 17.3561 15.379 17.5223 15.4932 17.6284C15.6053 17.7466 15.7832 17.7566 15.9363 17.7486C16.0944 17.7434 16.2546 17.6593 16.3216 17.5112C16.3885 17.363 16.3839 17.2031 16.3811 17.0463C16.3811 15.754 16.3811 14.4617 16.3811 13.1693C17.4274 13.167 18.4734 13.1693 19.5195 13.1693C19.5221 14.4488 19.5195 15.7283 19.5195 17.0074C19.5195 17.4428 19.47 17.8836 19.3193 18.2946C19.1782 18.6811 18.9397 19.0358 18.6162 19.2929C18.2835 19.5638 17.8805 19.736 17.4669 19.8401C16.9414 19.9737 16.3959 20.0074 15.8553 20.0009C15.2944 19.9917 14.7303 19.9388 14.1868 19.7929C13.682 19.6547 13.1874 19.4308 12.8075 19.0635C12.5669 18.8362 12.3782 18.5596 12.2543 18.2526C12.0881 17.8464 12.0286 17.4033 12.0367 16.9654V7.06836C12.0266 6.78123 12.0508 6.49392 12.1087 6.21253C12.2006 5.76201 12.4117 5.33009 12.738 5.00286C13.0029 4.72769 13.3353 4.52517 13.6863 4.37986L13.688 4.37815Z"
        fill="white"
      />
      <path
        d="M3.99997 4.11699L4.01284 4.06722C5.37754 4.07323 6.74224 4.06722 8.10694 4.0698C8.64384 4.06207 9.18903 4.10641 9.70076 4.27861C10.064 4.40046 10.4056 4.60069 10.6676 4.88101C11.0174 5.24714 11.2059 5.73914 11.286 6.23199C11.3395 6.54034 11.3486 6.85413 11.3432 7.1662V10.653C11.3501 11.0807 11.3338 11.5129 11.2259 11.9288C11.123 12.3438 10.9279 12.7449 10.6187 13.0444C10.431 13.2327 10.2103 13.3849 9.96763 13.4934C9.61924 13.6525 9.24138 13.736 8.86209 13.7775C8.49853 13.8207 8.13182 13.8061 7.76684 13.8075C7.61495 13.8075 7.46335 13.8089 7.31175 13.8075C7.30116 14.1101 7.31003 14.4136 7.30717 14.7168C7.30717 16.4554 7.30717 18.1939 7.30717 19.9322C6.2042 19.9322 5.10122 19.9354 3.99854 19.9322C3.99949 14.6603 3.99997 9.38855 3.99997 4.11699ZM7.31089 6.35527C7.30574 6.87014 7.31089 7.38702 7.3086 7.90304C7.3106 9.10956 7.30459 10.3164 7.31146 11.5226C7.44869 11.5286 7.58617 11.5201 7.72164 11.4974C7.92559 11.4688 8.14184 11.383 8.25339 11.1991C8.37639 11.0014 8.38039 10.7586 8.37725 10.5329C8.37725 9.49057 8.37725 8.44805 8.37725 7.40533C8.37725 7.23885 8.3844 7.06952 8.34407 6.9059C8.30373 6.74228 8.22078 6.58725 8.07433 6.50258C7.84636 6.36671 7.56975 6.35355 7.31089 6.35527Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4413_64636">
        <rect
          width="15.5212"
          height="16"
          fill="white"
          transform="translate(4 4)"
        />
      </clipPath>
    </defs>
  </Svg>
);

export const IconPS4 = (props) => (
  <Svg {...props} viewBox="170 0 322.921 104.794">
    <g>
      <g>
        <g>
          <path
            fill="none"
            d="M502.3,24.062H180.797v64.45v0.633h322.124V24.062H502.3z M489.103,81.218h5.627v0.831h-2.322v6.418h-0.98     v-6.418h-2.324V81.218z"
          />
          <polygon points="491.427,88.467 492.408,88.467 492.408,82.049 494.73,82.049 494.73,81.218 489.103,81.218 489.103,82.049      491.427,82.049    " />
        </g>
        <g>
          <path
            fill="none"
            d="M502.3,24.062H180.797v64.45v0.633h322.124V24.062H502.3z M495.632,81.218h1.352l2.102,6.191l2.033-6.191     h1.182v7.249h-0.811v-5.89l-1.953,5.89h-0.971l-1.953-5.89v5.89h-0.98V81.218z"
          />
          <polygon points="496.613,82.577 498.566,88.467 499.537,88.467 501.49,82.577 501.49,88.467 502.3,88.467 502.3,81.218      501.119,81.218 499.085,87.409 496.984,81.218 495.632,81.218 495.632,88.467 496.613,88.467    " />
        </g>
        <path d="M335.361,71.101V41.126c0-6.115,2.854-10.494,8.941-10.494h37.547c0.23,0,0.451-0.228,0.451-0.454v-5.964    c0-0.052-0.015-0.103-0.035-0.152h-45.909c-9.951,1.265-14.812,8.2-14.812,17.064v29.974c0,6.115-2.934,10.495-8.94,10.495    h-39.652c-0.225,0-0.451,0.151-0.451,0.453v5.965c0,0.247,0.152,0.436,0.33,0.499h45.019    C329.584,88.204,335.361,80.713,335.361,71.101z" />
        <path d="M181.104,88.513h13.183c0.178-0.063,0.33-0.252,0.33-0.499V68.911c0-6.115,3.454-10.344,8.486-10.344h54.301    c12.242,0,18.176-7.55,18.176-17.441c0-8.864-4.857-15.799-14.813-17.064H180.86c-0.023,0.05-0.062,0.089-0.062,0.152v5.964    c0,0.302,0.15,0.454,0.45,0.454h71.574c6.084,0,8.938,4.379,8.938,10.494c0,6.116-2.854,10.495-8.938,10.495h-56.628    c-8.787,0-15.396,7.476-15.396,17.29v19.103C180.797,88.261,180.903,88.449,181.104,88.513z" />
        <g>
          <path
            fill="none"
            d="M393.714,74.649h60.465c0.221,0,0.451-0.227,0.451-0.453V36.974c0-0.83-0.752-0.906-1.131-0.604     l-60.156,37.223c-0.381,0.227-0.531,0.453-0.451,0.755C392.962,74.499,393.193,74.649,393.714,74.649z"
          />
          <path d="M382.08,81.596h72.1c0.221,0,0.371,0.151,0.371,0.302v6.116c0,0.302,0.23,0.453,0.451,0.453h12.996     c0.23,0,0.449-0.151,0.449-0.453v-5.965c0-0.227,0.23-0.453,0.451-0.453h12.916c0.301,0,0.451-0.227,0.451-0.452v-6.041     c0-0.227-0.15-0.453-0.451-0.453h-12.916c-0.221,0-0.451-0.227-0.451-0.453V30.632c0-3.555-1.321-5.819-3.542-6.57h-3.76     c-1.172,0.301-2.446,0.84-3.812,1.661l-77.656,47.945c-3.004,1.887-4.057,4-3.305,5.586     C376.972,80.614,378.695,81.596,382.08,81.596z M393.343,73.593L453.5,36.37c0.379-0.302,1.131-0.226,1.131,0.604v37.223     c0,0.227-0.23,0.453-0.451,0.453h-60.465c-0.521,0-0.752-0.15-0.822-0.302C392.812,74.046,392.962,73.819,393.343,73.593z" />
        </g>
      </g>
    </g>
  </Svg>
);

export const IconPS5 = (props) => (
  <Svg {...props} viewBox="340 0 600.96 215.56">
    <path
      id="ps5"
      d="M970.58,172.41h-1.92V159.26h-4.4v-1.84H975v1.84h-4.4Zm13.31-3.48h0L988,157.42h3v15H989V159.88h0l-4.55,12.53h-1.22l-4.53-12.53h0v12.53H976.8v-15h3ZM945,42.94H761V92.82s-.56,19.26,23.26,19.26H896.73a31.57,31.57,0,0,1,12.83,2.61c6.28,2.8,13.34,8.5,13.34,20,0,10.32-5,16.18-9.95,19.46a25,25,0,0,1-13.76,4H761v14H915.09s35-1.42,35-37.39c0-18.29-10.68-27.35-20.29-31.79A47,47,0,0,0,910,98.68H798.53a11.24,11.24,0,0,1-5.34-1.27c-2.38-1.29-5-3.85-5-8.89V56.75H945ZM529.41,158.1v14h78.1a38.71,38.71,0,0,0,25.5-9.23,32.27,32.27,0,0,0,11.38-25.36V78a21.5,21.5,0,0,1,8-17A20,20,0,0,1,665,56.75h68.09V42.94H652s-35,.56-35,37.58v55.57A24.12,24.12,0,0,1,613.46,149a18.78,18.78,0,0,1-16.7,9.13ZM349.09,42.94V56.75h139.2a26.28,26.28,0,0,1,11.22,2.41c5.52,2.59,11.72,7.92,11.72,18.73,0,10.5-6.2,15.75-11.72,18.35a26.78,26.78,0,0,1-11.4,2.44H384.87a39.28,39.28,0,0,0-17.64,4c-8.59,4.31-18.14,14.46-18.14,31.2v38h26.79V134.05a19.66,19.66,0,0,1,1.31-7.2c2.21-5.67,7.8-14.77,20.87-14.77h104.1a37.78,37.78,0,0,0,10.36-1.39c9.56-2.72,25.5-10.58,25.5-32.8,0-34.53-34.37-34.95-34.37-34.95Z"
    />
  </Svg>
);

export const IconPlayStation = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.6687 17.1554C23.2046 17.741 22.0675 18.1587 22.0675 18.1587L13.6085 21.1971V18.9563L19.8337 16.7383C20.5402 16.4851 20.6486 16.1273 20.0744 15.9395C19.5013 15.7512 18.4635 15.8052 17.7565 16.0593L13.6085 17.5203V15.1948L13.8476 15.1138C13.8476 15.1138 15.0462 14.6896 16.7317 14.5029C18.4171 14.3173 20.4808 14.5283 22.1009 15.1424C23.9267 15.7193 24.1323 16.5699 23.6687 17.1554ZM14.4137 13.3399V7.60959C14.4137 6.93661 14.2896 6.31705 13.6582 6.14166C13.1746 5.98677 12.8746 6.43578 12.8746 7.10822V21.4583L9.00453 20.23V3.12C10.65 3.42545 13.0473 4.14754 14.336 4.58199C17.6135 5.70722 18.7247 7.10768 18.7247 10.2632C18.7247 13.3388 16.8261 14.5045 14.4137 13.3399ZM1.90344 18.7221C0.0291303 18.1943 -0.282804 17.0944 0.571508 16.4609C1.36106 15.8758 2.70378 15.4355 2.70378 15.4355L8.25276 13.4624V15.7118L4.25967 17.1409C3.55431 17.394 3.44584 17.7523 4.01898 17.9401C4.59266 18.1279 5.631 18.0745 6.33744 17.8209L8.25276 17.1257V19.1382C8.13133 19.1598 7.99587 19.1814 7.87067 19.2024C5.95481 19.5154 3.91428 19.3848 1.90344 18.7221Z"
      fill="white"
    />
  </Svg>
);

export const IconBattlenet = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path
      d="M18.94 7.90321C15.904 6.49921 11.536 5.60721 7.42802 5.93921C7.63202 4.57921 8.14402 3.63121 8.97602 3.43121C10.124 3.15521 11.376 3.91121 12.568 5.28321C13.348 5.38321 14.276 5.56321 14.924 5.71121C12.748 1.61921 9.82802 -0.672789 7.60802 0.175211C5.92002 0.819211 5.05602 3.14321 5.16002 6.26721C2.96002 6.73521 1.24401 7.56721 0.144012 8.76321C0.0880121 8.82721 -0.0359881 8.99121 0.00801199 9.06721C0.044012 9.12721 0.152012 9.05921 0.204012 9.02721C1.47601 8.13521 3.10802 7.65521 5.23202 7.35121C5.53602 10.6832 6.94402 14.9112 9.28802 18.3032C8.00802 18.8072 6.93202 18.8392 6.34402 18.2152C5.53202 17.3592 5.56002 15.8952 6.15202 14.1752C5.84802 13.4472 5.54002 12.5552 5.34802 11.9232C2.88402 15.8552 2.35601 19.5312 4.20002 21.0312C5.60402 22.1712 8.04802 21.7592 10.7 20.1072C12.204 21.7792 13.784 22.8472 15.368 23.1992C15.452 23.2152 15.656 23.2432 15.7 23.1672C15.736 23.1072 15.62 23.0432 15.568 23.0192C14.16 22.3632 12.928 21.1912 11.604 19.5032C14.34 17.5752 17.296 14.2392 19.06 10.5152C20.136 11.3752 20.7 12.2872 20.456 13.1112C20.12 14.2432 18.84 14.9512 17.052 15.2952C16.572 15.9232 15.956 16.6352 15.504 17.1192C20.136 17.2792 23.584 15.8992 23.96 13.5552C24.248 11.7712 22.664 9.85921 19.908 8.38721C20.604 6.24721 20.74 4.34721 20.252 2.79921C20.224 2.71921 20.148 2.52721 20.056 2.52721C19.988 2.52721 19.988 2.65921 19.992 2.71521C20.136 4.25921 19.74 5.91521 18.94 7.90321ZM10.408 17.7712C8.44802 14.6272 7.32002 10.9232 7.32402 7.17921C11.028 7.05521 14.8 7.92721 18.04 9.80721C16.296 13.0752 13.656 15.9072 10.408 17.7712Z"
      fill="#3F8FF7"
    />
  </Svg>
);

export const IconCheckmark = (props) => (
  <Svg {...props} stroke="currentColor" strokeWidth="4px" viewBox="0 0 32 32">
    <path fill="none" d="m4 16.5 8 8 16-16"></path>
  </Svg>
);

export const IconCheckmarkBubble = (props) => (
  <Svg {...props} viewBox="0 0 12 12">
    <g fill="none" fillRule="evenodd">
      <circle fill={props.fill || '#169617'} cx={6} cy={6} r={6} />
      <path
        d="M5.333 8.444 3.111 6.312l.627-.602 1.595 1.527L8.707 4l.626.606z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export const IconCaret = (props) => (
  <Svg {...props} viewBox="0 0 6 9">
    <g fill="none" fillRule="evenodd">
      <path fill="#000" d="M-362-379H52v2187h-414z" />
      <path
        d="M-347-101H36V85a8 8 0 0 1-8 8h-367a8 8 0 0 1-8-8v-186Z"
        fill="#152431"
      />
      <rect
        width={349}
        height={40}
        rx={4}
        fill="#000"
        transform="translate(-331 -17)"
      />
      <path d="m3 .842 3 3H0l3-3Zm0 8 3-3H0l3 3Z" fill="#fff" />
    </g>
  </Svg>
);

export const IconRightArrow = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M4,13h12.2l-5.6,5.6L12,20l8-8l-8-8l-1.4,1.4l5.6,5.6H4V13z" />
  </Svg>
);

export const IconYoutube = (props) => (
  <Svg {...props} viewBox="0 0 576 512">
    <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
  </Svg>
);

export const IconTwitter = (props) => (
  <Svg {...props} viewBox="0 0 18 15">
    <g transform="translate(-1061.000000, -4202.000000)" fillRule="nonzero">
      <g id="Group-18" transform="translate(0.000000, 4054.000000)">
        <g id="Group-6">
          <g id="Footer">
            <g id="Group-9" transform="translate(1036.000000, 145.000000)">
              <path
                d="M36.03,3.17222432 C34.44,3.75122432 33.435,5.24322432 33.549,6.87622432 L33.587,7.50622432 L32.951,7.42922432 C30.636,7.13322432 28.613,6.13022432 26.895,4.44522432 L26.055,3.60922432 L25.84,4.22622432 C25.382,5.60222432 25.675,7.05622432 26.629,8.03422432 C27.138,8.57422432 27.023,8.65122432 26.146,8.33022432 C25.841,8.22722432 25.573,8.15022432 25.548,8.18922432 C25.459,8.27922432 25.764,9.44922432 26.006,9.91322432 C26.337,10.5572243 27.011,11.1862243 27.749,11.5602243 L28.373,11.8562243 L27.634,11.8672243 C26.922,11.8672243 26.896,11.8802243 26.973,12.1512243 C27.227,12.9872243 28.232,13.8752243 29.352,14.2612243 L30.141,14.5312243 L29.454,14.9432243 C28.436,15.5362243 27.24,15.8702243 26.044,15.8942243 C25.471,15.9072243 25,15.9582243 25,15.9972243 C25,16.1252243 26.553,16.8452243 27.455,17.1292243 C30.165,17.9652243 33.384,17.6042243 35.801,16.1772243 C37.519,15.1612243 39.236,13.1412243 40.038,11.1852243 C40.471,10.1442243 40.903,8.24022432 40.903,7.32722432 C40.903,6.73522432 40.941,6.65822432 41.653,5.95122432 C42.073,5.53922432 42.467,5.08922432 42.544,4.96122432 C42.672,4.71622432 42.658,4.71622432 42.01,4.93522432 C40.929,5.32122432 40.776,5.27022432 41.311,4.69122432 C41.705,4.27922432 42.176,3.53322432 42.176,3.31522432 C42.176,3.27722432 41.985,3.34122432 41.769,3.45622432 C41.54,3.58522432 41.031,3.77822432 40.649,3.89322432 L39.962,4.11222432 L39.339,3.68622432 C38.995,3.45522432 38.513,3.19722432 38.258,3.12022432 C37.608,2.94022432 36.616,2.96622432 36.03,3.17222432 Z"
                id="twitter-icon"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconTwitch = (props) => (
  <Svg {...props} viewBox="131.836 357.682 111.787 127.387">
    <g
      transform="matrix(1.333333, 0, 0, -1.333333, -326.856018, 1293.480225)"
      id="g3363"
    >
      <g transform="translate(420.064,651.1567)" id="g3365">
        <path
          id="path3367"
          fillOpacity="1"
          fillRule="evenodd"
          stroke="none"
          d="m 0,0 -13.652,-13.651 -21.445,0 -11.699,-11.697 0,11.697 -17.548,0 0,56.544 L 0,42.893 0,0 Z m -72.146,50.692 -3.899,-15.599 0,-70.19 17.55,0 0,-9.751 9.746,0 9.752,9.751 15.596,0 31.196,31.192 0,54.597 -79.941,0 z"
        />
      </g>
      <path
        id="path3369"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="none"
        d="m 377.167,655.053 7.799,0 0,23.401 -7.799,0 0,-23.401 z m 21.446,0 7.799,0 0,23.401 -7.799,0 0,-23.401 z"
      />
    </g>
  </Svg>
);

export const IconInstagram = (props) => (
  <Svg {...props} viewBox="0 0 30 30">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 0c-4.074 0-4.584.017-6.184.09-1.597.073-2.688.327-3.642.698-1 .376-1.907.966-2.657 1.73a7.358 7.358 0 00-1.73 2.656C.418 6.128.163 7.22.09 8.817.018 10.416 0 10.925 0 15c0 4.075.017 4.584.09 6.184.073 1.597.327 2.688.698 3.642.376 1 .966 1.907 1.73 2.657a7.359 7.359 0 002.656 1.73c.954.37 2.045.624 3.642.697 1.6.073 2.11.09 6.184.09s4.584-.017 6.184-.09c1.597-.073 2.688-.327 3.642-.698 1-.376 1.907-.966 2.657-1.73a7.358 7.358 0 001.73-2.656c.37-.954.624-2.045.697-3.642.073-1.6.09-2.11.09-6.184s-.017-4.584-.09-6.184c-.073-1.597-.327-2.688-.698-3.642a7.353 7.353 0 00-1.73-2.657 7.358 7.358 0 00-2.656-1.73C23.872.418 22.78.163 21.183.09 19.584.018 19.075 0 15 0zm0 2.703c4.005 0 4.48.015 6.062.087 1.462.067 2.256.31 2.785.517.7.271 1.2.597 1.725 1.121.525.525.85 1.025 1.121 1.725.206.529.45 1.323.517 2.785.072 1.582.087 2.057.087 6.062 0 4.005-.015 4.48-.087 6.062-.067 1.462-.31 2.256-.517 2.785a4.646 4.646 0 01-1.121 1.725 4.642 4.642 0 01-1.725 1.121c-.529.206-1.323.45-2.785.517-1.582.072-2.056.087-6.062.087s-4.48-.015-6.062-.087c-1.462-.067-2.256-.31-2.785-.517a4.646 4.646 0 01-1.725-1.121 4.648 4.648 0 01-1.121-1.725c-.206-.529-.45-1.323-.517-2.785-.072-1.582-.087-2.057-.087-6.062 0-4.005.015-4.48.087-6.062.067-1.462.31-2.256.517-2.785.271-.7.597-1.2 1.121-1.725a4.643 4.643 0 011.725-1.121c.529-.206 1.323-.45 2.785-.517 1.582-.072 2.057-.087 6.062-.087z"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 20.005a5.005 5.005 0 110-10.01 5.005 5.005 0 010 10.01zM15 7.29a7.71 7.71 0 100 15.42 7.71 7.71 0 000-15.42zm9.953-.14a1.822 1.822 0 11-3.645 0 1.822 1.822 0 013.645 0"
    ></path>
  </Svg>
);

export const IconFacebook = (props) => (
  <Svg {...props} viewBox="0 0 30 30">
    <path d="M30 15.091C30 6.756 23.285 0 15 0S0 6.756 0 15.091C0 22.625 5.484 28.868 12.656 30V19.454H8.848V15.09h3.808v-3.324c0-3.782 2.239-5.872 5.666-5.872 1.64 0 3.358.295 3.358.295v3.714h-1.893c-1.863 0-2.443 1.164-2.443 2.358v2.83h4.16l-.665 4.362h-3.495V30C24.516 28.868 30 22.625 30 15.091z"></path>
  </Svg>
);

export const IconGlobe = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M9.862 8a.49.49 0 0 1-.488-.572 17.01 17.01 0 0 1 .736-2.864 6.761 6.761 0 0 1 1.09-2.048c.374-.435.65-.516.8-.516.15 0 .424.081.798.516a6.761 6.761 0 0 1 1.09 2.048 17.043 17.043 0 0 1 .736 2.864.49.49 0 0 1-.488.572zm-2.537-.432a.507.507 0 0 1-.5.432h-3.23a.472.472 0 0 1-.43-.688A10.043 10.043 0 0 1 7.677 2.98a.497.497 0 0 1 .641.665c-.03.078-.06.157-.088.236a19.627 19.627 0 0 0-.906 3.688zM16.32 2.98a.496.496 0 0 0-.64.664c.03.078.06.157.087.236a19.627 19.627 0 0 1 .906 3.688.507.507 0 0 0 .5.432h3.23a.472.472 0 0 0 .431-.688 10.043 10.043 0 0 0-4.514-4.333zm-1.36 7.486a.493.493 0 0 0-.496-.466h-4.93a.493.493 0 0 0-.495.466 29.266 29.266 0 0 0 0 3.068.493.493 0 0 0 .495.466h4.93a.493.493 0 0 0 .495-.466 29.321 29.321 0 0 0 0-3.068zM17.47 14a.507.507 0 0 1-.505-.51v-.023q.07-1.466 0-2.934a.507.507 0 0 1 .48-.532l.023-.001h3.922a.483.483 0 0 1 .482.402 10.067 10.067 0 0 1 0 3.196.483.483 0 0 1-.482.402zm-2.846 2.572a.49.49 0 0 0-.488-.572H9.862a.49.49 0 0 0-.488.572 17.114 17.114 0 0 0 .736 2.864 6.761 6.761 0 0 0 1.09 2.048c.374.435.648.516.8.516s.424-.081.798-.516a6.761 6.761 0 0 0 1.09-2.048 17.043 17.043 0 0 0 .736-2.864zm1.696 4.448a.496.496 0 0 1-.64-.664c.03-.078.06-.157.087-.236a19.627 19.627 0 0 0 .906-3.688.507.507 0 0 1 .5-.432h3.23a.472.472 0 0 1 .431.688 10.043 10.043 0 0 1-4.514 4.333zm-8.642 0a.496.496 0 0 0 .641-.664q-.045-.117-.088-.236a19.627 19.627 0 0 1-.906-3.688.507.507 0 0 0-.5-.432h-3.23a.472.472 0 0 0-.43.688 10.043 10.043 0 0 0 4.513 4.333zm-.645-7.553a.507.507 0 0 1-.48.532L6.53 14H2.61a.483.483 0 0 1-.482-.402 10.072 10.072 0 0 1 0-3.196A.483.483 0 0 1 2.61 10h3.92a.506.506 0 0 1 .504.533q-.068 1.466 0 2.934z"></path>
  </Svg>
);

export const IconCoin = (props) => (
  <Svg {...props} viewBox="0 0 33 33">
    <defs>
      <path
        d="M13.664,26.9071515 C6.27151515,26.9071515 0.278787879,20.9144242 0.278787879,13.5219394 C0.278787879,6.12945455 6.27151515,0.136727273 13.664,0.136727273 C21.056,0.136727273 27.0487273,6.12945455 27.0487273,13.5219394 C27.0487273,15.5888485 26.5803636,17.5466667 25.7435152,19.2945455 C25.7444848,19.2916364 25.7449697,19.2901818 25.7449697,19.2901818 C23.0404848,24.870303 17.8603636,26.3718788 15.5985455,26.7684848 C14.9667879,26.8596364 14.3204848,26.9071515 13.664,26.9071515 M0.513939394,13.5219394 C0.513939394,20.7844848 6.40145455,26.672 13.664,26.672 C20.9260606,26.672 26.8135758,20.7844848 26.8135758,13.5219394 C26.8135758,6.25939394 20.9260606,0.372363636 13.664,0.372363636 C6.40145455,0.372363636 0.513939394,6.25939394 0.513939394,13.5219394"
        id="path-1"
      ></path>
      <radialGradient
        cx="50%"
        cy="50%"
        fx="50%"
        fy="50%"
        r="101.380644%"
        gradientTransform="translate(0.500000,0.500000),scale(0.986376,1.000000),translate(-0.500000,-0.500000)"
        id="radialGradient-3"
      >
        <stop stopColor="#D49425" offset="0%"></stop>
        <stop stopColor="#AC7528" offset="100%"></stop>
      </radialGradient>
      <linearGradient
        x1="-21.1443866%"
        y1="-10.6232317%"
        x2="118.265336%"
        y2="95.4491384%"
        id="linearGradient-4"
      >
        <stop stopColor="#DB9800" offset="0%"></stop>
        <stop stopColor="#FFF071" offset="52.5131119%"></stop>
        <stop stopColor="#DB9800" offset="100%"></stop>
      </linearGradient>
      <path
        d="M8.77793828,14.4774139 L20.4253617,14.4774139 C20.4253617,14.4774139 21.7519227,14.5237455 21.7519227,13.5044494 C21.7519227,12.4852155 21.7519227,12.2179224 21.7519227,12.2179224 C21.7519227,12.2179224 21.8788127,10.9848166 20.5316367,10.9848166 C19.1845838,10.9848166 8.77793828,10.9848166 8.77793828,10.9848166 L7.04,8.96401084 L20.5598823,8.96401084 C20.5598823,8.96401084 24.3192,8.73235264 24.3192,11.7901787 L24.3192,13.6045755 C24.3192,13.6045755 24.456736,16.4233428 21.1100879,16.4233428 L24.32,22.4 L21.3400531,22.4 L18.3135839,16.4233428 L11.3450926,16.4233428 L11.3450926,22.4 L8.77793828,22.4 L8.77793828,14.4774139 Z"
        id="path-5"
      ></path>
      <filter
        x="-26.0%"
        y="-33.5%"
        width="152.1%"
        height="167.0%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.639945652   0 0 0 0 0.374513649   0 0 0 0 0  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id="Rival-Coins"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="5---Wallet" transform="translate(-828.000000, -290.000000)">
        <g id="Group-2-Copy-4" transform="translate(828.886065, 290.886065)">
          <g id="Group-12-Copy-4">
            <path
              d="M29.2218182,24.8780606 C29.2237576,24.8756364 29.2252121,24.8732121 29.2266667,24.8707879 C29.2654545,24.8436364 29.3052121,24.816 29.3454545,24.7873939 L29.2218182,24.8780606"
              id="Fill-286"
              fill="#191E2A"
            ></path>
            <path
              d="M31.8778182,15.7900606 C31.8778182,24.5105455 24.8082424,31.5796364 16.0882424,31.5796364 C7.36775758,31.5796364 0.298181818,24.5105455 0.298181818,15.7900606 C0.298181818,7.06957576 7.36775758,0 16.0882424,0 C24.8082424,0 31.8778182,7.06957576 31.8778182,15.7900606"
              id="Fill-312"
              fill="#EBA23B"
            ></path>
            <line
              x1="26.7335758"
              y1="4.12848485"
              x2="26.7335758"
              y2="4.12848485"
              id="Fill-314"
              fill="#FEF8DC"
            ></line>
            <g id="Group-320" transform="translate(2.424242, 2.324364)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g id="Clip-319"></g>
            </g>
            <g
              id="Group-323"
              transform="translate(2.909091, 2.964364)"
              fill="url(#radialGradient-3)"
            >
              <path
                d="M13.1791515,26.032 C5.91660606,26.032 0.0290909091,20.1444848 0.0290909091,12.8819394 C0.0290909091,12.9420606 0.032969697,13.0012121 0.0334545455,13.0613333 C0.129939394,5.88169697 5.97672727,0.0906666667 13.1791515,0.0906666667 C20.3810909,0.0906666667 26.2278788,5.88169697 26.3243636,13.0613333 C26.3248485,13.0012121 26.3287273,12.9420606 26.3287273,12.8819394 C26.3287273,20.1444848 20.4412121,26.032 13.1791515,26.032"
                id="Fill-321"
              ></path>
            </g>
          </g>
          <g id="Fill-4-Copy-9">
            <use
              fill="black"
              fillOpacity="1"
              filter="url(#filter-6)"
              xlinkHref="#path-5"
            ></use>
            <use
              fill="url(#linearGradient-4)"
              fillRule="evenodd"
              xlinkHref="#path-5"
            ></use>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconTrophy = (props) => (
  <Svg {...props} viewBox="0 0 20 18">
    <g
      id="Tournament-Admin"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="SCHEDULED-10"
        transform="translate(-758.000000, -531.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-9" transform="translate(758.000000, 531.000000)">
          <path
            d="M14.7222222,0 C15.1840278,0 15.5555556,0.376171875 15.5555556,0.84375 L15.5555556,0.84375 L15.5555556,2.25 L19.1666667,2.25 C19.6284722,2.25 20,2.62617188 20,3.09375 L20,3.09375 L20,5.0625 C20,6.31757812 19.2152778,7.6078125 17.8506944,8.60273437 C16.7604167,9.40078125 15.4305556,9.90703125 14.03125,10.06875 C12.9409722,11.9003906 11.6666667,12.65625 11.6666667,12.65625 L11.6666667,12.65625 L11.6666667,15.1875 L13.3333333,15.1875 C14.5590278,15.1875 15.5555556,15.9152344 15.5555556,17.15625 L15.5555556,17.15625 L15.5555556,17.578125 C15.5555556,17.8101563 15.3680556,18 15.1388889,18 L15.1388889,18 L4.86111111,18 C4.63194444,18 4.44444444,17.8101563 4.44444444,17.578125 L4.44444444,17.578125 L4.44444444,17.15625 C4.44444444,15.9152344 5.44097222,15.1875 6.66666667,15.1875 L6.66666667,15.1875 L8.33333333,15.1875 L8.33333333,12.65625 C8.33333333,12.65625 7.05902778,11.9003906 5.96875,10.06875 C4.57291667,9.90703125 3.24305556,9.40078125 2.14930556,8.60273437 C0.78125,7.6078125 0,6.31757812 0,5.0625 L0,5.0625 L0,3.09375 C0,2.62617188 0.371527778,2.25 0.833333333,2.25 L0.833333333,2.25 L4.44444444,2.25 L4.44444444,0.84375 C4.44444444,0.376171875 4.81597222,0 5.27777778,0 L5.27777778,0 Z M4.5012987,5 L2,5 L2,5.55684455 C2,5.96055684 2.42467532,6.64269142 3.37532468,7.25522042 C3.86233766,7.56844548 4.41168831,7.81902552 5,8 C4.72727273,7.12993039 4.54025974,6.13457077 4.5012987,5 L4.5012987,5 Z M18,5 L15.4980545,5 C15.459144,6.13457077 15.2723735,7.12993039 15,8 C15.5875486,7.81902552 16.1400778,7.56844548 16.6264591,7.25522042 C17.311284,6.81322506 18,6.11716937 18,5.55684455 L18,5.55684455 L18,5 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconCalendar = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M20 8.5H4a1 1 0 0 0-1 1v8.25A3.25 3.25 0 0 0 6.25 21h11.5A3.25 3.25 0 0 0 21 17.75V9.5a1 1 0 0 0-1-1zm-12.75 9a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1-1.25 1.25zm0-4.5a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 7.25 13zM12 17.5a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 12 17.5zm0-4.5a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 12 13zm4.75 0A1.25 1.25 0 1 1 18 11.75 1.25 1.25 0 0 1 16.75 13zM21 6.25a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 6.25 3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25z"></path>
  </Svg>
);

export const IconMarketplace = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M20.121 4.621l-1.535-1.535a2 2 0 0 0-1.414-.586H6.828a2 2 0 0 0-1.414.586L3.88 4.62A3 3 0 0 0 3 6.743V18.5a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6.743a3 3 0 0 0-.879-2.122zM12 15.5a5 5 0 0 1-5-5 1 1 0 0 1 2 0 3 3 0 0 0 6 0 1 1 0 0 1 2 0 5 5 0 0 1-5 5zm6.147-9.147a.5.5 0 0 1-.354.147H6.207a.5.5 0 0 1-.353-.854l.853-.853a1 1 0 0 1 .707-.293h9.172a1 1 0 0 1 .707.293l.853.853a.5.5 0 0 1 0 .707z"></path>
  </Svg>
);

export const IconExplore = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm3.962 6.748l-3.038 7.9a.55.55 0 0 1-.932.159.535.535 0 0 1-.082-.151l-.97-2.467a2 2 0 0 0-1.13-1.13l-2.466-.97a.535.535 0 0 1-.15-.081.55.55 0 0 1 .158-.931l7.9-3.04v.001a.55.55 0 0 1 .71.71z"></path>
  </Svg>
);

export const IconPlus = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <g id="GEMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Global-Wallet" transform="translate(-961.000000, -1143.000000)">
        <g id="add-24px-copy-6" transform="translate(961.000000, 1143.000000)">
          <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
          <polygon
            id="plus"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="19 13 13 13 13 19 11 19 11 13 5 13 5 11 11 11 11 5 13 5 13 11 19 11"
          ></polygon>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconNewWindow = (props) => (
  <Svg {...props} viewBox="0 0 32 32">
    <path d="M27 16.77a1 1 0 0 0-1 1V25a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7.23a1 1 0 0 0 0-2H7a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-7.23a1 1 0 0 0-1-1z"></path>
    <path d="M27 4h-6.42a1 1 0 0 0 0 2h4l-10.2 10.21a1 1 0 0 0 0 1.41 1 1 0 0 0 .7.3 1 1 0 0 0 .71-.3L26 7.41v4a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1z"></path>
  </Svg>
);

export const IconBell = (props) => (
  <Svg {...props} viewBox="0 0 480 480">
    <g fill="#fff">
      <path d="M381.834,361.391c5.045,0,9.174-4.125,9.174-9.168v-14.657c0-5.048-3.158-11.848-6.986-15.109   c0,0-59.893-50.876-64.393-131.984c-5.389-97.003-54.984-93.017-80.742-93.017s-75.348-3.986-80.742,93.017   c-4.508,81.108-64.389,131.984-64.389,131.984c-3.836,3.262-6.986,10.062-6.986,15.109v14.657c0,5.043,4.125,9.168,9.174,9.168   H381.834z" />
      <path d="M236.022,79.188h2.865h2.869l3.365-0.013c7.93,0,16.131,0.53,24.188,2.235v-7.158c0-10.031-8.211-18.25-18.256-18.25   h-24.328c-10.049,0-18.26,8.219-18.26,18.25v7.158c8.055-1.705,16.258-2.235,24.188-2.235L236.022,79.188z" />
      <path d="M202.381,379.641c0,16.736,13.686,36.363,30.422,36.363h12.172c16.736,0,30.422-19.627,30.422-36.363l0,0H202.381   L202.381,379.641z" />
    </g>
  </Svg>
);

export const IconMenu = (props) => (
  <Svg {...props} viewBox="0 0 32 32">
    <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
  </Svg>
);

export const IconAvatar = (props) => (
  <Svg {...props} viewBox="0 0 23 26">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-583.000000, -538.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-31" transform="translate(533.000000, 67.000000)">
          <g id="Group-26" transform="translate(17.000000, 450.000000)">
            <g
              id="users-solid-copy"
              transform="translate(33.000000, 21.000000)"
            >
              <path
                d="M11.5,13 C15.2075521,13 18.2083333,10.0924107 18.2083333,6.5 C18.2083333,2.90758929 15.2075521,0 11.5,0 C7.79244792,0 4.79166667,2.90758929 4.79166667,6.5 C4.79166667,10.0924107 7.79244792,13 11.5,13 Z M16.1,14.8571429 L15.6028646,14.8571429 C14.3570312,15.4375 12.9734375,15.7857143 11.5,15.7857143 C10.0265625,15.7857143 8.64895833,15.4375 7.39713542,14.8571429 L6.9,14.8571429 C3.090625,14.8571429 0,17.8517857 0,21.5428571 L0,23.2142857 C0,24.7522321 1.28776042,26 2.875,26 L20.125,26 C21.7122396,26 23,24.7522321 23,23.2142857 L23,21.5428571 C23,17.8517857 19.909375,14.8571429 16.1,14.8571429 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconChevronDown = (props) => (
  <Svg {...props} viewBox="0 0 18 18">
    <g id="NEW" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="RCC-Comms" transform="translate(-1337.000000, -38.000000)">
        <g id="Group" transform="translate(1134.000000, 29.000000)">
          <g id="Group-2" transform="translate(42.000000, 0.000000)">
            <g
              id="baseline-chevron_right-24px"
              transform="translate(170.000000, 18.000000) rotate(90.000000) translate(-170.000000, -18.000000) translate(161.000000, 9.000000)"
            >
              <polygon
                id="Shape"
                fill="#FFFFFF"
                fillRule="nonzero"
                points="7.5 4.5 6.4425 5.5575 9.8775 9 6.4425 12.4425 7.5 13.5 12 9"
              ></polygon>
              <polygon id="Shape" points="0 0 18 0 18 18 0 18"></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconLeftChevron = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M16.207 4.299a1 1 0 0 1 0 1.414l-6.293 6.293 6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0z"></path>
  </Svg>
);

export const IconCopy = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M10.5 1.5a1 1 0 0 0 0 2h5a3 3 0 0 1 3 3v12a1 1 0 0 0 2 0v-12a5 5 0 0 0-5-5z"></path>
    <path d="M5.5 4.5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2z"></path>
  </Svg>
);

export const IconArenas = (props) => (
  <Svg {...props} viewBox="0 0 29 29">
    <g stroke="none" fill="none" fillRule="evenodd">
      <g transform="translate(-81.000000, -23.000000)" fill="#fff">
        <path d="M98.5345337,24.256945 L108.743055,34.4654663 C110.418982,36.141393 110.418982,38.858607 108.743055,40.5345337 L98.5345337,50.743055 C96.858607,52.4189817 94.141393,52.4189817 92.4654663,50.743055 L82.256945,40.5345337 C80.5810183,38.858607 80.5810183,36.141393 82.256945,34.4654663 L92.4654663,24.256945 C94.141393,22.5810183 96.858607,22.5810183 98.5345337,24.256945 Z M94.2592717,32.9629194 L94.1625101,32.9696871 L94.1625101,32.9696871 L93.0029138,33.1273414 C92.6346003,33.1672756 92.4601477,33.3832387 92.374483,33.7744958 C92.1362281,34.8631313 91.8811303,35.9477243 91.6030547,37.0247225 C91.5458334,37.246443 91.3597804,37.4279843 91.2331796,37.6280228 C91.0754585,37.4784533 90.8694394,37.3604882 90.7681587,37.174047 C90.2455819,36.2119515 89.7646104,35.2224165 89.2344486,34.2657109 C89.10439,34.0311281 88.8442728,33.8835186 88.7375266,33.7835606 C88.139547,33.8721263 87.7344244,33.9254128 87.3314212,33.9932764 C86.6068408,34.1152839 86.515822,34.3285521 86.8776661,35.0424676 C87.9333048,37.125048 88.9920667,39.2056683 90.0461438,41.2891061 C90.793702,42.7666712 90.7940366,42.7824734 92.3043228,42.4268631 C92.5048763,42.379579 92.7706822,42.1300516 92.8192032,41.9216833 C93.4614652,39.1597318 94.0701529,36.3883479 94.6875409,33.6195365 C94.7980796,33.1236665 94.6004262,32.9209331 94.1625101,32.9696871 Z M101.404026,32.5590668 C100.343081,32.3703529 99.2713051,32.3505862 98.2293135,32.7124332 C96.9898895,33.1425335 96.3177169,34.0583134 96.3270809,35.2831516 C96.3367833,36.5413607 96.9306598,37.3397031 98.2345031,37.7537575 C98.914573,37.9696797 99.6219449,38.0923496 100.308671,38.28804 C100.504411,38.3438519 100.670931,38.5080318 100.850764,38.6224462 C100.679167,38.7811612 100.521785,38.9620847 100.331009,39.0902195 C100.212775,39.1696352 100.039599,39.2117266 99.8983502,39.1969597 C99.2127523,39.1254508 98.5260261,39.0510349 97.8468588,38.9337137 C97.4075436,38.85767 96.9490492,38.8884828 96.9041475,39.3742787 C96.8530407,39.9276303 96.9988022,40.5106319 97.1266255,41.0640997 C97.1584403,41.2018852 97.4411635,41.336764 97.6251704,41.3674605 C98.1240538,41.451062 98.6318498,41.4779215 99.3224118,41.5455934 C99.7969264,41.4609454 100.455674,41.4003662 101.082042,41.2203729 C102.482232,40.8178297 103.35714,39.6263624 103.297797,38.3012953 C103.240372,37.0170407 102.420746,36.1467242 100.943614,35.8117366 C100.320517,35.6704628 99.6914411,35.5551183 99.0721804,35.3983799 C98.9372495,35.3641951 98.8326668,35.2030383 98.7140945,35.1002515 C98.8372923,34.9996738 98.9558646,34.8197968 99.0844776,34.8118901 C99.661657,34.7767751 100.266703,34.6794531 100.815113,34.8109599 C101.771588,35.0404862 102.326768,34.8346799 102.083419,33.5415884 C102.058373,33.4085701 102.077665,33.2402043 102.00501,33.1484635 C101.828449,32.9253322 101.632822,32.5997629 101.404026,32.5590668 Z"></path>
      </g>
    </g>
  </Svg>
);

export const IconController = (props) => (
  <Svg {...props} viewBox="0 0 512.368 512.368">
    <g>
      <g>
        <path
          d="M447.303,128.681c-0.427-1.259-0.875-3.264-1.408-5.525c-3.52-14.315-6.827-27.84-19.904-32.832l-62.08-23.616
            c-12.032-4.565-25.515-2.923-36.139,4.48l-3.84,3.435c-3.115,3.563-7.339,8.021-10.347,10.88H199.197
            c-2.539-2.667-5.931-6.592-8.768-10.112l-4.437-4.16c-10.624-7.424-24.149-9.131-36.117-4.523L87.73,90.324
            c-13.013,4.949-16.277,18.325-19.755,32.512c-0.533,2.155-0.981,4.117-0.811,4.117c0,0,0.021,0,0.043-0.021
            C46.045,168.66-54.606,379.902,39.623,442.26c13.483,8.917,31.424,7.509,43.691-3.456l73.856-66.219
            c6.507-5.845,14.784-9.067,23.275-9.067h152.853c8.491,0,16.747,3.221,23.275,9.067l73.856,66.219
            c6.955,6.229,15.616,9.408,24.277,9.408c6.955,0,13.888-2.069,19.883-6.293C557.746,383.572,482.823,202.494,447.303,128.681z
            M341.469,149.502c11.776,0,21.333,9.557,21.333,21.333c0,11.776-9.557,21.333-21.333,21.333s-21.333-9.557-21.333-21.333
            S329.693,149.502,341.469,149.502z M213.469,256.169h-21.333v21.333c0,11.776-9.536,21.333-21.333,21.333
            s-21.333-9.557-21.333-21.333v-21.333h-21.333c-11.797,0-21.333-9.557-21.333-21.333s9.536-21.333,21.333-21.333h21.333V192.17
            c0-11.776,9.536-21.333,21.333-21.333s21.333,9.557,21.333,21.333v21.333h21.333c11.797,0,21.333,9.557,21.333,21.333
            S225.266,256.169,213.469,256.169z M298.802,234.836c-11.776,0-21.333-9.557-21.333-21.333s9.557-21.333,21.333-21.333
            s21.333,9.557,21.333,21.333S310.578,234.836,298.802,234.836z M341.469,277.502c-11.776,0-21.333-9.557-21.333-21.333
            s9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333S353.245,277.502,341.469,277.502z M384.135,234.836
            c-11.776,0-21.333-9.557-21.333-21.333s9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333S395.911,234.836,384.135,234.836z"
        />
      </g>
    </g>
  </Svg>
);

export const IconChat = (props) => (
  <Svg {...props} viewBox="0 0 512 512">
    <path d="M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"></path>
  </Svg>
);

export const IconStream = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M19 3H5a3.226 3.226 0 0 0-3 3v9a3.226 3.226 0 0 0 3 3h14a3.226 3.226 0 0 0 3-3V6a3.226 3.226 0 0 0-3-3zm-4.215 7.924l-4.138 3.008v-.001c-.287.192-.647-.047-.647-.431V7.499a.435.435 0 0 1 .647-.432l4.138 2.995a.54.54 0 0 1 0 .862zM18 20a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1z"></path>
  </Svg>
);

export const IconClose = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M5.287 5.305a1 1 0 0 1 1.414 0l5.293 5.293 5.293-5.293a1 1 0 0 1 1.438 1.39l-.024.024-5.293 5.293 5.293 5.293a1 1 0 0 1-1.414 1.414l-5.293-5.293L6.7 18.72a1 1 0 0 1-1.414-1.414l5.293-5.293L5.287 6.72a1 1 0 0 1 0-1.414z"></path>
  </Svg>
);

export const IconList = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M4 8a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm0 6a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm2 4a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM9 5a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2zm-1 7a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm1 5a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2z"></path>
  </Svg>
);

export const IconPicture = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 12l-5.72-2.697a3 3 0 0 0-2.56 0L5 15V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-8.5-6.5a2 2 0 1 1-2-2 2 2 0 0 1 2 2z"></path>
  </Svg>
);

export const IconFlag = (props) => (
  <Svg {...props} width="15px" height="17px" viewBox="0 0 15 17">
    <g
      id="Tournament"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Tournament-Detail-Not-Joined/Logged-Out-State"
        transform="translate(-275.000000, -611.000000)"
      >
        <g
          id="Tournament---Content"
          transform="translate(158.000000, 416.000000)"
        >
          <g
            id="baseline-flag-24px-(1)"
            transform="translate(112.000000, 191.000000)"
          >
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
            <polygon
              id="Path"
              fill="white"
              fillRule="nonzero"
              points="14.4 6 14 4 5 4 5 21 7 21 7 14 12.6 14 13 16 20 16 20 6"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconSearch = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M19 10.5a8.5 8.5 0 1 0-8.5 8.5 8.5 8.5 0 0 0 8.5-8.5zm-15 0a6.5 6.5 0 1 1 6.5 6.5A6.509 6.509 0 0 1 4 10.5zm14.558 5.915c-.14-.14-.733.227-1.324.818-.591.592-.958 1.184-.818 1.324l2.998 3a1.515 1.515 0 1 0 2.142-2.143z"></path>
  </Svg>
);

export const IconRemove = (props) => (
  <Svg {...props} viewBox="0 0 512 512">
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276a12 12 0 0 1-12 12H124a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z"></path>
    <path
      fill="#ffffff"
      d="M400 284a12 12 0 0 1-12 12H124a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z"
    ></path>
  </Svg>
);

export const IconPlay = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M18.068 10.204l-9.221-6.73A2.401 2.401 0 0 0 5 5.271V18.73a2.402 2.402 0 0 0 3.846 1.797l9.22-6.73a2.197 2.197 0 0 0 0-3.592z"></path>
  </Svg>
);

export const IconPause = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M7 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm8 0a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"></path>
  </Svg>
);

export const IconCrossPlatform = (props) => (
  <Svg {...props} viewBox="0 0 69.78 21.93">
    <g id="Cross-Platform-Icon">
      <g id="Group-4">
        <g id="Group-14">
          <g id="Group-12">
            <circle
              id="Oval"
              fill="none"
              stroke="#fff"
              cx="10.96"
              cy="10.96"
              r="10.46"
            />
          </g>
          <g id="games-24px-_2_" data-name="games-24px-(2)">
            <polygon
              id="Path"
              fill="none"
              points="4.07 4.07 17.86 4.07 17.86 17.86 4.07 17.86 4.07 4.07"
            />
            <path
              id="Shape"
              fill="#fff"
              d="M12.91,8.43V5.27H9.46V8.43l1.73,1.73ZM8.6,9.3H5.44v3.44H8.6L10.32,11Zm.86,4.31v3.16h3.45V13.61l-1.72-1.73ZM13.77,9.3,12.05,11l1.72,1.72h3.16V9.3Z"
              transform="translate(-0.22 -0.06)"
            />
          </g>
        </g>
        <g id="Group-3">
          <path
            id="CROSSPLATFORM"
            fill="#fff"
            d="M28,21.34V19h1a3,3,0,0,0,.75-.1,2.06,2.06,0,0,0,.61-.31,1.7,1.7,0,0,0,.42-.5,1.57,1.57,0,0,0,.15-.7h0v-.72a2,2,0,0,0-.14-.75,1.54,1.54,0,0,0-.41-.53,1.8,1.8,0,0,0-.61-.33,2.8,2.8,0,0,0-.79-.1H26.8v6.39Zm1-3.39H28V16h1a.93.93,0,0,1,.56.17.62.62,0,0,1,.23.51h0v.72a.45.45,0,0,1-.24.44,1.09,1.09,0,0,1-.55.13Zm6.91,3.39v-1H33V15H31.83v6.39Zm1.52,0,.45-1.51H40l.44,1.51H41.7L39.65,14.9H38.23l-2.11,6.44Zm2.39-2.45H38.1l.83-2.78ZM45,21.34V16h1.91V15H42v1h1.89v5.35Zm3.76,0V18.57h2v-1h-2V16h2.43V15H47.62v6.39Zm5.73.09a3.42,3.42,0,0,0,1-.13,2.59,2.59,0,0,0,.8-.39,1.92,1.92,0,0,0,.54-.66,1.86,1.86,0,0,0,.21-.89h0V16.92a1.75,1.75,0,0,0-.22-.87,2,2,0,0,0-.56-.65,2.58,2.58,0,0,0-.79-.41,3.34,3.34,0,0,0-.94-.14h-.16a3.31,3.31,0,0,0-1,.14,2.41,2.41,0,0,0-.8.4A2.18,2.18,0,0,0,52,16a1.81,1.81,0,0,0-.2.88h0v2.44a1.87,1.87,0,0,0,.2.9,1.8,1.8,0,0,0,.54.65,2.54,2.54,0,0,0,.81.39,3.39,3.39,0,0,0,1,.13h.15Zm0-1h-.15a2.1,2.1,0,0,1-.51-.06,1.46,1.46,0,0,1-.44-.19.89.89,0,0,1-.41-.79h0V16.92a.94.94,0,0,1,.11-.45,1.18,1.18,0,0,1,.31-.32,1.48,1.48,0,0,1,.44-.2,2.05,2.05,0,0,1,.49-.06h.16A1.66,1.66,0,0,1,55,16a1.3,1.3,0,0,1,.43.2,1.14,1.14,0,0,1,.3.32.84.84,0,0,1,.12.45h0v2.43a1,1,0,0,1-.11.46,1,1,0,0,1-.3.32,1.14,1.14,0,0,1-.43.2,2.07,2.07,0,0,1-.5.06Zm4.7.94v-2.6H60l1.42,2.6h1.3l-1.5-2.72a1.76,1.76,0,0,0,.88-.52,1.44,1.44,0,0,0,.32-1h0v-.49a1.53,1.53,0,0,0-.53-1.29A2.22,2.22,0,0,0,60.48,15H58v6.39Zm1.27-3.63H59.21V16h1.26a.94.94,0,0,1,.57.17.59.59,0,0,1,.22.51h0v.47a.47.47,0,0,1-.24.44,1.06,1.06,0,0,1-.54.14Zm4.08,3.63V16.25l1.79,3.9h.55l1.83-3.9v5.09h1V15H68.32l-1.69,3.31L65,15H63.53v6.39Z"
            transform="translate(-0.22 -0.06)"
          />
          <path
            id="CROSSPLATFORM-Copy-9"
            fill="#fff"
            d="M30.7,12.22A6.44,6.44,0,0,0,32.51,12a4.27,4.27,0,0,0,1.59-.92h0l-.82-1.37a3.27,3.27,0,0,1-1.16.66,4.36,4.36,0,0,1-1.42.22,2.51,2.51,0,0,1-1.45-.4,1.43,1.43,0,0,1-.58-1.27h0V5a1.62,1.62,0,0,1,.15-.72,1.57,1.57,0,0,1,.44-.52,2,2,0,0,1,.65-.32,2.43,2.43,0,0,1,.77-.11A2.74,2.74,0,0,1,32,3.64a4.78,4.78,0,0,1,1,.74h0l1-1.26a7.79,7.79,0,0,0-.7-.63A3.35,3.35,0,0,0,32.63,2a3.61,3.61,0,0,0-.86-.27,6.94,6.94,0,0,0-1.09-.08,4.91,4.91,0,0,0-1.5.23,3.85,3.85,0,0,0-1.24.65,3.14,3.14,0,0,0-.83,1.05A3,3,0,0,0,26.8,5h0V8.9a3.32,3.32,0,0,0,.3,1.45,3.11,3.11,0,0,0,.82,1,3.75,3.75,0,0,0,1.23.62A5.48,5.48,0,0,0,30.7,12.22Zm6.67-.15V7.92h1.3l2.27,4.15H43L40.61,7.72A2.84,2.84,0,0,0,42,6.88a2.24,2.24,0,0,0,.51-1.53h0V4.56a2.41,2.41,0,0,0-.85-2.06,3.57,3.57,0,0,0-2.26-.66H35.51V12.07Zm2.05-5.81H37.37V3.5h2a1.46,1.46,0,0,1,.9.27,1,1,0,0,1,.36.81h0v.75a.77.77,0,0,1-.38.71,1.71,1.71,0,0,1-.87.22Zm8.83,6A5.51,5.51,0,0,0,49.79,12a3.83,3.83,0,0,0,1.28-.63,3,3,0,0,0,.87-1.05,3,3,0,0,0,.33-1.43h0V5a2.86,2.86,0,0,0-.34-1.39,3.45,3.45,0,0,0-.9-1,4.06,4.06,0,0,0-1.28-.65,5,5,0,0,0-1.5-.23H48a5.19,5.19,0,0,0-1.53.22,3.78,3.78,0,0,0-1.28.65,3.25,3.25,0,0,0-.89,1A2.94,2.94,0,0,0,44,5h0V8.9a3.19,3.19,0,0,0,.32,1.45,3.25,3.25,0,0,0,.87,1,4.07,4.07,0,0,0,1.29.62,5.65,5.65,0,0,0,1.56.21h.23Zm0-1.65H48a3.61,3.61,0,0,1-.82-.1,2.4,2.4,0,0,1-.69-.3A1.52,1.52,0,0,1,46,9.65a1.49,1.49,0,0,1-.18-.75h0V5A1.36,1.36,0,0,1,46,4.29a1.62,1.62,0,0,1,.49-.52,2.35,2.35,0,0,1,.7-.32,3.08,3.08,0,0,1,.8-.1h.24a2.65,2.65,0,0,1,.79.11,2.13,2.13,0,0,1,.68.32,1.73,1.73,0,0,1,.49.52A1.31,1.31,0,0,1,50.4,5h0V8.9a1.44,1.44,0,0,1-.18.73,1.71,1.71,0,0,1-.47.53,2.17,2.17,0,0,1-.69.31,3.59,3.59,0,0,1-.81.1Zm9.27,1.62A6,6,0,0,0,59,12a3.66,3.66,0,0,0,1.2-.54,2.72,2.72,0,0,0,.81-.94,2.78,2.78,0,0,0,.3-1.33A3,3,0,0,0,61,8a2.45,2.45,0,0,0-.66-.87,3.87,3.87,0,0,0-1-.62A10.49,10.49,0,0,0,57.94,6l-.77-.21a3.5,3.5,0,0,1-.71-.28,2,2,0,0,1-.52-.41.87.87,0,0,1-.2-.58A1,1,0,0,1,55.9,4a1.13,1.13,0,0,1,.41-.37,1.79,1.79,0,0,1,.59-.2,3.82,3.82,0,0,1,.68-.06,2.39,2.39,0,0,1,.63.09,3.68,3.68,0,0,1,.66.23,4.68,4.68,0,0,1,.59.31,2.92,2.92,0,0,1,.45.33h0l1-1.39a6.56,6.56,0,0,0-1.46-.87,4.78,4.78,0,0,0-1.91-.36,6,6,0,0,0-1.44.17A3.46,3.46,0,0,0,55,2.37a2.44,2.44,0,0,0-.8.89,2.68,2.68,0,0,0-.29,1.3,2.85,2.85,0,0,0,.2,1.15,2.22,2.22,0,0,0,.59.83,3.51,3.51,0,0,0,1,.61,11.35,11.35,0,0,0,1.27.48l.81.22a4.83,4.83,0,0,1,.81.29,2,2,0,0,1,.63.42.94.94,0,0,1,.25.65,1.07,1.07,0,0,1-.18.63,1.42,1.42,0,0,1-.47.41,2.49,2.49,0,0,1-.65.22,4.39,4.39,0,0,1-.72.07,2.27,2.27,0,0,1-.74-.13,4.09,4.09,0,0,1-.75-.31,5.16,5.16,0,0,1-.67-.44,2.62,2.62,0,0,1-.49-.52h0l-1.22,1.15a3.6,3.6,0,0,0,.75.81,4.5,4.5,0,0,0,1,.59,5.17,5.17,0,0,0,1.11.37A5.23,5.23,0,0,0,57.52,12.19Zm8.73,0A6.11,6.11,0,0,0,67.69,12a3.66,3.66,0,0,0,1.2-.54,2.72,2.72,0,0,0,.81-.94A2.78,2.78,0,0,0,70,9.21,3,3,0,0,0,69.77,8a2.32,2.32,0,0,0-.65-.87,3.94,3.94,0,0,0-1.05-.62A9.88,9.88,0,0,0,66.68,6l-.77-.21a3.5,3.5,0,0,1-.71-.28,2,2,0,0,1-.52-.41.87.87,0,0,1-.2-.58A1,1,0,0,1,64.64,4a1.13,1.13,0,0,1,.41-.37,1.79,1.79,0,0,1,.59-.2,3.71,3.71,0,0,1,.67-.06,2.41,2.41,0,0,1,.64.09,3.68,3.68,0,0,1,.66.23A5.49,5.49,0,0,1,68.2,4a2.92,2.92,0,0,1,.45.33h0l1-1.39a6.27,6.27,0,0,0-1.45-.87,4.8,4.8,0,0,0-1.92-.36,5.9,5.9,0,0,0-1.43.17,3.46,3.46,0,0,0-1.17.51,2.44,2.44,0,0,0-.8.89,2.68,2.68,0,0,0-.3,1.3,2.85,2.85,0,0,0,.21,1.15,2.22,2.22,0,0,0,.59.83,3.51,3.51,0,0,0,1,.61,11.35,11.35,0,0,0,1.27.48l.81.22a4.83,4.83,0,0,1,.81.29,2,2,0,0,1,.63.42.93.93,0,0,1,.24.65,1.07,1.07,0,0,1-.18.63,1.3,1.3,0,0,1-.46.41,2.49,2.49,0,0,1-.65.22,4.39,4.39,0,0,1-.72.07,2.27,2.27,0,0,1-.74-.13,4.09,4.09,0,0,1-.75-.31A5.16,5.16,0,0,1,64,9.66a2.62,2.62,0,0,1-.49-.52h0l-1.22,1.15a3.38,3.38,0,0,0,.75.81,4.27,4.27,0,0,0,1,.59,5.57,5.57,0,0,0,2.29.5Z"
            transform="translate(-0.22 -0.06)"
          />
        </g>
      </g>
    </g>
  </Svg>
);

export const IconLogo = (props) => (
  <Svg width="136px" height="24px" viewBox="0 0 136 24">
    <defs>
      <polygon
        id="path-1"
        points="0 0 135.354947 0 135.354947 24 0 24"
      ></polygon>
    </defs>
    <g id="RIVAL" stroke="none" fill="none">
      <g id="Login" transform="translate(-120.000000, -204.000000)">
        <g id="Group-2" transform="translate(120.000000, 122.000000)">
          <g id="Rival-Logo-White" transform="translate(0.000000, 82.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <g id="Clip-2"></g>
            <path
              d="M3.13644549,24.0001455 L3.13644549,9.85245236 L24.1560001,9.85245236 C24.1560001,9.85245236 26.54999,9.93525463 26.54999,8.11505976 C26.54999,6.2950104 26.54999,5.81769674 26.54999,5.81769674 C26.54999,5.81769674 26.7790423,3.61565094 24.3477987,3.61565094 C21.916846,3.61565094 3.13644549,3.61565094 3.13644549,3.61565094 L0,0.00713060034 L24.3988771,0.00713060034 C24.3988771,0.00713060034 31.1831339,-0.406589742 31.1831339,5.05399489 L31.1831339,8.29390685 C31.1831339,8.29390685 31.4312497,13.3273831 25.3916312,13.3273831 L31.1845642,24.0001455 L25.8066613,24.0001455 L20.3449125,13.3273831 L7.7692984,13.3273831 L7.7692984,24.0001455 L3.13644549,24.0001455"
              fill="#FFFFFE"
              mask="url(#mask-2)"
            ></path>
            <polyline
              fill="#FFFFFE"
              mask="url(#mask-2)"
              points="34.8747476 3.25475525 34.8747476 24.0001455 39.488246 24.0001455 39.488246 0.0171716498 34.8747476 3.25475525"
            ></polyline>
            <polyline
              fill="#FFFFFE"
              mask="url(#mask-2)"
              points="111.352474 23.9951978 111.352474 24.0001455 111.358877 23.9951978 135.354947 23.9951978 132.862002 20.4424125 116.068274 20.4424125 116.068274 0.00713060034 111.352474 3.31645677"
            ></polyline>
            <polyline
              fill="#FFFFFE"
              mask="url(#mask-2)"
              points="73.046452 0.00713060034 60.7190992 18.9532812 48.3926196 0.00713060034 43.1263074 0.00713060034 59.1375612 24.0001455 62.3009283 24.0001455 78.3132007 0.00713060034 73.046452 0.00713060034"
            ></polyline>
            <polyline
              fill="#FFFFFE"
              mask="url(#mask-2)"
              points="91.6714345 0.00713060034 88.5079219 0.00713060034 72.4956495 24.0001455 77.7623982 24.0001455 90.0898965 5.05399489 102.416376 24.0001455 107.682543 24.0001455 91.6714345 0.00713060034"
            ></polyline>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconShare = (props) => (
  <Svg viewBox="0 0 595.28 595.28" {...props}>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Calque_1" data-name="Calque 1">
        <polygon
          fill="none"
          points="595.28 595.28 0 595.28 0 0 595.28 0 595.28 595.28"
        />
        <path
          fill="#fff"
          stroke="#fff"
          strokeWidth="10px"
          d="M310,66.29V358.41a13.64,13.64,0,1,1-27.28,0V66.27l-53.63,52.94a13.92,13.92,0,0,1-19.32,0,13.5,13.5,0,0,1,0-19.07l67.27-66.41L278.86,32a25,25,0,0,1,35.08,0l1.78,1.76L383,100.14a13.5,13.5,0,0,1,0,19.07,14,14,0,0,1-19.32.1Zm62,107.33a12.4,12.4,0,0,1,0-24.8h74.56a49.46,49.46,0,0,1,49.46,49.4V471.46a49.46,49.46,0,0,1-49.46,49.41H148.67a49.46,49.46,0,0,1-49.46-49.41V198.22a49.46,49.46,0,0,1,49.46-49.4h74.56a12.4,12.4,0,0,1,0,24.8H149a24.86,24.86,0,0,0-25,24.77V471.3a24.88,24.88,0,0,0,25,24.77h297.3a24.86,24.86,0,0,0,25-24.77V198.39a24.88,24.88,0,0,0-25-24.77Z"
        />
      </g>
    </g>
  </Svg>
);

export const IconShield = (props) => (
  <Svg {...props} viewBox="0 0 50 58">
    <g stroke="none" fill="none">
      <g transform="translate(-163.000000, -122.000000)">
        <g transform="translate(120.000000, 122.000000)">
          <image
            x="43"
            y="0"
            width="50"
            height="58"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYEAAAG+CAYAAAB1dbhcAAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABgaADAAQAAAABAAABvgAAAAD1N6yXAAA3L0lEQVR4Ae2dB7gtRZmuOWQkIyjqQY4kRRgFFVEUz5EroIAKXkAGVBwTY46MOjqiCAgmvHovowL6KDIYAAkqUTkqIyJIGDGAZJAMggTJ+77/Zq3j2uvssNZeHaq633qeb/faq7ur/v+t6vpXdaies4RJAjUTGBsbWxYTVkYrzWK5HPss3adl+v6P9ZN9193vYdZPpocm+X6y7x5gu3vQ3cMu58yZ8yD7mCRQG4E5tZVswY0kQIe+Ko6thdbsW0723WpsE51/dNBtTRFUInjciW5Ft/UtF/uOwHEX25gkUAgBg0AhGJudCR378ng4t0fr8PnJKDr2rqLTD7W5Q8f9SlIEjggW3YARgSJ0A7oOXd8VAeN+PpskMCUBg8CUaNqxoqeDj46929H3f47O3ZQngQgUvYFhsc8GijwrtiirDQJFkUw0Hzr5JTEtOvUNerQhn9dF0enbwQOh5SkCRYwerkF/Rpf36DqCxKP8b2ooAYNAAyqWjj4ucM5DvR199/PT+D4uvJokMBsCceH6KtQbGLqfryZAPDybTN0nHQIGgXTqYkZL6OyfxEabdBS/5rsdffyqj0BgkkCVBCIAXIO6QSFGEb8PERxuZGnKgIBBIMFKorOPi63dzn7TzudYrp6guZokgckI/JUvL0ERFLrLCA5xAduUEAGDQI2VQWcfnXp/Zx//P6FGsyxaAmUSuIXMx0cLLHuDQwQNUw0EDAIVQafDX4+intvR5izjl33cZmmSgAQeu701gsKF6LchRg1XCqZ8AgaBghnT2QfTOFcfHf5zepbxYJRJAhIYnEA8QHcBiqDQXV5OcBgbPAu3nImAQWAmQtOsp8OP2y83Qr0dfvzKX2Wa3VwlAQnMnsDf2LU7WugGhssIDN7GOkumBoEhwNHpP5XNX9hRdPyboZWQSQISqI/APRR9EYoRwzkhgsK1LE0DEDAITAGJDj+mP4hf9Vv16ClTbO7XEpBAWgT+gjm/6tGFBIaYbsPUR8Ag0AFCpx935MSv/G6n/zw+x5w5JglIIH8CMYfS+agbGGK0EHcqtT61Mgh0zuXH3TndDj+W67e+NQhAAu0icAXudoNCLC9p47WFVgQBOv2lqOA4tbOgo61ZevEWCCYJSGARgbjo/Eu0sKM4hfQInxudGhkEOp1+3J65oKMXs7TTB4JJAhIYmEAEhbPRwo4uaGJQaEQQ6JzeiU7/pWgBstMHgkkCEiiUQG9QOIucIyhkf2tqtkGAjn8elbBtR9uwfDwySUACEqiKwO0U9DN0RoiAcDXL7FI2QYBOf1XoRmff7fjjqVyTBCQggVQIxGyq4wGB5c8ICnelYth0diQbBDqneLbA+B3Qdig+xwVekwQkIIHUCcQF5fPQ6egn8TnVU0dJBQE6/jWAtT2Kjv/laE1kaj6BmAvmXnQ3iqc/h13GQ0AP92iY/+NgjR8X8T6GUDwk2P086P/x1PjKaNjliuyT1DGIPaZyCNxGtqeiCAinERDuKKeY4XOtvQHS8cfUC9Hph16A/LUPhIxTdOgxLXA0+lsnWfZ/F9vdy0HRuknBaPtx/EUgiB87obV6lr2fe9etzja1H7fYYJo9gfjh8WsUAeEntP2Y8qK2VHljouEvh7dxbn9ntBN6MjKlTyB+acfboq5D13cUn+Px/OjYu537bTTqxt9bjb+1JI6f+JHUGzQiWDwFrYPmdhSf4y10MZIxpU/gBkz8EToBxbWEB6o0uZIgQMNdDad2RK9Gr0ArIVM6BKKDj4YYnXt/J9/t8G+kcWZ/O1w6yMu1hGNuSUqIQNAbGPo/xw8wA0W5VTFs7vewwynoRPRjjrk7h81g2O1LCwI0wvg1Ep1+aAGysQGhxhTn2S+fRFfwnR18jRVTV9E9gWJ9bNhgEsV1DlN9BOLH2UIUAeFEAkL8QCs8FRoEaFTrYeGuaDf0vMKtNcOZCMS5+Mk6+ngRxy0z7ex6CfQS4HiOSRUnCw7xXVybMFVL4HyK+wE6luP5yqKKHjkI0FA2xJhux795UYaZz5QE4gLqtegS9PvO8lKW0dEnc8cB9pgaTIDjPu7ki2DwdLQp2qSzfCrLkfsV8jBNT+BCVncDwp+n33T6tbOqLBpAVPRr0T8jO/7pGY+yNi66djv7bof/Bzr7e0bJ1H0lUBYB+oa43vdM1A0M3eAQF69N5RCIgHAM+h59Q/xAHCoNHASo3LgLYXe0B3oRGnhftjVNT+BmVnc7+ViOf6ZC75p+N9dKIA8C9B+rYml/YIgA8cQ8PMjCyjhL8N/ou+j79B+3DmL1tB05FRe3c74KvR7FXT1LI9NoBK5n9wtQvAovFJNQxa2XJgm0jgB9TNzBFJM/PrdHjhpGbwlxUTnuMjoKnUQf88BUWU4aBKiYzdjhzWgv5AWgqejN/H0MzcY7+s7yt1SGF2hn5uYWLSZA/xMXpLtBoRsg4hS0aXYE4oaRo9GR9D8X9WexKAgAPoZre6K3oABvGo7AVWze/wv/tuGycGsJSGAyAvRPa/J9NyBEgIjPT5tsW7+blkD0UUeg/yIgjJ9ungPc+XwRHf//Risg08wE/s4m56FfoXNiCVA7fECYJFAVgU5g2IryXohiuQWyDwPCACn6sOPQEREE4mKCaXoC8ZDGeGfPMjr+i+j0H5p+F9dKQAJVEqArW4by4lR2BIRucIiHVk3TEDAILA4nOvc4bxad/bjo8ONirkkCEsiMAIFhLiZ3g0IsI0hEsDB1CBgEHpu6OG6rWohieT6dfgyVTBKQQMMIEBTidNHz0IvQgs5yJZatTW0MAvGg1dloIfo5ik4/bqcySUACLSNAUFgalyMoxLXRBejFqFVBoQ1B4G4qtftLfyGf4zZNO31AmCQggYkEOkEh7j5a0FGMGFZGjU1NDALRwf8GndHRuXb6jW2/OiaBUgl0gsKWFLJtR89nGaOHxqSmBIHLqJFup38Wnf7fGlNDOiIBCSRDgKCwCsa8FHWDwkbJGDdLQ3INAvEE3OlovOOn048nc00SkIAEKiVAUIgnmbsBYTs+ZzfDQk5B4H8A/BP0Y3QOHf8jLE0SkIAEkiBAQFgKQ+LBtR3RDuhZKPmUchCIu3jORNHxx8uY/5I8TQ2UgAQk0CFAUJjLx5h4MwLCy1CSdx2lFgTitM6J6CT0Czr+B1maJCABCWRNgICwLA68BL0KvRolMyFeCkHgYoBEx38Cnf6FLE0SkIAEGk2AoLA5Du6MIiA8u05n6wgCcS7/l6jb8V9dJwDLloAEJFAnAQLCPMrvBoSt+RzXFipLVQWBh/DoZ+hY9EN+8d9emYcWJAEJSCATAgSENTE1AsKuaBu0DCo1lRkEouOPWzij4z+Rjv+OUj0xcwlIQAINIkBAWAN34nRRBIS4DbWUgFBmEHi8HT/VZpKABCQwIoFOQCjlDEppQYAAsOitZSP67+4SkIAEWk+AQFDKu1+WbD1ZAUhAAhJoMQGDQIsrX9clIAEJGARsAxKQgARaTMAg0OLK13UJSEACBgHbgAQkIIEWEzAItLjydV0CEpCAQcA2IAEJSKDFBAwCLa58XZeABCRgELANSEACEmgxAYNAiytf1yUgAQkYBGwDEpCABFpMwCDQ4srXdQlIQAIGAduABCQggRYTMAi0uPJ1XQISkIBBwDYgAQlIoMUEDAItrnxdl4AEJGAQsA1IQAISaDEBg0CLK1/XJSABCRgEbAMSkIAEWkzAINDiytd1CUhAAgYB24AEJCCBFhMwCLS48nVdAhKQgEHANiABCUigxQQMAi2ufF2XgAQkYBCwDUhAAhJoMQGDQIsrX9clIAEJGARsAxKQgARaTMAg0OLK13UJSEACBgHbgAQkIIEWEzAItLjydV0CEpCAQcA2IAEJSKDFBAwCLa58XZeABCRgELANSEACEmgxAYNAiytf1yUgAQkYBGwDEpCABFpMwCDQ4srXdQlIQAIGAduABCQggRYTMAi0uPJ1XQISkIBBwDYgAQlIoMUEDAItrnxdl4AEJGAQsA1IQAISaDEBg0CLK1/XJSABCRgEbAMSkIAEWkzAINDiytd1CUhAAgYB24AEJCCBFhMwCLS48nVdAhKQgEHANiABCUigxQQMAi2ufF2XgAQkYBCwDUhAAhJoMQGDQIsrX9clIAEJGARsAxKQgARaTMAg0OLK13UJSEACS4tgcgJjY2NfYM1bJl/rtxJoJIGl8Go5FP3CI+hh9AC6u6O7WN6MbuzoBpZ/RpfNmTMnPpsyJDCHzm6sDLtpFHPKyLeqPMESB8KP0PZVlWk5EsiYwD3Yfhm6GJ3b0e/oBiKYmAogUFpfXVrGmQeBqDPYrMzibPSs+N8kAQkMReA+tj4fnYF+RJdw0VB7u/EEAqX11aVl3IAgEDUAn7ksfo2eEv+bJCCBWRP4C3v+GJ2MTqOLeGjWObVwx9L66tIybkgQiLYGo2ez+CWKkYFJAhIYnUBcW/gmOoKu4orRs2t+DqX11aVl3KAgEM0LTtuxiF8xca3AJAEJFEMgrkmehb6KjqXbKOUaZTGm1ptLWX21t4gOWK80ztPZ9O0Dbu5mEpDAYATiBpJt0PfRRXR0Ow22m1sVRcAgMARJAsERbH7gELu4qQQkMDiBuAHjZALB2eglg+/mlqMQ8BbRIenROOOXy1ForyF3dXMJSGA4Asex+T78+Lp9uN2auTV9TymnygwCs2gv1MWy7Banh+bPYnd3kYAEBicQD6a9sXM6dvC9GrhlWUHA00GzaCw0yAfZbRf0p1ns7i4SkMDgBJ7EpqfSAR6K4mlmU8EEHAmMAJRGOY/d4xmCJ46QjbtKQAKDEYinkV/Bj7AYHbQuORJIsMppjFdj1itRPBlpkoAEyiUQz+v8gs5wnXKLaVfung4asb4JBOeRxZ7o0RGzcncJSGBmAhuwSQSCp828qVsMQsAgMAilGbYhEJzIJu+bYTNXS0ACxRCYRzYRCDYsJrt25+I1gQLrn0b5RbJ7f4FZmpUEJDA1gZiLaDN+hN029SbNWUP/Usotoo4Eim0jHyK744vN0twkIIEpCMSkjt+cYp1fD0jAIDAgqEE24xdJXBd4HYo7hkwSkED5BHbiB/K7yy+muSV4OqiEuqVRrkW2EQjWKyF7s5SABCYSiLefbcmPsLiFtLHJ00EZVS2N8VbMfQW6IyOzNVUCuRKIh8iOoZNcIVcH6rTb00El0ScQXEbWr0bxK8UkAQmUS2Bjst+n3CKambung0quV36dvJYijkFZv3O5ZExmL4EiCFxPJuvzAyymdWlc8nRQplVKg/wepn80U/M1WwI5EYhXwcaNGaYhCDgSGALWKJsSxePNSQ5XR4HovhKYmUCcht2YH1+Ne4LfkcDMlZ/6Fu/EwFNSN1L7JJA5gY2w/zWZ+1Cp+V4Yrgg3v0weoajd0YUVFWkxEmgrAadwGaLmPR00BKwiNmVI92TyiWcInAmxCKDmIYHFCcT0Ck/mh9dNi6/K9xtPB+VbdxMsp2HewBc7oLsmrPAfCUigKAJxJ96risqs6fk4EqiphonqS1G0p+Nq4m+xkxKIh61WQauieKNXzN+/OYrXqMadNzmlk/jBFc/pNCaVNRIwCDSmieiIBMohQOcTv6xfjN6A9kbLoNTTrQSBJ6Ru5DD2GQSGoeW2EpBAKQToiNYn44PRrqUUUGym6xEIrio2y/pyKysIeDqivjq1ZAlkR4BO9Qq0G4a/Fd2fuAPPT9y+JMwzCCRRDRohgbwIEAiOwOJ4v3bKc2PFMwOmGQgYBGYA5GoJSGByAgSCM1mz1+Rrk/h23SSsSNwIg0DiFaR5EkiZAIHgOOz7WqI2zkvUrqTMMggkVR0aI4EsCXwYq1N8d0Y8mGmagYBBYAZArpaABKYnwGggHnz84vRb1bJ2pVpKzaxQg0BmFaa5EkiUwHcStOtxCdqUnEkGgeSqRIMkkB8BRgPXYPV5iVluEBigQgwCA0ByEwlIYCACxw+0VXUbLVtdUfmWZBDIt+60XAKpEbggMYN8pesAFWIQGACSm0hAAgMRuHSgrdwoKQIGgaSqQ2MkkDWBa7H+oaw9aKHxBoEWVrouS6AMAlwcHiPfe8rI2zzLI2AQKI+tOUugjQQ8D59ZrRsEMqswzZVA4gSWT9w+zesjYBDoA+K/EpCABNpEwCDQptrWVwlIQAJ9BAwCfUD8VwISkECbCBgE2lTb+ioBCUigj4BBoA+I/0pAAhJoEwGDQJtqW18lIAEJ9BEwCPQB8V8JSEACbSJgEGhTbeurBCQggT4CBoE+IP4rAQlIoE0EDAJtqm19lYAEJNBHwCDQB8R/JSABCbSJgEGgTbWtrxKQgAT6CBgE+oD4rwQkIIE2ETAItKm29VUCEpBAHwGDQB8Q/5WABCTQJgIGgTbVtr5KQAIS6CNgEOgD4r8SkIAE2kTAINCm2tZXCZRIYGxsbBmyX67EIsy6BAIGgRKgmqUEWkpgTfxO6R3DKdmSbJMwCCRbNRomgewIzEvM4kcTsydJcwwCSVaLRkkgSwLbJGb1vYnZk6Q5BoEkq0WjJJAlgVcmZvWdidmTpDkGgSSrRaMkkBcBLgrPx+ItE7P6xsTsSdIcg0CS1aJREsiHAAFgKaw9OEGLr0nQpuRMMggkVyUaJIHsCByIxS9I0OorE7QpOZMMAslViQZJIB8CjAL2xdoPJ2rxxYnalZRZSydljcZIQAJZEKDzXwFDv4DenrDBFyVsWzKmORJIpio0RALpE4jz/2gPLI0ONuUA8Dfsuyx9ovVb6Eig/jrQAgkkT4COfyWMfBN6P5qHUk8L58yZ48NiA9SSQWAASG4igbYRoNNfDZ83Qdugl6G48LssyiWdkYuhddtpEKipBjjI3kXRKd5RURMRi62ZQNzmGb/2n4DWR49HOafTcza+StsNAlXSnljW1vy7+8Sv/E8CEiiAwIWcCvJ6wIAgvTA8ICg3k4AEsiFwVDaWJmCoQSCBStAECUigMAKPkNMxheXWgowMAi2oZF2UQIsInMCpoJta5O/IrhoERkZoBhKQQEIEDkrIlixMMQhkUU0aKQEJDEDgFEYBFwywnZv0EDAI9MDwowQkkDWBA7K2vibjDQI1gbdYCUigUALfYRTwq0JzbElmBoGWVLRuSqDBBG7Htw802L9SXTMIlIrXzCUggQoIfJBRwK0VlNPIIgwCjaxWnZJAawj8mADwrdZ4W4KjBoESoJqlBCRQCYE/UsqelZTU4EIMAg2uXF2TQIMJxHWAVzIKiPcGmEYgYBAYAZ67SkACtRB4iFJ3JQBcUUvpDSvUINCwCtUdCTScwH34tzMBYGHD/azMPaeSrgy1BUlAAiMSuIP9dyIAnDNiPu7eQ8Ag0APDjxKQQLIErsey7QkAf0jWwkwN83RQphWn2RJoEYEz8fUFBoByatwgUA5Xc5WABEYncA9ZvJ3Of1v0l9GzM4fJCHg6aDIqficBCdRN4CwMeBOd/9V1G9L08h0JNL2G9U8CeRG4BHP3Qv/LAFBNxTkSqIazpUhAAtMTOJfV8UKYk+n8x6bf1LVFEjAIFEnTvCQggWEIxPuAT0efp+P/2TA7um1xBAwCxbE0JwlIYGYCD7NJ3Of//RCd/y0z7+IWZRIwCJRJ17wlIIGY4uF3KE73nIF+SsfvfD+ASCUZBFKpCe2QQL4E4rROTOh2I7q8R9H5X0Sn/wBLU6IEDAKJVkwNZu1HmefVUK5F/oPAUnw8Cq32j6+S+vRBrPktehBFxx7z+MTLXP5KR/8oS1OGBAwCGVZaSSafz4F8Skl5m+2ABMbGxj7HpgcOuHnVm8Vtm1+sulDLK5eAzwmUy9fcJTAsga+wQ5xaSTHtQJCan6Jh2jR7AgaB2bNzTwkUToBf2neT6cGFZ1xchp8tLitzSoGAQSCFWtAGCUwkcBj/3jzxq2T+ez6jgd2TsUZDRiZgEBgZoRlIoFgCjAbigmuq1wXC2QMJBMsU67W51UXAIFAXecuVwPQEDmd1qjNnboBt+0xvvmtzIWAQyKWmtLNVBBgN3I/Dn07Y6U8wGlg5Yfs0bUACBoEBQbmZBGog8E3KvKaGcgcpci02+rdBNnSbtAkYBNKuH61rMQFGA/FQ1qcSRvB+RgNrJ2yfpg1AwCAwACQ3kUCNBOIJ4itqLH+6oldkZcpBajrbXdchYBCwKUggYQKMBmLWzZjSI9X0JkYDz0jVOO2amYBBYGZGbiGBugkcgwF/qtuIKcqPqWc+M8U6v86AgEEgg0rSxHYTYDQQk7P9R8IUdmY0sFXC9mnaNAQMAtPAcZUEEiJwHLbE1MypJqeTSLVmZrDLIDADIFdLIAUCjAbGsOPjKdgyhQ0vYjSwyxTr/DphAgaBhCtH0yTQS4BAcBL/x3z+qaaDCATxTgRTRgQMAhlVlqZKAAIpjwbiLqG3WEt5ETAI5FVfWttyAowGTgXBOQlj2I/RQDw/YMqEgEEgk4rSTAn0EEh5NPAk7PxAj61+TJyAQSDxCtI8CfQTYDTwM777ef/3Cf2/L6OBmFvIlAEBg0AGlaSJEpiEQMrPDcTsop+YxGa/SpCAQSDBStEkCcxEgNHAL9nmtJm2q3H9PowG1q+xfIsekIBBYEBQbiaBBAmkPKdQvHnM6SQSbDT9JhkE+on4vwQyIcBo4FxMPTlhc3dlNLBFwvZpGgQMAjYDCeRN4JOYH08Tp5jmYJTTSaRYMz02GQR6YPhRArkRYDRwATYfn7DdCxgN7Jiwfa03zSDQ+iYggAYQ+CQ+pDoaCLwHEwjsa4JEgsmKSbBSNEkCwxBgNHAJ2393mH0q3nZTytu74jItbkACBoEBQbmZBBInEK95fCRhG/dnNLB8wva11jSDQGurXsebRIDRwKX4E+8jTjXNxbD3pmpcm+0yCLS59vW9aQQ+jUMPJ+zURxgNrJGwfa00zSDQymrX6SYSYDRwJX59I2HfVsO2lCe/SxhdeaYZBMpja84SqIPAgRT6YB0FD1jmOxgNzBtwWzergIBBoALIFiGBqggwGriWsr5eVXmzKGc59jlgFvu5S0kEDAIlgTVbCdRIIObsub/G8mcqek9GA5vNtJHrqyFgEKiGs6VIoDICjAZuoLDDKitw+IKcTmJ4ZqXtYRAoDa0ZS6BWAodQ+r21WjB94dsyGth2+k1cWwUBg0AVlC1DAhUTYDRwC0V+ueJihy3uEAJBjApMNRIwCNQI36IlUDKBz5P/3SWXMUr2m7PzXqNk4L6jEzAIjM7QHCSQJAFGA3dg2BeTNO4fRn2a0UDcMWSqiYBBoCbwFiuBiggcSjl/rais2RQzj53eOZsd3acYAgaBYjiaiwSSJMBo4C4Mi9NCKaePMRpYNWUDm2ybQaDJtatvEniMQFwgvi1hGDGf0EcTtq/RphkEGl29OieBJZZgNHAPHOKW0ZTTexgNxEyjpooJGAQqBm5xEqiJQDw8dlNNZQ9S7ApstP8gG7pNsQQMAsXyNDcJJEmA0cB9GHZQksb9w6i9GQ3EW8hMFRIwCFQI26IkUDOBmFju+pptmK746I9SP201nf1ZrjMIZFltGi2B4QkwGniAvVKfwXMHRgMLhvfOPWZLwCAwW3LuJ4E8CcRLZ65O3PTPJm5fo8wzCDSqOnVGAtMTYDTwEFvsP/1Wta/dgtHA7rVb0RIDDAItqWjdlEAPgXgh/eU9/6f48UACwTIpGtY0mwwCTatR/ZHADAQYDcTL6D85w2Z1r94AA/ap24g2lG8QaEMt66MEFidwDF/9cfGvk/rmE4wGVk7KogYaYxBoYKXqkgRmIsBo4FG2+cRM29W8fi3K37dmGxpfvEGg8VWsgxKYksBxrLl4yrVprPgAo4G10zClmVYYBJpZr3olgRkJMBoYY6PURwMrYuOnZnTGDWZNwCAwa3TuKIH8CRAITsKL8xP35E2MBp6RuI3ZmmcQyLbqNFwChRH4j8JyKiejpcn2M+Vkba4GAduABFpOgNHAqSD4VeIYdmY0sFXiNmZpnkEgy2rTaAkUTiD10UA4/LnCvTbDJQwCNgIJSCBePPMzMCxMHMVWjAZ2TtzG7MwzCGRXZRosgdII5DAa+AyBYKnSCLQwY4NACytdlyUwGQFGA2fz/WmTrUvou7hL6C0J2ZO9KQaB7KtQByRQKIHUnxsIZ/djNBDPD5gKIGAQKACiWUigKQQYDfwGX05O3J8nYd8HErcxG/MMAtlUlYZKoDICMRqIp4lTTvsyGoi5hUwjEjAIjAjQ3SXQNAKMBi7Cp+MT9ytmF83h1FXiGJfwFtHka0gDJVAPgf0o9tF6ih641H0YDcR7B0wjEHAkMAI8d5VAUwkwGvg9vn03cf/izWMHJm5j8uYZBJKvIg2UQG0EYvbOR2orfbCCd2M0sMVgm7rVZAQMApNR8TsJSCCeIr4MDPE+4pTTHIz7bMoGpm6bQSD1GtI+CdRLYH+Kf6heE2YsfQGjgR1n3MoNJiVgEJgUi19KQAJBgNHAVSy+mQGNgwkE9mezqCihzQKau0igZQQOwN8HEvd5U+zbO3EbkzTPIJBktWiUBNIhwGjgOqw5PB2LprRkf0YDK0y51hWTEjAITIrFLyUggT4CB/H/3/u+S+3fuRj0ntSMSt0eg0DqNaR9EkiAAKOBGzHjsARMmcmEjzAaWGOmjVz/DwIGgX+w8JMEJDA9gUNYfe/0m9S+djUs+FjtVmRkgEEgo8rSVAnUSYDRwK2U/+U6bRiw7HcyGpg34LZZbIY/8TxEKckgUApWM5VAYwl8Hs/+lrh3y2Ff3NHUpBQT5pWRHjAIlIHVPCXQUAKMBu7AtUMzcG9Pfj1vnoGdg5q4+qAbDrnd/QaBIYm5uQQkMB4E/po4hzh9EtcwmpJKCwJziJYPQ6mMFzcvz6+G1B8waUoD0Q8JSKDBBOinF+DeWSW4eE2MBO4vIePI0tu0SgJrthKQQOsIlDUSuD2CQFkPgJRldOtqX4clIIHWE1i7JAI3ORIoiazZSkACEiiQwGYF5tWb1XgQuKv3mwI/OxIoEKZZSUACrSaweUnejweBeBy8jPTEMjI1TwlIQAJtIsBF4bhx559K8vmqOB1UVhAoa/hSEguzlYAEJJAkgY2xavmSLPtTmUHguSUZbbYSkIAE2kSgrFNBwXA8CFxTEs1nM4xZuqS8zVYCEpBAWwjML8nR23mW67YYCfyxpALi5Q7PLClvs5WABCTQeAL8kI4++pUlOXpx5BsF/KGkAiLb55WYt1lLQAISaDqBrXDwCSU5+evId0mGAzezLGsekG1LMt5sJSABCbSBwM4lOnlu5B0jgUgXPbYo/O9ODGfKuqpduLFmKAEJSCAxAmUGgcdGAh2HzynJ8ZXId/uS8jZbCUhAAo0lwA/oTXFu/ZIcvIyzQLdE3t2RwK9KKiiy3bXEvM1aAhKQQFMJvKVEx07r5j3+yjIiTsz4eRsq4xVmd5HvE4g6D3YLdSkBCUhAAlMToE+Osyh/QatMvdVIa3akT/5J5DA+EuCfeFvQ70bKcuqdV2XVK6Ze7RoJSEACEugj8Eb+LysAxHteFqLx1D0dFP+MR4XHvi787/sKz9EMJSABCTSQAKOAOCPz7hJdO4sf/vd1868qCCzAsed0C3UpAQlIQAJTEoibaTaacu3oK77fm0VvEIiLw3f2riz48wcLzs/sJCABCTSRQJlnTuLa7A97oS0KAgwPHmHFyb0rC/68O6OBuQXnaXYSkIAEGkOAPvLFOFPmbfWn0ddP+LG/KAh0KP5XiTRjMrn3lpi/WUtAAhLIncBnS3ZgsT5+wi2hRKHoqOO2pLLmqribvDckEsVUFSYJSEACEugQoP99DR+PKxFIPAYwl/437g5alCaMBFj5MGsmXDRYtGUxH1YmmwOKycpcJCABCTSDQOcH+GdK9uZb/QFg0vIw5jmozPQImT970sL9UgISkEALCdAnvr3MTreT9+B3HLHDOSUb9NMW1rMuS0ACEliMAH3tKuimkvvcMxcruPPFhNNBPRsd1vO5jI/b4PCrysjYPCUgAQlkRuBz2PvEkm2OMiZNEy4Md7egg16Oz9ejNbvflbD8M3luyjkq5xQqAa5ZSkAC6ROgr90GK8s+M3Ix/exmU9GYdCTQuXhQ9mhgQ4z65FSG+b0EJCCBJhMgADwO/w6vwMfZ3XaKgWugu1GZ6WEyf0EFECxCAhKQQFIE6Pu+VGbn2sn7CpZx6//sEjt/rgIjL6WMFWZnoXtJQAISyI8Afd5WKO6ULDvtMRIdrHsSur9sK8n/SyMZ6s4SkIAEMiFAf/c49McK+tVzKWPS675DoSKTz1Zg7KOUsWAow9xYAhKQQIYE6Ou+VUGfGkVsXQgeMop7WG+OHEtOV5H/6oUYbSYSkIAEEiRAH/fWkvvRbvYTZgodGUWFhv+Esia9Y2lkJ8xAAhKQQI0E6Ns2Q39HZaeHKGDwp4MHYUKGS6KLyra8k//+g9jkNhKQgARyIUDftiq6vKI+9CulcMH4l1bkQFwfeGUpTpipBCQggRoI0KcdV1H/eRflrFWai2T+w4ocuZNy4mEykwQkIIGsCdCX7VtRvxnF/FupsChgffRAlFRBuoQyVizVITOXgAQkUCIB+rDXoCqeB4gu+Xw0+wfDBuVAIYdEaRWlGHksNahtbicBCUggFQL0XVui+yrqK+N5rk0q8Z2C4kGHeMq3qvSflThmIRKQgAQKIkDn+DRUxa313X74IwWZPlg2lLoFituQqkofH8wyt5KABCRQLwE6xdXRn6rqHCnn16j6MyYUuh+qMr2p3qq1dAlIQALTE6BDXBYtrLBjjOcOnjG9VSWtpeClUcxNUVWKkceOJbljthKQgARGIkD/FM9THVNVh9gp54MjGT3qzhixEbq3QqejrC1Htdv9JSABCRRJgH5pDjqywr4wijob1T/DAka8I6ypMN1OWZsXWYHmJQEJSGAUAvRJh1XYB0ZR96B0nqXCmFPDqgqTgWCUFuu+EpBAYQTo9w6tsO/rFrVbYQ4UkRFWxXsHbu1aV9HSQFBE5ZmHBCQwawL0dQdX1N/1FjO710XO2ssBd8TC+ejBXksr+GwgGLB+3EwCEiiWAP3bJyvo4/qLOJMvqr8ddFB0GPf2fosr+N9AMGgFuZ0EJFAIAfq1j1fQt/UXcQ1frFmIA2VmgpFf67e8gv8NBGVWqnlLQAKLCNCfVfHu9f5uM54HeO4iI1L+gKHLoF/0e1DB/zGF6vyU2WibBCSQLwH6l3gO4PAK+rLJiviXrMjhwRNQDF2qTjGJ0muygqWxEpBA8gToV+LH7fer7tA65R2WPKDJDMT4zVGVD5J16yembd1nMpv8TgISkMCwBOhPYtLMU7odTMXLX1LessPanMz2GP/aioH1FvcfyYDQEAlIIEsCdCjxWsh4MreO9HsKXT1LcL1G48R+ddDrlPn/WNb/WHUvED9LQAJZEKDveDKq6t3qnS5r0eJaPs3NAtQgRuLMlxe5Vv2HOI+3/CB2uo0EJCCBIECfsRm6rvruarzE2/i7caNqAodicqVvj7tXz5+Y7XTtRkHVGQlIoBQC9BU7orvr6arGr6O+oBTH6s4UoDH19Ak1gY1iI6o78VzdDcHyJZAwAfqId6OHUR0ppsvfIWE8o5uGg8uhn9ZBt1Nm3K3kLaSjV6U5SKBRBOgXlkJ1nrZ+lPLf0CioUzmDoyuhKl9GQ3ETUsD+2FT2+b0EJNAuAvQH0Sf9aEIvUf0/H2oVdfiugS6pnvOEEo/mPy8Yt6rl6awEJhKgD5iH6roDqNshHTzRqpb8h/dx+9UVXQo1LWNE0pzbsFrSdnRTAkUQ4NjfDsWdOHWmdgaAbgVCfl1UdyC4BRte1rXJpQQk0HwCHPMfQTG7QJ3pwOaTHsBDaiBGBH+ssyYoOxpDTA07ZwCT3UQCEsiUAMf4yuh4VHfaP1OE5ZhNbcSEcxfXXSuU/2O0RjlemqsEJFAnAY7tZ6C6f3Biwth+dXJItmzAxMXi84JQzekqys9j3u5ka1PDJJAWAY7pXdDfUN3p42mRScwaamcVVNdkTb2NI6akdibSxNqH5khgWAIcx/GQ6iEobg2vO310WPtbuT21tCL6ad211Sn/OyxXbmVF6LQEMifAsRu3f57TOZbrXMQ1x3/NHGe15gNseZTCxZtoOFegZs7lUW21WpoEKiPAMbsbuhPVnXzR1WxrnZqLV7l9pe4a7JQfc3rE3UNOSz3bCnU/CVRAgGN0BVTHe84pdrEUQchX3o5a70DcF6VwPi9q+OdonVF9cn8JSKB4Ahybm6C6ZyLAhPF0A3+fVbyXLc0RmHugGFalkP6KEbu1tCp0WwJJEuCYfBu6L4UOAhsuRfOSBJWzUUCdj6IDTiUdiSEr5sxU2yWQOwGOwbi1/AepdArY8Ru0Zu5ck7UfuDHcuwalkv6MIS9KFpiGSaDBBDj2dkQ3ptIZYMcPkT8My25zQI5pJiLappLi9q8voBXK9t38JSCB8Vc/xtQPh6fSAXTsOIil085U1UCBHbeQHtWBn8riTxjiraRVNQLLaSUBjrGXoCtTOeixI65Vvq6VlZGC08D/EIpf4qmksOWzaLkU+GiDBJpCgGMqfvjFiDul4/1m7HlhUxhn6weV8HKU0gVjzBn7A3p+tlA1XAIJEeBYei76PUopxYSXT00IU7tNoTI2QinMDtjbSONl1XGecNl2147eS2B2BOLYQZ9C8bBmSulEjFlpdl65V2kEqJSYfK7u94RO1lBjVLB1aY6bsQQaSIBjZisUx05KKR5aPQA5c0CqbS4qp1NJqTxhjDnjKez5OlotVXbaJYEUCHCMxEvfY7qYlM79Y874KeedUmCkDQMQoMLiOsGtUXOJpbinefcBXHATCbSOAMfGDujaxI7ZMOdCtF7rKiR3h6m0uei/UYop3mC2bu6MtV8CRRDgWFgLHZ3igYpN30DLF+GnedRAgMqLF0p8HqWY7sGoD6ClakBjkRJIggDt/3XoNpRaivv/35oEJI0YnQCV+WqU2m2k3Ub/Wz74OsvRq9kcMiJAm98Ando9CBJbXoU9HpMZtaeBTKVSn4bOQymmuAh2GPIl9wPVphvlSoA2Hg99xW2f8Us7xRS3f3oc5trAZrKbyo37jr+EUrt7CJPGUwyL34a8BW2mynR9dgRo1zHh2xUoxfR3jHpXdlA1eHYEqOztUUqzD/YfFDFi8Ynj2VWveyVGgLa8LjoBpZriaeR/Sgyb5pRNgEpfE6XcMGO0cgRaq2wW5i+BMgjQdmPk/e/oXpRq+iqGOQNwGQ0glzxpAHH6JeVGGhe034m8iyiXRqWdS9BeX4b+hFJNt2PYLlaVBMYJ0Bg2QqleNO4eRBfx4SVWmQRSJkAbjRswftBttIkuf45dc1PmqG01EKBRLIMOQqk9ro5JE9Lx/LdhDYgsUgJTEqBNxtxdh6BU7/rBtLEH0ceQN15MWZOuiGHs1uhylHKKxvx/0OOtMgnUSYA2uBTaB92CUk7/g3Gb1cnKsjMiQGN5HIpONtVbSTFtPMX1gnixji+xyah9NcVU2t126Hco5fQwxsUI3yndm9LwqvSDhhOjgniZfOrpSgx0YroqG0eLy6KtPQP9OPWDAvviwvSWLa4qXS+CAI0oRgUpP2CGeYvSOXzaqgi/zUMC/QRoW49HMc1zai95waQJKUbwccx662d/Jfr/7AnQoHIZFcTR8H3k1Lezr2737CFAW4qbJt6PUp1/C9MWpRgVz+8x348SKI4Ajas7Kkj9DqI4Ih5A8WLu1YsjYE5tI0D72RnlcEo0fv3H/Fu+9rFtjbQOf2loW6FLUA4pHop5H/LCWB2NJdMyaS/PRWehHFK8X/zFmaLW7FwJ0OhiiByPxMfEUzmkqzDyjcgnj3NtdBXYTfvYGMXDXvHLOvUUt0rvj7w7roK2YRFTEKABxrzoZ6Bc0qUYugeaM4VLft1CArSHddE3UdxSmUOKmyA2bWFV6XKqBGiQr0O35HD0dGy8mOWrU+WpXdUQoA08EcUdP3ENKYd0N0a+G/nUbzVNxFKGIUDDXAN9A+WUfoOx2w3jp9vmT4A6Xx3FQ1QpT56IeRNSPJvw1Pzp60HjCdBQF6B4UCWn9AuM3brxldNyB6njFVFcy8rhdk/MHE838HePlled7udGgEa7LPoIihfK55ROxdgtcuOtvdMToE6jPcZplJtQLikeSjsUrTy9d66VQMIEaMBz0fdQbukEDPZtSwm3rUFMow5jgrd/QVejnNIvMdb2N0glu00eBGjQL0W5PFvQ7SziNsFj0NPzoKyVXQLU2ZJodxT30OeUbsbYvZF3r3Ur02VzCNCwl0bx+P1dKKcUT0h/Fz2rObXRTE+oo/jlvxf6A8opRRv7v2i1ZtaMXkmghwANfW30bZTDAzmYuSiFvSei5/e448cECFAn8fDim1AOUzxg5oT0a/57TgIYNUEC1RKg4b8I/XbC4ZDPP6djqq+7rLbJLFYadbAc+leU2zl/TB6Lu37ieoWnfharWb9oDYE4ANDe6DqUY4oLeNu3psIScRTmK6D3oOtRbuk+DD4AOdlbIu1JMxIgwAERB/XHUTwRmWM6D6Njxkl/1ZXYnuC7EtoX5XSrJ+aOpzideDRap0REZi2BvAlwgMRj/F9DuczhgqkT0u/475+RE9UV2BThuSr6GLoN5Zh+hdG+5avANmFWDSfAAbMJOiXHo71jc1ygjAuVyzS8qkp1D34xFcn+KKcnfDF3UYprFT7tW2orMfNGE+AA2hZdvOiQyu/DNZgc7zPwqc8hWiq81kFfQLmeHvwbtn8ULT+E224qAQlMRoADaUkUv6rjbopc050Yfgh6ymQ++t1jBOCzGToKPYRyTHG//+HoidapBCRQMAEOrJj865Mot/mIMHlRepBP30bPLhhP1tnBYzsUt93mnM7EeB8ozLolanwWBDjQnoSORPGrK+d0Bsa/PAvoJRiJ7/GA1+tRzqf7MH/sUvTKEhCZpQQkMB0BDrxnoZNQ7inuKIqHhlrxHmT8XAV9COV4jz9mL0ph/9vQ0tO1U9dJQAIlE+Ag3BLFr+rcU1zz+He0esnIaskev2JG2c+h3OaOwuQJ6Vb++yDyom8tLclCJTAFAQ7K+Sie4M09xTWPr6D1pnA1q6/xI0ZscR0krofknCJ47Ye80yurFqixrSPAQfpydD7KPcU1j2NRdnMUYXNMB7Ijyv1iLy6MxTQPMYJ5fOsOJh2WQM4EOGh3QXG+vQkpLp6+Ga2Qcp1gX5zvfy/6M8o9xcjlq+jJKTPXNglIYBoCHMDxjMGe6DLUhHQ7TsTzButO43blq7Dn6ShOYd2Nck8xAvsOWr9ykBYoAQmUQ4ADemkUv6TjCd4mpJhb6Ydom3KIzZwrZccpnx1QvJc5t3dDYPKk6QS+3XRm791CAhLIkgAH+LLoXehG1JR0CY7sg1asolIoJ075vAc1ZXSFK2M/RU7wVkUDSqwMp/1NrEKqMocD/nGU9Q70IdSUR/zvwpdvo/+cM2fOH1kWmmAWT8MGs71QU+bCX4gv+8PrLJYmCUigbQTo2JZH70bXoialhTgTL1ofaRZT9o+RU1xTORs1KZ2GMy9uW3vX38UJOBJYnEkrv6FDiM5yb/RhtEGDINyCL99Ah/Nr98pB/YLHhmz7NvRGtCZqSvoRjnwaFr9pikP6MRoBg8Bo/Bq3N51fvAwm5n//KNqkQQ6O4cuZ6OvoRDrBh/p9w/eYtuLVaB8UF5ybcnyE78ejA/D7IpYmCSwi0JRGvsghPxRDgA4x2sYu6GPoOcXkmkwuMTr4FjqSTjEmP3s6n9+CYiS0FmpKehRHvocOxM/fN8Up/SiWgEGgWJ6NzI1O8hU4FsHgRQ108Ap8atr98A/j09HoIDr/yxpYZ7pUIAGDQIEwm54VwWABPkYweFnTfc3UvwexO0Y4n6HzvypTHzS7YgIGgYqBN6E4gkHcTx7BwDnk06jQ+zHjSHQInf91aZikFbkQMAjkUlMJ2kkwiPvm4zmDuJA80q2YCbqXg0l/xcivoi/T+d+Ug8HamB4Bg0B6dZKdRQSDp2D0e1DcUrladg7kZ/DVmPwldASd/735ma/FKREwCKRUG5nbQjCIp2jjLpv3onnIVCyB88nuC+gHdP6PFJu1ubWVgEGgrTVfot8Eg3jWYFf0QbRFiUW1Ieu4x/8U9Dk6/oVtcFgfqyVgEKiWd+tKIyDEC2EiGMRFZNvb4C0g7vSJ2zw/T+f/h8F3c0sJDEfAg3I4Xm49SwIEg3gg6/0oHsjy3bRTc7yTVd2LvTdOvZlrJFAMAYNAMRzNZUACBIN4Ijdm4nwnis+mxwhcw+JQFE8x3yMUCVRFwCBQFWnLmUCAYBCjgTeguKuoSXMUTfBzgH/OZZu40+dYOv940tckgUoJGAQqxW1hkxEgIMRkbe9Gr0JLTrZNw76L8/0/QHF/v7N5Nqxyc3PHIJBbjTXYXoLBPNyLU0VvRmugpqV4oCvO93+Nzt+Hu5pWu5n6YxDItOKabDbBYAX82wvF6CCeSs49xa/9L6O4vz9GASYJSEACEhiEAAFhPjoWxYvlc0oPYuzRKOZZMkkgWQKOBJKtGg3rJUBnug7/x7QU8UTy2r3rEvt8PfZ8HcWbzDzlk1jlaI4EJJA5AYLBMijeHXwWSiU9iiGno11QPC1tkoAEJCCBsgnQ4W6MvoTuQHWk2yj08yjeR2ySgAQkIIE6CNAJL49ej85GVaSfU8ieaLk6/LVMCUhAAhKYggAd8zPRoSh+pReZbiWzL6CNpyjaryUgAQlIIBUCdNbLoT3QGegRNJsU+8W5/teiZVPxTTskIAEJSGAIAnTg66L90JVokBTb7YeeOkQxbioBCUhAAikToFOfg+ajI9FdqDfF//H9fOSt0ylXpLZJQAISGJUAHf0KKE4XfaOzjKeUTRJoHYH/D6njQSS9N1CCAAAAAElFTkSuQmCC"
          ></image>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconLive = (props) => (
  <Svg {...props} viewBox="0 0 22 16">
    <g id="Tournament-Page" stroke="none" fill="none" fillRule="evenodd">
      <g
        id="T-Overview-Checked-In"
        transform="translate(-1071.000000, -528.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-27" transform="translate(159.000000, 490.000000)">
          <g id="Group" transform="translate(875.000000, 22.000000)">
            <g
              id="icons8-youtube-live-copy"
              transform="translate(37.000000, 16.000000)"
            >
              <path
                d="M20,8 C20,10.481 18.991,12.731 17.361,14.361 L18.775,15.775 C20.766,13.783 22,11.033 22,8 C22,4.967 20.766,2.217 18.775,0.225 L17.361,1.639 C18.991,3.269 20,5.519 20,8 Z"
                id="Path"
              ></path>
              <path
                d="M2,8 C2,5.519 3.009,3.269 4.639,1.639 L3.225,0.225 C1.234,2.217 0,4.967 0,8 C0,11.033 1.234,13.783 3.225,15.775 L4.639,14.361 C3.009,12.731 2,10.481 2,8 Z"
                id="Path"
              ></path>
              <path
                d="M15.947,3.053 L14.533,4.467 C15.439,5.372 16,6.622 16,8 C16,9.378 15.439,10.628 14.534,11.534 L15.948,12.948 C17.215,11.68 18,9.93 18,8 C18,6.07 17.215,4.32 15.947,3.053 Z"
                id="Path"
              ></path>
              <path
                d="M6.053,12.947 L7.467,11.533 C6.561,10.628 6,9.378 6,8 C6,6.622 6.561,5.372 7.466,4.466 L6.053,3.053 C4.785,4.32 4,6.07 4,8 C4,9.93 4.785,11.68 6.053,12.947 Z"
                id="Path"
              ></path>
              <circle id="Oval" cx="11" cy="8" r="3"></circle>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconTimer = (props) => (
  <Svg {...props} viewBox="0 0 14 14">
    <path
      d="M7 14C3.13359 14 0 10.8664 0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7C14 10.8664 10.8664 14 7 14ZM6.34375 7C6.34375 7.21875 6.45312 7.42383 6.63633 7.52227L9.26133 9.27227C9.56211 9.49648 9.96953 9.41445 10.1473 9.11367C10.3715 8.81289 10.2895 8.40547 9.98867 8.20312L7.65625 6.65V3.28125C7.65625 2.91758 7.36367 2.625 6.97539 2.625C6.63633 2.625 6.31914 2.91758 6.31914 3.28125L6.34375 7Z"
      fill="white"
    />
  </Svg>
);

export const IconFire = (props) => (
  <Svg {...props} viewBox="0 0 11 14">
    <path
      d="M10.5 8.72544C10.5 11.6458 8.1457 14 5.25 14C2.3543 14 0 11.6449 0 8.75005C0 7.14579 0.760703 5.82973 1.49215 5.08325C1.90148 4.62934 2.625 4.91645 2.625 5.50981V7.8477C2.625 8.80938 3.3898 9.61138 4.35203 9.62341C5.3293 9.63872 6.125 8.84848 6.125 7.87505C6.125 5.4688 1.33711 5.24676 4.69902 0.295356C5.06816 -0.243863 5.90625 0.000864179 5.90625 0.651646C5.88164 3.4727 10.5 4.09341 10.5 8.72544Z"
      fill="white"
    />
  </Svg>
);

export const IconArrowRight = (props) => (
  <Svg {...props} viewBox="0 0 10.15 9.9">
    <path
      fill="#fff"
      d="M1159.63,3484.03a1.02,1.02,0,0,1-.72-1.74l3.22-3.21-3.22-3.22a1.018,1.018,0,0,1,1.44-1.44l3.93,3.94a1,1,0,0,1,0,1.43l-3.93,3.94a1.015,1.015,0,0,1-.72.3h0Zm2.86-3.94h-7.05a1.015,1.015,0,0,1,0-2.03h7.05a1.015,1.015,0,1,1,0,2.03h0Z"
      transform="translate(-1154.44 -3474.13)"
    />
  </Svg>
);

export const IconGameStop = (props) => (
  <Svg {...props} viewBox="0 0 295.2 72.17">
    <path
      class="a"
      d="M127.8,56.25H114.24V30.64c0-3.46-.39-5.95-2.26-5.95s-2.26,2.49-2.26,5.95V56.25H96.17V30.64c0-3.46-.39-5.95-2.26-5.95s-2.26,2.49-2.26,5.95V56.25H78.09V17.14H91.66V21.2a9.69,9.69,0,0,1,8.63-4.81c3.7,0,6.91,1.34,8.93,5.18a9.42,9.42,0,0,1,8.8-5.18c5.26,0,9.79,3.36,9.79,11.83ZM59.86,36.72c-1.81,1.5-4.53,3.07-4.53,7.83,0,3.2.82,4.51,2.27,4.51s2.26-1.31,2.26-4.51ZM57.94,16.39c9,0,15.48,3.12,15.48,12.94V56.25H59.86V52.86c-1.45,2.31-4.07,4.1-8.3,4.1-2.91,0-9.71-1-9.71-11.16,0-13.91,18-9.14,18-17.6,0-3.46-.82-4.87-2.27-4.87s-2.26,1.41-2.26,4.87v2.15H42.45v-1c0-9.82,6.49-12.94,15.49-12.94m92.7,24.14h12.88C163.34,51.93,156.77,57,147.7,57s-15.82-5.17-15.82-16.9V33.29c0-11.73,6.63-16.9,15.82-16.9s15.82,5.17,15.82,16.9v4.1H145.45v6.69c0,3.45.44,5.94,2.59,5.94s2.6-2.49,2.6-5.94ZM150,29.27c0-3.45-.39-5.94-2.26-5.94s-2.26,2.49-2.26,5.94v2.07H150ZM38,25.53v-2C38,10,29.92,6.34,21,6.34S4.14,11.15,4.14,24.69V38.6C4.14,47.71,8,57,18.33,57c4.74,0,7.78-2.29,9.09-4.46l1.07,3.75h9.44V30.35H21.53v8.36h3.69v1.75c0,4.25-.59,8.14-3.27,8.14s-3.26-3.89-3.26-8.14V22.64c0-4.14.27-7.94,2.35-7.94s2.35,3.8,2.35,7.94v2.89Z"
    />
    <path
      fill="#ee2a28"
      class="b"
      d="M222,55.43A19.92,19.92,0,0,1,214.22,57C207.79,57,204,53.34,204,46.38V22.32h-2.73V17.14H204v-5.3h13.55v5.3H222v5.18h-4.45V45.77c0,2.53.45,4.75,2.64,4.75A3.43,3.43,0,0,0,222,50v5.44M185.27,22.32h13.45v-2.1c0-9.61-6.42-13.88-15.94-13.88-9.1,0-15.94,5.09-15.94,14,0,16.7,18.9,13,18.9,24.33,0,3-1.17,4-2.59,4s-2.58-1-2.58-4V40.53H167v2C167,52.56,173.53,57,183.35,57c9.38,0,16.38-5.22,16.38-14.56,0-18.61-19.44-13.45-19.44-23.75,0-3,1.21-4,2.49-4s2.49,1,2.49,4Zm56.66,7c0-3.45-.39-5.94-2.26-5.94s-2.26,2.49-2.26,5.94V44.08c0,3.45.39,5.94,2.26,5.94s2.26-2.49,2.26-5.94Zm-2.26-12.88c9.19,0,15.82,5.17,15.82,16.9v6.77c0,11.73-6.63,16.9-15.82,16.9s-15.82-5.17-15.82-16.9V33.29c0-11.73,6.62-16.9,15.82-16.9m38,14.25c0-3.46-.39-5.95-2.26-5.95s-2.26,2.49-2.26,5.95V42.72c0,3.45.39,5.94,2.26,5.94s2.26-2.49,2.26-5.94Zm3.44-14.25c6.41,0,10.12,5.17,10.12,16.9v6.77c0,11.73-3.71,16.9-10.12,16.9a9.66,9.66,0,0,1-8-4.17V66H259.63V17.14h13.56v3.42a9.66,9.66,0,0,1,8-4.17m8.28,2.17a1.42,1.42,0,0,0,.53.53,1.35,1.35,0,0,0,.74.2,1.39,1.39,0,0,0,.72-.19,1.42,1.42,0,0,0,.53-.53,1.4,1.4,0,0,0,.2-.73,1.42,1.42,0,0,0-.74-1.26,1.38,1.38,0,0,0-.71-.19,1.53,1.53,0,0,0-.73.19,1.37,1.37,0,0,0-.53.54,1.39,1.39,0,0,0-.2.72,1.49,1.49,0,0,0,.19.72m.19-1.34a1.23,1.23,0,0,1,1.7-.46,1.27,1.27,0,0,1,.46.46,1.23,1.23,0,0,1,0,1.25,1.32,1.32,0,0,1-.46.45,1.14,1.14,0,0,1-.62.17,1.19,1.19,0,0,1-.63-.17,1.24,1.24,0,0,1-.46-.45,1.26,1.26,0,0,1-.16-.63,1.14,1.14,0,0,1,.17-.62m1.51-.1a.69.69,0,0,0-.47-.13h-.44v1.7h.25V18h.21l.41.68h.28l-.44-.74a.57.57,0,0,0,.26-.19.49.49,0,0,0-.06-.64m-.66.11h.17a.55.55,0,0,1,.29.06.23.23,0,0,1,.09.2c0,.2-.13.29-.38.29h-.17Z"
    />
  </Svg>
);

export const IconXplorer = (props) => (
  <Svg {...props} viewBox="0 0 708 71">
    <g
      id="Rival-Pay"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-20" fillRule="nonzero">
        <g id="Group-22">
          <path
            d="M132.8,71 L132.8,45 L177.2,45 C181.2,45 184.6,44.5833333 187.4,43.75 C190.2,42.9166667 192.483333,41.75 194.25,40.25 C196.016667,38.75 197.3,36.9666667 198.1,34.9 C198.9,32.8333333 199.3,30.5333333 199.3,28 L199.3,28 L199.3,17.6 C199.3,15.0666667 198.9,12.7666667 198.1,10.7 C197.3,8.63333333 196.016667,6.85 194.25,5.35 C192.483333,3.85 190.2,2.68333333 187.4,1.85 C184.6,1.01666667 181.2,0.6 177.2,0.6 L177.2,0.6 L119.5,0.6 L119.5,71 L132.8,71 Z M177.2,34.6 L132.8,34.6 L132.8,11 L177.2,11 C183.066667,11 186,13.1666667 186,17.5 L186,17.5 L186,28.1 C186,32.4333333 183.066667,34.6 177.2,34.6 L177.2,34.6 Z M291.1,71 L291.1,60.6 L234,60.6 L234,0.6 L220.6,0.6 L220.6,71 L291.1,71 Z M378.6,71 C382.6,71 386,70.5833333 388.8,69.75 C391.6,68.9166667 393.883333,67.75 395.65,66.25 C397.416667,64.75 398.7,62.9666667 399.5,60.9 C400.3,58.8333333 400.7,56.5333333 400.7,54 L400.7,54 L400.7,17.6 C400.7,15.0666667 400.3,12.7666667 399.5,10.7 C398.7,8.63333333 397.416667,6.85 395.65,5.35 C393.883333,3.85 391.6,2.68333333 388.8,1.85 C386,1.01666667 382.6,0.6 378.6,0.6 L378.6,0.6 L332.1,0.6 C328.1,0.6 324.7,1.01666667 321.9,1.85 C319.1,2.68333333 316.816667,3.85 315.05,5.35 C313.283333,6.85 312,8.63333333 311.2,10.7 C310.4,12.7666667 310,15.0666667 310,17.6 L310,17.6 L310,54 C310,56.5333333 310.4,58.8333333 311.2,60.9 C312,62.9666667 313.283333,64.75 315.05,66.25 C316.816667,67.75 319.1,68.9166667 321.9,69.75 C324.7,70.5833333 328.1,71 332.1,71 L332.1,71 L378.6,71 Z M378.6,60.6 L332.1,60.6 C326.233333,60.6 323.3,58.4333333 323.3,54.1 L323.3,54.1 L323.3,17.5 C323.3,13.1666667 326.233333,11 332.1,11 L332.1,11 L378.6,11 C384.466667,11 387.4,13.1666667 387.4,17.5 L387.4,17.5 L387.4,54.1 C387.4,58.4333333 384.466667,60.6 378.6,60.6 L378.6,60.6 Z M438.5,71 L438.5,39.6 L475.6,39.6 L492.1,71 L506.3,71 L489.7,39.4 C495.966667,38.8 500.433333,36.9833333 503.1,33.95 C505.766667,30.9166667 507.1,27.1333333 507.1,22.6 L507.1,22.6 L507.1,17.6 C507.1,15.0666667 506.7,12.7666667 505.9,10.7 C505.1,8.63333333 503.816667,6.85 502.05,5.35 C500.283333,3.85 498,2.68333333 495.2,1.85 C492.4,1.01666667 489,0.6 485,0.6 L485,0.6 L425.2,0.6 L425.2,71 L438.5,71 Z M485,29.2 L438.5,29.2 L438.5,11 L485,11 C490.866667,11 493.8,13.1666667 493.8,17.5 L493.8,17.5 L493.8,22.7 C493.8,27.0333333 490.866667,29.2 485,29.2 L485,29.2 Z M602.2,71 L602.2,60.6 L543.1,60.6 L543.1,39 L599.2,39 L599.2,28.6 L543.1,28.6 L543.1,11 L602.2,11 L602.2,0.6 L529.8,0.6 L529.8,71 L602.2,71 Z M638.8,71 L638.8,39.6 L675.9,39.6 L692.4,71 L706.6,71 L690,39.4 C696.266667,38.8 700.733333,36.9833333 703.4,33.95 C706.066667,30.9166667 707.4,27.1333333 707.4,22.6 L707.4,22.6 L707.4,17.6 C707.4,15.0666667 707,12.7666667 706.2,10.7 C705.4,8.63333333 704.116667,6.85 702.35,5.35 C700.583333,3.85 698.3,2.68333333 695.5,1.85 C692.7,1.01666667 689.3,0.6 685.3,0.6 L685.3,0.6 L625.5,0.6 L625.5,71 L638.8,71 Z M685.3,29.2 L638.8,29.2 L638.8,11 L685.3,11 C691.166667,11 694.1,13.1666667 694.1,17.5 L694.1,17.5 L694.1,22.7 C694.1,27.0333333 691.166667,29.2 685.3,29.2 L685.3,29.2 Z"
            id="PLORER"
            fill="#FFFF"
          ></path>
          <g id="Group-6-Copy-3">
            <path
              d="M64.564,41.345 L97.2,70.4 L80,70.4 L55.925,48.855 L64.564,41.345 Z M17.3,0 L41.409,21.722 L33.078,28.964 L0,0 L17.3,0 Z"
              id="Combined-Shape"
              fill="#FFFF"
            ></path>
            <polygon
              id="X-Copy-2"
              fill="#FFFF"
              transform="translate(48.600000, 35.200000) scale(-1, 1) translate(-48.600000, -35.200000) "
              points="48.6 42.3 80 70.4 97.2 70.4 57.1 34.7 48.6 28.2 17.3 0 0 0 40.2 35.2"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const IconEdit = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <path d="M13.893 5.066l5.04 5.04-9.898 9.9a2.24 2.24 0 0 1-.995.577l-5.096 1.39a.747.747 0 0 1-.917-.918l1.39-5.095a2.239 2.239 0 0 1 .577-.995l9.899-9.9zm7.063-2.022a3.564 3.564 0 0 1 0 5.04l-.966.966-5.041-5.04.966-.966a3.564 3.564 0 0 1 5.04 0z" />
  </Svg>
);

export const IconPoints = (props) => (
  <Svg {...props} viewBox="0 0 24 24">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor="#F35D7D" offset="0%"></stop>
        <stop stopColor="#DB3356" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-2">
        <stop stopColor="#B5B5B5" offset="0%"></stop>
        <stop stopColor="#FFFFFF" offset="51.1199738%"></stop>
        <stop stopColor="#B5B5B5" offset="100%"></stop>
        <stop stopColor="#ADADAD" offset="100%"></stop>
      </linearGradient>
      <path
        d="M15.48,0 L15.6948923,0.00461538462 C15.9725538,0.0169230769 16.2147692,0.0538461538 16.4215385,0.115384615 C16.68,0.192307692 16.8907692,0.3 17.0538462,0.438461538 C17.2169231,0.576923077 17.3353846,0.741538462 17.4092308,0.932307692 C17.4830769,1.12307692 17.52,1.33538462 17.52,1.56923077 L17.52,1.56923077 L17.52,2.52923077 L17.5130769,2.70057692 C17.4992308,2.86788462 17.4646154,3.02307692 17.4092308,3.16615385 C17.3353846,3.35692308 17.2169231,3.52153846 17.0538462,3.66 C16.8907692,3.79846154 16.68,3.90615385 16.4215385,3.98307692 C16.1630769,4.06 15.8492308,4.09846154 15.48,4.09846154 L15.48,4.09846154 L11.3815385,4.09846154 L11.3815385,6.49846154 L10.1538462,6.49846154 L10.1538462,0 L15.48,0 Z M15.48,0.96 L11.3815385,0.96 L11.3815385,3.13846154 L15.48,3.13846154 C16.0215385,3.13846154 16.2923077,2.93846154 16.2923077,2.53846154 L16.2923077,2.53846154 L16.2923077,1.56 L16.2866667,1.46416667 C16.2452991,1.12805556 15.9764103,0.96 15.48,0.96 L15.48,0.96 Z"
        id="path-3"
      ></path>
      <filter
        x="-61.1%"
        y="-69.2%"
        width="222.2%"
        height="238.5%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-5">
        <stop stopColor="#B5B5B5" offset="0%"></stop>
        <stop stopColor="#FFFFFF" offset="51.1199738%"></stop>
        <stop stopColor="#B5B5B5" offset="100%"></stop>
        <stop stopColor="#ADADAD" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="Rival-Coins"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="7---Wallet" transform="translate(-1263.000000, -26.000000)">
        <g id="Header-Desktop" transform="translate(1.000000, 0.000000)">
          <g id="Group-3" transform="translate(1167.000000, 26.000000)">
            <g id="Group-21" transform="translate(95.000000, 0.000000)">
              <g id="Group-6-Copy-10">
                <circle
                  id="Oval-Copy-6"
                  fill="#0C141D"
                  cx="12"
                  cy="12"
                  r="11.5384615"
                ></circle>
                <path
                  d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.8280543 C6.38218951,1.8280543 1.8280543,6.38218951 1.8280543,12 C1.8280543,17.6178105 6.38218951,22.1719457 12,22.1719457 C17.6178105,22.1719457 22.1719457,17.6178105 22.1719457,12 C22.1719457,6.38218951 17.6178105,1.8280543 12,1.8280543 Z"
                  id="Oval-Copy-9"
                  fill="url(#linearGradient-1)"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="Group-25" transform="translate(3.230769, 8.769231)">
                <g id="RP" fillRule="nonzero">
                  <use
                    fill="black"
                    fillOpacity="1"
                    filter="url(#filter-4)"
                    xlinkHref="#path-3"
                  ></use>
                  <use fill="#FFFFFF" xlinkHref="#path-3"></use>
                  <use fill="url(#linearGradient-2)" xlinkHref="#path-3"></use>
                </g>
                <path
                  d="M1.08965625,2.6895259 L6.68937903,2.6895259 C6.68937903,2.6895259 7.32714874,2.71180072 7.32714874,2.22175453 C7.32714874,1.73173823 7.32714874,1.60323191 7.32714874,1.60323191 C7.32714874,1.60323191 7.38815357,1.01039262 6.74047279,1.01039262 C6.09285119,1.01039262 1.08965625,1.01039262 1.08965625,1.01039262 L0.254109,0.0388513676 L6.75405243,0.0388513676 C6.75405243,0.0388513676 8.5614167,-0.0725227681 8.5614167,1.39758592 L8.5614167,2.26989207 C8.5614167,2.26989207 8.62753978,3.62506864 7.01857435,3.62506864 L8.56180131,6.49846154 L7.12913451,6.49846154 L5.67410125,3.62506864 L2.32386504,3.62506864 L2.32386504,6.49846154 L1.08965625,6.49846154 L1.08965625,2.6895259 Z"
                  id="Fill-4-Copy-10"
                  fill="url(#linearGradient-5)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const RivalShield = (props) => (
  <Svg {...props} viewBox="140.33 42.742 36.368 42.357">
    <g fill="none" fillRule="evenodd">
      <g transform="matrix(1.34959 0 0 1.34959 140.33 42.684)">
        <mask id="a" fill="#fff">
          <path d="M0 .043h26.945v31.381H0z" />
        </mask>
        <path
          d="M26.947 20.492V2.378S20.931.043 13.474.043C6.017.043 0 2.378 0 2.378v18.37c0 5.761 13.474 10.68 13.474 10.68s13.473-4.919 13.473-10.936"
          fill="#DB3356"
          mask="url(#a)"
        />
      </g>
      <path
        d="M148.747 70.786V59.781h16.35s1.863.065 1.863-1.351v-1.787s.178-1.713-1.713-1.713h-16.5l-2.44-2.807h18.98s5.276-.322 5.276 3.926v2.52s.193 3.915-4.504 3.915l4.506 8.302h-4.184l-4.248-8.302h-9.782v8.302h-3.604"
        fill="#FFFFFE"
      />
    </g>
  </Svg>
);

export const IconLFC = (props) => (
  <Svg
    x={0}
    y={0}
    viewBox="0 0 227.2 307.7"
    style={{
      enableBackground: 'new 0 0 227.2 307.7',
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        '.st0{stroke-linecap:round;stroke-linejoin:round}.st0,.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff;stroke:#fff;stroke-width:4.0448;stroke-miterlimit:30}.st2{fill:#00a88e}.st9{fill:#fff}.st10{stroke-linecap:round;stroke-linejoin:round}.st10,.st11{fill:#fff;stroke:#fff;stroke-width:4.0448;stroke-miterlimit:30}.st19,.st31,.st44{fill:#d71920}.st31,.st44{fill-rule:evenodd;clip-rule:evenodd}.st44{fill:#fff}'
      }
    </style>
    <linearGradient
      id="SVGID_1_"
      gradientUnits="userSpaceOnUse"
      x1={-791.648}
      y1={589.045}
      x2={-790.941}
      y2={588.338}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#20ac4b',
        }}
      />
      <stop
        offset={0.983}
        style={{
          stopColor: '#19361a',
        }}
      />
    </linearGradient>
    <path
      className="st0"
      d="M4.3 240.8s3.1 8.9 8.3 13.7c5.2 4.9 6.7 5.2 6.7 5.2s-1.7 2.3-7.1 6.6C6.9 270.7 2 272.8 2 272.8s6.9 4.6 17.5 4.6c14.7 0 27.1-6 27.1-6s-.7 3.4 10.3 17.6c7.3 9.4 9.7 11.8 13.4 14 9.7 5.8 17.8-2.8 40.6-2.8 20.2 0 33.4 5.4 36.9 5.4 4.6 0 7.4-.5 9.5-2.3 4-3.4 9.7-9.6 15.4-16.9 7.7-10 8-14.4 8-14.4s14.9 5.9 26.8 5.9c12 0 17.7-4.6 17.7-4.6s-7.7-3.9-11.8-7.7c-4.1-3.9-5.3-5.3-5.3-5.3s5-3.1 8.4-7c4.2-4.8 6.7-12 6.7-12s-9.8 7.4-28 .2c-13.6-5.4-18.3-8.7-18.3-8.7l-29.4 5.8-96.8-6.4s-9.8 5.9-22.3 9.9c-15.5 5.2-24.1-1.3-24.1-1.3z"
    />
    <path
      className="st1"
      d="m67.2 267.4 22.4-4 54-.3 14.5 4.9-2.1 8.4-78.2-.5z"
    />
    <path
      className="st2"
      d="M50.7 232.3c.3.7.7 1.4 1 2.1 0 .3-.2.2-.4.4-2.4 1.4-2.6 1.6-4.9 2.8-3.1 1.7-6.3 3.2-9.7 4.5-1.5.6-3.2 1.1-4.7 1.7-5 1.7-10.2 2.8-15.9 2.7-3.6-.1-7.2-1-10.5-2.6-.4-.9-.9-1.8-1.2-2.8.1-.1-.1-.2 0-.3 1.9 1.1 4 2.1 6.2 2.6 5 1.1 10.7.8 15.5-.5 4.3-1.1 8.5-2.7 12.6-4.4 3.5-1.5 6.9-3.3 10.3-5.2.5-.3 1.1-.7 1.7-1zM178.7 233.9c2.4 1.3 3.7 2.1 6.1 3.3.9.5 1.5.7 2.4 1.2 1.7.8 2.7 1.2 4.5 1.9 3.7 1.5 5.9 2.3 9.8 3.3 2.4.6 3.8.9 6.3 1.1 3 .2 4.7.3 7.7-.3 1.6-.3 2.5-.5 4-1 1.4-.6 2.3-1.2 3.5-1.8.1 0 .1 0 .1.1-.1.7-.5 1.3-.8 2-.2.3-.3.7-.5 1-.6.2-1.1.5-1.9.8-1.6.6-2.6 1-4.3 1.3-1 .2-1.6.3-2.7.4-3.1.3-4.9.1-7.9-.3-3.1-.4-4.8-.9-7.8-1.8-5.9-1.7-9.1-3.3-14.6-6.1-1.6-.8-2.5-1.3-4-2.2-1.1-.6-1.8-1-2.7-1.5-.1-.1.1-.3.1-.4.3-.6.6-1.3 1-1.9 1.1.6 1 .5 1.7.9z"
    />
    <linearGradient
      id="SVGID_2_"
      gradientUnits="userSpaceOnUse"
      x1={7.134}
      y1={266.971}
      x2={55.745}
      y2={241.475}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M53 236.8c2.6 5 5.7 9.9 8.8 14.7l.9 1.4c0 .1.1.2 0 .2-4.2 2.2-8.3 4.4-11.7 7.9-.7.8-1.4 1.6-1.9 2.5-.3.5-.5 1-.7 1.4-1 .5-1.9.9-2.9 1.4-1.4.6-2.7 1.2-4.2 1.8-2.6 1-5.3 1.9-7.9 2.6-3.3.8-6.8 1.4-10.3 1.7l-.1-.1v.1c-3.3.2-6.6.1-9.9-.5-1.8-.4-3.6-.8-5.3-1.6-.6-.3-.7-.2-.4-.5 1.5-.9 2.6-1.7 4.2-2.9 3.2-2.5 5.3-4.5 7.7-7.1-.4-.3-.8-.5-1.3-.8-5.1-3.3-8-7.1-10.6-11.5.1-.1 0-.2.2-.2.7.3 1.4.6 2.1.8 3.8 1.2 8.6 1.4 12.7.8 1.3-.1 2.6-.4 3.8-.7 1.4-.3 2.8-.7 4.1-1 8-2.6 15.5-6.2 22.7-10.4z"
      style={{
        fill: 'url(#SVGID_2_)',
      }}
    />
    <linearGradient
      id="SVGID_3_"
      gradientUnits="userSpaceOnUse"
      x1={217.171}
      y1={266.71}
      x2={172.222}
      y2={241.263}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M175.9 238c1.9 1 2.9 1.7 4.8 2.7 2 1.1 3.2 1.7 5.3 2.7.9.4 1.5.7 2.5 1.1 3.1 1.3 4.8 2 8 3 2.2.7 3.5 1 5.7 1.4.9.2 1.2.3 2.3.4 2.2.4 4.1.6 6.7.4 1.4-.1 2.1-.1 3.5-.4 2.1-.4 3.6-.9 5.3-1.5 0 .1.1.1.1.2-1.7 3-3.4 5.6-6.4 8.3-1.9 1.7-3.4 2.7-5.2 3.7-.1.1-.2.1-.3.2 0 .2.2.2.2.4.5.4.7.8 1.2 1.3 1.9 2 3.1 3 5.2 4.7.7.6 1.1.9 1.9 1.5 1.3.9 2.2 1.5 3.3 2.3-.3.2-.7.4-1.1.6-4.4 2.3-7.6 2.1-12.6 2-1.5 0-2.3-.1-3.7-.3-2.9-.3-4.6-.6-7.5-1.3-4.8-1.1-7.5-2.1-12-4.1-1.6-.7-2.6-1.3-4-2-.5-1.3-1.3-2.2-2.3-3.5-.4-.5-.7-.8-1.2-1.3-2.7-2.8-4.9-3.8-8.3-5.7-1-.5-1.7-.9-2.5-1.3-.1-.1 0-.2 0-.3l1.5-2.1 4.5-7.2c1.4-2.2 2.6-4.4 3.8-6.6.5.3.8.5 1.3.7z"
      style={{
        fill: 'url(#SVGID_3_)',
      }}
    />
    <linearGradient
      id="SVGID_4_"
      gradientUnits="userSpaceOnUse"
      x1={64.34}
      y1={252.13}
      x2={76.47}
      y2={244.281}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M64.3 255.4c3.2 4.8 6.7 9.3 10.4 13.7 0 .1.3.1.1.3-.6.1-1.1.2-1.7.4-3.1.7-4.8 1.2-7.9 1.6-3.5.5-5.6 1-9.1.5-.4-.1-.7-.1-1.1-.2-1-.2-1.6-.3-2.5-.8-.5-.3-.9-.7-1.1-.8-1.1-1-1.3-2.8-.8-4.2 1.4-3.5 4.3-5.4 8-7.7.6-.4 1-.6 1.6-.9 1.4-.8 2.5-1.3 3.8-1.9.1-.1.2-.2.3 0z"
      style={{
        fill: 'url(#SVGID_4_)',
      }}
    />
    <linearGradient
      id="SVGID_5_"
      gradientUnits="userSpaceOnUse"
      x1={163.825}
      y1={252.418}
      x2={150.868}
      y2={244.626}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M164.7 256.4c1 .4 1.5.8 2.5 1.3 1.1.6 1.7.9 2.7 1.6.7.4 1.1.7 1.7 1.2 2.7 2.1 4.8 3.9 5.3 6.8.3 1.4-.3 2.9-1.6 3.7-.4.2-.8.4-1.3.6-.8.3-1.3.4-2.1.6-3.1.7-4.9.2-8.1-.1-2-.2-3.1-.5-5.1-.9-2.5-.5-4.2-.8-6.3-1.4.2-.5 3.7-4.5 6-7.6 1.9-2.5 3.1-4.2 4.6-6.4.8-.1 1.1.3 1.7.6z"
      style={{
        fill: 'url(#SVGID_5_)',
      }}
    />
    <path
      className="st2"
      d="M122.2 266.4c8.6.7 13.4 1.9 21.8 3.7 4.9 1 7.6 2 12.6 3 4.6.9 7.1 1.8 11.8 1.9 1.5 0 2.4.1 3.8-.2 2.6-.5 4.6-1 6.1-3.2.5-.8.9-1.4 1-2.1.1-.3.1-.6.3-.9.4.2.8.4 1.4.6.7.3 1 .5 1.7.8 1 .4 1.6.6 2.6 1 3.9 1.5 6.2 2.1 10.3 3.1.4.1.7.2 1.1.3 3 .7 4.7.9 7.7 1.1 3.2.2 5 .3 8.1-.1.6-.1 1.2-.3 1.4-.2 2.2-.3 4-.8 6.4-1.9.8-.4 1.4-.6 2.1-1 .3 0 .2 0 .9.3s1.3.6 1.9 1c-.2 0-.4.2-.6.3-4.5 2.7-8.9 3.9-14.9 4.2h-1.5c-1.7 0-2.6 0-4.3-.2-.8-.1-1.3-.1-2.2-.2-.9-.1-1.4-.2-2.3-.3-3.5-.6-5.5-1.1-8.9-2.1-2-.6-3-.9-5-1.6-2.2-.8-3.8-1.5-5.6-2.3-.6 1.5-1.5 2.8-3.1 3.9-1.1.8-1.9 1.1-3.2 1.5-1.4.4-2.2.5-3.6.7-1.6.2-2.5.1-4.1 0-1.7-.1-2.6-.3-4.3-.5-4.6-.7-7.1-1.5-11.6-2.5-2.5-.6-3.9-.9-6.4-1.5-3.2-.7-5-1.2-8.2-1.8-5.9-1.1-9.3-1.7-15.3-2.1-5.9-.4-9.2-.3-15.1.1s-9.2 1-15.1 2c-3.4.6-5.3 1-8.6 1.7-4.2.9-6.5 1.7-10.8 2.5-2.4.5-3.7.8-6.1 1.1-2.5.3-3.9.5-6.4.3-1.1-.1-1.8-.1-2.9-.3-1.1-.2-1.8-.3-2.9-.8-1-.4-1.6-.7-2.5-1.4-.4-.3-.6-.4-.9-.8-.5-.6-.8-.9-1.2-1.6-.2-.4-.4-.8-.5-1.1-.9.4-1.7.7-2.7 1.2-7.2 3-11.6 4.6-19.4 5.2-5.7.5-9.2.7-14.8-.8-3.4-.9-5.8-1.9-8.4-3.5.6-.4 1.3-.8 2.1-1 .5-.2.5-.3.8-.3 1.2.7 2.3 1.2 3.8 1.7 4.1 1.5 6.7 1.6 11 1.6 1 0 1.6 0 2.6-.1 3.1-.2 4.8-.4 7.8-1 7.1-1.3 12-3.2 17.6-5.8.2.3.1.7.2 1 .6 2.8 3.3 3.9 6.3 4.9 1.8.6 3 .4 4.9.4 1.3 0 2-.1 3.3-.2 5.8-.4 9-1.7 14.7-2.9 4.5-.9 7-1.7 11.5-2.5 1.2-.2 1.9-.4 3.1-.6 3-.5 4.7-.8 7.7-1.2 8.3-1 13.1-1.2 21.5-.6.7 0 1 .1 1.5.1z"
    />
    <linearGradient
      id="SVGID_6_"
      gradientUnits="userSpaceOnUse"
      x1={123.077}
      y1={266.308}
      x2={160.415}
      y2={280.815}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M119.3 271.5c8.9.5 13.8 1.7 22.5 3.5 4.8 1 7.4 2 12.1 3 4.5 1 7.8 1.7 11.7 2.1 2.3.1 4.6.2 6.9-.3 1.3-.3 2.4-.8 3.6-1.3 1.1-.6 1.9-1.3 2.7-2.3.1.1.4-.2.4.1v.2c-.8 1.5-1.7 2.8-2.5 4.2-1.4 2.1-2.9 4-4.5 6.2-1.6 1.8-3 3.8-4.5 5.6-1.3 1.5-2.7 3-4 4.4-1 .8-1.9 1.5-2.9 2.3-.5.4-1.1.7-1.6 1-2.3 1.2-5.2 1.4-7.9 1.2-2.7-.4-4.9-1.2-8-2-1.2-.3-1.9-.5-3.1-.8-5.1-1.2-8-1.9-13.2-2.6-6.4-.9-10.1-1.1-16.6-1-3.8.1-6 .2-9.8.6-3.4.4-5.3.7-8.7 1.4-5.8 1.1-9.8 2.3-14.7 3.5-1.6.3-3.2.5-4.8.5-1.3 0-2.6-.3-3.9-.6-1.9-.5-3.5-1.8-4.9-3.2-.6-.8-1.3-1.3-1.8-2.1-3-3.2-5.5-6.7-8-10.3-1.7-2.2-3.1-4.4-4.7-6.7-.4-.9-1-1.7-1.5-2.5 0-.1-.1-.3.1-.4h.3c2 2.8 5.3 3.5 8.4 4 1.4.1 2.9.2 4.4.1 2.7-.1 5-.5 8.2-1.1 6.2-1 9.6-2.2 15.8-3.5 2.1-.4 3.3-.7 5.4-1.1 6.7-1.2 10.6-1.9 17.4-2.2 4.6-.2 7.2-.1 11.7.1z"
      style={{
        fill: 'url(#SVGID_6_)',
      }}
    />
    <linearGradient
      id="SVGID_7_"
      gradientUnits="userSpaceOnUse"
      x1={109.749}
      y1={256.27}
      x2={57.903}
      y2={271.015}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M110.5 295c-3.8.1-6 .2-9.8.6-3.4.4-5.3.7-8.7 1.4-5.8 1.1-9.8 2.3-14.7 3.5-1.6.3-3.2.5-4.8.5-1.3 0-2.6-.3-3.9-.6-1.9-.5-3.5-1.8-4.9-3.2-.6-.8-1.3-1.3-1.8-2.1-3-3.2-5.5-6.7-8-10.3-1.7-2.2-3.1-4.4-4.7-6.7-.4-.9-1-1.7-1.5-2.5 0-.1-.1-.3.1-.4h.3c2 2.8 5.3 3.5 8.4 4 1.4.1 2.9.2 4.4.1 2.7-.1 5-.5 8.2-1.1 6.2-1 9.6-2.2 15.8-3.5 2.1-.4 3.3-.7 5.4-1.1 6.7-1.2 10.6-1.9 17.4-2.2l2.8 23.6z"
      style={{
        fill: 'url(#SVGID_7_)',
      }}
    />
    <path
      className="st2"
      d="M131.3 299.5c3.2.7 6.3 1.3 9.5 2 3 .8 6 1.4 9 2.2.6 0 1.2.2 1.8.2 1.9 0 3.8 0 5.4-.8.2 0 .3.1.4.3-.3.3-.5.5-.9.7-.2.1-.5.2-.7.4-.7.3-1 .4-2 .7-2.3.7-5.2.7-7.6.3l-2.9-.7c-3-.8-6.1-1.5-6.8-1.6-4.3-1-8.8-1.7-13.3-2.3-1.5-.1-3.1-.2-4.6-.4-1.2 0-2.4-.1-3.6-.1-5.8-.2-11.4.3-16.9 1-1.2.3-2.5.4-3.7.6-4.1.7-8.1 1.7-12.2 2.6-2.6.7-5.6.7-8.2.1-.3-.1-1-.3-1.6-.6-.6-.2-.7-.3-1.5-.7l-.5-.3c-.1-.2.1-.2.2-.3.7.1 1.5.4 2.2.5 3.6.5 7-.5 10.3-1.4 4.6-1.2 9.2-2.3 14-3 3.6-.6 7.3-.9 11-1.2 2.8-.1 5.5-.1 8.3 0 5 .3 10 .9 14.9 1.8z"
    />
    <path
      className="st9"
      d="M107.8 279.6c-.2.1-.4.4-.6.1-.1-.2-.5-.4-.6-.6l-.7-.5c-.8-.3-1.7-.5-2.7-.3-.1.1.1.2 0 .3.2 2.5.4 5.1.7 7.7l.1.1c0 .5.1 1.1.2 1.6.1.9.9 1.6 1.2 2.2-1.7.2-3.4.3-5.1.5-.1-.1-.2-.2-.2-.4.7-.4.9-1.2 1.1-1.9.3-2-.1-4.1-.3-6.1-.1-1.2-.2-2.5-.4-3.6-1.3.1-2.8.5-3.5 1.7l-.3.6c-.2-.1-.4-.1-.5-.3 0-1.1.1-2.1.2-3.2 2.6-.4 5.3-.7 7.9-1 .8 0 1.7-.1 2.5-.1l1 3.2zM119.7 276.6c-.2 3.7-.3 7.3-.6 11 .1.2 0 .4 0 .6.1.7.3 1.5 1 2.1-.1.1-.1.3-.3.4l-4.8-.3c-.1-.1-.1-.2-.2-.4 1.1-.5 1.5-1.6 1.6-2.7.1-.2.1-.4.1-.6l-.1-.1.1-.1c0-1.5.3-3.1.2-4.4 0-1-.4-2.1-1.4-2.6-.1 0-.1 0-.1-.1 0-.2-.1-.6.2-.5 1-.7 1.9-1.5 2.9-2.4.5 0 .9.1 1.4.1zM93 278.2c.2.8.5 1.6.7 2.4 0 .2-.2.3-.3.5-.2-.1-.4-.4-.5-.5-.5-.3-1.1-.7-1.8-.7-.9-.1-1.7.2-2.2.8-.4.5-.5 1.2-.2 1.7.7 1.2 2.1 1.2 3.3 1.5 1.4.4 2.9 1.1 3.6 2.5.6 1.3.5 3.2-.4 4.3-.5.7-1.2 1.3-2 1.5-1.5.6-3 .1-4.6.5l-.1-.1c-.4-1-.7-1.9-1-2.9.1-.1.2-.3.4-.4.8.8 1.8 1.6 3.1 1.6h.7c.8-.2 1.7-.7 1.9-1.6.1-.7.2-1.5-.3-2-.8-.9-1.9-1-2.9-1.4-1.5-.4-3.2-1-4-2.5-.4-.7-.4-1.6-.2-2.3.3-.8.8-1.6 1.4-2.1 1-.6 2.2-.8 3.5-.8.5 0 1.1-.1 1.9 0zM80.8 280.4c.4.8.9 1.6 1.2 2.5-.2.1-.1.4-.4.3-1.4-.8-3.2-.7-4.7-.2-.3.1-.9.1-.9.5.3 1.1.6 2.1.8 3.2.1.1 0 .4.2.4.5-.1 1.1-.4 1.6-.6.7-.4 1.5-1.1 1.7-1.9.1 0 .4.1.4.1.4 1.4.8 2.9 1.1 4.3-.1.1-.3.3-.4.2-.9-1-2.4-.9-3.6-.6-.1.1-.4.1-.3.3.2.6.2 1.2.5 1.8v.1c.2.8.4 1.7.7 2.5.8-.1 1.5-.5 2.2-.7.7-.3 1.3-.8 1.9-1.1.5-.5.9-.9 1.3-1.4.1 0 .2.1.3.1 0 1.1 0 2.2.1 3.3-.1.2-.4.1-.6.2-2.8.7-5.7 1.4-8.5 2.1-.1-.1-.3-.2-.3-.4.4-.5.6-1 .6-1.7.1-.3 0-.5.1-.8 0-1-.3-1.9-.5-2.9-.4-1.2-.7-2.4-.9-3.6-.2-.6-.4-1.2-.6-1.7-.2-.5-.5-1.1-1-1.4-.1-.3-.8-.3-.7-.7 0-.2.3-.2.5-.3 2.6-.6 5.4-1.3 8.2-1.9zM140.3 280.3c-.7-.5-1.4-1-2.3-1.1l-.2-.1c-1.5-.1-2.9.4-3.9 1.5-.2.3-.4.5-.5.8-.7 1.2-.7 2.8.1 4 1 1.3 2.7 1.9 4.3 1.5-.4.7-1.1 1.2-1.6 1.8-1.3 1.2-2.8 2.1-4.5 2.5-.3 0-.7.2-1 0 0 .2.1.3.1.5 1.1.3 2.3.5 3.4.7.6 0 1.2-.5 1.7-.7 1.6-1 3.1-2.3 4.2-3.8.6-1 1.3-2.2 1.5-3.4.3-1.5-.1-3.1-1.3-4.2zm-1.5 4.3-.4.4c-.5.3-1.3.4-1.8.2-.3-.1-.6-.3-.8-.6v-.1c0-.1-.1 0-.1 0-.2-.4-.4-.9-.3-1.4.1-.6.3-1.3.8-1.6.5-.5 1.4-.6 2.1-.3.3.1.6.3.8.6.1.2.1.3.2.5.1.7-.1 1.6-.5 2.3zM151 282.4c.1.2.3.3.5.5.1.2.3.4.4.6.5.7.6 1.5.6 2.4-.1.6-.3 1.2-.6 1.8-1.4 2.5-3.7 4.1-6.2 5.2-.1.1-.1.1-.1.2.3.3.8.2 1.3.4 1 .2 1.9.3 3 .3.5-.1 1.1-.1 1.7-.5.2 0 .1.2.2.2v.2c-.6.9-1.1 1.7-1.8 2.6-3.4-.8-6.8-1.7-10.1-2.5-.1-.1 0-.4-.1-.5.5-.2 1-.3 1.4-.5 2.8-1 5.5-2.7 7.6-4.8.9-1 1.4-2.3.9-3.6 0-.2-.3-.2-.3-.4-.4-.4-1-.6-1.6-.5-.8.1-1.4.9-1.6 1.7 0 .3-.1.5-.1.8-.1.1-.3.1-.5.1-.7-.7-1.4-1.5-2-2.3.1-.3.4-.4.6-.7.3-.3.7-.5 1-.8.2 0 .4-.2.6-.3 1.5-.9 3.8-.7 5.2.4zM112 282.7c.4.4.2 1 .1 1.5-.3.6-.8.9-1.4 1-.6.1-1.1-.4-1.4-.9-.3-.5-.1-1.1.2-1.5.4-.5 1-.7 1.7-.6.3.1.6.2.8.5zM130.4 281.2c.2-1.2-.3-2.3-1.2-3.1-.3-.1-.5-.3-.8-.5-1.3-.8-3-.4-4.1.4-1.1.9-1.6 2.3-1.1 3.6.2.8.8 1.3 1.3 1.8-.2.1-.4.2-.7.3-.3.3-.7.4-1 .8-1.2 1-1.7 2.7-1.1 4.2.3.9 1.1 1.7 1.9 2.2 1 .4 2.4.7 3.5.2 1.5-.5 2.6-1.9 2.8-3.4.2-1.4-.5-2.8-1.6-3.7-.1-.1-.2 0-.3-.2 1.1-.2 2.2-1.3 2.4-2.6zm-3 6.6c-.1.8-.7 1.5-1.4 1.8-.7.3-1.3 0-1.9-.3-.2-.3-.5-.5-.5-.9-.3-.6-.1-1.5.1-2.1.3-.7 1.1-1.3 1.9-1.3.6.1 1.3.3 1.5 1 .3.5.5 1.1.3 1.8zm.2-5.5c-.4.4-1 .5-1.5.4-.3-.1-.6-.2-.7-.4-.3-.2-.4-.6-.5-1 0-.7.1-1.4.7-1.8.4-.3 1-.5 1.5-.4.5.2.9.5 1.1 1 .2.7.1 1.6-.6 2.2z"
    />
    <path
      className="st0"
      d="m114.6 17.1 1.3 1.3c2.7 1.8 6.6 1.6 9.6.8 1.1-.3 1-.3 1.6-.5.3 1.1.1 2 0 3.3-.2 2.3-.7 3.7-1.6 5.8-.2.4-.3.7-.5 1.1-1.1 2.4-1.8 3.7-3.4 5.8-2.3 3-4.5 4.7-7.2 6.5h-.1c-.8-.6-1.5-1.1-2.5-1.8-1.2-1-1.9-1.6-2.9-2.7s-1.5-1.7-2.4-3c-1.3-1.9-1.9-3-2.7-5.1-1.1-2.6-1.7-4.2-1.9-7-.1-1-.2-1.7 0-2.5 0-.1 0 0-.1 0 0-.1.1-.2.1-.3h.3c1.1.4 2 .7 3.4 1 1.4.2 2.3.3 3.7.1 2.3-.4 4.1-1.1 5.3-2.8zm.9-14.1c.4.8.5 1.4.6 2.3.1.5.1.8.1 1.4 0 .7-.2 1.1-.2 1.7 0 0 .1 0 .1.1 1-.6 2.3-1.1 3.5-.4.7.4 1.1.7 1.5 1.5.5 1 .5 2-.2 2.8-.5.6-1 .9-1.7.9-.2-.2.1-.3.1-.5.1-.6.2-1-.1-1.5-.3-.7-1-1.1-1.8-1.1-.9 0-1.4.6-1.8 1.3-.5.9 0 2.4.9 3.5.5.5.8.7 1.5 1 .4.2.7.3 1.2.5.6.2.9.2 1.5.2h.6c2.5 0 4.1-.3 6.3-1.6 1.1-.6 1.9-1.1 2.6-2h.1c.5 3.9.2 7.8-.6 11.6l-.5 1.7c-.4 1.4-1 2.8-1.6 4.1 0 .1-1.1 2.4-1.1 2.4-2.1 3.5-4.7 6.7-7.9 9.3-.9.8-1.7 1.4-2.5 2v8c.1 0 .1.1.2 0 .2-.8.5-1.5.7-2.2.5-1.2 1.1-2.4 2-3.4 1-1.1 2.1-2 3.4-2.5 1.7-.6 3.6-.4 5.2.4.8.4 1.7 1.2 2.4 1.8.1.2.3.4.4.6 1.2 1.5 1.8 3.2 2.3 5.1.2.8.3 1.6.4 2.4.1 2.9-.3 5.7-1.4 8.2-1.2 2.7-3.8 5.5-7 5.5-.6.1-1.2-.1-1.7-.2-.4-.2-.9-.3-1.3-.5-3-1.5-4.8-4.7-5.5-7.7 0-.1-.1-.1-.1 0V70c33 0-24.3-.1-3.4 0 0-3.6.1-10.5 0-10.4-.2.6-.4 1.2-.7 1.9-.3.7-.4 1.1-.8 1.7-.3.6-.6 1-1 1.6-.4.4-.6.7-1 1.1-.3.3-.5.5-.8.7-.5.3-.8.5-1.3.8-.4.2-.6.3-1 .4-.3.1-.5.2-.9.2-.6.1-.9.1-1.5.1-.3 0-.5-.1-.8-.1-.4-.1-.6-.1-.9-.3-.6-.2-.9-.4-1.4-.7-.4-.2-.6-.4-.9-.7-1.2-1-1.7-1.8-2.4-3.2-.2-.5-.4-.7-.6-1.2-.2-.5-.3-.8-.5-1.3-.2-.6-.3-.9-.4-1.6-.1-.5-.1-.9-.2-1.4-.1-.7-.1-1.2-.1-1.9s0-1 .1-1.7.2-1.2.3-1.9c.2-.8.3-1.3.7-2.1.2-.6.4-.9.6-1.4.2-.4.3-.6.6-1 .3-.5.5-.7.9-1.1.3-.4.6-.6 1-.9.6-.5.9-.8 1.6-1.2.6-.3 1-.4 1.6-.5.2 0 .3-.1.6-.1.6-.1.9 0 1.5 0 .2 0 .4 0 .6.1.8.1 1.2.3 1.9.7.6.4.9.7 1.4 1.1.3.3.5.4.8.8.5.6.8 1 1.2 1.7.4.6.5 1 .8 1.7.2.5.3.7.5 1.2.2.4.3 1.2.3 1.2h.1v-7.9c-.6-.5-1.1-.8-1.8-1.4-.8-.6-1.2-1-1.9-1.7-.7-.6-1.1-1-1.7-1.7-.5-.6-.8-.9-1.3-1.5-.4-.5-.7-.8-1.1-1.4-.5-.7-.8-1-1.2-1.7-.5-.7-.7-1.2-1.2-1.9-.5-.9-.7-1.4-1.1-2.2-.4-1-.7-1.6-1-2.6-.5-1.3-.7-2.1-1.1-3.5-.3-1.2-.4-1.8-.5-3-.1-.8-.1-1.3-.2-2.2-.1-1.4-.1-2.1-.1-3.5.1-1 .1-1.7.3-2.6v-.1h.1l.8.8c.3.3.5.4.8.6.4.3.7.4 1.1.7.8.4 1.3.6 2.2.9.3.1.5.2.8.3 1.2.3 1.9.4 3.1.3.6 0 1 0 1.6-.1.5-.1.8-.2 1.3-.4s.7-.4 1.1-.7c.2-.2.4-.3.6-.5.3-.3.5-.6.7-1 .2-.4.2-.6.3-1 .1-.3.1-.5.1-.8 0-.2 0-.4-.1-.6-.2-.4-.3-.6-.6-.9-.3-.2-.5-.3-.8-.4-.1 0-.2 0-.3-.1-.2 0-.3 0-.5.1s-.3.1-.5.2c-.4.2-.5.4-.7.8-.1.2-.2.4-.2.6v.5c0 .2.1.2.1.4.1.1.1.2.2.3 0 .1-.1.1-.1.2-.6-.1-.4-.1-.7-.2-.2-.1-.4-.1-.6-.3-.2-.1-.3-.3-.4-.5-.2-.2-.2-.4-.3-.7-.1-.3-.1-.4-.1-.7v-.6c0-.3.1-.4.2-.7.2-.4.3-.6.5-.9l.5-.5c.2-.1.3-.2.5-.3.2-.1.3-.2.6-.3.4-.1.7-.2 1.1-.2.3 0 .5 0 .8.1.4.1.6.1.9.3.3.1.5.2.7.3 0-.5-.2-.9-.2-1.5s0-.9.1-1.5c.1-.8.3-1.3.6-2.1.2-.4.3-.8.6-1.1.5.1.6.4.9.8zM109 48.7c-.4.7-3.5 4.2-4.5 5.3-1.6-1.8-3.1-3.5-4.6-5.3 1-1.8 2.9-3.2 5-3 1.7.3 3.1 1.6 4.1 3zm19.1-1c.2.2.4.5.6.7.2.3.4.8.7 1.1 0 .2.2.5.3.8-.6-.1-1.3 0-1.8.3-.1.4.4.4.5.5.4.2.7.6.8 1 0 .5-.5 1-.9 1.2-1.8.9-4.2 1-6.3.6-.3-.2-.7-.2-1-.4-.5-.2-.9-.5-1.3-.9 0-.2-.2-.4-.1-.7.2-.8 1-1.1 1.7-1.3.1-.1.1-.2.1-.2-.5-.5-1.2-.6-1.8-.4.1-.4.3-.8.5-1.2 1-1.8 2.8-3.3 5-3 1.1.1 2.1.9 3 1.9zm-17.8 4.2c.6 2.8.6 5.6-.2 8.4-.2-.1-2.6-2.8-3.6-4v-.2c1.2-1.4 1.2-1.4 3.8-4.2h0zm-7.8 4.4c-1.2 1.4-2.4 2.8-3.7 4.1-.7-2.4-.8-4.9-.5-7.4.1-.3.1-.6.2-1 1.5 1.4 2.7 2.8 4 4.3zm28.2-.7v.3h.1l-.1.1c.1 1-.1 2-.2 2.9-.2.8-.3 1.7-.6 2.4l-.2.3c-.1-.1.1-.3 0-.4l-.1.1c-.1-.7-.6-1.3-1.3-1.6-.8-.3-1.7-.1-2.3.5-.2.3-.5.5-.7.8v-5c.6-.1 1.1-.1 1.6-.2.3.4.4 1.2 1.1 1 .1-.1.3-.1.4-.3.1-.2.2-.6.1-.8-.1-.5.5-.4.8-.6.5-.2.9-.5 1.3-.8.2.4.1.8.1 1.3zm-11.6-.8c.4.2.8.3 1.2.5.1.5-.3 1.3.3 1.5.7-.1.8-.8 1.1-1.2l1.8.3v4.5c-.2-.2-.4-.4-.7-.6-.6-.4-1.6-.4-2.3 0-.4.3-.8.7-.9 1.2 0 .3-.2.5-.1.8h-.1c-.3-.5-.4-1-.6-1.6-.1-.4-.1-.8-.3-1.1-.2-1.6-.3-3.2-.1-4.7.3.1.5.3.7.4zm-14.6 3.7c1.3 1.6 2.8 3.1 4.1 4.6-.3.6-.7 1-1.2 1.5-1.4 1.1-2.7 1.4-4.3.9-1.1-.3-1.6-.5-2.5-1.6-.2-.3-.4-.5-.2-.9 1.2-1.4 4-4.5 4.1-4.5zm17.6 3c.1.1.3.2.4.4.2.3.5.6.6 1 .2.5.4 1.1.4 1.6.1.5 0 1 0 1.5-.3 0-.6-.2-1-.3-.5-.3-1-.7-1.2-1.2-.2-.1-.2-.3-.2-.5-.3-.4-.4-1.2-.2-1.7 0-.1 0-.2.1-.3 0-.2.2-.3.3-.5.2.1.3-.2.5-.1.1 0 .2.2.3.1zm5.8.3c.4.6.2 1.6 0 2.2-.5 1-1.5 1.7-2.6 1.9-.1-.6-.1-1.2 0-1.7 0-1 .4-2 1.2-2.6.5-.3 1.2-.3 1.4.2z"
    />
    <path
      className="st10"
      d="M126.4 32.8c.1 0 .2.1.2.1v.7c0 .5.1.8.3 1.3.1.3.3.7.3.7s.6 1 1 1.5c.4.4.6.7 1 1.1.7.6 1.1.8 1.8 1.5.4.4.7.6 1.1 1.1.5.7.8 1.2 1 2.1 0 .3.1.4.1.7 0 .4-.1.6-.2.9.1.1.9.2 1.2.1 0 0 .3-.1.5-.3.1-.1.2-.2.4-.3.2-.2.3-.4.4-.6.1-.2.1-.3.1-.6v-.6c0-.2-.1-.3-.1-.4.6.2 1 .4 1.7.6.9.2 1.5.2 2.3.2-.6.8-1.2 1.3-1.9 2.3-.3.5-.5.7-.8 1.2-.4.7-.6 1.1-.8 1.9-.2.5-.3.7-.4 1.2-.2.8-.3 1.3-.4 2.2-.1.6-.1.9-.1 1.4v1.4c0 .6.1.9.2 1.5.2.9.3 1.4.6 2.3.1.4.2.6.4 1 .2.6.4.9.7 1.4.2.4.4.6.6 1 .5.8.9 1.2 1.5 1.8l.9.9c.4.4.7.6 1.1.9.5.4.8.5 1.4.8.3.2.5.3.9.5.5.2.9.4 1.4.5.8.3 1.3.4 2.1.6.9.2 1.5.2 2.4.2h1.8c.8 0 1.2-.1 2-.2.6-.1.9-.2 1.4-.3 1.2-.3 1.9-.5 3.1-.9 1.9-.6 2.5-.9 4.4-1.5 1.3-.4 2.1-.6 3.4-.8.6-.1 1-.2 1.6-.2 1.1-.1 1.7-.1 2.7 0 1.1.1 1.8.2 2.8.5 1.2.4 2.5 1.1 2.8 1.3 0-.4 0-.8-.1-1.2-.1-.3-.1-.4-.3-.7-.1-.2-.2-.4-.4-.6-.2-.2-.3-.4-.5-.6-.2-.2-.4-.3-.7-.5-.3-.2-.5-.3-.8-.4-.6-.3-1.1-.4-1.7-.6.5-.4 1-.6 1.6-1 1.5-.8 2.3-1.1 3.8-1.7.9-.4 1.4-.5 2.4-.8.9-.3 1.4-.5 2.3-.7.8-.2 1.2-.3 2-.4.6-.1.9-.1 1.5-.1.7 0 1.2-.1 1.9 0 .8.1 1.2.2 1.9.4.5.2.8.3 1.3.5.6.3.9.5 1.4.9.2.2.4.3.6.5.3.3.4.5.6.8l.3.6c.1.2.2.4.3.7.1.5.2.8.2 1.3 0 .3 0 .5-.1.8-.1.4-.2.6-.4 1s-.4.6-.7.9c-.3.3-.5.4-.9.6-.3.1-.4.2-.7.3-.5.2-.8.2-1.4.3-.5 0-.8 0-1.3-.2-.3-.1-.5-.2-.8-.3-.2-.1-.3-.2-.4-.3.2-.2.4-.3.6-.5.2-.2.2-.3.3-.5.1-.2.2-.4.2-.6v-.5c0-.2-.1-.3-.1-.6-.1-.2-.2-.4-.3-.5-.2-.3-.4-.5-.7-.6-.2-.1-.4-.1-.7-.2h-.7c-.2 0-.4.1-.6.1l-.4.2c-.2.1-.4.2-.6.5-.1.2-.2.3-.3.5-.1.2-.1.3-.1.5-.1.5-.1.7 0 1.2.1.3.1.5.2.8.1.2.2.3.3.6.2.3.3.4.5.7.2.3.4.4.6.6.3.2.4.3.7.5.6.4 1 .5 1.7.7.3.1.5.1.9.2s.6.1 1 .1.6 0 1-.1c.4 0 .7-.1 1.1-.2.4-.1.6-.2.9-.4.3-.1.5-.2.8-.4.3-.2.5-.3.8-.6.3-.3.5-.4.7-.7.2-.3.3-.5.5-.8.2-.4.3-.6.4-1 .1-.3.1-.5.2-.8.1-.5.1-.7.1-1.2 0-.4 0-.6-.1-.9-.1-.6-.2-1-.4-1.6-.1-.3-.2-.4-.3-.7-.3-.5-.4-.8-.8-1.2-.3-.4-.4-.5-.8-.8-.3-.3-.5-.4-.8-.6-.3-.2-.5-.4-.8-.6-.6-.3-.9-.5-1.5-.7-.4-.2-.7-.2-1.2-.3-.5-.1-.8-.1-1.2-.2-.9-.1-1.4-.2-2.3-.2-.8 0-1.2 0-2 .1-.7.1-1.1.1-1.7.2-.7.1-1 .2-1.7.4-1 .3-1.5.5-2.5.8-1.6.6-2.4.9-4 1.6-1.1.5-1.7.8-2.8 1.4-.7.4-1.1.6-1.7 1 .1-.3.1-.5.1-.8 0-.2 0-.3-.1-.5-.1-.3-.1-.5-.3-.7-.1-.2-.2-.2-.4-.4-.2-.1-.3-.2-.5-.2-.3-.1-.9-.2-.9-.2s.1.1.1.2c.1.4 0 .6 0 1 0 .3-.1.5-.2.7-.1.2-.1.3-.3.5-.1.2-.3.3-.4.5-.3.3-.5.4-.8.7-.4.3-.6.4-1 .7-1 .6-1.5.8-2.6 1.2-1.5.6-2.5 1-3.9 1.4.3-.6.7-1 1-1.6.2-.4.2-.6.4-1 .1-.5.2-.8.2-1.3.1-.7 0-1.1-.1-1.8-.1-.6-.2-1-.5-1.6-.1-.3-.2-.5-.4-.8-.2-.3-.3-.5-.6-.8-.2-.3-.4-.4-.6-.7-.6-.5-1-.8-1.6-1.1-.3-.1-.4-.2-.7-.3-.8-.3-1.3-.4-2.2-.5h-1.1c-.4 0-.6.1-1 .2s-.6.2-.9.3c-.4.2-.7.3-1 .6-.2.1-.3.2-.5.4s-.3.3-.4.6c-.2.4-.3.6-.3 1.1v.6c0 .4.1.7.3 1 .2.4.3.6.6.9.2.2.3.2.5.4.2.1.3.1.5.2.3.1.5.1.8.2h.6c.3 0 .4-.1.7-.2.2-.1.3-.2.5-.3.2-.2.3-.3.4-.5.1-.2.2-.3.2-.5.1-.2.1-.3.1-.5s0-.3-.1-.5c0-.2-.1-.3-.2-.5s-.2-.3-.3-.4c-.2-.2-.5-.4-.8-.5-.1-.1.1-.1.1-.1.2-.1.3-.1.5-.1h1c.6.1 1 .3 1.6.6.3.2.5.3.8.6l.8.8c.2.2.3.4.4.6.2.3.2.5.3.9.1.3.1.5.1.8 0 .5 0 .8-.1 1.3-.1.4-.1.6-.2.9-.3.9-.6 1.5-1.4 2.1-.2.2-.4.3-.6.5-.3.2-.5.3-.8.5-.4.2-.7.3-1.2.4-.3.1-.4.1-.7.1h-1.2c-.5 0-.8-.1-1.3-.2s-.7-.3-1.1-.5c-.5-.3-.7-.4-1.1-.8-.3-.4-.5-.6-.7-1.1-.1-.2-.1-.3-.2-.6-.1-.5 0-.9.1-1.3-.2.1-.4.1-.6.2-.2.1-.3.1-.4.2-.3.2-.4.3-.6.5-.2.3-.3.4-.5.7-.2.4-.2.6-.3 1-.4-.2-.8-.4-1.2-.7-.3-.2-.4-.4-.7-.7-.2-.3-.3-.4-.5-.7-.7-1-.9-1.7-1.1-3 0-.3-.1-.4-.1-.7v-1.3c0-.4.1-.6.2-1 .1-.6.2-.9.5-1.4.2-.4.3-.6.6-1 .2-.2.3-.4.5-.6.2-.2.3-.3.6-.4.2-.2.4-.2.6-.3.3-.1.4-.1.7-.2h.6c.4 0 .6 0 .9.1.5.2.8.4 1.2.6l.1-.1c.2-.4.2-.7.2-1.1v-.9c-.1-.5-.1-.8-.3-1.2-.1-.2-.2-.3-.3-.5-.2-.3-.3-.5-.6-.7-.2-.2-.3-.3-.5-.4-.4-.2-.7-.4-1.1-.5 0-.1.1-.2.1-.3.2-.4.4-.5.7-.8.6-.6 1-.8 1.7-1.2.5-.3.8-.4 1.4-.7.4-.2.6-.2 1.1-.4.6-.2 1-.3 1.6-.4.8-.1 1.2-.1 1.9-.1.4 0 .7.1 1.1.1.7.1 1 .2 1.6.5.6.3.9.4 1.4.8.3.2.4.3.7.5.4.3.5.5.8.9.3.4.5.7.7 1.2.2.5.3.8.4 1.4.1.5.1.8 0 1.3 0 .3-.1.4-.1.7-.1.4-.2.6-.3 1 0 0 .6.1.9.1.3 0 .5-.1.7-.2.3-.1.5-.2.8-.4.3-.2.5-.4.8-.6.4-.4.6-.7.9-1.2.2-.3.2-.4.3-.7.2-.4.3-.8.4-1.1.3.3.5.5.7.9.2.3.3.5.4.8.3.5.4.9.5 1.5.2.7.2 1.1.3 1.9v1.1c0 .9-.1 1.6-.2 2.3l.1.1c.3.1.6 0 .9-.2.3-.2.4-.3.7-.5.3-.2.4-.4.7-.6.3-.3.4-.5.6-.8.2-.3.2-.4.4-.7.3-.7.4-1.2.6-1.9.4.3.6.6 1 1 .3.3.5.5.9.8.6.5 1 .8 1.6 1 .2-.3.3-.5.4-.9.2-.6.2-.9.3-1.5 0-.4.1-.7 0-1l.1-.1c.2.1.3.2.3.2.4.3.8.6 1.3.9l.6.3c.3.1.5.2.8.3 1 .3 1.8.3 2.8.3h20c-.4.9-.6 1.3-.8 2.2-.1.6-.2.9-.3 1.5-.1.5-.1.8-.1 1.3 0 .8-.1 1.2 0 2 .1.6.1 1 .3 1.6.2.9.3 1.5.7 2.3.1.4.2.6.4 1l.5 1c.2.3.3.5.5.8.2.3.4.4.6.7.3.3.4.4.7.6.3.2.5.3.8.5.5.3.8.4 1.3.5.3.1.5.1.9.1h1.1c.4 0 .6-.1.9-.2l.6-.3c.3-.2.5-.3.8-.5l.5-.5c.1-.2.2-.3.3-.5.1-.2.2-.4.2-.7.1-.3.1-.5.1-.8 0-.5 0-.7-.2-1.2-.1-.3-.1-.5-.3-.7-.2-.3-.3-.5-.5-.8-.2-.2-.3-.3-.5-.4-.2-.2-.3-.2-.6-.3-.3-.1-.5-.2-.8-.2-.4 0-.7-.1-1.1.1-.2.1-.4.2-.5.4v.1l.9.3c.3.2.5.3.7.5.2.2.3.4.4.7.1.2.1.3.2.5v.4c0 .2 0 .4-.1.6-.1.2-.1.3-.2.5l-.3.3c-.2.1-.2.2-.4.3-.3.2-.5.2-.9.2-.2 0-.4 0-.6-.1-.3-.1-.4-.1-.7-.2-.3-.1-.5-.2-.8-.4-.5-.4-.7-.7-1-1.3-.2-.3-.3-.5-.4-.8-.3-.5-.4-.8-.6-1.4-.1-.4-.2-.7-.3-1.1-.1-.5-.2-1.2-.2-1.2s-.1-1.2-.1-2c0-1 0-1.6.3-2.6.1-.5.2-.8.4-1.3s.3-.8.5-1.2c.4-.7.6-1.1 1.2-1.7.4-.5.8-.8 1.3-1.1 0-.1 0 0-.1-.1h-12.2c-.3-.3-.4-.5-.6-.9-.1-.3-.2-.4-.3-.8-.4-1.1-.2-.4-.2-1.5 0-.6 0-1 .1-1.6.1-.3.1-.5.2-.9s.3-.7.5-1c.2-.3.3-.4.5-.6.2-.2.4-.3.7-.4.2-.1.3-.1.6-.2h.6c.2 0 .3.1.4.2.1.1.2.1.3.3.2.2.3.3.4.6.1.3 0 .5-.1.8-.1.2-.1.3-.3.5-.2.2-.3.2-.6.3-.3 0-.5-.1-.8-.3 0-.1-.3-.2-.4-.1 0 .3.1.6.3.9.2.3.3.4.5.6.2.1.3.2.5.2.3.1.4.1.7.1.4 0 .7-.1 1.1-.2.3-.2.5-.3.8-.6.2-.2.3-.3.4-.6.1-.3.1-.6.2-.8v-1.1c-.1-.5-.2-.7-.4-1.1-.2-.2-.3-.3-.4-.5l-.5-.5c-.3-.2-.5-.3-.9-.4-.4-.1-.6-.2-1-.2-.5 0-.8 0-1.3.2-.3.1-.5.2-.8.3-.5.2-.8.5-1.2.8.1-.9.2-1.6.2-2.6 0-.9 0-1.4-.2-2.3-.1-.5-.2-.8-.4-1.3-.2-.4-.2-.6-.5-.9-.2-.2-.4-.4-.5-.4-.3.3-.4.6-.6 1-.3.6-.4.9-.5 1.5-.1.5-.2.8-.2 1.3v1.2c0 1 .2 1.7.3 2.5-.2-.1-.3-.2-.5-.3-.3-.2-.5-.3-.9-.5-.2-.1-.4-.1-.6-.2-.5-.1-.8-.1-1.2-.1-.2 0-.3 0-.5.1-.5.1-.7.2-1.1.5-.2.1-.3.2-.5.4-.4.4-.6.6-.7 1.1-.1.3-.2.4-.2.7-.1.5 0 .9.2 1.4.2.5.3.8.7 1.1.2.1.2.2.4.3.2.1.3.1.5.2.3.1.5.2.9.2.3 0 .4 0 .7-.1.3-.1.4-.1.6-.3l.3-.3c.1-.2.2-.3.2-.5.1-.3 0-.5 0-.8 0 0-.1-.1-.1 0 0 0-.1.2-.2.3-.1.1-.2.1-.3.1-.3.1-.5.1-.8-.1-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.3-.4-.1-.2-.1-.4-.1-.7 0-.3.1-.5.3-.7.2-.3.5-.3.8-.3h.6c.4.1.6.2 1 .4.2.1.3.2.5.4s.2.3.4.5.2.4.3.6c.2.6.3.9.4 1.5v1.1c0 .4 0 .6-.1 1s-.1.6-.2.9c-.2.5-.3.8-.6 1.1h-8.7s.4-.2.6-.4l.5-.5c.2-.2.2-.3.4-.5.2-.4.2-.5.3-1v-.2s-.2.1-.3.1c-.1 0-.2.1-.3.1-.4.1-.5.2-.9.3-.7.2-1.1.1-1.8 0-.3 0-.5-.1-.7-.1-.5-.1-.8-.3-1.3-.5-.6-.3-.9-.6-1.5-.9-1.9-1.3-2.6-2.5-4.5-3.8-1-.8-1.6-1.2-2.7-1.8-.6-.3-.9-.5-1.5-.7-1.1-.5-1.9-.8-2.9-1.1.1-.2.3-.2.5-.4s.2-.2.3-.4l.3-.6c.1-.2.1-.4.1-.6v-.5c0-.2 0-.4-.1-.6-.1-.3-.2-.5-.4-.8-.1-.1-.2-.1-.2-.2h-.2s-.2.4-.4.7c-.2.3-.3.4-.6.7-.4.4-.7.5-1.3.7-.3.1-.5.1-.8.2-.9.2-1.5.1-2.5.1H154c-.8 0-1.3.1-2.1.2-1.1.2-1.9.3-2.9.6.2-.5.3-.9.4-1.5 0-.5.1-.8 0-1.3 0-.3-.1-.4-.2-.7-.2-.6-.3-.9-.6-1.4-.2-.4-.4-.6-.8-.9-.5-.4-.8-.6-1.4-.8-.4-.1-.6-.2-1-.2-.8-.1-1.3-.1-2 .3-.4.2-.7.4-1 .7-.3.3-.4.5-.6.9-.1.2-.1.4-.2.6v.7c.1.4.2.7.5 1 .1.1.2.2.4.3.1.1.2.2.4.2.2.1.3.1.6.1h.6c.2 0 .3-.1.5-.2l.4-.2.5-.5c.1-.2.2-.3.2-.4.1-.3.1-.5.1-.9 0-.3-.1-.5-.2-.8h.2s.4.3.7.5l.3.3c.2.3.2.4.3.7.1.4.2.6.2 1v.6c0 .2-.1.4-.1.6-.1.3-.2.4-.3.7-.2.3-.3.5-.6.8l-.5.5c-.3.2-.4.4-.7.6l-1 .5c-.4.1-.6.2-1 .3-.6.2-1 .2-1.6.3-1 .1-1.6.1-2.5-.2-.7-.2-1.2-.4-1.7-.7v-.1s.3-.2.5-.3l.4-.4c.2-.3.3-.5.3-.8.1-.3.1-.5 0-.8-.1-.4-.2-.6-.4-.9l-.3-.3-.3.6c-.2.2-.2.3-.4.5s-.3.3-.6.4l-.6.3c-.3.1-.5.1-.8.2-.3 0-.5.1-.9.1s-.6 0-1-.1-.6-.1-.9-.3c-.3-.1-.4-.2-.6-.3-.3-.2-.6-.3-.8-.6-.3-.3-.5-.5-.7-.9-.1-.2-.2-.4-.3-.7-.1-.3-.2-.4-.2-.7 0-.2 0-.4.1-.5.1 0 .6.4 1.2.4.9 0 2.2-.5 2.2-2 0-1.6-1.6-2.2-2.7-2.2s-1.9.5-1.9.5c-.2.2-.4.3-.7.7-.1-.1-.3-.1-.3-.2-.2.2-1.6 3.1-1.2 2.5h0zM102.5 32.9c-.1 0-.2.1-.2.1v.7c0 .5-.1.8-.3 1.3-.1.3-.3.7-.3.7s-.6 1-1 1.5c-.4.4-.6.7-1 1.1-.6.6-1.1.9-1.8 1.5-.4.4-.7.6-1.1 1.1-.5.7-.8 1.2-1 2.1 0 .3-.1.4-.1.7 0 .4.1.6.2.9-.1.1-.9.2-1.2.1 0 0-.3-.1-.5-.3-.2-.1-.2-.2-.3-.3-.2-.2-.3-.4-.4-.6-.1-.2-.1-.3-.2-.6v-.6c0-.2.1-.3.1-.4-.6.2-1 .4-1.7.6-.9.2-1.5.2-2.3.2.6.7 1.2 1.3 1.9 2.3.3.5.5.7.8 1.2.4.7.6 1.1.8 1.9.2.5.3.7.4 1.2.2.8.3 1.3.4 2.2.1.6.1.9.1 1.4v1.4c0 .6-.1.9-.2 1.5-.2.9-.3 1.4-.6 2.3-.1.4-.2.6-.4 1-.2.6-.4.9-.7 1.4-.2.4-.4.6-.6 1-.5.8-.8 1.2-1.5 1.8-.3.4-.6.6-.9.9-.4.4-.7.6-1.1.9-.5.4-.8.5-1.4.8-.4.2-.6.3-.9.5-.5.2-.9.4-1.4.5-.8.3-1.3.4-2.1.6-.9.2-1.5.2-2.4.2h-1.8c-.8 0-1.2-.1-2-.2-.6-.1-.9-.2-1.4-.3-1.2-.3-1.9-.5-3.1-.9-1.9-.6-2.5-.9-4.4-1.5-1.3-.4-2-.6-3.4-.8-.6-.1-1-.2-1.6-.2-1.1-.1-1.7-.1-2.7 0-1.1.1-1.8.2-2.8.5-1.2.4-2.5 1.1-2.8 1.3 0-.4 0-.8.1-1.2.1-.3.1-.4.3-.7.1-.2.2-.4.4-.6.2-.2.3-.4.5-.6.2-.2.4-.3.7-.5.3-.2.5-.3.8-.4.6-.3 1.1-.4 1.7-.6-.5-.4-1-.6-1.7-1-1.5-.8-2.3-1.1-3.8-1.7-.9-.4-1.4-.5-2.4-.8-.9-.3-1.4-.5-2.3-.7-.8-.2-1.2-.3-2-.4-.6-.1-.9-.1-1.5-.1-.7 0-1.2-.1-1.9 0-.8.1-1.2.2-1.9.4-.5.2-.8.3-1.3.5-.6.3-.9.5-1.4.9-.2.2-.4.3-.6.5-.3.3-.4.5-.6.8-.2.2-.2.4-.3.6-.1.2-.2.4-.3.7-.1.4-.1.7-.1 1.2 0 .3 0 .5.1.8.1.4.2.6.4 1s.4.6.7.9c.3.3.5.4.9.6.3.1.4.2.7.3.5.2.8.3 1.4.3.5 0 .8-.1 1.3-.2.3-.1.5-.2.8-.3.2-.1.3-.2.4-.3-.2-.2-.4-.3-.6-.5-.2-.2-.2-.3-.4-.5-.1-.2-.2-.4-.2-.6v-.5c0-.2.1-.3.1-.5.1-.2.2-.4.3-.5.2-.3.4-.5.7-.6.2-.1.4-.1.7-.2h.7c.2 0 .4.1.6.1.2.1.3.1.4.2.2.1.4.2.6.5.1.2.2.3.3.5.1.2.1.3.1.5.1.5.1.7 0 1.2 0 .3-.1.5-.2.8-.1.2-.2.3-.3.6-.2.3-.3.4-.5.7-.2.3-.4.4-.6.6-.3.2-.4.3-.7.5-.6.4-1 .5-1.7.7-.3.1-.5.1-.9.2s-.6.1-1 .1-.6 0-1-.1c-.4 0-.7-.1-1.1-.2-.4-.1-.6-.2-.9-.4-.3-.1-.5-.2-.8-.4-.3-.2-.5-.3-.8-.6-.3-.3-.5-.4-.7-.7-.2-.3-.3-.5-.5-.8-.2-.4-.3-.6-.4-1-.1-.3-.1-.5-.2-.8-.1-.5-.1-.7-.1-1.2 0-.4 0-.6.1-.9.1-.6.2-1 .4-1.6.1-.3.2-.4.3-.7.3-.5.4-.8.8-1.2.3-.4.4-.5.8-.8.3-.3.5-.4.8-.6.3-.2.5-.4.8-.6.6-.3.9-.5 1.5-.7.4-.2.7-.2 1.2-.3.5-.1.8-.1 1.2-.2.9-.1 1.4-.2 2.3-.2.8 0 1.2 0 2 .1.7.1 1.1.1 1.7.2.7.1 1 .2 1.7.4 1 .3 1.5.5 2.5.8 1.6.6 2.4.9 4 1.6 1.1.5 1.7.8 2.8 1.4.7.4 1.1.6 1.7 1-.1-.3-.1-.5-.1-.8 0-.2 0-.3.1-.5.1-.3.1-.5.4-.8.1-.2.2-.2.4-.4.2-.1.3-.2.5-.2.3-.1.9-.2.9-.2s0 .1-.1.2c-.1.4 0 .6 0 1 0 .3.1.5.2.7.1.2.1.3.3.5.1.2.3.3.4.5.3.3.5.4.8.7.4.3.6.4 1 .7.9.6 1.5.8 2.6 1.2 1.5.6 2.5 1 3.9 1.4-.3-.6-.7-1-1-1.6-.2-.4-.3-.6-.4-1-.1-.5-.2-.8-.2-1.3-.1-.7 0-1.1.1-1.8.1-.6.2-1 .5-1.6.1-.3.2-.5.4-.8.2-.3.3-.5.5-.8.2-.3.4-.4.6-.7.6-.5 1-.8 1.7-1.1.3-.1.4-.2.7-.3.8-.3 1.3-.4 2.2-.5h1.1c.4 0 .6.1 1 .2s.6.1.9.3c.4.2.7.3 1 .6.2.1.3.2.5.4s.3.3.4.6c.2.4.3.6.4 1.1v.6c0 .4-.1.6-.3 1-.2.4-.3.6-.6.9-.2.2-.3.2-.5.4-.2.1-.3.1-.5.2-.3.1-.5.1-.8.2h-.6c-.3 0-.4-.1-.7-.2-.2-.1-.3-.2-.5-.3-.2-.2-.3-.3-.4-.5-.1-.2-.2-.3-.2-.5-.1-.2-.1-.3-.1-.5s0-.3.1-.6c0-.2.1-.3.2-.5s.2-.3.3-.4c.3-.2.5-.4.8-.5.1-.1-.1-.1-.1-.1-.2-.1-.3-.1-.5-.1h-1c-.6.1-1 .3-1.6.6-.3.2-.5.3-.8.6l-.8.8c-.2.2-.3.4-.4.6-.2.3-.2.5-.3.9-.1.3-.1.5-.1.8 0 .5 0 .8.1 1.3.1.4.1.6.2.9.3.9.6 1.5 1.4 2.1.2.2.4.3.6.5.3.2.5.3.8.5.5.2.7.3 1.2.4.3.1.4.1.7.1h1.2c.5 0 .8-.1 1.3-.2s.7-.3 1.1-.5c.5-.3.7-.4 1.1-.8.3-.4.5-.6.7-1.1.1-.2.2-.3.2-.5.1-.5 0-.9-.1-1.3.2.1.4.1.6.2.2.1.3.1.4.2.2.2.4.3.6.5.2.2.3.4.5.7.2.4.2.6.3 1 .4-.2.8-.4 1.2-.7.3-.2.4-.4.7-.7.2-.3.3-.4.5-.7.7-1 .9-1.7 1.1-3 0-.3.1-.4.1-.7v-1.3c0-.4-.1-.6-.2-1-.1-.5-.2-.9-.5-1.4-.2-.4-.3-.6-.6-1-.2-.2-.3-.4-.6-.6-.2-.2-.3-.3-.6-.4l-.6-.3c-.3-.1-.4-.1-.7-.2h-.6c-.4 0-.6 0-.9.1-.5.2-.8.4-1.2.6l-.1-.1c-.2-.4-.2-.7-.2-1.1v-.9c.1-.5.1-.8.3-1.2.1-.2.2-.3.3-.5.2-.3.3-.5.6-.7.2-.2.3-.3.5-.4.4-.2.7-.4 1.1-.5 0-.1-.1-.2-.1-.3-.2-.4-.4-.5-.7-.8-.6-.6-1-.8-1.7-1.2-.5-.3-.8-.4-1.4-.7-.4-.2-.7-.2-1.1-.4-.6-.2-1-.3-1.6-.4-.8-.1-1.2-.1-1.9-.1-.4 0-.7.1-1.1.1-.7.1-1 .2-1.7.5-.6.3-.9.4-1.4.8-.3.2-.4.3-.7.5-.3.3-.5.5-.8.9-.3.4-.5.7-.7 1.2-.2.5-.3.8-.4 1.4-.1.5-.1.8 0 1.3 0 .3.1.4.1.7.1.4.2.6.3 1 0 0-.6.1-.9.1-.3 0-.5-.1-.7-.2-.3-.1-.5-.2-.8-.4-.3-.2-.5-.4-.8-.6-.4-.4-.6-.7-.9-1.2-.2-.3-.2-.4-.4-.7-.2-.4-.3-.8-.4-1.1-.3.3-.5.5-.7.9-.2.3-.3.5-.4.8-.3.6-.4.9-.5 1.5-.2.7-.2 1.1-.3 1.9v1.1c0 .9.1 1.6.2 2.3l-.1.1c-.3.1-.6 0-.9-.1-.3-.2-.4-.3-.7-.5-.3-.2-.4-.4-.7-.6-.3-.3-.4-.5-.6-.8-.2-.3-.2-.4-.4-.7-.3-.7-.4-1.2-.6-1.9l-1 1c-.3.3-.5.5-.9.8-.6.5-1 .8-1.6 1-.2-.3-.3-.5-.4-.9-.2-.6-.2-.9-.3-1.5 0-.4-.1-.7 0-1l-.1-.1c-.2.1-.3.2-.3.2-.4.3-.8.6-1.3.9-.2.1-.3.2-.6.3-.3.1-.5.2-.8.3-1 .3-1.8.3-2.8.3h-20c.4.9.6 1.3.8 2.2.1.6.2.9.3 1.5.1.5.1.8.1 1.3 0 .8.1 1.2 0 2-.1.6-.1 1-.3 1.6-.2.9-.3 1.5-.7 2.3-.1.4-.2.6-.4 1l-.5 1c-.2.3-.3.5-.5.8-.2.3-.4.4-.6.7-.3.3-.4.4-.7.6-.3.2-.5.4-.8.5-.5.3-.8.4-1.3.5-.3.1-.5.1-.9.1h-1.1c-.4 0-.6-.1-.9-.2-.2-.1-.4-.1-.6-.3-.3-.2-.5-.3-.8-.5l-.5-.5c-.1-.2-.2-.3-.3-.5-.1-.2-.1-.4-.2-.7-.1-.3-.1-.5-.1-.8 0-.5 0-.7.2-1.2.1-.3.1-.5.3-.7.2-.3.3-.5.6-.8.2-.2.3-.3.5-.4.2-.2.3-.2.6-.3.3-.1.5-.2.8-.2.4 0 .7-.1 1.1.1.2.1.4.2.5.4v.1l-.9.3c-.3.2-.5.2-.7.5-.2.2-.3.4-.4.7-.1.2-.1.3-.2.5v.4c0 .2 0 .4.1.6.1.2.1.3.2.5l.3.3c.1.1.2.2.4.3.3.2.5.2.9.2.2 0 .4 0 .6-.1.3-.1.4-.1.7-.2.3-.1.5-.2.8-.4.5-.4.7-.7 1-1.3.2-.3.3-.5.4-.8.3-.5.4-.8.6-1.4.1-.4.2-.7.3-1.1.1-.5.2-1.2.2-1.2s.1-1.2.1-2c0-1 0-1.6-.3-2.6-.1-.5-.2-.8-.4-1.3s-.3-.8-.5-1.2c-.4-.7-.6-1.1-1.2-1.7-.4-.5-.8-.8-1.3-1.1 0-.1 0 0 .1-.1H37c.3-.3.4-.5.6-.9.2-.3.2-.4.3-.8.2-.6.2-.9.2-1.5s0-1-.1-1.6c-.1-.3-.1-.5-.2-.9s-.3-.7-.5-1c-.2-.3-.3-.4-.5-.6-.3-.2-.4-.3-.7-.4-.2-.1-.4-.1-.6-.2h-.6c-.2 0-.3.1-.4.2-.1.1-.2.1-.3.3-.2.2-.3.3-.4.6-.1.3 0 .5.1.8.1.2.1.3.3.5.2.2.3.2.6.3.3 0 .5-.1.8-.3 0-.1.3-.2.4-.1 0 .3-.1.6-.3.9-.2.3-.3.4-.5.6-.2.1-.3.2-.5.2-.3.1-.4.1-.7.1-.4 0-.7-.1-1.1-.2-.3-.2-.5-.3-.8-.6-.2-.2-.3-.3-.4-.6-.1-.3-.1-.6-.2-.8v-1.1c.1-.5.2-.7.4-1.1.1-.2.3-.3.4-.5l.5-.5c.3-.2.5-.3.9-.4.4-.1.6-.2 1-.2.5 0 .8 0 1.3.2.3.1.5.2.8.3.5.2.8.5 1.2.8-.1-.9-.2-1.6-.2-2.6 0-.9 0-1.4.2-2.3.1-.5.2-.8.4-1.3.2-.4.2-.6.5-.9.2-.2.4-.4.5-.4.3.3.4.6.6 1 .3.6.4.9.5 1.5.1.5.2.8.2 1.3v1.2c0 1-.2 1.7-.3 2.5.2-.1.3-.2.5-.3.3-.2.5-.3.9-.5.2-.1.4-.1.6-.2.5-.1.8-.1 1.2-.1.2 0 .3 0 .5.1.5.1.7.2 1.1.5.2.1.3.2.5.4.4.4.6.6.8 1.1.1.3.1.4.2.7.1.5 0 .9-.2 1.4-.2.5-.3.8-.7 1.1-.1.1-.2.2-.4.3-.2.1-.3.1-.5.2-.3.1-.5.2-.9.2-.3 0-.4 0-.7-.1-.3-.1-.4-.1-.6-.3l-.3-.3c-.1-.2-.2-.3-.2-.5-.1-.3 0-.5 0-.8 0 0 .1-.1.1 0 0 0 .1.2.2.3.1.1.2.1.3.1.3.1.5.1.8-.1.1-.1.2-.1.3-.2.1-.1.2-.2.3-.4.1-.2.1-.4.1-.7 0-.3-.1-.5-.3-.7-.2-.3-.5-.3-.8-.3h-.6c-.4.1-.6.2-1 .4-.2.1-.3.2-.5.4s-.2.3-.4.5-.2.4-.3.6c-.2.6-.3.9-.4 1.5v1.1c0 .4 0 .6.1 1s.1.6.2.9c.2.5.3.8.6 1.1h8.7s-.4-.2-.6-.4l-.5-.5c-.2-.2-.3-.3-.4-.5-.2-.3-.2-.5-.3-1v-.2s.2.1.3.1c.1.1.2.1.3.1.3.1.5.2.9.3.7.2 1.1.1 1.8 0 .3 0 .5-.1.8-.1.5-.1.8-.3 1.3-.5.6-.3.9-.6 1.5-.9 1.9-1.3 2.6-2.5 4.5-3.8 1-.7 1.6-1.2 2.7-1.8.6-.3.9-.5 1.5-.7 1.1-.5 1.9-.7 2.9-1.1-.1-.2-.3-.2-.5-.4-.1-.1-.2-.2-.3-.4-.2-.2-.2-.4-.3-.6-.1-.2-.1-.4-.1-.6v-.5c0-.2.1-.4.1-.6.1-.3.2-.5.4-.8.1-.1.2-.1.2-.2h.1s.2.4.4.7c.2.3.3.4.6.7.4.4.7.5 1.3.7.3.1.5.1.8.2.9.2 1.5.1 2.5.1h3.4c.8 0 1.3.1 2.1.2 1.1.2 1.9.3 2.9.6-.2-.5-.3-.9-.4-1.5-.1-.5-.1-.8 0-1.3 0-.3.1-.4.2-.7.2-.6.3-.9.6-1.4.2-.4.4-.6.7-.9.5-.4.8-.6 1.4-.8.4-.1.6-.2 1-.2.8-.1 1.3-.1 2 .3.5.2.7.4 1 .7.3.3.4.5.6.9.1.2.1.4.2.6v.7c-.1.4-.2.7-.5 1-.1.2-.2.2-.4.4-.1.1-.2.2-.4.2-.2.1-.3.1-.6.1h-.6c-.2 0-.3-.1-.5-.2l-.4-.2-.5-.5c-.1-.2-.2-.3-.2-.4-.1-.3-.1-.5-.1-.9 0-.3.1-.5.2-.8H83s-.4.3-.7.5l-.3.3c-.2.3-.2.4-.3.7-.1.4-.2.6-.2 1v.5c0 .2.1.4.1.6.1.3.2.4.3.7.2.3.3.5.5.8l.5.5c.3.2.4.4.7.6l1 .5c.4.2.6.2 1 .3.6.2 1 .2 1.6.3 1 .1 1.6.1 2.5-.2.7-.2 1.2-.4 1.7-.7v-.1s-.3-.2-.5-.3c-.2-.1-.2-.2-.4-.4-.2-.3-.3-.5-.3-.8-.1-.3-.1-.5 0-.8.1-.4.2-.6.4-.9l.3-.3.3.6c.2.2.2.3.4.5s.3.3.6.4l.6.3c.3.1.5.1.8.2.3 0 .5.1.9.1s.6 0 1-.1.6-.1.9-.3c.3-.1.4-.2.6-.3.3-.2.5-.3.8-.6.3-.3.5-.5.7-.9.1-.2.2-.4.3-.7.1-.3.2-.4.2-.7 0-.2 0-.4-.1-.5-.1 0-.6.4-1.2.4-.9 0-2.2-.5-2.2-2 0-1.6 1.6-2.2 2.7-2.2s1.9.5 1.9.5c.2.2.4.3.7.7l.1-.1c.4.1 1.9 3 1.6 2.4h0z"
    />
    <path
      className="st9"
      d="M100.9 16.5c0 .5.1 4.9.1 4.9l2.2 7.7 5.1 8.4 6.1 4.4 5.6-3.5 5.7-7.4 3.3-8.3-.2-6.5-5.8 1.9-7.1-2.6-4.3 2-7.9-.1c-.1.1-2.8-1.4-2.8-.9z"
    />
    <path
      className="st9"
      d="m115 22.9 14.9 13.6 8.2-1.2 4.5-.4 12.4 4.7 17.4 8.3 14 3.1 13.1.2 1.1 10.6 7 10.2H21.8l5.4-5.7 2.2-9.9-1.6-5.7 21-.3 6.9-4.8 14.6-8.2 9.7-.3 8.4-1 5.4 2.6 6.6-2.9 4.8-10.1z"
    />
    <path className="st1" d="M114 69.6h101v21.6H114z" />
    <path className="st1" d="M13.5 69.6h101v21.6h-101z" />
    <path
      className="st11"
      d="M14.1 173.8s-.2.8-.9 2.1-.9 2.2-.9 2.2l-.9-2-.5-4.8 1.7-5.8 1.6 1.7v6.6h-.1zM213.7 173.8s.2.8.9 2.1 1 2.2 1 2.2l.9-2 .5-4.8-1.7-5.8-1.6 1.7v6.6z"
    />
    <path
      className="st10"
      d="M25.6 160.3c0 2.5-.8 3.8-1 6.2 0 .4-.1.6-.1 1 0 0-.1.1-.2.1-.2-.4-.4-.6-.7-1-.3-.5-.4-.8-.6-1.3-.2-.5-.2-.9-.3-1.4-.2-.8-.2-1.6-.2-2.2 0 0 0 0 0 0-.2-.8 0-1.9 0-2.9-.1-1.2 0-2.3-.3-3.7-.2-.9-.5-1.4-.8-2.3-.1-.3-.5-.7-.4-.8.2-.2.5.1.7.2 2.8 1.6 3.9 4.4 4 7.8-.1.1-.1.2-.1.3h0zM11.4 158.2c2.5 2 3.7 4.7 4.1 8.2.2 1.7.1 2.7-.3 4.3-.1.4-.2.6-.3 1-.2.8-.4 1.4-.7 2-.1.1-.2.2-.2 0 0-1.3.2-2.5-.1-4-.2-1.2-.5-2-.9-3-.1.1-.1.2-.2.3-.5 1.3-.8 2.5-1 4.1-.3 2.6-.1 4.6.5 6.7 0 .2-.1.3-.3.1-1.2-1.4-1.9-2.9-2.4-5-.4-2-.4-3.2 0-5.2.4-2.2 1.3-3.3 1.4-5.6.1-1.6.1-2.8-.3-4.1 0-.1 0-.1.1-.2.2.1.5.3.6.4h0z"
    />
    <path
      className="st10"
      d="M20.3 165.4c4.3 4.6 4.1 9.1 5 15.4.1 1 .1 1.8.3 2.6 1.1-1.1 2.5-1.8 4.1-1.7 0 .1-.1.2-.1.4-1.5 2.5-1.5 5.8-.7 8.6.4 1.6 1 3 1.6 4.5l1.2 3c.8 2.3 1.1 4.8 1.2 7.3 0 3.4-.7 6.9-2.7 9.7-.5.8-1.1 1.4-1.6 2.2-.8.7-1.6 1.4-2.6 1.9-.4.2-.9.5-1.4.5.8-1.8 1.9-3.8 2.1-5.9.1-1.4.3-2.6.2-3.9-.2-2.9-1.3-5.5-2.9-7.9-1.5-1.9-2.9-3.9-3.8-6-.6 2.6-1.5 5.3-3.1 7.5-.4.9-1.1 1.5-1.4 2.4-1.2 2-2.2 4.1-2.7 6.5-.3 2.5-.1 5 1.2 7 0 .1-.1.1-.1.1l-.1-.1-.1.1c-2.3-.3-4.2-2-5.7-3.8-2.7-3.5-3.5-7.9-3.2-12.3 0-1.7.1-3.4 0-5.1-.2-2.2-.5-4.5-1.4-6.5 0-.1.1-.1.1-.2 1.2.3 2.3.9 3.3 1.6 1.1.8 1.9 1.7 2.7 2.7-.1-5.1 1.8-10 3.9-14.6.8-1.9 1.7-3.7 2.6-5.6 1.7-3.6 3-7.4 3-11.6 0-.1-.1-.2 0-.3.3.4.6.9 1.1 1.5h0zM28.2 222.4c0 .1.1.1.1.2-.1.1 0 .2-.1.3-1.4.4-2.8 1.4-3.6 2.7-.4.5-.6 1.1-.9 1.7-1.5-.1-1.1-.1-3.6-.1-3.1 0-1.3 0-3.8.1-.3-.5-.6-1.1-.9-1.6-.8-1-1.9-2.1-3.2-2.5-.3-.2-.7-.3-1-.5-.1-.1 0-.3 0-.4 5.1-1.7 11.7-1.8 17 .1h0z"
    />
    <path
      className="st11"
      d="M23.2 228.9v3.2c1.2 0 3-.2 4.2.5.8.5 1.1 1.4 1 2.3-.2.9-.7 1.7-1.6 1.9-.8.3-1.6.2-2.5.2h-1.1v3.9c-.2.3.2.3-.1.4-2.2.4-4.7.5-6.8.5v-4.7h-2c-.7-.1-1.6-.1-2.2-.5-.8-.5-1.2-1.5-1.1-2.4.1-.8.8-1.7 1.6-1.9 1.2-.3 2.3-.1 3.6-.1v-3.3h7z"
    />
    <path
      className="st10"
      d="M202.3 160.3c0 2.5.8 3.8 1 6.2 0 .4.1.6.1 1 0 0 .1.1.2.1.2-.4.4-.6.7-1 .3-.5.4-.8.6-1.3.2-.5.2-.9.3-1.4.2-.8.2-1.6.2-2.2 0 0 0 0 0 0 .2-.8 0-1.9 0-2.9.1-1.2 0-2.3.3-3.7.2-.9.5-1.4.8-2.3.1-.3.5-.7.4-.8-.1-.2-.5.1-.7.2-2.8 1.6-3.9 4.4-4 7.8.1.1.1.2.1.3h0zM216.5 158.2c-2.5 2-3.7 4.7-4.1 8.2-.2 1.7-.1 2.7.3 4.3.1.4.1.6.3 1 .2.8.4 1.4.7 2 .1.1.2.2.2 0 0-1.3-.2-2.5.1-4 .2-1.2.5-2 .9-3 .1.1.1.2.2.3.5 1.3.8 2.5 1 4.1.3 2.6.1 4.6-.5 6.7 0 .2.1.3.3.1 1.2-1.4 1.9-2.9 2.4-5 .4-2 .4-3.2 0-5.2-.4-2.2-1.3-3.3-1.4-5.6-.1-1.6-.1-2.8.3-4.1 0-.1 0-.1-.1-.2-.2.1-.5.3-.6.4h0z"
    />
    <path
      className="st10"
      d="M207.5 165.4c-4.3 4.6-4.2 9.1-5 15.4-.1 1-.1 1.8-.3 2.6-1.1-1.1-2.5-1.8-4.1-1.7 0 .1.1.2.1.4 1.5 2.5 1.5 5.8.7 8.6-.4 1.6-1 3-1.6 4.5l-1.2 3c-.8 2.3-1.1 4.8-1.2 7.3 0 3.4.7 6.9 2.7 9.7.5.8 1.1 1.4 1.7 2.2.8.7 1.6 1.4 2.6 1.9.4.2.9.5 1.4.5-.8-1.8-1.9-3.8-2.1-5.9-.1-1.4-.3-2.6-.2-3.9.2-2.9 1.3-5.5 2.9-7.9 1.5-1.9 2.9-3.9 3.8-6 .6 2.6 1.5 5.3 3.1 7.5.4.9 1.1 1.5 1.4 2.4 1.2 2 2.2 4.1 2.7 6.5.3 2.5.1 5-1.2 7 0 .1.1.1.1.1l.1-.1.1.1c2.3-.3 4.2-2 5.7-3.8 2.7-3.5 3.5-7.9 3.2-12.3 0-1.7-.1-3.4 0-5.1.2-2.2.5-4.5 1.4-6.5 0-.1-.1-.1-.1-.2-1.2.3-2.3.9-3.3 1.6-1.1.8-1.9 1.7-2.7 2.7.1-5.1-1.8-10-3.9-14.6-.8-1.9-1.7-3.7-2.6-5.6-1.7-3.6-3-7.4-3-11.6 0-.1.1-.2 0-.3-.3.4-.6.9-1.2 1.5h0z"
    />
    <path
      d="M199.7 222.4c0 .1-.1.1-.1.2.1.1 0 .2.1.3 1.4.4 2.8 1.4 3.6 2.7.4.5.6 1.1.9 1.7 1.5-.1 1.1-.1 3.6-.1 3.1 0 1.3 0 3.8.1.3-.5.6-1.1.9-1.6.8-1 1.9-2.1 3.2-2.5.3-.2.7-.3 1-.5.1-.1 0-.3 0-.4-5.2-1.7-11.8-1.8-17 .1z"
      style={{
        fill: '#fff',
        stroke: '#fff',
        strokeWidth: 4.0448,
        strokeLinejoin: 'round',
        strokeMiterlimit: 30,
      }}
    />
    <path
      className="st11"
      d="M204.6 228.9v3.2c-1.2 0-3-.2-4.2.5-.8.5-1.1 1.4-1 2.3.2.9.7 1.7 1.6 1.9.8.3 1.6.2 2.5.2h1.1v4c.2.3-.2.3.1.4 2.2.4 4.7.4 6.8.4v-4.7h2c.7-.1 1.6-.1 2.2-.5.8-.5 1.2-1.5 1.1-2.4-.1-.8-.8-1.7-1.6-1.9-1.2-.3-2.3-.1-3.6-.1v-3.3h-7zM33 92.6c.4.3.8.8 1.2 1.1 2.1 2 4.3 3.5 6.7 5 .5.2 1 .6 1.5.8 4.6 2.5 9.5 4.3 14.6 5.4 1.2.3 2.5.5 3.7.7 4 .6 8.1.9 12.1.7 11.2-.6 21.1-4.2 30.2-10 1.7-1.1 3.5-2.4 5.1-3.7.1-.1.2-.1.3-.1 3.6 0 7.3 0 11 .1.2.2.5 0 .7.2.9.7 1.6 1.3 2.6 2.1 1.8 1.3 2.9 2 4.8 3.2 4.4 2.6 7 3.8 11.8 5.5 1.6.6 2.5.9 4.2 1.3 11.4 3.1 19 3 30.4-.2 7.8-2.2 12.3-4.1 18.6-9.1.7-.5 1.1-.8 1.7-1.4.5-.5.8-.8 1.2-1.3l.1.1.1-.1c1 .1 2.1-.1 3.1.1.3 3.9.4 7.9.7 11.8 0 2.9.1 5.4.1 8.8 0 4.6.1 7.8-.1 11.7-.1 5.3-.3 9.8-.7 16-.4 5.4-.7 9.2-1.2 13.8-.3 2-.5 4-.8 6-1.2 8.5-3 16.8-5.2 24.9-2 7.9-4.5 15.5-7.2 23.1-1.9 5.3-4.1 10.5-6.4 15.7-.8 1.8-1.6 3.6-2.5 5.3-.8 1.7-1.7 3.4-2.5 5.1-1.1 2-2.1 3.8-3.3 5.9-1.3 2.2-2.7 4.6-4.1 6.8-1.9 3-3.9 5.9-5.9 8.7-2.5 3.4-5.1 6.7-7.8 10-.7.8-1.3 1.6-2.1 2.3 0 0 0 .1-.1.2-.1-.1-.1.1-.2.1-2-.4-4-.9-6-1.3 2.3-2.8 4.7-5.3 6.8-8 5.6-7.2 10.7-14.9 15.2-22.8.7-1.3 1.4-2.6 2.1-3.8 1.7-3.2 3.2-6.3 4.7-9.4.5-1.4 1.2-2.8 1.9-4.2 2.2-4.9 4.1-9.8 5.8-14.8l2.4-7.1c.6-1.7 1.1-3.6 1.6-5.3 1.9-6.3 3.5-12.6 4.8-19 .4-2.3 1-4.6 1.3-6.9.8-4.4 1.4-8.1 2-13.3.9-7 1.1-11 1.4-18.1.1-2.4.2-3.8.3-6.3.3-9.3.8-14.6 0-23.9-.1-1.1-.1-1.9-.3-2.9-.1-.1-.2 0-.3 0-8.2 5.2-16 8.6-27.2 10-2.8.3-4.4.5-7.3.5-4.1 0-6.5-.2-10.5-.9-1.5-.3-2.4-.4-3.9-.8-6.9-1.6-10.8-3.1-17.1-6.3-.9-.5-1.4-.7-2.2-1.2-4.6-2.6-7.7-4.8-11.2-7.6-.4.2-.7.5-1 .8-4.7 3.7-8.9 6.4-15.3 9.2-10.4 4.7-17.1 6.6-28.4 6.5-8.8-.1-14-1.1-22.3-4.3-2.5-1-3.9-1.7-6.3-2.9-2.5-1.3-4.3-2.3-6.3-3.6-.2 1.1-.2 2.3-.3 3.4l-.2 7.9c-.1 2.9-.1 5.8-.1 8.8.1 6.2.3 11.9.7 18l.4 5.5c.2 2.6.6 5.2.7 7.8 1.2 10 2.9 19.7 5.3 29.3 1 4 2.1 8 3.3 11.9.9 3 1.9 6.1 2.9 9.2.8 2.3 1.6 4.5 2.4 6.7 1.7 4.5 3.5 8.8 5.6 13.3h-.1c2.1 4.5 4.4 8.8 6.8 13.2 4.5 8 9.4 15.6 14.9 22.8 2.3 2.8 4.7 5.7 7.2 8.4-2.1.5-4.1.9-6.1 1.3-.1 0-1.3-1.3-1.8-1.9-2.7-3.2-5.2-6.5-7.7-9.9-2.9-4-5.5-8.1-8.1-12.2v-.1l-.1-.1c-1.1-1.7-2.1-3.6-3.1-5.4-.1-.4-1-2-1.3-2.5-4.2-7.8-7.7-15.9-10.9-24.1-3.9-10.5-7.3-21.1-9.8-32l-1.6-7.4c-1.6-7.6-2.8-15.3-3.5-23-.5-5.6-.8-11.3-1.1-16.8l-.3-6.7-.1-5.7c-.1-3.4.1-6.9.1-10.3.1-4.1.2-8 .5-12.1.1-1.9.2-4 .4-6 0-.1.1-.1.2-.1l3.7-.1z"
    />
    <linearGradient
      id="SVGID_8_"
      gradientUnits="userSpaceOnUse"
      x1={72.359}
      y1={92.713}
      x2={30.491}
      y2={92.713}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_8_)',
      }}
      d="M13.5 69.6h101v21.6h-101z"
    />
    <linearGradient
      id="SVGID_9_"
      gradientUnits="userSpaceOnUse"
      x1={156.071}
      y1={92.713}
      x2={198.154}
      y2={92.713}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_9_)',
      }}
      d="M114 69.6h101v21.6H114z"
    />
    <path
      className="st9"
      d="m32.3 96.2-1.4 22.2s1.4 40.8 5.7 57.4c4.3 16.6 18 52.8 20 57.4 2 4.6 23.7 35 23.7 35s16.7-4.1 32.4-4.1c17.9 0 33.8 4.4 33.8 4.4l17.4-23.1s19.4-30.2 25.7-62.2c6.3-32 6.3-83.3 6.3-83.3s-27.7 10-37.1 10c-9.4 0-44.5-16-44.5-16S93.2 109 69.5 109c-23.8.1-37.2-12.8-37.2-12.8z"
    />
    <linearGradient
      id="SVGID_10_"
      gradientUnits="userSpaceOnUse"
      x1={29.393}
      y1={175.777}
      x2={29.393}
      y2={201.393}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="M14.1 173.8s-.2.8-.9 2.1-.9 2.2-.9 2.2l-.9-2-.5-4.8 1.7-5.8 1.6 1.7v6.6h-.1z"
      style={{
        fill: 'url(#SVGID_10_)',
      }}
    />
    <linearGradient
      id="SVGID_11_"
      gradientUnits="userSpaceOnUse"
      x1={198.437}
      y1={174.824}
      x2={198.437}
      y2={199.316}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="M213.7 173.8s.2.8.9 2.1 1 2.2 1 2.2l.9-2 .5-4.8-1.7-5.8-1.6 1.7v6.6z"
      style={{
        fill: 'url(#SVGID_11_)',
      }}
    />
    <path
      className="st9"
      d="m204.3 227.2.3 1.7 6.9.1.2-1.7-5.3-.9-2.1.8zM16.2 227h7.4l-.4 2h-6.9l-.1-2z"
    />
    <linearGradient
      id="SVGID_12_"
      gradientUnits="userSpaceOnUse"
      x1={192.408}
      y1={174.825}
      x2={192.408}
      y2={199.321}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="m208.9 191.2.7 5.5 3.8 8.3s2.2 4.6 2.4 5.2c.2.6.1 5.7.1 5.7l-1.9 3.6s-4.1.2-5.8.1c-1.7-.1-4.9.1-4.9.1l-2.9-3.7-.2-6.5 1.5-7 4.2-6.7 3-4.6z"
      style={{
        fill: 'url(#SVGID_12_)',
      }}
    />
    <linearGradient
      id="SVGID_13_"
      gradientUnits="userSpaceOnUse"
      x1={35.642}
      y1={175.778}
      x2={35.642}
      y2={201.394}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="M17.5 219.7s-2.9 0-3.9-.2c-1-.3-1.7-6.6-1.7-6.6l2.8-10 4.8-10.5 3.2 5.7 3.9 5.5 1.4 6.1-1.3 5.7-1.9 4.3s-2.6-.1-3.5-.1c-.9-.1-3.8.1-3.8.1z"
      style={{
        fill: 'url(#SVGID_13_)',
      }}
    />
    <path
      className="st19"
      d="M25.6 160.3c0 2.5-.8 3.8-1 6.2 0 .4-.1.6-.1 1 0 0-.1.1-.2.1-.2-.4-.4-.6-.7-1-.3-.5-.4-.8-.6-1.3-.2-.5-.2-.9-.3-1.4-.2-.8-.2-1.6-.2-2.2-.2-.8 0-1.9 0-2.9-.1-1.2 0-2.3-.3-3.7-.2-.9-.5-1.4-.8-2.3-.1-.3-.5-.7-.4-.8.2-.2.5.1.7.2 2.8 1.6 3.9 4.4 4 7.8-.1.1-.1.2-.1.3zM11.4 158.2c2.5 2 3.7 4.7 4.1 8.2.2 1.7.1 2.7-.3 4.3-.1.4-.2.6-.3 1-.2.8-.4 1.4-.7 2-.1.1-.2.2-.2 0 0-1.3.2-2.5-.1-4-.2-1.2-.5-2-.9-3-.1.1-.1.2-.2.3-.5 1.3-.8 2.5-1 4.1-.3 2.6-.1 4.6.5 6.7 0 .2-.1.3-.3.1-1.2-1.4-1.9-2.9-2.4-5-.4-2-.4-3.2 0-5.2.4-2.2 1.3-3.3 1.4-5.6.1-1.6.1-2.8-.3-4.1 0-.1 0-.1.1-.2.2.1.5.3.6.4z"
    />
    <path
      className="st19"
      d="M20.3 165.4c4.3 4.6 4.1 9.1 5 15.4.1 1 .1 1.8.3 2.6 1.1-1.1 2.5-1.8 4.1-1.7 0 .1-.1.2-.1.4-1.5 2.5-1.5 5.8-.7 8.6.4 1.6 1 3 1.6 4.5l1.2 3c.8 2.3 1.1 4.8 1.2 7.3 0 3.4-.7 6.9-2.7 9.7-.5.8-1.1 1.4-1.6 2.2-.8.7-1.6 1.4-2.6 1.9-.4.2-.9.5-1.4.5.8-1.8 1.9-3.8 2.1-5.9.1-1.4.3-2.6.2-3.9-.2-2.9-1.3-5.5-2.9-7.9-1.5-1.9-2.9-3.9-3.8-6-.6 2.6-1.5 5.3-3.1 7.5-.4.9-1.1 1.5-1.4 2.4-1.2 2-2.2 4.1-2.7 6.5-.3 2.5-.1 5 1.2 7 0 .1-.1.1-.1.1l-.1-.1-.1.1c-2.3-.3-4.2-2-5.7-3.8-2.7-3.5-3.5-7.9-3.2-12.3 0-1.7.1-3.4 0-5.1-.2-2.2-.5-4.5-1.4-6.5 0-.1.1-.1.1-.2 1.2.3 2.3.9 3.3 1.6 1.1.8 1.9 1.7 2.7 2.7-.1-5.1 1.8-10 3.9-14.6.8-1.9 1.7-3.7 2.6-5.6 1.7-3.6 3-7.4 3-11.6 0-.1-.1-.2 0-.3.3.4.6.9 1.1 1.5z"
    />
    <linearGradient
      id="SVGID_14_"
      gradientUnits="userSpaceOnUse"
      x1={34.747}
      y1={175.776}
      x2={34.747}
      y2={201.393}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="M20.7 174.4c.8 4.5 1.7 9.1 3.1 13.4.6 2.1 1.4 4.1 2.3 6.1 1.1 2.7 2.5 5.3 3.4 8.2 1.2 3.5 1 7.6-.3 11.1-.4.9-.8 1.7-1.3 2.5 0-.5.2-.9.4-1.5.9-4.3.7-7-.7-11.1-.5-1.5-.9-2.3-1.6-3.7-.7-1.4-1.1-2.1-2-3.4-.1-.2-.2-.3-.3-.5-.5-.7-.8-1.1-1.2-1.8-.5-.8-.7-1.3-1-2.2-.8-2-1.3-3.5-1.2-5.3 0-.1-.1-.1-.2 0-1.5 1.5-2.3 3.5-2.8 5.5-.3 1.6-.8 3.2-1.2 4.8-.8 2.6-2 5-3.1 7.3-1.7 3.7-2.7 8-1.9 12.3 0 0 0-.1-.1-.1h-.1c-.9-1-1.6-2.2-2-3.4-.6-1.4-.9-2.8-1.1-4.3-.4-2.9-.1-5.8.6-8.7.7.5 1.2 1.2 1.7 1.8.3.4.5.9.8 1.3.1 0 .2 0 .2-.1.2-3.8 1.5-7 2.7-10.4.6-1.5 1.2-3.1 2-4.5.7-1.7 1.6-3.2 2.3-4.7 1-2.9 2.1-5.7 2.6-8.6z"
      style={{
        fill: 'url(#SVGID_14_)',
      }}
    />
    <path
      className="st19"
      d="M20.5 203.1c3.1 2.6 4.1 6.9 3.6 10.8-.3 1.2-.6 2.4-1.1 3.6-.4.9-.9 1.6-1.8 2.2-.1-.1-.3-.2-.1-.4.5-1.1.7-2.3.9-3.6 0-1.8-.4-3.5-1.4-4.9-.1-.1-.2-.3-.4-.4-.2 1.3-1 2.5-1.6 3.7-.3.7-.6 1.3-.7 2.1-.2.8-.1 1.7-.1 2.5.1.3.2.6.2.8-.5.1-.7-.4-1-.7-.3-.3-.5-.6-.7-1-.8-1.4-.8-2.6-.7-4.2.1-.6.1-1 .3-1.6.5-1.8 1.2-2.6 2.1-4.2 1-1.6 1.9-2.2 2.2-4 .1-.3.1-.9.1-.9.1 0 .1.1.2.2z"
    />
    <linearGradient
      id="SVGID_15_"
      gradientUnits="userSpaceOnUse"
      x1={32.87}
      y1={212.467}
      x2={40.242}
      y2={212.467}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M28.2 222.4c0 .1.1.1.1.2-.1.1 0 .2-.1.3-1.4.4-2.8 1.4-3.6 2.7-.4.5-.6 1.1-.9 1.7-1.5-.1-1.1-.1-3.6-.1-3.1 0-1.3 0-3.8.1-.3-.5-.6-1.1-.9-1.6-.8-1-1.9-2.1-3.2-2.5-.3-.2-.7-.3-1-.5-.1-.1 0-.3 0-.4 5.1-1.7 11.7-1.8 17 .1z"
      style={{
        fill: 'url(#SVGID_15_)',
      }}
    />
    <linearGradient
      id="SVGID_16_"
      gradientUnits="userSpaceOnUse"
      x1={32.869}
      y1={221.896}
      x2={40.242}
      y2={221.896}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M23.2 228.9v3.2c1.2 0 3-.2 4.2.5.8.5 1.1 1.4 1 2.3-.2.9-.7 1.7-1.6 1.9-.8.3-1.6.2-2.5.2h-1.1v3.9c0 .3 0 .4-.1.4-2.2.4-4.7.5-6.8.5v-4.7h-2c-.7-.1-1.6-.1-2.2-.5-.8-.5-1.2-1.5-1.1-2.4.1-.8.8-1.7 1.6-1.9 1.2-.3 2.3-.1 3.6-.1v-3.3h7z"
      style={{
        fill: 'url(#SVGID_16_)',
      }}
    />
    <path
      className="st19"
      d="M202.3 160.3c0 2.5.8 3.8 1 6.2 0 .4.1.6.1 1 0 0 .1.1.2.1.2-.4.4-.6.7-1 .3-.5.4-.8.6-1.3.2-.5.2-.9.3-1.4.2-.8.2-1.6.2-2.2.2-.8 0-1.9 0-2.9.1-1.2 0-2.3.3-3.7.2-.9.5-1.4.8-2.3.1-.3.5-.7.4-.8-.1-.2-.5.1-.7.2-2.8 1.6-3.9 4.4-4 7.8.1.1.1.2.1.3zM216.5 158.2c-2.5 2-3.7 4.7-4.1 8.2-.2 1.7-.1 2.7.3 4.3.1.4.1.6.3 1 .2.8.4 1.4.7 2 .1.1.2.2.2 0 0-1.3-.2-2.5.1-4 .2-1.2.5-2 .9-3 .1.1.1.2.2.3.5 1.3.8 2.5 1 4.1.3 2.6.1 4.6-.5 6.7 0 .2.1.3.3.1 1.2-1.4 1.9-2.9 2.4-5 .4-2 .4-3.2 0-5.2-.4-2.2-1.3-3.3-1.4-5.6-.1-1.6-.1-2.8.3-4.1 0-.1 0-.1-.1-.2-.2.1-.5.3-.6.4z"
    />
    <path
      className="st19"
      d="M207.5 165.4c-4.3 4.6-4.2 9.1-5 15.4-.1 1-.1 1.8-.3 2.6-1.1-1.1-2.5-1.8-4.1-1.7 0 .1.1.2.1.4 1.5 2.5 1.5 5.8.7 8.6-.4 1.6-1 3-1.6 4.5l-1.2 3c-.8 2.3-1.1 4.8-1.2 7.3 0 3.4.7 6.9 2.7 9.7.5.8 1.1 1.4 1.7 2.2.8.7 1.6 1.4 2.6 1.9.4.2.9.5 1.4.5-.8-1.8-1.9-3.8-2.1-5.9-.1-1.4-.3-2.6-.2-3.9.2-2.9 1.3-5.5 2.9-7.9 1.5-1.9 2.9-3.9 3.8-6 .6 2.6 1.5 5.3 3.1 7.5.4.9 1.1 1.5 1.4 2.4 1.2 2 2.2 4.1 2.7 6.5.3 2.5.1 5-1.2 7 0 .1.1.1.1.1l.1-.1.1.1c2.3-.3 4.2-2 5.7-3.8 2.7-3.5 3.5-7.9 3.2-12.3 0-1.7-.1-3.4 0-5.1.2-2.2.5-4.5 1.4-6.5 0-.1-.1-.1-.1-.2-1.2.3-2.3.9-3.3 1.6-1.1.8-1.9 1.7-2.7 2.7.1-5.1-1.8-10-3.9-14.6-.8-1.9-1.7-3.7-2.6-5.6-1.7-3.6-3-7.4-3-11.6 0-.1.1-.2 0-.3-.3.4-.6.9-1.2 1.5z"
    />
    <linearGradient
      id="SVGID_17_"
      gradientUnits="userSpaceOnUse"
      x1={193.11}
      y1={174.824}
      x2={193.11}
      y2={199.32}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff450',
        }}
      />
      <stop
        offset={0.195}
        style={{
          stopColor: '#ffef50',
        }}
      />
      <stop
        offset={0.374}
        style={{
          stopColor: '#ffe650',
        }}
      />
      <stop
        offset={0.547}
        style={{
          stopColor: '#ffd94f',
        }}
      />
      <stop
        offset={0.716}
        style={{
          stopColor: '#ffc64e',
        }}
      />
      <stop
        offset={0.88}
        style={{
          stopColor: '#fbad4b',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#f89848',
        }}
      />
    </linearGradient>
    <path
      d="M207.2 174.4c-.8 4.5-1.7 9.1-3.1 13.4-.6 2.1-1.4 4.1-2.3 6.1-1.1 2.7-2.5 5.3-3.4 8.2-1.2 3.5-1 7.6.3 11.1.4.9.8 1.7 1.3 2.5 0-.5-.2-.9-.4-1.5-.9-4.3-.7-7 .7-11.1.5-1.5.9-2.3 1.6-3.7.7-1.4 1.1-2.1 2-3.4.1-.2.2-.3.4-.5.5-.7.7-1.1 1.2-1.8.5-.8.7-1.3 1-2.2.8-2 1.3-3.5 1.2-5.3 0-.1.1-.1.2 0 1.5 1.5 2.3 3.5 2.8 5.5.3 1.6.8 3.2 1.2 4.8.7 2.6 2 5 3.1 7.3 1.7 3.7 2.7 8 1.9 12.3 0 0 0-.1.1-.1h.1c.9-1 1.6-2.2 2-3.4.6-1.4.9-2.8 1.1-4.3.4-2.9.1-5.8-.6-8.7-.7.5-1.2 1.2-1.7 1.8-.3.4-.5.9-.8 1.3-.1 0-.2 0-.2-.1-.2-3.8-1.5-7-2.7-10.4-.6-1.5-1.2-3.1-2-4.5-.7-1.7-1.6-3.2-2.3-4.7-1.2-2.9-2.3-5.7-2.7-8.6z"
      style={{
        fill: 'url(#SVGID_17_)',
      }}
    />
    <path
      className="st19"
      d="M207.4 203.1c-3.1 2.6-4.1 6.9-3.6 10.8.3 1.2.6 2.4 1.1 3.6.4.9.9 1.6 1.8 2.2.1-.1.3-.2.1-.4-.5-1.1-.7-2.3-.9-3.6 0-1.8.4-3.5 1.4-4.9.1-.1.2-.3.4-.4.2 1.3 1 2.5 1.6 3.7.3.7.6 1.3.7 2.1.2.8.1 1.7.1 2.5-.1.3-.1.6-.1.8.5.1.7-.4 1-.7.3-.3.5-.6.7-1 .8-1.4.8-2.6.7-4.2-.1-.6-.1-1-.3-1.6-.5-1.8-1.1-2.6-2.1-4.2s-1.9-2.2-2.2-4c-.1-.3-.1-.9-.1-.9-.2 0-.2.1-.3.2z"
    />
    <linearGradient
      id="SVGID_18_"
      gradientUnits="userSpaceOnUse"
      x1={197.204}
      y1={212.467}
      x2={188.403}
      y2={212.467}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M199.7 222.4c0 .1-.1.1-.1.2.1.1 0 .2.1.3 1.4.4 2.8 1.4 3.6 2.7.4.5.6 1.1.9 1.7 1.5-.1 1.1-.1 3.6-.1 3.1 0 1.3 0 3.8.1.3-.5.6-1.1.9-1.6.8-1 1.9-2.1 3.2-2.5.3-.2.7-.3 1-.5.1-.1 0-.3 0-.4-5.2-1.7-11.8-1.8-17 .1z"
      style={{
        fill: 'url(#SVGID_18_)',
      }}
    />
    <linearGradient
      id="SVGID_19_"
      gradientUnits="userSpaceOnUse"
      x1={197.203}
      y1={221.897}
      x2={188.403}
      y2={221.897}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M204.6 228.9v3.2c-1.2 0-3-.2-4.2.5-.8.5-1.1 1.4-1 2.3.2.9.7 1.7 1.6 1.9.8.3 1.6.2 2.5.2h1.1v4c0 .3 0 .4.1.4 2.2.4 4.7.4 6.8.4v-4.7h2c.7-.1 1.6-.1 2.2-.5.8-.5 1.2-1.5 1.1-2.4-.1-.8-.8-1.7-1.6-1.9-1.2-.3-2.3-.1-3.6-.1v-3.3h-7z"
      style={{
        fill: 'url(#SVGID_19_)',
      }}
    />
    <linearGradient
      id="SVGID_20_"
      gradientUnits="userSpaceOnUse"
      x1={42.679}
      y1={176.429}
      x2={185.36}
      y2={176.429}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M33 92.6c.4.3.8.8 1.2 1.1 2.1 2 4.3 3.5 6.7 5 .5.2 1 .6 1.5.8 4.6 2.5 9.5 4.3 14.6 5.4 1.2.3 2.5.5 3.7.7 4 .6 8.1.9 12.1.7 11.2-.6 21.1-4.2 30.2-10 1.7-1.1 3.5-2.4 5.1-3.7.1-.1.2-.1.3-.1 3.6 0 7.3 0 11 .1.2.2.5 0 .7.2.9.7 1.6 1.3 2.6 2.1 1.8 1.3 2.9 2 4.8 3.2 4.4 2.6 7 3.8 11.8 5.5 1.6.6 2.5.9 4.2 1.3 11.4 3.1 19 3 30.4-.2 7.8-2.2 12.3-4.1 18.6-9.1.7-.5 1.1-.8 1.7-1.4.5-.5.8-.8 1.2-1.3l.1.1.1-.1c1 .1 2.1-.1 3.1.1.3 3.9.4 7.9.7 11.8 0 2.9.1 5.4.1 8.8 0 4.6.1 7.8-.1 11.7-.1 5.3-.3 9.8-.7 16-.4 5.4-.7 9.2-1.2 13.8-.3 2-.5 4-.8 6-1.2 8.5-3 16.8-5.2 24.9-2 7.9-4.5 15.5-7.2 23.1-1.9 5.3-4.1 10.5-6.4 15.7-.8 1.8-1.6 3.6-2.5 5.3-.8 1.7-1.7 3.4-2.5 5.1-1.1 2-2.1 3.8-3.3 5.9-1.3 2.2-2.7 4.6-4.1 6.8-1.9 3-3.9 5.9-5.9 8.7-2.5 3.4-5.1 6.7-7.8 10-.7.8-1.3 1.6-2.1 2.3 0 0 0 .1-.1.2-.1-.1-.1.1-.2.1-2-.4-4-.9-6-1.3 2.3-2.8 4.7-5.3 6.8-8 5.6-7.2 10.7-14.9 15.2-22.8.7-1.3 1.4-2.6 2.1-3.8 1.7-3.2 3.2-6.3 4.7-9.4.5-1.4 1.2-2.8 1.9-4.2 2.2-4.9 4.1-9.8 5.8-14.8l2.4-7.1c.6-1.7 1.1-3.6 1.6-5.3 1.9-6.3 3.5-12.6 4.8-19 .4-2.3 1-4.6 1.3-6.9.8-4.4 1.4-8.1 2-13.3.9-7 1.1-11 1.4-18.1.1-2.4.2-3.8.3-6.3.3-9.3.8-14.6 0-23.9-.1-1.1-.1-1.9-.3-2.9-.1-.1-.2 0-.3 0-8.2 5.2-16 8.6-27.2 10-2.8.3-4.4.5-7.3.5-4.1 0-6.5-.2-10.5-.9-1.5-.3-2.4-.4-3.9-.8-6.9-1.6-10.8-3.1-17.1-6.3-.9-.5-1.4-.7-2.2-1.2-4.6-2.6-7.7-4.8-11.2-7.6-.4.2-.7.5-1 .8-4.7 3.7-8.9 6.4-15.3 9.2-10.4 4.7-17.1 6.6-28.4 6.5-8.8-.1-14-1.1-22.3-4.3-2.5-1-3.9-1.7-6.3-2.9-2.5-1.3-4.3-2.3-6.3-3.6-.2 1.1-.2 2.3-.3 3.4l-.2 7.9c-.1 2.9-.1 5.8-.1 8.8.1 6.2.3 11.9.7 18l.4 5.5c.2 2.6.6 5.2.7 7.8 1.2 10 2.9 19.7 5.3 29.3 1 4 2.1 8 3.3 11.9.9 3 1.9 6.1 2.9 9.2.8 2.3 1.6 4.5 2.4 6.7 1.7 4.5 3.5 8.8 5.6 13.3 2.1 4.5 4.3 8.9 6.7 13.3 4.5 8 9.4 15.6 14.9 22.8 2.3 2.8 4.7 5.7 7.2 8.4-2.1.5-4.1.9-6.1 1.3-.1 0-1.3-1.3-1.8-1.9-2.7-3.2-5.2-6.5-7.7-9.9-2.9-4-5.5-8.1-8.1-12.2l-.1-.1c-1.1-1.7-2.1-3.6-3.1-5.4-.1-.4-1-2-1.3-2.5-4.2-7.8-7.7-15.9-10.9-24.1-3.9-10.5-7.3-21.1-9.8-32l-1.6-7.4c-1.6-7.6-2.8-15.3-3.5-23-.5-5.6-.8-11.3-1.1-16.8l-.3-6.7-.1-5.7c-.1-3.4.1-6.9.1-10.3.1-4.1.2-8 .5-12.1.1-1.9.2-4 .4-6 0-.1.1-.1.2-.1l3.7-.3z"
      style={{
        fill: 'url(#SVGID_20_)',
      }}
    />
    <path
      className="st2"
      d="M124.4 53c-.6 0-.8-.1-1.3-.4-.4-.3-.7-.7-.7-1.2-.1-.8.7-1.8.3-2.6-.3-.3-.8-.8-.8-.9 0-.1.1-.1.1-.1.8.1 1.6.2 2.4.2.8 0 1.6-.1 2.4-.2l.1.1c0 .1-.5.6-.8.9-.5.9.3 1.8.3 2.6-.1.5-.3.9-.7 1.2-.4.4-.7.4-1.3.4z"
    />
    <linearGradient
      id="SVGID_21_"
      gradientUnits="userSpaceOnUse"
      x1={115.537}
      y1={58.055}
      x2={115.537}
      y2={32.846}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.192}
        style={{
          stopColor: '#00a58b',
        }}
      />
      <stop
        offset={0.367}
        style={{
          stopColor: '#009f86',
        }}
      />
      <stop
        offset={0.537}
        style={{
          stopColor: '#00967f',
        }}
      />
      <stop
        offset={0.702}
        style={{
          stopColor: '#008973',
        }}
      />
      <stop
        offset={0.863}
        style={{
          stopColor: '#007864',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#065',
        }}
      />
    </linearGradient>
    <path
      d="M116.9 30.6c.7.3 1.3.7 1.8 1.3.6.7.8 1.7.5 2.6-.1.3-.3.7-.5 1l-.1.1v-.1c.2-.7.2-1.3-.1-2-.1-.4-.3-.6-.5-.9-.4-.6-1.3-1.2-2.1-1.7.4.4.9.7 1.2 1.1.4.6.6 1.3.4 2.1 0 .1 0 .1-.1.2 0-.3 0-.7-.1-1l-.3-.6c-.3-.3-.3-.2-.5-.2-.1.7 0 1.4.5 1.9.1.1.2.2.3.2-.1.1-.2.1-.3.1-.2 0-.4-.1-.5-.2 0 .8.2 1.5.4 2.2.1.2.1.4.3.6.1.1.3.1.5.1s.5 0 .6.1l.1.1c0 .1-.1.3-.2.3h-.1c0-.1-.1-.1-.2-.2-.1 0-.1 0-.2-.1-.5-.1-1.1-.1-1.6-.1-.3 0-.5.1-.8.2 0 .1-.1.1-.1.2-.1 0-.2 0-.2-.1v-.2s.1-.1.2-.1c-.2 0-.4 0-.5.2 0 0-.1 0-.1-.1v-.2c.1-.1.2-.2.3-.2h.2V37c.2-.2.4-.1.6 0 .1 0 .3.1.4.1h.1s.1 0 .1-.1-.1-.2-.1-.3c-.4-.8-.6-1.6-.7-2.5-.1 0-.1.1-.2.2s-.2.2-.3.2v-.1c.2-.5.1-1-.1-1.4-.2 0-.4-.1-.7-.1 0 .5.1 1.2.4 1.6h-.1c-.2-.1-.3-.2-.5-.3 0 .3-.1.7-.3 1-.4.6-.8 1.1-1.2 1.7v.1c0 .1.1.1.2.1h.7c.1 0 .2.1.2.2s0 .2-.1.3c-.1 0-.1.1-.1.1v-.1c-.1-.1-.3-.1-.5-.2h-.9c-.3 0-.7 0-1 .1-.1.1-.2.1-.2.2-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.2.1-.1.1-.1.2-.1h-.2c-.2 0-.3.1-.4.3-.1 0-.1-.1-.1-.1 0-.1 0-.2.1-.2.1-.1.3-.1.5-.1v-.2c.1-.1.1-.1.3-.1.3 0 .6.2.9.2l.3-.3c.4-.6.7-1.1 1-1.8.2-.4.3-.6.3-.9-.2.2-.4.4-.7.4.2-.5.3-1.2.4-1.7-.1 0-.2-.1-.2-.1-.7-.3-1.6-.8-1.9-1.6-.4-.8-.4-1.8 0-2.5.1-.2.2-.3.3-.5.6-.9 1.6-1.5 2.4-2.2.2-.2.4-.5.3-.9 0-.1-.1-.1-.1-.1-.2-.2-.5-.2-.7-.2-.2 0-.4.1-.6.1-.1.2-.2.3-.3.4.1 0 .3 0 .4.1l.2.2c.1 0 .2-.1.3-.2 0 .2-.2.4-.3.5-.1.1-.3 0-.5-.1-.1-.1-.2-.2-.2-.3-.1.1-.2.1-.2.2.1.1 0 .3-.1.3-.1.1-.3.2-.3.4-.1 0-.3 0-.3-.2v-.3c.1-.3.4-.3.6-.5l.1-.1h-.2c-.2.1-.3.2-.5.2H111.1c-.1 0-.1-.1-.1-.2h.2c.2-.1.4-.3.7-.2.1 0 .3.1.4.2.1-.1.2-.2.2-.4-.1 0-.2 0-.2-.2v-.1h.3c0-.1.1-.3.1-.4-.3 0-.5.1-.7.2 0-.1 0-.1.1-.2.1-.2.4-.3.6-.4 0-.1-.1-.2-.2-.3h.3c.1.1.1.2.1.3h.5v-.2c.2-.3.6-.2.9-.2.3.1.5.1.8.2.4.1.7.2 1.1.3.2 0 .3 0 .4-.2 0 0 0-.1.1-.1s0 .1 0 .2c0 .2-.2.3-.3.3-.2.1-.5.1-.7.1-.1 0-.2-.1-.3 0 .1.1.2.1.3.3.2.3.1.7 0 1-.3.4-.6.8-1 1.2-.5.6-.9 1.3-.7 2.1 0 .1.1.2.2.2s.2-.1.2-.1c0-.1.1-.2.1-.3l.3-1.2c.1-.4.3-.7.6-1l.3-.3c.7-.7 1.5-1.2 2.1-2 .5-.6.9-1.2 1.1-1.9.1-.3 0-.6-.1-.8v-.1c.1 0 .1 0 .2.1 0 0 .6.3.7.7.1.2.1.3.1.5.1.2.1.4.1.6v.5c.4-.6.7-1.2.9-1.9.1-.2.1-.4.2-.6 0-.2.1-.3 0-.5v-.1s.1 0 .1.1c.2.2.3.4.3.7.1.2.2.6.2.9.1.7 0 1.2-.3 1.8-.2.4-.5.5-.6.9-.1.3-.1.5-.1.9-.1.6-.4.9-.6 1.5-.2.5-.2.7-.5 1.2s-.5.7-.8 1.2c-.2.3-.1.6-.4.8-.3.3-.6.4-1 .5-.2-.5-.3-.5-.4-.5z"
      style={{
        fill: 'url(#SVGID_21_)',
      }}
    />
    <linearGradient
      id="SVGID_22_"
      gradientUnits="userSpaceOnUse"
      x1={90.323}
      y1={219.068}
      x2={26.108}
      y2={219.068}
      gradientTransform="matrix(.8 0 0 .8 22.757 30.811)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff',
        }}
      />
      <stop
        offset={0.32}
        style={{
          stopColor: '#f8f9f8',
        }}
      />
      <stop
        offset={0.572}
        style={{
          stopColor: '#e9edea',
        }}
      />
      <stop
        offset={0.801}
        style={{
          stopColor: '#d4ddd8',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#bcc9c1',
        }}
      />
    </linearGradient>
    <path
      d="M39.8 146.5s1.1 34.6 17.9 72.7c0 0 14.5 30.8 30.4 47.2 0 0 16.9-2.5 24.6-2.2V145.8l-72.9.7z"
      style={{
        fill: 'url(#SVGID_22_)',
      }}
    />
    <linearGradient
      id="SVGID_23_"
      gradientUnits="userSpaceOnUse"
      x1={91.085}
      y1={219.068}
      x2={26.872}
      y2={219.068}
      gradientTransform="matrix(-.8 0 0 .8 205.182 30.811)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#fff',
        }}
      />
      <stop
        offset={0.32}
        style={{
          stopColor: '#f8f9f8',
        }}
      />
      <stop
        offset={0.572}
        style={{
          stopColor: '#e9edea',
        }}
      />
      <stop
        offset={0.801}
        style={{
          stopColor: '#d4ddd8',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#bcc9c1',
        }}
      />
    </linearGradient>
    <path
      d="M187.6 146.5s-1.1 34.6-17.9 72.7c0 0-14.5 30.8-30.4 47.2 0 0-16.9-2.5-24.6-2.2V145.8l72.9.7z"
      style={{
        fill: 'url(#SVGID_23_)',
      }}
    />
    <path
      className="st19"
      d="M50.6 160.6v-2.4c1.3 0 2.3.2 3 .6l1.1-1.8h-4.2v-4.3h.4c1.4 0 2.5.2 3.3.7l1-2H48c.4 1 .6 2 .6 3.2v5.9c0 1.2-.1 2.2-.6 3.2h3c-.2-.9-.4-1.9-.4-3.1z"
    />
    <path
      className="st31"
      d="M68.3 157.6c0-1.8-.6-3.4-1.7-4.6-1-1.1-2.3-1.6-3.9-1.6-1.8 0-3.5.8-4.6 2.2-.9 1.1-1.3 2.5-1.3 4 0 2 .7 3.8 2 4.9 1.1.9 2.4 1.4 3.7 1.4 1.5 0 2.8-.6 3.9-1.6 1.3-1.2 1.9-2.8 1.9-4.7zm-5.5 4.8c-1.2 0-2.4-.7-3.1-1.8-.6-1-.9-2.1-.9-3.3 0-2.7 1.5-4.5 3.7-4.5 1.3 0 2.5.7 3.2 2.1.5.9.8 1.9.8 3.2-.1 2.6-1.6 4.3-3.7 4.3zM81.6 157.6c0-1.8-.6-3.4-1.7-4.6-1-1.1-2.3-1.6-3.9-1.6-1.8 0-3.5.8-4.6 2.2-.9 1.1-1.3 2.5-1.3 4 0 2 .7 3.8 2 4.9 1.1.9 2.4 1.4 3.7 1.4 1.5 0 2.8-.6 3.9-1.6 1.2-1.2 1.9-2.8 1.9-4.7zm-5.6 4.8c-1.2 0-2.4-.7-3.1-1.8-.6-1-.9-2.1-.9-3.3 0-2.7 1.5-4.5 3.7-4.5 1.3 0 2.5.7 3.2 2.1.5.9.8 1.9.8 3.2 0 2.6-1.6 4.3-3.7 4.3z"
    />
    <path
      className="st19"
      d="M86.1 152.8v7.8c0 1.2-.2 2.2-.5 3.2h3c-.4-1-.5-2-.5-3.2v-7.8c1.4 0 2.5.2 3.4.7l.8-2.1h-9.5l-.6 2.1c1-.4 2.3-.6 3.9-.7z"
    />
    <path
      className="st31"
      d="M93.9 163.8h2.6c3.2 0 4.9-1.4 4.9-3.4 0-1.3-.8-2.3-2.3-3.2 1.2-.6 1.8-1.5 1.8-2.7 0-1-.6-2-1.7-2.6-.7-.4-1.7-.5-3.2-.5h-2.1c.4 1 .5 2 .5 3.2v5.9c.1 1.3-.1 2.3-.5 3.3zm2.5-11.2c1.5 0 2.4.9 2.4 2 0 1.3-.9 2.3-2.4 2.5v-4.5zm0 4.9c1.8.3 2.9 1.5 2.9 2.9s-1 2.3-2.5 2.3h-.4v-5.2zM106.3 160h4.5l.8 1.9c.2.4.3.8.3 1.3 0 .2 0 .4-.1.6h3.2c-.8-1-1.3-1.9-1.7-2.7l-4.7-10-4.9 9.6c-.6 1.2-1.2 2.2-1.9 3h3v-.4c0-.6.2-1.1.5-1.8l1-1.5zm.7-1.4 1.6-3.5 1.5 3.5H107z"
    />
    <path
      className="st19"
      d="M119.7 151.5h-3c.4 1 .5 2 .5 3.2v5.9c0 1.2-.1 2.2-.5 3.2h6.3c.3-.7.6-1.5 1-2.3-1.3.6-2.9.9-4.8 1.1v-8c0-1.1.1-2.1.5-3.1zM128.7 151.5h-3c.4 1 .5 2 .5 3.2v5.9c0 1.2-.1 2.2-.5 3.2h6.3c.3-.7.6-1.5 1-2.3-1.3.6-2.9.9-4.8 1.1v-8c0-1.1.1-2.1.5-3.1z"
    />
    <linearGradient
      id="SVGID_24_"
      gradientUnits="userSpaceOnUse"
      x1={89.38}
      y1={248.791}
      x2={126.811}
      y2={248.791}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M116 244.7c-.8-1.2-1.3-2.5-1.7-3.9-.3-1.1-.5-2.7-.5-3.8l-1.5-.3c-1.9-.4-3.7-1.2-5.4-2-.1 1.9-.5 4.2-1.1 6.1-.3.9-.6 1.8-1 2.6 1.6 0 3-1.1 4.1-2-.4 1.8-1.1 3.2-1.9 5.2-1.3 3.1-2.6 5.4-4 7.7-.5.8-.9 1.5-1.4 2.3-.3.6-.7 1.2-1.4 1.6-1.9.5-3.2-1-5.1-.8-.9.2-1.2.3-1.4.6-.2.3-.1.6 0 .8-1-.1-2.1-.1-3 .5-.3.3-.5.8-.4 1.3.1.3.3.6.7.7.4-.8 1.3-1.2 2.2-1.5.4-.1.8-.1 1.2 0 .1.1 0 .2-.1.2-.4.2-.8.4-1.1.7-.3.4-.5.9-.4 1.4.3.6.9.9 1.5.8.1-.1 0-.1 0-.2-.1-.7.6-1.1 1.2-1.4 1.8-.6 3.8-.6 5.7-.7 1.6-.1 3.2 0 4.8.1.9.1 1.9.3 2.6.9.2.2.2.5.1.7.2.1.5-.1.7-.2 0 0 .1 0 .1-.1.6-.4.7-1 .7-1.7 0-.6-.6-1-1.1-1.2-.1 0-.1-.1-.3-.1-1.2-.4-2.5-.2-3.9-.2-.4-.1-.8 0-1-.4-.1-.2 0-.5.1-.7.8-1.2 1.7-2.3 2.5-3.5 1.4-2 2.9-4 4.3-6 1-1.6 1.7-3.5 1.8-5.3.7.7 1.6 1.3 2.6 1.7.2.1.5.2.8.1z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_24_)',
      }}
    />
    <linearGradient
      id="SVGID_25_"
      gradientUnits="userSpaceOnUse"
      x1={121.718}
      y1={236.675}
      x2={148.471}
      y2={236.675}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M140.7 240.4c.1-3.6-1-7.3-3.4-9.9-1.4-1.7-3.2-2.9-5-3.8-2.6-1.3-5.7-2.2-8.3-3.3-.5-.2-1-.5-1.5-.6-.1.1-.1.1-.1.2 1.5 1.3 3.2 2.6 4.7 3.8 2.3 1.7 4.5 3.6 6.4 6.5 1.3 1.9 2 3.1 2.8 5.2.2.6.4 1.3.6 1.9.9 3.3.9 6.2 0 9.3 0 .3-.2.5-.1.7.4.1.5-.4.7-.6 1-1.7 2-3.4 2.5-5.3.4-1.2.7-2.7.7-4.1z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_25_)',
      }}
    />
    <linearGradient
      id="SVGID_26_"
      gradientUnits="userSpaceOnUse"
      x1={126.026}
      y1={206.749}
      x2={135.836}
      y2={206.749}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M137.4 215.5c.1.4-.3.6-.4.9-.6.8-1.2 1.7-1.9 2.4-1.5.3-3 .2-4.6.1-.6 0-1.2-.2-1.8-.3-.1-.1 0-.1 0-.2 3.1-.4 5.9-1.6 8.6-3.1 0 .2.1.2.1.2z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_26_)',
      }}
    />
    <linearGradient
      id="SVGID_27_"
      gradientUnits="userSpaceOnUse"
      x1={126.1}
      y1={213.208}
      x2={141.446}
      y2={213.208}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M141.7 208.7c-.1-.1-.1-.2-.2-.2-.6.2-1 .7-1.5 1-2.3 1.5-4.9 2.7-7.4 3.5-1.1.3-2.1.6-3.3.8v.2c.2 1.7-1.3 3-2.7 3.7v.1h.2c1.1-.1 2.2-.4 3.2-.6 2.8-.9 5.5-2.1 7.8-4l.1-.1s.1 0 .1-.1c1.2-.9 2.4-2.1 3.3-3.3.1-.3.5-.6.4-1z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_27_)',
      }}
    />
    <linearGradient
      id="SVGID_28_"
      gradientUnits="userSpaceOnUse"
      x1={103.934}
      y1={187.243}
      x2={107.158}
      y2={187.243}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M104 188.3c.1-.2.2-.7.3-1.1.1-.4.1-.4.1-.9 1.8 0 2.7.1 2.7.6.1.7-1.6 1.2-3.1 1.4z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_28_)',
      }}
    />
    <linearGradient
      id="SVGID_29_"
      gradientUnits="userSpaceOnUse"
      x1={126.591}
      y1={254.118}
      x2={126.602}
      y2={254.118}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_29_)',
      }}
      d="M126.6 254.1z"
    />
    <linearGradient
      id="SVGID_30_"
      gradientUnits="userSpaceOnUse"
      x1={128.901}
      y1={206.955}
      x2={144.425}
      y2={206.955}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M144.4 201.2c-.9.6-1.4 1.3-2.3 1.9-1.1.8-2.2 1.6-3.3 2.3-2.5 1.4-5.1 2.7-7.8 3.6.1 1.4-.4 2.7-1.5 3.6 0 .1-.2.1-.2.2v.1c2.3-.4 4.4-1.4 6.5-2.4 2.8-1.7 5.6-3.7 7.6-6.5.5-.8 1-1.5 1.1-2.4.2-.4.1-.5-.1-.4z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_30_)',
      }}
    />
    <g id="XMLID_1_">
      <linearGradient
        id="SVGID_31_"
        gradientUnits="userSpaceOnUse"
        x1={91.415}
        y1={214.659}
        x2={150.63}
        y2={214.659}
      >
        <stop
          offset={0}
          style={{
            stopColor: '#5e0000',
          }}
        />
        <stop
          offset={0.056}
          style={{
            stopColor: '#7b0000',
          }}
        />
        <stop
          offset={0.121}
          style={{
            stopColor: '#96070b',
          }}
        />
        <stop
          offset={0.188}
          style={{
            stopColor: '#ad1015',
          }}
        />
        <stop
          offset={0.257}
          style={{
            stopColor: '#c0151b',
          }}
        />
        <stop
          offset={0.329}
          style={{
            stopColor: '#cd171e',
          }}
        />
        <stop
          offset={0.407}
          style={{
            stopColor: '#d51920',
          }}
        />
        <stop
          offset={0.5}
          style={{
            stopColor: '#d71920',
          }}
        />
        <stop
          offset={0.599}
          style={{
            stopColor: '#d51920',
          }}
        />
        <stop
          offset={0.677}
          style={{
            stopColor: '#cd171e',
          }}
        />
        <stop
          offset={0.748}
          style={{
            stopColor: '#c1151b',
          }}
        />
        <stop
          offset={0.814}
          style={{
            stopColor: '#af1116',
          }}
        />
        <stop
          offset={0.878}
          style={{
            stopColor: '#98080c',
          }}
        />
        <stop
          offset={0.939}
          style={{
            stopColor: '#7e0000',
          }}
        />
        <stop
          offset={0.998}
          style={{
            stopColor: '#5f0000',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#5e0000',
          }}
        />
      </linearGradient>
      <path
        d="M149.9 166.5c1.2 1.5 1.9 3.4 1.6 5.2-.6 3.3-2.4 6.3-4 9.2l-1.2 1.8c-3 4.5-6.8 8.6-10.9 11.8-.9.7-1.9 1.4-2.8 2.1l-3.9 2.7c-1.4.9-2.8 1.8-4.2 2.8-.1.1-.1.2 0 .3.2.2.4-.1.6-.1 1.8-.6 3.4-1.3 5.1-2.1.2 0 .3.1.4.3.2 1-.4 2-1.1 2.7-1.9 1.7-4.3 2.5-6.7 3.3 0 .1-.2.1-.1.2.2.3.5 0 .8 0 2.3-.4 4.4-1 6.5-1.9.1 0 .2 0 .3.1.2.6-.3 1.1-.5 1.6-1 1.2-2.5 1.8-3.9 2.3-1 .4-2.1.6-3.2.9-.1.1-.2.2-.1.3.5.1 1 .1 1.5 0 1.9-.1 3.7-.6 5.6-.9.2.4-.1.7-.3 1.1-.3.2-.4.6-.7.9-1.1.9-2.3 1.4-3.6 1.8-.8.2-1.6.3-2.4.3-.1.1-.2.1-.2.2s0 .2.2.2c1.6.3 3.5.3 5.2.2.2.1.1.3.1.4-1.2 2-3.5 2.7-5.7 2.8v.3c1 .7 2.1 1.1 3.2 1.5 1.2.4 2.8.8 4.1 1h-.1c1.6.3 3.3.4 5 .3.1 0 .1.1.2.2l-.1.2c-1.6 1.6-3.5 2.7-5.7 3-3.7.1-6.8-1.4-9.5-3.6 0 0-1-.8-1.4-1.2l-.9-1h-.3c-.3.3 0 .6.1.9.2.4.5.9.8 1.2 1.9 2.7 4.6 4.7 7.1 6.8 1.2 1 2.3 2.2 3.3 3.4 2.1 2.9 3.2 6.7 2.5 10.3-.1.4-.1.7-.2 1.1-.1.3-.2.7-.5.9-.1 0-.2-.1-.3-.1.1-.5.1-.9.1-1.4v-.4c-.1-1.3-.3-2.7-.7-3.9-.5-1.1-1-2.1-1.7-3.1-1.9-2.5-4.5-4.5-6.7-6.8-1.4-1.4-2.8-2.9-3.7-4.7-.4-.7-.8-1.4-1.1-2.2 0 0-.5-1.3-.8-1.9 0-.1-.1 0-.2 0-.3.3-.1.8-.1 1.2 0 .2.1.5.1.7.5 2.6 2 4.8 3.7 6.8.9 1 1.9 2.1 2.9 3 1 1 2 1.8 3.2 2.8-.5 2.7-.1 5.7 1.1 8.1.5.9 1 1.7 1.7 2.4.5.5 1.1.9 1.6 1.3-.3.4-1 .4-1.5.3-1.1-.2-2-.6-2.9-1.2-.1 0-.1.1-.1.2.3 3.6.9 7.1 1.8 10.6v-.2c.1.5.3 1.2.4 1.7.5 1 .7 2.3 1.6 3.1.8.5 1.7.5 2.6.5h.2c1.1-.1 2.5-.1 3.4.6.2.2.3.4.4.6.2.8-.4 1.4-1 1.9-.2.1-.4.2-.6.2-.1-.4-.5-.8-.9-.9-.3-.2-.3-.2-.9-.3-2.7-.6-5.9-.5-8.7-.3-1.5.2-3 .3-4.2 1.3-.3.3-.5.6-.4 1-.1.1-.1 0-.2 0-.5 0-.9-.3-1.1-.7-.2-.5-.1-.9.2-1.3.2-.3.6-.4.8-.7 0-.1-.1-.2-.1-.2-1 0-2.1.2-2.5 1.1 0 .1 0 .2-.1.3-.2 0-.5-.1-.6-.4-.2-.3-.2-.8-.1-1.1.4-.7 1-1.2 1.8-1.1h1.1c-.1-.3-.1-.6 0-.9.9-1 2.5-.4 3.6-.2.7.2 1.5.6 2.2.7.2.1.6.1.8.1.2 0 .4-.2.6-.4.2-.7-.5-1.2-.7-1.8-.4-.8-.7-1.7-1.1-2.5 0 0 0-.1-.1-.1-1.4-3.5-2.2-7.3-2.8-11.1 0-.1-.1-.1-.2-.1-.3.3-.5.7-.8.9-.5.5-1.1.9-1.7 1.1 0-.2.1-.4.1-.5.3-1 .5-2.1.5-3.2v-.7c-.1-1.4-.4-2.8-.9-4.1l-.1-.1c-4.1-.5-8-1.5-11.8-3.1-3.3-1.3-6.9-3.5-9.2-6.5l.1.2c-.6-.7-1.2-1.7-1.6-2.5-.8-1.4-1.2-2.9-1.5-4.5-.1-.7-.1-1.4-.1-2.2 0-1.6.2-3.2.7-4.7.3-.9.6-1.7 1-2.5.4-1 .9-1.9 1.5-2.6 2.3-3.5 5.7-6 8.9-8.6l-.1.1c1.5-1.2 3.1-2.5 4.5-3.9 1.2-1.3 2.3-2.9 1.7-4.7-.1-.3-.3-.6-.5-.8-.9-1.2-2.7-1.3-4.1-1-1.2.3-2.3.5-3.5.6-.5.9-1 1.7-1.6 2.5.8-.2 1.6 0 2.2.5.4.3.6.5.9.9.7-.1 1.3-.5 1.8-1 .1 1.2-.9 2.2-1.9 2.6-.8.4-1.8.1-2.5-.4-.6-.5-.9-1.2-1.2-1.8-.5.3-.9.7-1.3 1 .3.7 0 1.4-.4 1.9-.6.6-1.7 1.3-1.4 2.3 0 .1.1.1.1.2-.7.1-1.5-.3-1.8-.9-.2-.5-.2-1.2 0-1.8.8-1.4 2.3-1.8 3.6-2.7.2-.2.5-.3.6-.6-.4-.2-.8 0-1.2.1-.9.3-1.6 1-2.6 1.1-.4 0-.9 0-1.3-.1-.3 0-.5-.2-.7-.3-.3-.2-.5-.6-.4-.9.3.1.6.3.9.1 1.3-.3 2.3-1.4 3.7-1.3.7 0 1.5.4 2 .9.6-.6 1-1.3 1.3-2-.3-.3-1.2-.2-1.2-.9 0-.1.1-.2.1-.3.6-.1 1.2 0 1.7-.1.2-.7.4-1.4.4-2.1l-.1-.1c-1.4.1-2.7.5-3.9 1-.1-.4.2-.8.4-1.2.7-1.2 2.2-1.6 3.4-2-.1-.7-.5-1.3-.9-1.9.6.1 1.1-.1 1.6-.2.3.6.5 1.3.7 1.9.9-.1 1.8 0 2.7-.1-.2-.4-.3-.8-.1-1.1 1-1.5 3.2-1.1 4.8-.9 1.5.3 2.9.8 4.3 1.2 2 .7 4 1.3 6.2 1.6.9 0 1.8-.3 2.4-.9.1-.1.1-.5.3-.4.3.2.2.7.1 1-.2.9-1.1 1.5-1.8 1.8-1.2.5-2.6.7-3.9.5-.6 0-1.1-.3-1.7-.1-.1.1-.1.2 0 .2.7.3 1.3.8 1.6 1.5 1 1.6.7 3.8-.2 5.3-.6 1-1.4 2-2.2 3-.8 1-1.7 1.9-2.5 2.8-.2.3-.5.6-.7.8-2.7 3.2-4.8 7.2-3.8 11.6.1.5.4 1 .9 1.3 0 0 .1 0 .1.1.2 0 .3 0 .4-.1.3-.1.6-.5.8-.8.2-.5.5-.9.6-1.5.6-2.3 1.1-4.6 1.8-6.8.6-1.6 1.4-3.2 2.4-4.7.3-.3.6-.7.9-1 .4-.6 1-1.1 1.6-1.7 3.9-3.7 8.4-6.8 11.8-11 2.6-3.1 4.8-6.4 5.9-10.2.5-1.5.2-3.4-.7-4.7-.1-.1 0-.3.2-.3.7-.1 1.3.5 1.8.8 1.7 1.1 2 3.3 1.6 5.3-.2 1.7-.9 3.2-1.7 4.7-2.1 3.6-5.1 6.7-8.2 9.5-.7.5-1.3 1.2-2 1.7-1.3 1.1-2.6 2.2-3.9 3.4-1.3 1.1-2.6 2.3-3.7 3.6-.9 1.1-1.8 2.3-2.5 3.6-1.4 2.5-2 5.3-2.9 8-.3.8-.6 1.5-1.1 2.1-.6.7-1.3 1.3-2.1 1.7-.1.1-.2.3-.2.5.2.3.6.1.9.1 1.4-.4 2.4-1.2 3.3-2.2 1-1.2 1.7-2.8 2.1-4.2.5-1.2 1-2.5 1.6-3.7.9-1.7 2.5-2.9 4-4 .8-.6 1.7-1.2 2.5-1.7 5.5-3.8 10.9-7.6 14.9-13 3.3-4.2 5.7-8.7 7.2-13.7.3-1.2.7-2.3.9-3.5.1-.9.4-1.8.3-2.8 0-.1.1-.3.2-.3.6-.1.8.1.9.3zm-36.8 62.1c0-.2-.3-.3-.4-.4-.7-.4-1.4-1-2-1.5-1.1-.9-2.2-1.9-3-3-.3-.2-.4-.5-.6-.8-.6-.9-1.1-1.8-1.5-2.8-.7-1.7-1.3-3.7-1.4-5.7v-1.3c.1-2.1.7-4.2 1.5-6.2.4-1 .9-1.9 1.5-2.8v-.2c0-.1-.1-.1-.2-.1-1.1.7-1.8 1.6-2.6 2.5-.8 1.1-1.6 2.4-2.2 3.7-.4 1-.7 2-.8 3-.1.5-.1 1.1-.1 1.6 0 1.8.4 3.6 1 5.2.4 1 .9 1.9 1.5 2.7 1.2 1.7 3 3.2 4.7 4.2 1.1.6 2.3 1.2 3.5 1.6.4.2.7.5 1.1.3z"
        style={{
          fill: 'url(#SVGID_31_)',
        }}
      />
    </g>
    <linearGradient
      id="SVGID_32_"
      gradientUnits="userSpaceOnUse"
      x1={130.256}
      y1={200.4}
      x2={147.475}
      y2={200.4}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M147.3 192.9c-2.2 2.4-4.7 4.5-7.3 6.4-2.7 1.9-5.5 3.6-8.4 5 .3 1 .1 2.1-.4 3-.1.2-.4.4-.4.6.1.1.2 0 .3 0 4.7-2 9.4-4.7 13-8.6.5-.6 1.1-1.2 1.6-1.8 1-1.4 2-2.8 2.1-4.5-.1-.2-.3-.2-.5-.1z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_32_)',
      }}
    />
    <linearGradient
      id="SVGID_33_"
      gradientUnits="userSpaceOnUse"
      x1={130.738}
      y1={192.755}
      x2={151.775}
      y2={192.755}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M151.6 182.5c-5.3 6.9-12.4 12.5-19.6 16.8-.1.1-.2.1-.3.2 0 .2.1.4.2.6.3 1 .1 2.1-.4 2.9v.2c2.1-1.2 4.2-2.5 6.2-3.8 3.7-2.6 7.2-5.5 10.2-8.9 1.6-2 2.9-4 3.9-6.2.2-.5.4-1 .4-1.6-.1-.4-.5-.4-.6-.2z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_33_)',
      }}
    />
    <linearGradient
      id="SVGID_34_"
      gradientUnits="userSpaceOnUse"
      x1={140.115}
      y1={182.526}
      x2={153.141}
      y2={182.526}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M153.3 175c-.1-.5-.1-1.1-.4-1.6-.1-.1-.2-.1-.3 0l-.9 2.4c-1.5 3.2-3.2 6.3-5.5 9.1-1.7 2.3-3.8 4.2-5.6 6.3 0 .1-.1.2 0 .3.1.1.3.1.3.1l.9-.7c3.9-3.3 7.6-6.8 10.4-11 1-1.4 1.3-3.1 1.1-4.9z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_34_)',
      }}
    />
    <linearGradient
      id="SVGID_35_"
      gradientUnits="userSpaceOnUse"
      x1={95.961}
      y1={182.035}
      x2={146.064}
      y2={182.035}
      gradientTransform="matrix(1.2 0 0 1.2 -23.059 -30.705)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M142.2 175.2c1.4 2.2.5 5.2-.7 7.2-2.7 5-6.9 8.9-11.4 12.2-1.3.9-2.5 1.8-3.8 2.7-1.6 1.1-3.1 2.3-4.6 3.5-.2 0-.3.1-.4 0l-.2-.2c0-.5.5-.8.8-1.2 5.1-5 11.3-8.8 15.5-14.7 1.9-2.6 3.5-5.6 3.9-8.9 0-.4-.1-.8-.1-1.2 0-.1.2-.2.3-.1.4.2.6.5.7.7z"
      style={{
        fill: 'url(#SVGID_35_)',
      }}
    />
    <path
      className="st44"
      d="M112.7 185c.1 0 0 .1 0 .2-.9.1-1.8.5-2.7.5-.3 0-.5 0-.8-.2-.3-.3-.3-.7-.2-1.1.1-.2.4-.1.6-.1 1 .2 2.1.4 3.1.7M104.5 186.2c1.8 0 2.7.1 2.7.6 0 .8-1.7 1.2-3.2 1.4.1-.3.2-.7.3-1.1.2-.3.2-.4.2-.9"
    />
    <path
      className="st19"
      d="m149.1 163 .1-2.1c-1.3 1-2.6 1.5-3.9 1.5-2.7 0-4.5-1.8-4.5-4.6 0-3.1 1.8-4.9 4.6-4.9 1.3 0 2.5.4 3.5 1.1v-2.2c-1.1-.3-2.1-.4-3-.4-2 0-3.6.5-4.9 1.6-1.5 1.2-2.3 2.9-2.3 5 0 2 .8 3.7 2.3 4.8 1.1.9 2.5 1.3 4 1.3 1.1-.2 2.6-.5 4.1-1.1zM154.6 151.5h-3c.4 1 .6 2 .6 3.2v5.9c0 1.2-.2 2.2-.6 3.2h6.3c.3-.7.6-1.5 1-2.3-1.3.6-2.9.9-4.8 1.1v-8c0-1.1.1-2.1.5-3.1zM168.2 162.4v1.4h2.2c-.4-1-.5-2-.5-3.2v-5.9c0-1.2.1-2.2.5-3.2h-3c.4 1 .5 2 .5 3.2v4.3c0 1.1 0 2-.8 2.7-.6.6-1.4.9-2.2.9-1 0-2-.5-2.5-1.2-.3-.5-.3-1.2-.3-2.2v-4.5c0-1.2.1-2.2.5-3.2h-3c.4 1 .5 2 .5 3.2V159.8c0 .8 0 1.6.5 2.3.2.5.6.8 1.1 1.1.8.5 1.7.8 2.6.8 1.3-.1 2.6-.6 3.9-1.6z"
    />
    <path
      className="st31"
      d="M172.9 163.8h2.6c3.2 0 4.9-1.4 4.9-3.4 0-1.3-.8-2.3-2.3-3.2 1.2-.6 1.8-1.5 1.8-2.7 0-1-.6-2-1.7-2.6-.7-.4-1.7-.5-3.2-.5h-2.1c.4 1 .5 2 .5 3.2v5.9c0 1.3-.2 2.3-.5 3.3zm2.4-11.2c1.5 0 2.4.9 2.4 2 0 1.3-.9 2.3-2.4 2.5v-4.5zm0 4.9c1.8.3 2.9 1.5 2.9 2.9s-1 2.3-2.5 2.3h-.4v-5.2z"
    />
    <linearGradient
      id="SVGID_36_"
      gradientUnits="userSpaceOnUse"
      x1={49.502}
      y1={178.209}
      x2={178.542}
      y2={178.209}
      gradientTransform="matrix(1.2 0 0 1.2 -22.752 -30.889)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M125.6 106.4c2.3 1.2 3.6 1.9 6 2.9.6.3.9.4 1.6.6 8.7 3.5 14.1 4.9 23.5 5.2 4.1.1 6.5 0 10.5-.6 5.4-.7 8.4-1.4 13.6-3.2 4.2-1.5 7.1-2.7 10.4-4.6.1 0 .1.1.1.1.1 1.1.1 3.8.2 6.2.1 2.7.1 4.2.1 6.8 0 2.6 0 4.1-.1 6.7-.1 2.7-.2 4.2-.3 6.9-.2 3.9-.3 6.1-.6 10-.9 11-1.9 17.2-4.1 28-.5 2.6-.8 4.1-1.4 6.8-.4 1.5-.6 2.4-1 4-.9 3.7-1.5 5.8-2.6 9.6-3.1 10.5-5 16.3-9.4 26.3-1.6 3.8-2.9 6.3-4.5 9.5-3.1 6.2-6.4 12.2-10.2 18-1.4 2-2.8 4.1-4.2 6.1l-3.3 4.4c-1.4 1.8-2.9 3.7-4.4 5.4-1.6 1.9-3.4 3.6-4.9 5.5-1.4-.3-2.6-.5-2.8-.5.1-.2.1-.2.4-.4 6.6-6.9 12.4-14.5 17.5-22.4.3-.5.6-.9.9-1.4 2.6-4.2 5-8.5 7.3-12.8.1-.4.4-.9.6-1.3 5.8-11.4 9.8-21.3 14.1-35.6 2.4-7.8 3.5-12.3 5.1-20.3.7-3.3 1-5.2 1.6-8.6.5-3.2.9-5.6 1.3-8.3.3-2.2.6-4.5.8-6.7l-.1-.1H40.9c.4 4.3 1 8.5 1.6 12.8 2.2 14 5.7 27.8 10.2 41l1.8 5.2c1.5 4.1 3.2 8.2 5 12.2 3.4 7.5 7.3 14.9 11.7 22 .7 1.1 1.4 2.4 2.3 3.5 2.4 3.8 5.3 7.6 8 11.3 2 2.4 4 5.1 6.1 7.4.8 1 1.5 1.5 2.4 2.4-1 .2-1.9.4-2.9.5 0-.1-4.5-5.1-6.5-7.6-3.2-4-6.2-8-9-12.3-1.4-2.2-2.8-4.2-4.1-6.4-.8-1.4-1.7-2.8-2.4-4.2-6.1-10.9-11-22.1-15-33.8l-2.1-6.7c-3.2-10.4-5.9-21.1-7.6-31.9l-.9-5.8s-.5-3.3-.7-5.4c-.6-4.9-.8-7.6-1.1-12.5-.4-6.1-.6-9.6-.8-15.7-.1-2.7-.1-4.3-.1-7 0-3.7.1-6.4.2-9.5.1-.6 0-1.3.2-1.9 1.5.8 2.7 1.5 4.4 2.3 6.9 3.2 12 4.6 18.6 5.6 1.7.2 3.1.5 5 .6 8.4.7 13.3 0 21.4-2 7.8-2 12.2-4 19.1-8.1 3.4-2 5.7-3.7 8.4-5.7 3.7 2.8 6.7 5 11.5 7.5z"
      style={{
        fill: 'url(#SVGID_36_)',
      }}
    />
    <path
      className="st9"
      d="M49.2 120.4c.1.2.2.3.2.5-1.9 1.5-1.8 4-1.9 6.2 0 4.4-.1 8.8.1 13.2 1.7.1 3.4-.1 4.9-.6 1.1-.4 2.2-1.2 3-2.1.1 0 .2.1.3.3-.5 1.7-1.2 3.4-1.8 5-3.9.1-7.9-.1-11.8-.1-.1-.1-.1-.3-.2-.4 1.2-1 1.5-2.5 1.6-4 .2-3.9.1-7.8.1-11.7 0-1.4 0-2.9-.3-4.2-.1-.7-.6-1.3-1.1-1.7.1-.2.2-.4.3-.5 2.3.1 4.2.1 6.6.1zM63.3 120.8c-1.5 2.2-1.4 5-1.4 7.6 0 3.5-.1 6.9 0 10.4.1 1 .3 1.9.8 2.8.2.2.4.6.7.8 0 .2-.1.4-.3.5h-6.7c-.1-.1-.2-.3-.2-.5 1-.6 1.4-1.8 1.5-2.8.2-1.1.2-2.4.3-3.5v-8c-.1-2.2.3-4.5-.6-6.4-.1-.1-.2-.3-.3-.5l-.4-.4.2-.4h6.2l.2.4zM85.1 120.4c.1.2.2.4.1.5-2.2 1.4-2.8 4-3.7 6.2-1.7 4.6-3.2 9.2-4.9 13.8-.1.4-.5 1.5-.5 1.5-.2.1-.1.5-.4.4-.9 0-1.8.1-2.7 0-1.8-5.3-3.7-10.4-5.4-15.8-.8-1.9-1.1-4.2-2.7-5.8-.1-.2-.6-.2-.5-.6.1-.1.1-.2.2-.3h6.9c.1.1.2.3.2.5-1.2 1-1 2.9-.6 4.2.9 2.8 2.7 8.3 2.7 8.4.4 1.2.7 2.4 1.2 3.6 1.4-3.9 2.6-7.6 4-11.4.3-1.2.9-2.6.4-4-.1-.3-.4-.6-.7-.8 0-.2.2-.3.2-.5 2.1.1 4.2.1 6.2.1zM91.5 120.5c2.3 0 4.7 0 7.1.1.1 1.4.3 2.8.4 4.3-.1 0-.2.1-.4.1-1.7-1.7-4.1-1.9-6.4-1.9l-.1.1c0 2.3-.1 4.6 0 6.9l.1.1c1.1 0 2.3-.1 3.4-.4.7-.2 1.2-.7 1.6-1.2.7.1.3.9.4 1.4 0 1.4-.1 2.8-.1 4.1-.1.1-.3.1-.4.2-1.2-1.4-3.1-1.7-5-1.7-.2.1 0 .3-.1.5 0 .9 0 5.8-.1 7.3.1.1.3.1.5.1 2.8.2 5.6-.6 7.6-2.7.2 0 .2.1.3.2-.5 1.7-1.2 3.4-1.8 5.1-4.1 0-8.2 0-12.2-.1-.1-.1-.1-.2-.2-.4 0-.1.1-.1.2-.2 1.2-1 1.4-2.6 1.6-4.1.1-3.3.1-6.7.1-10-.1-2.1.4-4.5-.7-6.4-.2-.3-.5-.6-.9-.8l.2-.5c1.7-.1 3.3-.1 4.9-.1zM178 120.5c1 .1 2 0 3 .1.1.1.2.3.1.4-2 1.7-1.8 4.5-1.8 6.8-.1 3.5 0 7.1 0 10.6 0 .8-.1 1.4.1 2.1 3 .2 5.9-.5 7.8-2.6 0-.1.1-.1.1-.1.2 0 .2.2.3.3-.1.3-.2.6-.3 1-.5 1.4-.9 2.8-1.5 4.1h-12c-.1-.1-.1-.3-.2-.4.5-.4.9-.9 1-1.5.5-1 .5-2.2.6-3.3v-8.4c-.1-1.7.1-3.5-.1-5.2-.1-1.2-.2-2.6-1.4-3.2 0-.1-.1-.1-.2-.1.1-.2.1-.4.4-.4 1.5-.1 2.8-.2 4.1-.2zM172.4 128c-.5-1.5-1.1-2.9-2-4.1-1-1.3-2.4-2.3-3.8-3-.2-.1-.4-.1-.5-.2-3.2-.9-6.7-.2-8.9 2.2-.3.3-.5.6-.7.9-.5.7-.7 1.3-1 2-1.1 2.7-1.6 6.1-.9 9 .5 2 1.2 3.9 2.5 5.5 1.5 2.1 3.9 3.3 6.5 3.3 2.5.1 4.7-.9 6.4-2.6 1.3-1.4 2.1-3.2 2.7-5.1.4-2.6.4-5.3-.3-7.9zm-4.1 8.1c-.1.1-.1.3-.1.5-.5 1.9-1.9 4-4 4.3-1 .1-1.9-.2-2.7-.8-.9-.6-1.5-1.5-2-2.4-.5-.8-.6-1.7-.9-2.5-.1-.5-.2-1-.3-1.6-.3-1.5-.2-3.2 0-4.8.3-1.3.5-2.6 1.3-3.7.1 0 .1.1.1 0s-.1 0-.1-.1c.4-.6 1-1.2 1.7-1.6.5-.3 1.2-.5 1.9-.4l.1.1c0-.1.1 0 .2-.1.1.1.3 0 .5.1 1.3.3 2.4 1.3 3.1 2.5-.1.1.1.1.1.2 1.6 3 1.9 6.8 1.1 10.3zM150.6 124.8c-1.2-2-3.2-3.5-5.4-4.1-1.1-.3-2.3-.3-3.5-.2-.6.2-1.3.3-1.9.5-1.4.5-2.5 1.6-3.4 2.7-.5.6-.8 1.3-1.2 2-.5 1.3-.9 2.7-1.1 4.1-.2 1.4-.1 2.8 0 4.2.3 1.5.7 2.9 1.3 4.3.7 1.2 1.6 2.5 2.7 3.5.8.6 1.7 1.1 2.5 1.4.6.1 1.2.3 1.8.3 3 .3 5.6-1 7.5-3.2 3.4-4.3 3.4-11 .7-15.5zm-3.2 13.3c-.7 1.5-2.3 3.1-4.1 2.9-1.5-.1-2.9-1.3-3.7-2.6-.9-1.4-1.2-3-1.5-4.7-.3-1.6-.2-3.3 0-4.9.1-.6.3-1.2.4-1.7 0-.4.2-.7.4-1.1.7-1.5 2.1-2.8 3.8-3 1.5-.1 2.7.7 3.6 1.7 1.8 2.3 2.1 5.2 2.1 8-.1 1.9-.4 3.8-1 5.4zM114.1 138.4c-1.3-2-2.7-4-3.7-6.2.6-.5 1.4-.8 2.1-1.3 1.4-1 2.3-2.5 2.5-4.2 0-.3 0-.7-.1-1-.2-2-1.6-3.7-3.4-4.4-1-.5-2.1-.6-3.2-.7h-6.4c-.2.1-.2.4-.3.6.3.1.3.4.5.5.6.9.7 1.9.7 3v12.6c0 .8-.1 1.5-.2 2.2-.1.8-.3 1.6-.7 2.3-.2.4-.6.7-.8 1 .1.1.1.2.3.3h5.3c.5-.1 1.2.3 1.4-.4-.7-.8-1.2-1.7-1.4-2.7 0 0-.1-4.5-.1-6.6 0-.1.1-.1.1-.1.8 1.4 1.4 2.7 2.3 4 1.2 2.1 2.7 4.4 4.9 5.4 0 .1.1.1.1 0 1.1.5 2.5.7 3.6.3.1-.1.1-.2.1-.3-1.5-1-2.5-2.8-3.6-4.3zm-5.8-7.9c-.5.2-1 .4-1.6.4v-7.6c.2-.1-.1-.2.1-.2.5 0 .9 0 1.3.1 1.1.1 2 .7 2.6 1.6.7 1 .7 2.4.1 3.5-.1.2-.3.4-.5.6-.4.3-.6.6-1.1.9-.3.4-.6.5-.9.7zM133.1 126.2c-.1-.6-.3-1.4-.4-1.5-1.2-2.6-4-4-6.8-4.1h-6.4c-.1.1-.2.3-.3.5l.5.5c.7.9.8 2.1.9 3.2 0 4.5-.1 9-.1 13.5 0 1.4-.3 3-1.1 4.2-.1.2.1.3.2.5 1.9 0 3.9.1 5.8 0 .1-.1.2-.3.2-.4-.6-.7-.9-1.5-1.1-2.3-.3-2.1-.1-3.9-.1-6.1 0-.1 0-.2.1-.2 3.1-.2 6.3-.9 7.9-4 .6-1.4.9-2.3.7-3.8zm-3.8 1.8c-.1.2-.1.3-.1.5-.3 1-1.3 2-2.2 2.5-.7.4-1.6.5-2.5.5 0-.1-.1 0-.1-.1.1-2.7 0-5.5.1-8.2 1.8-.1 3.7.3 4.5 2 .3.9.4 1.9.3 2.8z"
    />
    <linearGradient
      id="SVGID_37_"
      gradientUnits="userSpaceOnUse"
      x1={96.004}
      y1={182.035}
      x2={146.109}
      y2={182.035}
      gradientTransform="matrix(1.2 0 0 1.2 -23.059 -30.705)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M142.3 175.2c1.4 2.2.5 5.2-.7 7.2-2.7 5-6.9 8.9-11.4 12.2-1.3.9-2.5 1.8-3.8 2.7-1.6 1.1-3.1 2.3-4.6 3.5-.2 0-.3.1-.4 0l-.2-.2c0-.5.5-.8.8-1.2 5.1-5 11.4-8.8 15.5-14.7 1.9-2.6 3.5-5.6 3.9-8.9 0-.4-.1-.8-.1-1.2 0-.1.2-.2.3-.1.4.2.5.5.7.7z"
      style={{
        fill: 'url(#SVGID_37_)',
      }}
    />
    <path
      className="st44"
      d="M112.7 185c.1 0 0 .1 0 .2-.9.1-1.8.5-2.7.5-.3 0-.5 0-.8-.2-.3-.3-.3-.7-.2-1.1.1-.2.4-.1.6-.1 1.1.2 2.1.4 3.1.7M104.6 186.2c1.8 0 2.7.1 2.7.6 0 .8-1.7 1.2-3.2 1.4.1-.3.2-.7.3-1.1.1-.3.2-.4.2-.9"
    />
    <path
      d="M188 281.3c-1.1 0-2.1.4-2.9 1.2-.8.8-1.2 1.9-1.2 3s.4 2.1 1.2 2.9c.8.8 1.8 1.2 2.9 1.2 1.1 0 2.1-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9-.7-.8-1.8-1.3-2.9-1.3z"
      style={{
        fill: '#fff',
        stroke: '#fff',
        strokeWidth: 2.0224,
        strokeMiterlimit: 3.8637,
      }}
    />
    <path
      d="M188 281.3c-1.1 0-2.1.4-2.9 1.2-.8.8-1.2 1.9-1.2 3s.4 2.1 1.2 2.9c.8.8 1.8 1.2 2.9 1.2 1.1 0 2.1-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9-.7-.8-1.8-1.3-2.9-1.3zm3.6 4.2c0 1-.4 1.8-1 2.5-.7.7-1.6 1.1-2.6 1.1-.9 0-1.8-.4-2.5-1.1-.7-.7-1.1-1.6-1.1-2.5 0-.9.4-1.9 1.1-2.6.7-.7 1.5-1 2.5-1s1.9.4 2.6 1.1c.6.6 1 1.5 1 2.5zm-3.5-2.5h-1.8v4.7h.9v-2h.9l1 2h1l-1-2.1c.7-.1 1.1-.6 1.1-1.3-.1-.8-.8-1.3-2.1-1.3zm-.1.6c.8 0 1.2.2 1.2.8 0 .5-.4.7-1.2.7h-.7v-1.5h.7z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
    />
    <path
      className="st44"
      d="m134 77.6 1.8 4.8c.1.2-.2.1-.2.1-1.2 0-2.3 0-3.4-.1.5-1.6 1.2-3.2 1.8-4.8zm33.3 0c.6 1.6 1.2 3.3 1.8 4.9-1.1 0-2.4 0-3.6-.1.4-1.6 1.2-3.1 1.8-4.8zm-56.1-.4c.2.6.2 1.4-.3 1.8-.6.6-1.3 1-2.1.9V76c1 0 2 .3 2.4 1.2zm75.7-1.3c.5.1 1 .6 1.2 1.1.5.8.7 1.6.9 2.5 0 .2.1.4.1.6.1 1.6.2 3.8-1.4 4.9-.5.3-1.2.3-1.7.1-1.6-.7-2-2.5-2.2-4.1-.2-1.8-.3-4 1.3-5.1.5-.2 1.3-.3 1.8 0zm-154 .8c.6 1.2 1 2.5 1.1 3.9 0 1.5-.1 3.4-1.7 4.3-.6.3-1.4.2-1.9-.1-.4-.3-.8-.7-1-1.2-.7-1.3-.9-2.8-.9-4.3 0-1.4.3-3.2 1.8-3.8 1-.3 2 .3 2.6 1.2zm177-1.7c0 .7.2 1.2.2 1.9-.4.6-.7-.2-1.1-.2-.8-.3-1.8-.4-2.7-.4 0 1.2-.1 2.3 0 3.5.2.1.5-.1.7-.1.7-.2 1.3-.4 1.7-1.1.1 0 .2-.1.2 0 .1.2.1.4.1.7v2.5c-.1.1-.2.2-.4.2-.5-.7-1.4-.8-2.2-.9-.1 0-.1.1-.2.2V85c.1.2.5.1.7.1 1.3-.1 2.5-.4 3.5-1.2.1-.1.2.1.3.1-.2.7-.5 1.3-.6 2-.1.2-.1.4-.3.6-2.1-.1-4.2 0-6.3 0-.1-.1-.2-.3-.2-.5.8-.4.9-1.4 1-2.2 0-1.6 0-3.4.1-4.9-.1-1.2.2-2.7-.8-3.7.1-.1.1-.3.3-.3h6zm-31.3-.2c.3.3-.3.4-.4.7-.6.7-.5 1.6-.6 2.5 0 2.3-.1 4.7 0 7.1 1.4 0 2.8-.3 3.7-1.3.1-.1.2 0 .3 0-.2.9-.5 1.7-.8 2.6l-.1.1c-1.9 0-4 0-6-.1 0-.1-.1-.2-.1-.4 1-.6 1-1.8 1-2.8 0-2.2.1-4.4 0-6.6-.1-.6-.4-1.3-.9-1.5.1-.1.1-.3.2-.4 1.3.1 2.5 0 3.7.1zm-43.7 0c1.4 3.2 2.6 6.5 4.1 9.7.1.2.3.6.5.8.3.3.5.5.9.6 0 .1-.1.3-.2.4H136c-.1-.1-.2-.2-.2-.4.3-.1.6-.4.7-.8.1-.5-.1-1-.3-1.4-1.6-.1-3.1 0-4.6 0-.2.5-.4 1.2-.1 1.7.2.3.4.4.6.5 0 .1-.1.2-.2.3h-3.8c0-.1-.1-.2-.1-.3 1.4-.6 2-2.1 2.5-3.4 1.1-2.6 2.1-5.2 3.2-7.8.4 0 .8 0 1.2.1zm60.1 0c0 .6.2 1.2.5 1.7 1.4 2.2 3 4.3 4.5 6.5.1-2.1 0-4.2.1-6.2 0-.6-.3-1.3-1-1.6.1-.1.1-.3.3-.3h3.1c.1.1.1.2.2.3-.2.2-.5.3-.6.6-.4.5-.4 1.2-.4 1.9-.1.7-.1 1.4-.1 2.1.1 1.8-.3 3.8.2 5.6.1.3.3.5.5.8 0 .1-.1.3-.2.4h-2.5c-.2-1-.9-1.7-1.4-2.5-1.3-1.9-2.6-3.7-3.9-5.7-.1 1.1 0 2.4 0 3.7-.1.9.1 1.9.1 2.8.2.5.3 1 .8 1.2.1.1-.1.2 0 .4l-.2.1-3.2-.1-.1-.3c1.2-1 .9-2.5 1-3.9 0-1.5.1-3 0-4.6-.1-.9-.2-1.9-1-2.5-.1-.1 0-.3 0-.3 1.1-.2 2.2-.1 3.3-.1zm-49.7-.1c0 .1.1.2.1.3-.8.4-1 1.3-1 2.1-.1.7 0 1.6-.1 2.3 0 1.8 0 3.7.1 5.6.9 0 1.8-.1 2.6-.5.5-.1.9-.5 1.2-.9.1 0 .2.1.2.2-.2.8-.6 1.7-.9 2.5-2 0-4.1 0-6.1-.1 0-.1-.1-.2-.1-.3 1.4-.8.9-2.6 1-4v-5.4c-.1-.6-.4-1.2-1-1.5.1-.1.1-.4.3-.3h3.7zm-32.4 1.9c.3.7.4 1.7 0 2.3-.4.8-1.2 1.4-2.1 1.7.8 1.8 1.8 3.4 3.2 4.9.3.3.8.5 1.2.6-.1.1-.1.3-.2.4-.6.1-1.2 0-1.8-.1-.3-.1-.5-.2-.8-.4-1.3-.9-2-2.2-2.8-3.4l-.6-1.3c-.1-.1-.1-.1-.2-.1-.1 1-.1 2.4-.1 3.6 0 .5.4 1 .7 1.3 0 .1-.2.2-.3.2H106c-.1-.1-.2-.2-.2-.3.8-.6.8-1.7 1-2.5.1-2.3.1-4.6 0-6.8-.1-.5-.2-.9-.6-1.3-.1-.1-.3-.1-.2-.2.1-.1.1-.2.2-.3 2.5 0 5.5-.7 6.7 1.7zm38.1-1.9h1.8c.1.1.1.2.1.4-1.5.8-1.1 2.8-1.2 4.2 0 0 .1.1.1 0 .9-.9 1.6-1.6 2.3-2.5.2-.5.9-1.1.4-1.7 0-.1.1-.2.2-.3h3.7c.2 0 .2.2.3.4-.3.1-.8.3-1.1.5-1.5 1.1-2.8 2.6-4.1 4 .7 1.1 1.6 2.1 2.3 3.2 1.2 1.2 2.1 2.5 3.5 3.2-.1.1-.1.2-.2.3h-3c-1.4-1.9-2.9-3.6-4.3-5.6-.1 0-.1 0-.1.1 0 1.2 0 2.7.1 3.8.1.5.4 1.1 1 1.2-.1.2-.1.4-.3.5-1.2-.1-2.4-.1-3.6-.1-.1-.1-.2-.3-.2-.5 1-.4 1-1.5 1.2-2.4.1-2.4 0-4.5 0-7-.1-.3-.1-.6-.3-.7-.1-.3-.4-.4-.6-.6 0-.1.1-.2.2-.4h1.8zm-30.8 0c.1.1.2.2.2.4-.5.1-.8.6-.9 1.1 0 .4-.1.8.1 1.1.4 1.6.9 3.3 1.4 4.9.2 0 .1-.3.2-.3.7-2.4 1.6-4.7 2.3-7.1h.3c.9 2.5 1.6 5 2.4 7.5 0 .1.1 0 .2 0 .5-1.3.8-2.7 1.3-4 .2-.7.5-1.5.5-2.3-.1-.4-.4-.9-.9-1 0-.1.1-.2.2-.3h2.5s1.3-.1 1.3.3c-.3.2-.6.3-.8.6-.8 1-1.1 2.3-1.5 3.5-.9 2.4-1.6 4.7-2.4 7.1h-1.1c-.7-2.2-1.4-4.3-2.1-6.5-.8 2.2-1.4 4.3-2.1 6.5-.3.1-.6.1-.9 0-1-3-2-6-2.9-9.1-.2-.8-.7-1.6-1.5-2 .2-.8 1.1-.2 1.6-.4h2.6zm48 0c1.2 2.8 2.3 5.6 3.4 8.3.4 1.1.9 2.4 2.1 2.9.1.1.1.2 0 .3-.1.1-.1.2-.2.2h-4.2l-.2-.4c.3-.2.7-.4.7-.8.1-.5-.1-1-.3-1.4h-4.1c-.2 0-.5-.1-.6.1-.1.6-.4 1.4.1 1.8.1.2.5.1.4.4l-.1.2c-1.3 0-2.5 0-3.8-.1-.1-.1-.2-.2-.1-.4 1.8-1 2.2-2.9 3-4.5.9-2.2 1.8-4.5 2.7-6.7.4 0 .8.1 1.2.1zm-78.4 0h1c.1.1.1.2.1.3-.8.5-.7 1.6-.5 2.4.6 2.2 1.4 4.3 2.1 6.5.5-1.3 1-2.7 1.4-4 .4-1.2.9-2.3 1-3.6 0-.5-.2-.9-.6-1.3 0-.4.5-.2.7-.3h2.8c.1.1.3.4.1.5-.5.3-.9.8-1.1 1.3-1.4 3.2-2.5 6.5-3.8 9.8h-1.3c-1.1-3-2.2-5.9-3.3-8.8-.5-.9-1-1.9-1.8-2.5.1-.3.3-.2.5-.3h2.7zm14.9 0c.1.7.2 1.3.3 2-.3.4-.7-.2-1.1-.3-.8-.3-1.7-.4-2.7-.4-.1 1.1 0 2.3-.1 3.5 0 .1 0 .1.1.2.5-.1 1-.2 1.5-.4.3-.2.7-.5.9-.9.1 0 .2.1.3.1v3.1c-.1.1-.2.2-.3.2-.5-.7-1.4-.9-2.2-.9-.1 0-.2 0-.2.1-.1 1.3 0 2.6 0 4l.1.1c1.5 0 3-.3 4.1-1.3.1 0 .3.1.3.2-.3.8-.5 1.6-.9 2.4h-6.4c-.1-.1-.2-.2-.2-.3 1-.6 1-1.8 1.1-2.8-.1-1.4 0-2.8 0-4.1 0-1 .1-1.9-.2-3-.2 0 0-.1-.1-.2-.1-.2-.3-.5-.5-.6 0-.1.1-.3.2-.4 2-.4 4-.3 6-.3zm-19.1 0c.1.7.2 1.3.3 2-.6.3-1.3-.6-2-.5-.6-.2-1.2-.2-1.8-.2 0 1.2-.1 2.4 0 3.5l.1.1c1-.1 2-.4 2.4-1.3.1 0 .1 0 .2.1l.1 3.1c-.1.1-.2.1-.4.2-.5-.7-1.5-.9-2.4-.9 0 .1 0 .2-.1.3v3.7c.1.1.4.1.6.1 1.3-.1 2.6-.4 3.6-1.3.1.1.3.1.2.3-.3.8-.5 1.6-.9 2.4h-6.2c-.1-.1-.2-.2-.2-.4.8-.4.9-1.3 1-2 .1-2.3.1-4.6.1-6.9-.1-.7-.2-1.4-.8-1.8 0-.1.1-.3.2-.4 2.1-.1 4.1-.2 6-.1zm-24.1-.1c.1.1.1.2.1.3-1.2.7-1.1 2.7-1.1 3.4 0 2.4.1 4.3.1 6.6 1.4 0 2.7-.3 3.7-1.3 0-.1.2-.1.3 0 .1.1.1.2 0 .3l-.6 1.8c-.1.2-.1.5-.3.5-2.1 0-3.9 0-6-.1-.1-.1-.1-.2-.1-.3.3-.2.5-.4.7-.6.3-.5.3-1.1.3-1.7.1-2.3 0-4.6.1-6.8-.1-.7-.3-1.5-1-1.7 0-.1.1-.3.2-.4h3.6zm9.6.1c.1.2 0 .4.1.6.1.4.3.7.4 1.1 1.5 2.1 2.9 4.3 4.5 6.5.1-.1 0-.1.1-.2v-5.6c0-.7 0-1.5-.6-1.9-.1-.1-.2-.1-.3-.1.1-.1.1-.2.2-.3h3c.1.1.1.2.2.4-1.4.7-1 2.4-1.1 3.7 0 2.1-.2 4.1.1 6.1.1.4.3.7.6 1-.1.1-.1.2-.2.3h-2.4c-.2-.9-.8-1.6-1.3-2.4-1.2-1.8-2.5-3.5-3.6-5.3-.1-.2-.3-.3-.4-.5-.1 1.8 0 3.4 0 5.4.1.9 0 2 1 2.5 0 .1-.1.2-.1.4h-3.2c-.1-.1-.2-.3-.1-.4.7-.6.9-1.5 1-2.3.1-2.1.1-4.1.1-6.2 0-1-.6-2-1-2.7.8-.3 1.9-.1 3-.1zm-16.9-.1c.1.1.1.2.1.3-.6.4-.9 1-1 1.7-.1 1.9-.1 3.9-.1 5.9.1.8 0 1.6.1 2.4.9 0 1.9-.2 2.7-.6.4-.2.8-.5 1.1-.8.1 0 .2.1.3.2-.3.9-.6 1.7-.9 2.5-1.9 0-4.1.1-6.1-.1-.1-.1-.1-.2-.1-.4 1.4-.9.8-2.5 1-4 0-1.8 0-3.6-.1-5.4 0-.1-.1-.3-.1-.4-.2-.4-.3-.9-.8-1 0-.1.1-.2.2-.3h3.7zm-13.7 0c.1.1.1.2.1.3-.1.1-.3.1-.4.3-.5.4-.6 1-.7 1.6 0 2.1-.1 4.2-.1 6.3.1.6.3 1.2.8 1.5 1 .5 2.1-.1 2.9-.7.3-.3.6-.5.8-.8v-5.8c0-.8.1-1.9-.8-2.3 0-.1.1-.3.2-.5h3.3c.2 0 .4.1.5.3-1.3.6-1 2.2-1.1 3.4 0 2.1-.1 4.3.1 6.4.1.5.4.9.9 1.1 0 .1-.1.2-.2.3H44v-1.2c-.1-.1-.2.1-.3.2-1.2 1-2.7 1.6-4.3 1.1-.7-.2-1.1-.8-1.5-1.2-.2-.4-.3-.7-.4-1.2-.1-1.7 0-3.3 0-4.9.1-1.1.1-2-.2-3-.1-.4-.5-.8-.9-.9l.2-.3c1.3-.1 2.5 0 3.9 0zm-13.3 0c.1.1.2.2.2.3-1.2.4-2 1.6-2.6 2.7-.6 1.1-1.3 2.2-1.8 3.3 0 1.3-.1 2.6.2 3.9.2.4.4.8.9.9 0 .1-.1.3-.2.4-1.2.1-2.3 0-3.6 0-.1-.1-.2-.2-.1-.4 1.2-1 1.1-2.7 1.1-4.1v-1l-2.4-4.2c-.6-.7-1.2-1.3-2-1.5.1-.1.1-.3.2-.4 1.5.1 3.1 0 4.7 0 .1.1.1.2.1.3-.3.1-.6.3-.7.7-.2.4-.1.8.1 1.1.4.9.9 1.7 1.4 2.5.3-.3.4-.8.6-1.1.4-1 1.5-2.1.5-3.2.1-.1.1-.3.2-.3.6 0 1 0 1.6-.1.5.1 1 .1 1.6.2zm22.4 0c-.4 1.3-1.1 2.8-2.4 3.3l-.3-.3c.1-.2.3-.3.4-.5.3-.6.5-1.3.5-2v-.2c0-.2.1-.4.1-.4l1.7.1zm141.1 3c.5.8.5 1.9.6 2.8 0 2.2-.7 4.7-2.9 5.8-.8.4-1.7.5-2.6.3-1.2-.3-2.5-1.2-3-2.3-.6-.9-.9-1.9-1-3v-1.4c.1-2.1 1.1-4.3 3.1-5.1 1.2-.4 2.6-.4 3.6.3 1 .6 1.8 1.6 2.2 2.6zM34.9 76.5c.1.1.2.3.2.4.7 1.7 1 3.6.6 5.4-.4 1.8-1.8 3.7-3.7 4-.3 0-.7.1-1 0-.2 0-.4-.1-.7-.1-.2-.1-.5-.1-.7-.3-1.9-.9-2.7-2.9-3-4.7-.2-2.5.4-5.1 2.6-6.5 1.3-.8 3.2-.6 4.4.3.5.4 1 .9 1.3 1.5z"
    />
    <linearGradient
      id="SVGID_38_"
      gradientUnits="userSpaceOnUse"
      x1={96.277}
      y1={182.036}
      x2={146.373}
      y2={182.036}
      gradientTransform="matrix(1.2 0 0 1.2 -23.059 -30.705)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M142.6 175.2c1.4 2.2.6 5.2-.7 7.2-2.7 5-6.9 8.9-11.4 12.2-1.3.9-2.5 1.8-3.8 2.7-1.6 1.1-3.1 2.3-4.6 3.5-.2 0-.3.1-.4 0l-.2-.2c0-.5.5-.8.8-1.2 5.1-5 11.3-8.8 15.5-14.7 1.9-2.6 3.5-5.6 3.9-8.9 0-.4-.1-.8-.1-1.2 0-.1.2-.2.3-.1.4.2.6.5.7.7z"
      style={{
        fill: 'url(#SVGID_38_)',
      }}
    />
    <linearGradient
      id="SVGID_39_"
      gradientUnits="userSpaceOnUse"
      x1={90.152}
      y1={214.645}
      x2={153.376}
      y2={214.645}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#5e0000',
        }}
      />
      <stop
        offset={0.056}
        style={{
          stopColor: '#7b0000',
        }}
      />
      <stop
        offset={0.121}
        style={{
          stopColor: '#96070b',
        }}
      />
      <stop
        offset={0.188}
        style={{
          stopColor: '#ad1015',
        }}
      />
      <stop
        offset={0.257}
        style={{
          stopColor: '#c0151b',
        }}
      />
      <stop
        offset={0.329}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.407}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#d71920',
        }}
      />
      <stop
        offset={0.599}
        style={{
          stopColor: '#d51920',
        }}
      />
      <stop
        offset={0.677}
        style={{
          stopColor: '#cd171e',
        }}
      />
      <stop
        offset={0.748}
        style={{
          stopColor: '#c1151b',
        }}
      />
      <stop
        offset={0.814}
        style={{
          stopColor: '#af1116',
        }}
      />
      <stop
        offset={0.878}
        style={{
          stopColor: '#98080c',
        }}
      />
      <stop
        offset={0.939}
        style={{
          stopColor: '#7e0000',
        }}
      />
      <stop
        offset={0.998}
        style={{
          stopColor: '#5f0000',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#5e0000',
        }}
      />
    </linearGradient>
    <path
      d="M104.5 186.2c1.8 0 2.7.1 2.7.6 0 .8-1.7 1.2-3.2 1.4.1-.2.2-.7.3-1.2.1-.3.2-.3.2-.8zm7.7 50.4c.5.1 1 .1 1.5.3.1 2.8.7 5.5 2.2 7.7-.2.1-.5 0-.8-.1-1-.4-1.8-1-2.6-1.7-.1 1.8-.7 3.8-1.8 5.3-2.1 3.2-4.6 6.3-6.8 9.5-.1.2-.2.5-.2.7.2.4.6.3 1 .4 1.3 0 2.6-.2 3.8.2.1 0 .2 0 .3.1.5.2 1.1.6 1.1 1.2s-.2 1.2-.7 1.7c-.1.1-.1.1-.2.1-.2.1-.4.3-.7.2.1-.2.1-.5-.1-.7-.7-.6-1.6-.8-2.6-.9-1.6-.1-3.2-.2-4.8-.1-1.9.1-3.9.1-5.7.7-.5.3-1.2.7-1.2 1.4 0 .1.1.1 0 .2-.6.1-1.3-.2-1.5-.8-.1-.5.1-1 .4-1.4.3-.3.7-.6 1.1-.7.1-.1.2-.2.1-.2-.4-.1-.8-.1-1.2 0-.9.2-1.8.6-2.2 1.5-.4-.1-.6-.4-.7-.7-.1-.5 0-1 .4-1.3.8-.6 1.9-.6 3-.5-.1-.3-.1-.6 0-.8.3-.3.6-.5 1.4-.6 1.8-.2 3.2 1.4 5.1.8.7-.3 1.1-1 1.4-1.6 2-3.3 3.7-5.9 5.5-10 .8-2 1.5-3.4 1.9-5.2-1.1.9-2.5 2-4.1 2 1.2-2.8 1.9-5.8 2-8.7 2 .8 3.8 1.6 5.7 2zm11.7-13.1c4.6 1.9 9.9 2.9 13.4 7 3.5 3.7 4.3 9.4 2.7 14.1-.6 1.9-1.5 3.6-2.6 5.3-.2.2-.3.7-.7.6-.1-.3.1-.5.1-.7 1.1-3.6.9-7.1-.6-11.2-.8-2.2-1.5-3.3-2.8-5.2-3.3-4.9-7.4-6.9-11.1-10.3 0-.1 0-.2.1-.2.5 0 1 .4 1.5.6zm13.5-8c.1.4-.3.6-.4.9-.6.8-1.2 1.7-1.9 2.4-1.5.3-3 .2-4.6.1-.6 0-1.2-.2-1.8-.3-.1-.1 0-.1 0-.2 3.1-.4 5.9-1.6 8.6-3.1 0 .2.1.2.1.2zm4.3-6.8c.1.3-.3.6-.4.9-1 1.3-2.2 2.6-3.5 3.5-2.3 1.9-5 3.1-7.8 4-1 .2-2.1.5-3.2.6h-.2v-.1c1.3-.7 2.9-2 2.7-3.7v-.2c3.9-.7 7.4-2.1 10.7-4.3.5-.3.9-.8 1.5-1 .1.1.2.3.2.3zm-34.5-4.9v.2c-.6.9-1.1 1.8-1.5 2.8-1 2.3-1.7 5-1.5 7.5.2 3.1 1.2 5.9 2.9 8.5.2.3.4.6.6.8 1.4 1.8 3.2 3.3 5.1 4.5.1.1.4.2.4.4-.3.2-.7-.1-1-.2-3.2-1-6.2-3-8.2-5.8-2.6-3.5-3.4-8.5-1.6-12.6.6-1.3 1.3-2.6 2.1-3.7.8-.9 1.6-1.9 2.6-2.6-.1.2 0 .2.1.2zm37.5-2.4c-.2.9-.6 1.7-1.1 2.4-1.9 2.8-4.7 4.8-7.6 6.5-2.1 1.1-4.3 2-6.5 2.4v-.1c0-.1.2-.1.2-.2 1.1-.9 1.6-2.2 1.5-3.6 2.7-.9 5.3-2.2 7.8-3.6 1.1-.7 2.2-1.4 3.3-2.3.9-.6 1.4-1.3 2.3-1.9 0 .1.1.2.1.4zm3.1-8.4c-.1 1.7-1.1 3.1-2.1 4.5-3.9 4.9-9.2 8.1-14.6 10.4-.1 0-.2.1-.3 0 .1-.2.3-.4.4-.6.5-.9.7-2 .4-3 5.8-2.8 11.2-6.6 15.7-11.4.2-.1.4-.1.5.1zm-35.2-8.1c.1 0 0 .1 0 .2-.9.1-1.8.5-2.7.5-.3 0-.5 0-.8-.2-.3-.3-.3-.7-.2-1.1.1-.2.4-.1.6-.1 1.1.3 2.2.4 3.1.7zm39.5-2.3c0 .6-.2 1.1-.4 1.6-.9 2.3-2.3 4.3-3.9 6.2-4.6 5.3-10.4 9.4-16.4 12.7-.1 0-.1-.1 0-.2.6-.8.8-1.9.4-2.9-.1-.2-.2-.4-.2-.6 7.4-4.3 14.6-10 20-17 .1-.1.5-.1.5.2zm.9-9.2c.3.5.3 1 .4 1.6.2 1.7-.1 3.5-1 4.9-2.9 4.3-6.6 7.7-10.4 11l-.9.7c-.1 0-.3 0-.3-.1-.1-.1 0-.2 0-.3 1.8-2.1 4-4 5.6-6.3 2.3-2.8 4-6 5.5-9.1l.9-2.4c-.1-.1.1-.1.2 0zm-3-7c1.2 1.5 1.9 3.4 1.6 5.2-.6 3.3-2.4 6.3-4 9.2l-1.2 1.8c-3 4.5-6.8 8.6-11 11.8l-2.7 2.1c-2.7 1.9-5.4 3.6-8.1 5.4-.1.1-.1.2 0 .3.2.2.4-.1.6-.1 1.8-.6 3.4-1.3 5.1-2.1.2 0 .3.1.4.3.2 1-.4 2-1.1 2.7-1.9 1.7-4.3 2.5-6.7 3.3 0 .1-.2.1-.1.2.2.3.5 0 .8.1 2.3-.4 4.4-1 6.5-1.9.1 0 .2 0 .3.1.2.6-.3 1.1-.5 1.6-1 1.2-2.5 1.8-3.9 2.3-1 .4-2.1.6-3.2.9-.1.1-.2.2-.1.3.5.1 1 .1 1.5 0 1.9-.1 3.7-.6 5.6-.9.2.4-.1.7-.3 1.1-.3.2-.4.6-.7.9-1.7 1.4-3.8 2-6 2.1 0 .1-.1.1-.2.2 0 .1 0 .2.2.2 1.6.4 3.5.3 5.2.2.2.1.1.3.1.4-1.2 2-3.5 2.7-5.6 2.8-.1.1-.1.2 0 .3 1 .7 2.1 1.1 3.2 1.5 2.8.9 5.8 1.5 9.1 1.3.1 0 .1.1.2.2l-.1.2c-1.6 1.6-3.5 2.7-5.7 3-4.3.1-7.9-2-10.8-4.8l-1-1c-.1-.1-.2 0-.3 0-.3.3 0 .6.1.9 2.7 4.8 7.8 7.1 11.2 11.5 2.3 3.3 3.4 7.4 2.3 11.4-.1.3-.2.7-.5.9-.1 0-.2 0-.3-.1.2-1.9-.1-3.9-.6-5.7-.5-1.1-1-2.1-1.7-3.1-3-4.1-8-6.9-10.4-11.4-.8-1.3-1.4-2.7-1.9-4.1 0-.1-.1 0-.2 0-.3.3-.1.8-.1 1.2.6 4.3 3.7 7.5 6.7 10.5 1 1 2 1.8 3.2 2.8-.7 3.8.3 7.8 2.9 10.5.5.5 1.1.9 1.6 1.3-.3.4-1 .4-1.5.3-1.1-.2-2.1-.6-2.9-1.2-.1 0-.1.1-.1.1.3 4.1 1.1 8.1 2.2 12.1.5 1 .7 2.3 1.6 3.1.8.5 1.7.5 2.6.5h.2c1.1-.1 2.5-.1 3.4.6.2.2.3.4.4.6.2.8-.4 1.4-1 1.9-.2.1-.4.2-.6.2-.1-.4-.5-.8-1-1-.3-.1-.3-.2-.9-.3-2.7-.6-5.9-.5-8.7-.3-1.5.1-3 .3-4.2 1.2-.3.3-.5.6-.4 1-.1.1-.1 0-.2 0-.5 0-.9-.3-1.1-.7-.2-.5-.1-.9.2-1.3.2-.3.6-.4.8-.7 0-.1-.1-.2-.1-.2-1 0-2.1.2-2.5 1.1 0 .1 0 .2-.1.3-.2 0-.5-.1-.6-.4-.2-.3-.2-.8-.1-1.1.3-.7 1-1.2 1.8-1.1.4 0 .7.1 1.1 0-.1-.3-.1-.6 0-.9.9-1 2.5-.4 3.6-.2.7.2 1.5.5 2.2.8.2.1.5.1.8.1.2 0 .4-.2.6-.4.2-.7-.5-1.2-.7-1.8-2-4.3-3.2-8.9-3.9-13.7 0-.1-.1-.1-.1-.1-.3.3-.5.7-.8.9-.5.5-1.1.9-1.7 1.1-.1-.2.1-.3.1-.5.9-2.6.5-5.5-.5-8l-.1-.1c-4.1-.5-8-1.5-11.8-3.1-4.1-1.6-8.6-4.6-10.6-8.7-2.3-4.1-2-9.8.1-13.9.4-1 .9-1.9 1.5-2.6 3.4-5.2 9.1-8.1 13.3-12.4 1.2-1.3 2.3-2.9 1.7-4.7-.1-.3-.3-.6-.5-.8-.9-1.2-2.7-1.3-4.1-1-1.2.3-2.3.5-3.5.6-.5.9-1 1.7-1.7 2.5.8-.1 1.6 0 2.2.5.3.3.6.5.9.9.7-.1 1.3-.5 1.8-1 .1 1.2-.9 2.2-1.9 2.6-.8.4-1.8.1-2.5-.4-.6-.5-.9-1.2-1.2-1.8-.5.3-.9.7-1.3 1 .3.7 0 1.4-.4 1.9-.6.6-1.7 1.2-1.4 2.3 0 .1.1.1.1.2-.8.1-1.4-.3-1.9-.9-.2-.6-.2-1.2 0-1.8.8-1.4 2.3-1.8 3.6-2.7.2-.2.5-.3.6-.6-.4-.2-.8 0-1.2.1-.9.3-1.6 1-2.6 1.1-.4 0-.9 0-1.3-.1-.3.1-.5-.2-.7-.3-.3-.2-.5-.6-.4-.9.3.1.6.3.9.2 1.3-.4 2.3-1.4 3.7-1.3.7 0 1.4.4 2 .9.5-.6 1-1.3 1.3-2-.4-.3-1.2-.2-1.2-.9 0-.1.1-.2.1-.3.6-.1 1.2 0 1.7-.1.2-.7.4-1.4.4-2.1l-.1-.1c-1.4.1-2.7.5-3.9 1-.1-.4.2-.8.4-1.2.8-1.2 2.2-1.6 3.4-2-.1-.7-.5-1.3-.9-1.9.6.1 1.1-.1 1.6-.2.3.6.5 1.2.7 1.9.9-.1 1.8-.1 2.7-.1-.2-.4-.3-.8-.1-1.1 1-1.5 3.2-1.1 4.8-.9 1.5.3 2.9.8 4.3 1.2 2 .7 4 1.3 6.2 1.6.9 0 1.8-.3 2.4-.9.1-.1.1-.5.3-.4.3.2.2.7.1 1-.2.9-1.1 1.4-1.8 1.8-1.2.5-2.6.7-4 .5-.5 0-1.1-.3-1.7-.1-.1.1-.1.2 0 .2.7.3 1.3.8 1.6 1.5 1 1.6.7 3.8-.2 5.4-1.5 2.4-3.6 4.4-5.4 6.6-2.7 3.2-4.8 7.2-3.8 11.6.1.5.4 1.1 1 1.3.6.1.9-.4 1.2-.8.2-.5.5-.9.6-1.5.6-2.3 1.1-4.6 1.8-6.8.8-2 1.7-4 3.3-5.7.4-.6 1-1.1 1.6-1.7 3.9-3.7 8.4-6.8 11.8-11 2.6-3.1 4.8-6.4 5.9-10.2.5-1.5.2-3.4-.7-4.7-.1-.1 0-.3.2-.3.7-.1 1.3.5 1.8.8 1.7 1.1 2 3.3 1.6 5.3-.2 1.7-.9 3.2-1.7 4.7-2.1 3.6-5.1 6.7-8.2 9.5-.7.5-1.3 1.2-2 1.7-3.7 3.2-7.8 6.1-10.1 10.5-1.4 2.5-2 5.3-2.9 8-.6 1.6-1.6 3.1-3.2 3.8-.1.1-.2.3-.2.4.2.3.6.1.9.1 3-.9 4.5-3.8 5.4-6.5.5-1.2 1-2.5 1.6-3.7.9-1.7 2.5-2.9 4-4 6.3-4.3 12.9-8.5 17.5-14.7 3.3-4.2 5.7-8.7 7.2-13.7.3-1.2.7-2.3.9-3.5.1-.9.3-1.7.3-2.8 0-.1.1-.3.2-.3.4 0 .5.2.7.3z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_39_)',
      }}
    />
    <linearGradient
      id="SVGID_40_"
      gradientUnits="userSpaceOnUse"
      x1={114.45}
      y1={69.884}
      x2={114.45}
      y2={2.022}
    >
      <stop
        offset={0.601}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.927}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="m114.6 17.1 1.3 1.3c2.7 1.8 6.6 1.6 9.6.8 1.1-.3 1-.3 1.6-.5.3 1.1.1 2 0 3.3-.2 2.3-.7 3.7-1.6 5.8-.2.4-.3.7-.5 1.1-1.1 2.4-1.8 3.7-3.4 5.8-2.3 3-4.5 4.7-7.2 6.5h-.1c-.8-.6-1.5-1.1-2.5-1.8-1.2-1-1.9-1.6-2.9-2.7s-1.5-1.7-2.4-3c-1.3-1.9-1.9-3-2.7-5.1-1.1-2.6-1.7-4.2-1.9-7-.1-1-.2-1.7 0-2.5 0-.1 0 0-.1 0 0-.1.1-.2.1-.3h.3c1.1.4 2 .7 3.4 1 1.4.2 2.3.3 3.7.1 2.3-.4 4.1-1.1 5.3-2.8zm.9-14.1c.4.8.5 1.4.6 2.3.1.5.1.8.1 1.4 0 .7-.2 1.1-.2 1.7 0 0 .1 0 .1.1 1-.6 2.3-1.1 3.5-.4.7.4 1.1.7 1.5 1.5.5 1 .5 2-.2 2.8-.5.6-1 .9-1.7.9-.2-.2.1-.3.1-.5.1-.6.2-1-.1-1.5-.3-.7-1-1.1-1.8-1.1-.9 0-1.4.6-1.8 1.3-.5.9 0 2.4.9 3.5.5.5.8.7 1.5 1 .4.2.7.3 1.2.5.6.2.9.2 1.5.2h.6c2.5 0 4.1-.3 6.3-1.6 1.1-.6 1.9-1.1 2.6-2h.1c.5 3.9.2 7.8-.6 11.6l-.5 1.7c-.4 1.4-1 2.8-1.6 4.1 0 .1-1.1 2.4-1.1 2.4-2.1 3.5-4.7 6.7-7.9 9.3-.9.8-1.7 1.4-2.5 2v8c.1 0 .1.1.2 0 .2-.8.5-1.5.7-2.2.5-1.2 1.1-2.4 2-3.4 1-1.1 2.1-2 3.4-2.5 1.7-.6 3.6-.4 5.2.4.8.4 1.7 1.2 2.4 1.8.1.2.3.4.4.6 1.2 1.5 1.8 3.2 2.3 5.1.2.8.3 1.6.4 2.4.1 2.9-.3 5.7-1.4 8.2-1.2 2.7-3.8 5.5-7 5.5-.6.1-1.2-.1-1.7-.2-.4-.2-.9-.3-1.3-.5-3-1.5-4.8-4.7-5.5-7.7 0-.1-.1-.1-.1 0V70c33 0-24.3-.1-3.4 0 0-3.6.1-10.5 0-10.4-.2.6-.4 1.2-.7 1.9-.3.7-.4 1.1-.8 1.7-.3.6-.6 1-1 1.6-.4.4-.6.7-1 1.1-.3.3-.5.5-.8.7-.5.3-.8.5-1.3.8-.4.2-.6.3-1 .4-.3.1-.5.2-.9.2-.6.1-.9.1-1.5.1-.3 0-.5-.1-.8-.1-.4-.1-.6-.1-.9-.3-.6-.2-.9-.4-1.4-.7-.4-.2-.6-.4-.9-.7-1.2-1-1.7-1.8-2.4-3.2-.2-.5-.4-.7-.6-1.2-.2-.5-.3-.8-.5-1.3-.2-.6-.3-.9-.4-1.6-.1-.5-.1-.9-.2-1.4-.1-.7-.1-1.2-.1-1.9s0-1 .1-1.7.2-1.2.3-1.9c.2-.8.3-1.3.7-2.1.2-.6.4-.9.6-1.4.2-.4.3-.6.6-1 .3-.5.5-.7.9-1.1.3-.4.6-.6 1-.9.6-.5.9-.8 1.6-1.2.6-.3 1-.4 1.6-.5.2 0 .3-.1.6-.1.6-.1.9 0 1.5 0 .2 0 .4 0 .6.1.8.1 1.2.3 1.9.7.6.4.9.7 1.4 1.1.3.3.5.4.8.8.5.6.8 1 1.2 1.7.4.6.5 1 .8 1.7.2.5.3.7.5 1.2.2.4.3 1.2.3 1.2h.1v-7.9c-.6-.5-1.1-.8-1.8-1.4-.8-.6-1.2-1-1.9-1.7-.7-.6-1.1-1-1.7-1.7-.5-.6-.8-.9-1.3-1.5-.4-.5-.7-.8-1.1-1.4-.5-.7-.8-1-1.2-1.7-.5-.7-.7-1.2-1.2-1.9-.5-.9-.7-1.4-1.1-2.2-.4-1-.7-1.6-1-2.6-.5-1.3-.7-2.1-1.1-3.5-.3-1.2-.4-1.8-.5-3-.1-.8-.1-1.3-.2-2.2-.1-1.4-.1-2.1-.1-3.5.1-1 .1-1.7.3-2.6v-.1h.1l.8.8c.3.3.5.4.8.6.4.3.7.4 1.1.7.8.4 1.3.6 2.2.9.3.1.5.2.8.3 1.2.3 1.9.4 3.1.3.6 0 1 0 1.6-.1.5-.1.8-.2 1.3-.4s.7-.4 1.1-.7c.2-.2.4-.3.6-.5.3-.3.5-.6.7-1 .2-.4.2-.6.3-1 .1-.3.1-.5.1-.8 0-.2 0-.4-.1-.6-.2-.4-.3-.6-.6-.9-.3-.2-.5-.3-.8-.4-.1 0-.2 0-.3-.1-.2 0-.3 0-.5.1s-.3.1-.5.2c-.4.2-.5.4-.7.8-.1.2-.2.4-.2.6v.5c0 .2.1.2.1.4.1.1.1.2.2.3 0 .1-.1.1-.1.2-.6-.1-.4-.1-.7-.2-.2-.1-.4-.1-.6-.3-.2-.1-.3-.3-.4-.5-.2-.2-.2-.4-.3-.7-.1-.3-.1-.4-.1-.7v-.6c0-.3.1-.4.2-.7.2-.4.3-.6.5-.9l.5-.5c.2-.1.3-.2.5-.3.2-.1.3-.2.6-.3.4-.1.7-.2 1.1-.2.3 0 .5 0 .8.1.4.1.6.1.9.3.3.1.5.2.7.3 0-.5-.2-.9-.2-1.5s0-.9.1-1.5c.1-.8.3-1.3.6-2.1.2-.4.3-.8.6-1.1.5.1.6.4.9.8zM109 48.7c-.4.7-3.5 4.2-4.5 5.3-1.6-1.8-3.1-3.5-4.6-5.3 1-1.8 2.9-3.2 5-3 1.7.3 3.1 1.6 4.1 3zm19.1-1c.2.2.4.5.6.7.2.3.4.8.7 1.1 0 .2.2.5.3.8-.6-.1-1.3 0-1.8.3-.1.4.4.4.5.5.4.2.7.6.8 1 0 .5-.5 1-.9 1.2-1.8.9-4.2 1-6.3.6-.3-.2-.7-.2-1-.4-.5-.2-.9-.5-1.3-.9 0-.2-.2-.4-.1-.7.2-.8 1-1.1 1.7-1.3.1-.1.1-.2.1-.2-.5-.5-1.2-.6-1.8-.4.1-.4.3-.8.5-1.2 1-1.8 2.8-3.3 5-3 1.1.1 2.1.9 3 1.9zm-17.8 4.2c.6 2.8.6 5.6-.2 8.4-.2-.1-2.6-2.8-3.6-4v-.2c1.2-1.4 1.2-1.4 3.8-4.2zm-7.8 4.4c-1.2 1.4-2.4 2.8-3.7 4.1-.7-2.4-.8-4.9-.5-7.4.1-.3.1-.6.2-1 1.5 1.4 2.7 2.8 4 4.3zm28.2-.7v.3h.1l-.1.1c.1 1-.1 2-.2 2.9-.2.8-.3 1.7-.6 2.4l-.2.3c-.1-.1.1-.3 0-.4l-.1.1c-.1-.7-.6-1.3-1.3-1.6-.8-.3-1.7-.1-2.3.5-.2.3-.5.5-.7.8v-5c.6-.1 1.1-.1 1.6-.2.3.4.4 1.2 1.1 1 .1-.1.3-.1.4-.3.1-.2.2-.6.1-.8-.1-.5.5-.4.8-.6.5-.2.9-.5 1.3-.8.2.4.1.8.1 1.3zm-11.6-.8c.4.2.8.3 1.2.5.1.5-.3 1.3.3 1.5.7-.1.8-.8 1.1-1.2l1.8.3v4.5c-.2-.2-.4-.4-.7-.6-.6-.4-1.6-.4-2.3 0-.4.3-.8.7-.9 1.2 0 .3-.2.5-.1.8h-.1c-.3-.5-.4-1-.6-1.6-.1-.4-.1-.8-.3-1.1-.2-1.6-.3-3.2-.1-4.7.3.1.5.3.7.4zm-14.6 3.7c1.3 1.6 2.8 3.1 4.1 4.6-.3.6-.7 1-1.2 1.5-1.4 1.1-2.7 1.4-4.3.9-1.1-.3-1.6-.5-2.5-1.6-.2-.3-.4-.5-.2-.9 1.2-1.4 4-4.5 4.1-4.5zm17.6 3c.1.1.3.2.4.4.2.3.5.6.6 1 .2.5.4 1.1.4 1.6.1.5 0 1 0 1.5-.3 0-.6-.2-1-.3-.5-.3-1-.7-1.2-1.2-.2-.1-.2-.3-.2-.5-.3-.4-.4-1.2-.2-1.7 0-.1 0-.2.1-.3 0-.2.2-.3.3-.5.2.1.3-.2.5-.1.1 0 .2.2.3.1zm5.8.3c.4.6.2 1.6 0 2.2-.5 1-1.5 1.7-2.6 1.9-.1-.6-.1-1.2 0-1.7 0-1 .4-2 1.2-2.6.5-.3 1.2-.3 1.4.2z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'url(#SVGID_40_)',
      }}
    />
    <linearGradient
      id="SVGID_41_"
      gradientUnits="userSpaceOnUse"
      x1={135.247}
      y1={82.658}
      x2={178.294}
      y2={52.693}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M126.4 32.8c.1 0 .2.1.2.1v.7c0 .5.1.8.3 1.3.1.3.3.7.3.7s.6 1 1 1.5c.4.4.6.7 1 1.1.7.6 1.1.8 1.8 1.5.4.4.7.6 1.1 1.1.5.7.8 1.2 1 2.1 0 .3.1.4.1.7 0 .4-.1.6-.2.9.1.1.9.2 1.2.1 0 0 .3-.1.5-.3.1-.1.2-.2.4-.3.2-.2.3-.4.4-.6.1-.2.1-.3.1-.6v-.6c0-.2-.1-.3-.1-.4.6.2 1 .4 1.7.6.9.2 1.5.2 2.3.2-.6.8-1.2 1.3-1.9 2.3-.3.5-.5.7-.8 1.2-.4.7-.6 1.1-.8 1.9-.2.5-.3.7-.4 1.2-.2.8-.3 1.3-.4 2.2-.1.6-.1.9-.1 1.4v1.4c0 .6.1.9.2 1.5.2.9.3 1.4.6 2.3.1.4.2.6.4 1 .2.6.4.9.7 1.4.2.4.4.6.6 1 .5.8.9 1.2 1.5 1.8l.9.9c.4.4.7.6 1.1.9.5.4.8.5 1.4.8.3.2.5.3.9.5.5.2.9.4 1.4.5.8.3 1.3.4 2.1.6.9.2 1.5.2 2.4.2h1.8c.8 0 1.2-.1 2-.2.6-.1.9-.2 1.4-.3 1.2-.3 1.9-.5 3.1-.9 1.9-.6 2.5-.9 4.4-1.5 1.3-.4 2.1-.6 3.4-.8.6-.1 1-.2 1.6-.2 1.1-.1 1.7-.1 2.7 0 1.1.1 1.8.2 2.8.5 1.2.4 2.5 1.1 2.8 1.3 0-.4 0-.8-.1-1.2-.1-.3-.1-.4-.3-.7-.1-.2-.2-.4-.4-.6-.2-.2-.3-.4-.5-.6-.2-.2-.4-.3-.7-.5-.3-.2-.5-.3-.8-.4-.6-.3-1.1-.4-1.7-.6.5-.4 1-.6 1.6-1 1.5-.8 2.3-1.1 3.8-1.7.9-.4 1.4-.5 2.4-.8.9-.3 1.4-.5 2.3-.7.8-.2 1.2-.3 2-.4.6-.1.9-.1 1.5-.1.7 0 1.2-.1 1.9 0 .8.1 1.2.2 1.9.4.5.2.8.3 1.3.5.6.3.9.5 1.4.9.2.2.4.3.6.5.3.3.4.5.6.8l.3.6c.1.2.2.4.3.7.1.5.2.8.2 1.3 0 .3 0 .5-.1.8-.1.4-.2.6-.4 1s-.4.6-.7.9c-.3.3-.5.4-.9.6-.3.1-.4.2-.7.3-.5.2-.8.2-1.4.3-.5 0-.8 0-1.3-.2-.3-.1-.5-.2-.8-.3-.2-.1-.3-.2-.4-.3.2-.2.4-.3.6-.5.2-.2.2-.3.3-.5.1-.2.2-.4.2-.6v-.5c0-.2-.1-.3-.1-.6-.1-.2-.2-.4-.3-.5-.2-.3-.4-.5-.7-.6-.2-.1-.4-.1-.7-.2h-.7c-.2 0-.4.1-.6.1l-.4.2c-.2.1-.4.2-.6.5-.1.2-.2.3-.3.5-.1.2-.1.3-.1.5-.1.5-.1.7 0 1.2.1.3.1.5.2.8.1.2.2.3.3.6.2.3.3.4.5.7.2.3.4.4.6.6.3.2.4.3.7.5.6.4 1 .5 1.7.7.3.1.5.1.9.2s.6.1 1 .1.6 0 1-.1c.4 0 .7-.1 1.1-.2.4-.1.6-.2.9-.4.3-.1.5-.2.8-.4.3-.2.5-.3.8-.6.3-.3.5-.4.7-.7.2-.3.3-.5.5-.8.2-.4.3-.6.4-1 .1-.3.1-.5.2-.8.1-.5.1-.7.1-1.2 0-.4 0-.6-.1-.9-.1-.6-.2-1-.4-1.6-.1-.3-.2-.4-.3-.7-.3-.5-.4-.8-.8-1.2-.3-.4-.4-.5-.8-.8-.3-.3-.5-.4-.8-.6-.3-.2-.5-.4-.8-.6-.6-.3-.9-.5-1.5-.7-.4-.2-.7-.2-1.2-.3-.5-.1-.8-.1-1.2-.2-.9-.1-1.4-.2-2.3-.2-.8 0-1.2 0-2 .1-.7.1-1.1.1-1.7.2-.7.1-1 .2-1.7.4-1 .3-1.5.5-2.5.8-1.6.6-2.4.9-4 1.6-1.1.5-1.7.8-2.8 1.4-.7.4-1.1.6-1.7 1 .1-.3.1-.5.1-.8 0-.2 0-.3-.1-.5-.1-.3-.1-.5-.3-.7-.1-.2-.2-.2-.4-.4-.2-.1-.3-.2-.5-.2-.3-.1-.9-.2-.9-.2s.1.1.1.2c.1.4 0 .6 0 1 0 .3-.1.5-.2.7-.1.2-.1.3-.3.5-.1.2-.3.3-.4.5-.3.3-.5.4-.8.7-.4.3-.6.4-1 .7-1 .6-1.5.8-2.6 1.2-1.5.6-2.5 1-3.9 1.4.3-.6.7-1 1-1.6.2-.4.2-.6.4-1 .1-.5.2-.8.2-1.3.1-.7 0-1.1-.1-1.8-.1-.6-.2-1-.5-1.6-.1-.3-.2-.5-.4-.8-.2-.3-.3-.5-.6-.8-.2-.3-.4-.4-.6-.7-.6-.5-1-.8-1.6-1.1-.3-.1-.4-.2-.7-.3-.8-.3-1.3-.4-2.2-.5h-1.1c-.4 0-.6.1-1 .2s-.6.2-.9.3c-.4.2-.7.3-1 .6-.2.1-.3.2-.5.4s-.3.3-.4.6c-.2.4-.3.6-.3 1.1v.6c0 .4.1.7.3 1 .2.4.3.6.6.9.2.2.3.2.5.4.2.1.3.1.5.2.3.1.5.1.8.2h.6c.3 0 .4-.1.7-.2.2-.1.3-.2.5-.3.2-.2.3-.3.4-.5.1-.2.2-.3.2-.5.1-.2.1-.3.1-.5s0-.3-.1-.5c0-.2-.1-.3-.2-.5s-.2-.3-.3-.4c-.2-.2-.5-.4-.8-.5-.1-.1.1-.1.1-.1.2-.1.3-.1.5-.1h1c.6.1 1 .3 1.6.6.3.2.5.3.8.6l.8.8c.2.2.3.4.4.6.2.3.2.5.3.9.1.3.1.5.1.8 0 .5 0 .8-.1 1.3-.1.4-.1.6-.2.9-.3.9-.6 1.5-1.4 2.1-.2.2-.4.3-.6.5-.3.2-.5.3-.8.5-.4.2-.7.3-1.2.4-.3.1-.4.1-.7.1h-1.2c-.5 0-.8-.1-1.3-.2s-.7-.3-1.1-.5c-.5-.3-.7-.4-1.1-.8-.3-.4-.5-.6-.7-1.1-.1-.2-.1-.3-.2-.6-.1-.5 0-.9.1-1.3-.2.1-.4.1-.6.2-.2.1-.3.1-.4.2-.3.2-.4.3-.6.5-.2.3-.3.4-.5.7-.2.4-.2.6-.3 1-.4-.2-.8-.4-1.2-.7-.3-.2-.4-.4-.7-.7-.2-.3-.3-.4-.5-.7-.7-1-.9-1.7-1.1-3 0-.3-.1-.4-.1-.7v-1.3c0-.4.1-.6.2-1 .1-.6.2-.9.5-1.4.2-.4.3-.6.6-1 .2-.2.3-.4.5-.6.2-.2.3-.3.6-.4.2-.2.4-.2.6-.3.3-.1.4-.1.7-.2h.6c.4 0 .6 0 .9.1.5.2.8.4 1.2.6l.1-.1c.2-.4.2-.7.2-1.1v-.9c-.1-.5-.1-.8-.3-1.2-.1-.2-.2-.3-.3-.5-.2-.3-.3-.5-.6-.7-.2-.2-.3-.3-.5-.4-.4-.2-.7-.4-1.1-.5 0-.1.1-.2.1-.3.2-.4.4-.5.7-.8.6-.6 1-.8 1.7-1.2.5-.3.8-.4 1.4-.7.4-.2.6-.2 1.1-.4.6-.2 1-.3 1.6-.4.8-.1 1.2-.1 1.9-.1.4 0 .7.1 1.1.1.7.1 1 .2 1.6.5.6.3.9.4 1.4.8.3.2.4.3.7.5.4.3.5.5.8.9.3.4.5.7.7 1.2.2.5.3.8.4 1.4.1.5.1.8 0 1.3 0 .3-.1.4-.1.7-.1.4-.2.6-.3 1 0 0 .6.1.9.1.3 0 .5-.1.7-.2.3-.1.5-.2.8-.4.3-.2.5-.4.8-.6.4-.4.6-.7.9-1.2.2-.3.2-.4.3-.7.2-.4.3-.8.4-1.1.3.3.5.5.7.9.2.3.3.5.4.8.3.5.4.9.5 1.5.2.7.2 1.1.3 1.9v1.1c0 .9-.1 1.6-.2 2.3l.1.1c.3.1.6 0 .9-.2.3-.2.4-.3.7-.5.3-.2.4-.4.7-.6.3-.3.4-.5.6-.8.2-.3.2-.4.4-.7.3-.7.4-1.2.6-1.9.4.3.6.6 1 1 .3.3.5.5.9.8.6.5 1 .8 1.6 1 .2-.3.3-.5.4-.9.2-.6.2-.9.3-1.5 0-.4.1-.7 0-1l.1-.1c.2.1.3.2.3.2.4.3.8.6 1.3.9l.6.3c.3.1.5.2.8.3 1 .3 1.8.3 2.8.3h20c-.4.9-.6 1.3-.8 2.2-.1.6-.2.9-.3 1.5-.1.5-.1.8-.1 1.3 0 .8-.1 1.2 0 2 .1.6.1 1 .3 1.6.2.9.3 1.5.7 2.3.1.4.2.6.4 1l.5 1c.2.3.3.5.5.8.2.3.4.4.6.7.3.3.4.4.7.6.3.2.5.3.8.5.5.3.8.4 1.3.5.3.1.5.1.9.1h1.1c.4 0 .6-.1.9-.2l.6-.3c.3-.2.5-.3.8-.5l.5-.5c.1-.2.2-.3.3-.5.1-.2.2-.4.2-.7.1-.3.1-.5.1-.8 0-.5 0-.7-.2-1.2-.1-.3-.1-.5-.3-.7-.2-.3-.3-.5-.5-.8-.2-.2-.3-.3-.5-.4-.2-.2-.3-.2-.6-.3-.3-.1-.5-.2-.8-.2-.4 0-.7-.1-1.1.1-.2.1-.4.2-.5.4v.1l.9.3c.3.2.5.3.7.5.2.2.3.4.4.7.1.2.1.3.2.5v.4c0 .2 0 .4-.1.6-.1.2-.1.3-.2.5l-.3.3c-.2.1-.2.2-.4.3-.3.2-.5.2-.9.2-.2 0-.4 0-.6-.1-.3-.1-.4-.1-.7-.2-.3-.1-.5-.2-.8-.4-.5-.4-.7-.7-1-1.3-.2-.3-.3-.5-.4-.8-.3-.5-.4-.8-.6-1.4-.1-.4-.2-.7-.3-1.1-.1-.5-.2-1.2-.2-1.2s-.1-1.2-.1-2c0-1 0-1.6.3-2.6.1-.5.2-.8.4-1.3s.3-.8.5-1.2c.4-.7.6-1.1 1.2-1.7.4-.5.8-.8 1.3-1.1 0-.1 0 0-.1-.1h-12.2c-.3-.3-.4-.5-.6-.9-.1-.3-.2-.4-.3-.8-.2-.6-.2-.9-.2-1.5s0-1 .1-1.6c.1-.3.1-.5.2-.9s.3-.7.5-1c.2-.3.3-.4.5-.6.2-.2.4-.3.7-.4.2-.1.3-.1.6-.2h.6c.2 0 .3.1.4.2.1.1.2.1.3.3.2.2.3.3.4.6.1.3 0 .5-.1.8-.1.2-.1.3-.3.5-.2.2-.3.2-.6.3-.3 0-.5-.1-.8-.3 0-.1-.3-.2-.4-.1 0 .3.1.6.3.9.2.3.3.4.5.6.2.1.3.2.5.2.3.1.4.1.7.1.4 0 .7-.1 1.1-.2.3-.2.5-.3.8-.6.2-.2.3-.3.4-.6.1-.3.1-.6.2-.8v-1.1c-.1-.5-.2-.7-.4-1.1-.2-.2-.3-.3-.4-.5l-.5-.5c-.3-.2-.5-.3-.9-.4-.4-.1-.6-.2-1-.2-.5 0-.8 0-1.3.2-.3.1-.5.2-.8.3-.5.2-.8.5-1.2.8.1-.9.2-1.6.2-2.6 0-.9 0-1.4-.2-2.3-.1-.5-.2-.8-.4-1.3-.2-.4-.2-.6-.5-.9-.2-.2-.4-.4-.5-.4-.3.3-.4.6-.6 1-.3.6-.4.9-.5 1.5-.1.5-.2.8-.2 1.3v1.2c0 1 .2 1.7.3 2.5-.2-.1-.3-.2-.5-.3-.3-.2-.5-.3-.9-.5-.2-.1-.4-.1-.6-.2-.5-.1-.8-.1-1.2-.1-.2 0-.3 0-.5.1-.5.1-.7.2-1.1.5-.2.1-.3.2-.5.4-.4.4-.6.6-.7 1.1-.1.3-.2.4-.2.7-.1.5 0 .9.2 1.4.2.5.3.8.7 1.1.2.1.2.2.4.3.2.1.3.1.5.2.3.1.5.2.9.2.3 0 .4 0 .7-.1.3-.1.4-.1.6-.3l.3-.3c.1-.2.2-.3.2-.5.1-.3 0-.5 0-.8 0 0-.1-.1-.1 0 0 0-.1.2-.2.3-.1.1-.2.1-.3.1-.3.1-.5.1-.8-.1-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.3-.4-.1-.2-.1-.4-.1-.7 0-.3.1-.5.3-.7.2-.3.5-.3.8-.3h.6c.4.1.6.2 1 .4.2.1.3.2.5.4s.2.3.4.5.2.4.3.6c.2.6.3.9.4 1.5v1.1c0 .4 0 .6-.1 1s-.1.6-.2.9c-.2.5-.3.8-.6 1.1h-8.7s.4-.2.6-.4l.5-.5c.2-.2.2-.3.4-.5.2-.4.2-.5.3-1v-.2s-.2.1-.3.1c-.1 0-.2.1-.3.1-.4.1-.5.2-.9.3-.7.2-1.1.1-1.8 0-.3 0-.5-.1-.7-.1-.5-.1-.8-.3-1.3-.5-.6-.3-.9-.6-1.5-.9-1.9-1.3-2.6-2.5-4.5-3.8-1-.8-1.6-1.2-2.7-1.8-.6-.3-.9-.5-1.5-.7-1.1-.5-1.9-.8-2.9-1.1.1-.2.3-.2.5-.4s.2-.2.3-.4l.3-.6c.1-.2.1-.4.1-.6v-.5c0-.2 0-.4-.1-.6-.1-.3-.2-.5-.4-.8-.1-.1-.2-.1-.2-.2h-.2s-.2.4-.4.7c-.2.3-.3.4-.6.7-.4.4-.7.5-1.3.7-.3.1-.5.1-.8.2-.9.2-1.5.1-2.5.1H154c-.8 0-1.3.1-2.1.2-1.1.2-1.9.3-2.9.6.2-.5.3-.9.4-1.5 0-.5.1-.8 0-1.3 0-.3-.1-.4-.2-.7-.2-.6-.3-.9-.6-1.4-.2-.4-.4-.6-.8-.9-.5-.4-.8-.6-1.4-.8-.4-.1-.6-.2-1-.2-.8-.1-1.3-.1-2 .3-.4.2-.7.4-1 .7-.3.3-.4.5-.6.9-.1.2-.1.4-.2.6v.7c.1.4.2.7.5 1 .1.1.2.2.4.3.1.1.2.2.4.2.2.1.3.1.6.1h.6c.2 0 .3-.1.5-.2l.4-.2.5-.5c.1-.2.2-.3.2-.4.1-.3.1-.5.1-.9 0-.3-.1-.5-.2-.8h.2s.4.3.7.5l.3.3c.2.3.2.4.3.7.1.4.2.6.2 1v.6c0 .2-.1.4-.1.6-.1.3-.2.4-.3.7-.2.3-.3.5-.6.8l-.5.5c-.3.2-.4.4-.7.6l-1 .5c-.4.1-.6.2-1 .3-.6.2-1 .2-1.6.3-1 .1-1.6.1-2.5-.2-.7-.2-1.2-.4-1.7-.7v-.1s.3-.2.5-.3l.4-.4c.2-.3.3-.5.3-.8.1-.3.1-.5 0-.8-.1-.4-.2-.6-.4-.9l-.3-.3-.3.6c-.2.2-.2.3-.4.5s-.3.3-.6.4l-.6.3c-.3.1-.5.1-.8.2-.3 0-.5.1-.9.1s-.6 0-1-.1-.6-.1-.9-.3c-.3-.1-.4-.2-.6-.3-.3-.2-.6-.3-.8-.6-.3-.3-.5-.5-.7-.9-.1-.2-.2-.4-.3-.7-.1-.3-.2-.4-.2-.7 0-.2 0-.4.1-.5.1 0 .6.4 1.2.4.9 0 2.2-.5 2.2-2 0-1.6-1.6-2.2-2.7-2.2s-1.9.5-1.9.5c-.2.2-.4.3-.7.7-.1-.1-.3-.1-.3-.2-.2.2-1.6 3.1-1.2 2.5z"
      style={{
        fill: 'url(#SVGID_41_)',
      }}
    />
    <linearGradient
      id="SVGID_42_"
      gradientUnits="userSpaceOnUse"
      x1={93.873}
      y1={82.847}
      x2={50.592}
      y2={53.12}
      gradientTransform="matrix(1.2 0 0 1.2 -22.79 -30.844)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00a88e',
        }}
      />
      <stop
        offset={0.817}
        style={{
          stopColor: '#005243',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#003c2f',
        }}
      />
    </linearGradient>
    <path
      d="M102.5 32.9c-.1 0-.2.1-.2.1v.7c0 .5-.1.8-.3 1.3-.1.3-.3.7-.3.7s-.6 1-1 1.5c-.4.4-.6.7-1 1.1-.6.6-1.1.9-1.8 1.5-.4.4-.7.6-1.1 1.1-.5.7-.8 1.2-1 2.1 0 .3-.1.4-.1.7 0 .4.1.6.2.9-.1.1-.9.2-1.2.1 0 0-.3-.1-.5-.3-.2-.1-.2-.2-.3-.3-.2-.2-.3-.4-.4-.6-.1-.2-.1-.3-.2-.6v-.6c0-.2.1-.3.1-.4-.6.2-1 .4-1.7.6-.9.2-1.5.2-2.3.2.6.7 1.2 1.3 1.9 2.3.3.5.5.7.8 1.2.4.7.6 1.1.8 1.9.2.5.3.7.4 1.2.2.8.3 1.3.4 2.2.1.6.1.9.1 1.4v1.4c0 .6-.1.9-.2 1.5-.2.9-.3 1.4-.6 2.3-.1.4-.2.6-.4 1-.2.6-.4.9-.7 1.4-.2.4-.4.6-.6 1-.5.8-.8 1.2-1.5 1.8-.3.4-.6.6-.9.9-.4.4-.7.6-1.1.9-.5.4-.8.5-1.4.8-.4.2-.6.3-.9.5-.5.2-.9.4-1.4.5-.8.3-1.3.4-2.1.6-.9.2-1.5.2-2.4.2h-1.8c-.8 0-1.2-.1-2-.2-.6-.1-.9-.2-1.4-.3-1.2-.3-1.9-.5-3.1-.9-1.9-.6-2.5-.9-4.4-1.5-1.3-.4-2-.6-3.4-.8-.6-.1-1-.2-1.6-.2-1.1-.1-1.7-.1-2.7 0-1.1.1-1.8.2-2.8.5-1.2.4-2.5 1.1-2.8 1.3 0-.4 0-.8.1-1.2.1-.3.1-.4.3-.7.1-.2.2-.4.4-.6.2-.2.3-.4.5-.6.2-.2.4-.3.7-.5.3-.2.5-.3.8-.4.6-.3 1.1-.4 1.7-.6-.5-.4-1-.6-1.7-1-1.5-.8-2.3-1.1-3.8-1.7-.9-.4-1.4-.5-2.4-.8-.9-.3-1.4-.5-2.3-.7-.8-.2-1.2-.3-2-.4-.6-.1-.9-.1-1.5-.1-.7 0-1.2-.1-1.9 0-.8.1-1.2.2-1.9.4-.5.2-.8.3-1.3.5-.6.3-.9.5-1.4.9-.2.2-.4.3-.6.5-.3.3-.4.5-.6.8-.2.2-.2.4-.3.6-.1.2-.2.4-.3.7-.1.4-.1.7-.1 1.2 0 .3 0 .5.1.8.1.4.2.6.4 1s.4.6.7.9c.3.3.5.4.9.6.3.1.4.2.7.3.5.2.8.3 1.4.3.5 0 .8-.1 1.3-.2.3-.1.5-.2.8-.3.2-.1.3-.2.4-.3-.2-.2-.4-.3-.6-.5-.2-.2-.2-.3-.4-.5-.1-.2-.2-.4-.2-.6v-.5c0-.2.1-.3.1-.5.1-.2.2-.4.3-.5.2-.3.4-.5.7-.6.2-.1.4-.1.7-.2h.7c.2 0 .4.1.6.1.2.1.3.1.4.2.2.1.4.2.6.5.1.2.2.3.3.5.1.2.1.3.1.5.1.5.1.7 0 1.2 0 .3-.1.5-.2.8-.1.2-.2.3-.3.6-.2.3-.3.4-.5.7-.2.3-.4.4-.6.6-.3.2-.4.3-.7.5-.6.4-1 .5-1.7.7-.3.1-.5.1-.9.2s-.6.1-1 .1-.6 0-1-.1c-.4 0-.7-.1-1.1-.2-.4-.1-.6-.2-.9-.4-.3-.1-.5-.2-.8-.4-.3-.2-.5-.3-.8-.6-.3-.3-.5-.4-.7-.7-.2-.3-.3-.5-.5-.8-.2-.4-.3-.6-.4-1-.1-.3-.1-.5-.2-.8-.1-.5-.1-.7-.1-1.2 0-.4 0-.6.1-.9.1-.6.2-1 .4-1.6.1-.3.2-.4.3-.7.3-.5.4-.8.8-1.2.3-.4.4-.5.8-.8.3-.3.5-.4.8-.6.3-.2.5-.4.8-.6.6-.3.9-.5 1.5-.7.4-.2.7-.2 1.2-.3.5-.1.8-.1 1.2-.2.9-.1 1.4-.2 2.3-.2.8 0 1.2 0 2 .1.7.1 1.1.1 1.7.2.7.1 1 .2 1.7.4 1 .3 1.5.5 2.5.8 1.6.6 2.4.9 4 1.6 1.1.5 1.7.8 2.8 1.4.7.4 1.1.6 1.7 1-.1-.3-.1-.5-.1-.8 0-.2 0-.3.1-.5.1-.3.1-.5.4-.8.1-.2.2-.2.4-.4.2-.1.3-.2.5-.2.3-.1.9-.2.9-.2s0 .1-.1.2c-.1.4 0 .6 0 1 0 .3.1.5.2.7.1.2.1.3.3.5.1.2.3.3.4.5.3.3.5.4.8.7.4.3.6.4 1 .7.9.6 1.5.8 2.6 1.2 1.5.6 2.5 1 3.9 1.4-.3-.6-.7-1-1-1.6-.2-.4-.3-.6-.4-1-.1-.5-.2-.8-.2-1.3-.1-.7 0-1.1.1-1.8.1-.6.2-1 .5-1.6.1-.3.2-.5.4-.8.2-.3.3-.5.5-.8.2-.3.4-.4.6-.7.6-.5 1-.8 1.7-1.1.3-.1.4-.2.7-.3.8-.3 1.3-.4 2.2-.5h1.1c.4 0 .6.1 1 .2s.6.1.9.3c.4.2.7.3 1 .6.2.1.3.2.5.4s.3.3.4.6c.2.4.3.6.4 1.1v.6c0 .4-.1.6-.3 1-.2.4-.3.6-.6.9-.2.2-.3.2-.5.4-.2.1-.3.1-.5.2-.3.1-.5.1-.8.2h-.6c-.3 0-.4-.1-.7-.2-.2-.1-.3-.2-.5-.3-.2-.2-.3-.3-.4-.5-.1-.2-.2-.3-.2-.5-.1-.2-.1-.3-.1-.5s0-.3.1-.6c0-.2.1-.3.2-.5s.2-.3.3-.4c.3-.2.5-.4.8-.5.1-.1-.1-.1-.1-.1-.2-.1-.3-.1-.5-.1h-1c-.6.1-1 .3-1.6.6-.3.2-.5.3-.8.6l-.8.8c-.2.2-.3.4-.4.6-.2.3-.2.5-.3.9-.1.3-.1.5-.1.8 0 .5 0 .8.1 1.3.1.4.1.6.2.9.3.9.6 1.5 1.4 2.1.2.2.4.3.6.5.3.2.5.3.8.5.5.2.7.3 1.2.4.3.1.4.1.7.1h1.2c.5 0 .8-.1 1.3-.2s.7-.3 1.1-.5c.5-.3.7-.4 1.1-.8.3-.4.5-.6.7-1.1.1-.2.2-.3.2-.5.1-.5 0-.9-.1-1.3.2.1.4.1.6.2.2.1.3.1.4.2.2.2.4.3.6.5.2.2.3.4.5.7.2.4.2.6.3 1 .4-.2.8-.4 1.2-.7.3-.2.4-.4.7-.7.2-.3.3-.4.5-.7.7-1 .9-1.7 1.1-3 0-.3.1-.4.1-.7v-1.3c0-.4-.1-.6-.2-1-.1-.5-.2-.9-.5-1.4-.2-.4-.3-.6-.6-1-.2-.2-.3-.4-.6-.6-.2-.2-.3-.3-.6-.4l-.6-.3c-.3-.1-.4-.1-.7-.2h-.6c-.4 0-.6 0-.9.1-.5.2-.8.4-1.2.6l-.1-.1c-.2-.4-.2-.7-.2-1.1v-.9c.1-.5.1-.8.3-1.2.1-.2.2-.3.3-.5.2-.3.3-.5.6-.7.2-.2.3-.3.5-.4.4-.2.7-.4 1.1-.5 0-.1-.1-.2-.1-.3-.2-.4-.4-.5-.7-.8-.6-.6-1-.8-1.7-1.2-.5-.3-.8-.4-1.4-.7-.4-.2-.7-.2-1.1-.4-.6-.2-1-.3-1.6-.4-.8-.1-1.2-.1-1.9-.1-.4 0-.7.1-1.1.1-.7.1-1 .2-1.7.5-.6.3-.9.4-1.4.8-.3.2-.4.3-.7.5-.3.3-.5.5-.8.9-.3.4-.5.7-.7 1.2-.2.5-.3.8-.4 1.4-.1.5-.1.8 0 1.3 0 .3.1.4.1.7.1.4.2.6.3 1 0 0-.6.1-.9.1-.3 0-.5-.1-.7-.2-.3-.1-.5-.2-.8-.4-.3-.2-.5-.4-.8-.6-.4-.4-.6-.7-.9-1.2-.2-.3-.2-.4-.4-.7-.2-.4-.3-.8-.4-1.1-.3.3-.5.5-.7.9-.2.3-.3.5-.4.8-.3.6-.4.9-.5 1.5-.2.7-.2 1.1-.3 1.9v1.1c0 .9.1 1.6.2 2.3l-.1.1c-.3.1-.6 0-.9-.1-.3-.2-.4-.3-.7-.5-.3-.2-.4-.4-.7-.6-.3-.3-.4-.5-.6-.8-.2-.3-.2-.4-.4-.7-.3-.7-.4-1.2-.6-1.9l-1 1c-.3.3-.5.5-.9.8-.6.5-1 .8-1.6 1-.2-.3-.3-.5-.4-.9-.2-.6-.2-.9-.3-1.5 0-.4-.1-.7 0-1l-.1-.1c-.2.1-.3.2-.3.2-.4.3-.8.6-1.3.9-.2.1-.3.2-.6.3-.3.1-.5.2-.8.3-1 .3-1.8.3-2.8.3h-20c.4.9.6 1.3.8 2.2.1.6.2.9.3 1.5.1.5.1.8.1 1.3 0 .8.1 1.2 0 2-.1.6-.1 1-.3 1.6-.2.9-.3 1.5-.7 2.3-.1.4-.2.6-.4 1l-.5 1c-.2.3-.3.5-.5.8-.2.3-.4.4-.6.7-.3.3-.4.4-.7.6-.3.2-.5.4-.8.5-.5.3-.8.4-1.3.5-.3.1-.5.1-.9.1h-1.1c-.4 0-.6-.1-.9-.2-.2-.1-.4-.1-.6-.3-.3-.2-.5-.3-.8-.5l-.5-.5c-.1-.2-.2-.3-.3-.5-.1-.2-.1-.4-.2-.7-.1-.3-.1-.5-.1-.8 0-.5 0-.7.2-1.2.1-.3.1-.5.3-.7.2-.3.3-.5.6-.8.2-.2.3-.3.5-.4.2-.2.3-.2.6-.3.3-.1.5-.2.8-.2.4 0 .7-.1 1.1.1.2.1.4.2.5.4v.1l-.9.3c-.3.2-.5.2-.7.5-.2.2-.3.4-.4.7-.1.2-.1.3-.2.5v.4c0 .2 0 .4.1.6.1.2.1.3.2.5l.3.3c.1.1.2.2.4.3.3.2.5.2.9.2.2 0 .4 0 .6-.1.3-.1.4-.1.7-.2.3-.1.5-.2.8-.4.5-.4.7-.7 1-1.3.2-.3.3-.5.4-.8.3-.5.4-.8.6-1.4.1-.4.2-.7.3-1.1.1-.5.2-1.2.2-1.2s.1-1.2.1-2c0-1 0-1.6-.3-2.6-.1-.5-.2-.8-.4-1.3s-.3-.8-.5-1.2c-.4-.7-.6-1.1-1.2-1.7-.4-.5-.8-.8-1.3-1.1 0-.1 0 0 .1-.1H37c.3-.3.4-.5.6-.9.2-.3.2-.4.3-.8.2-.6.2-.9.2-1.5s0-1-.1-1.6c-.1-.3-.1-.5-.2-.9s-.3-.7-.5-1c-.2-.3-.3-.4-.5-.6-.3-.2-.4-.3-.7-.4-.2-.1-.4-.1-.6-.2h-.6c-.2 0-.3.1-.4.2-.1.1-.2.1-.3.3-.2.2-.3.3-.4.6-.1.3 0 .5.1.8.1.2.1.3.3.5.2.2.3.2.6.3.3 0 .5-.1.8-.3 0-.1.3-.2.4-.1 0 .3-.1.6-.3.9-.2.3-.3.4-.5.6-.2.1-.3.2-.5.2-.3.1-.4.1-.7.1-.4 0-.7-.1-1.1-.2-.3-.2-.5-.3-.8-.6-.2-.2-.3-.3-.4-.6-.1-.3-.1-.6-.2-.8v-1.1c.1-.5.2-.7.4-1.1.1-.2.3-.3.4-.5l.5-.5c.3-.2.5-.3.9-.4.4-.1.6-.2 1-.2.5 0 .8 0 1.3.2.3.1.5.2.8.3.5.2.8.5 1.2.8-.1-.9-.2-1.6-.2-2.6 0-.9 0-1.4.2-2.3.1-.5.2-.8.4-1.3.2-.4.2-.6.5-.9.2-.2.4-.4.5-.4.3.3.4.6.6 1 .3.6.4.9.5 1.5.1.5.2.8.2 1.3v1.2c0 1-.2 1.7-.3 2.5.2-.1.3-.2.5-.3.3-.2.5-.3.9-.5.2-.1.4-.1.6-.2.5-.1.8-.1 1.2-.1.2 0 .3 0 .5.1.5.1.7.2 1.1.5.2.1.3.2.5.4.4.4.6.6.8 1.1.1.3.1.4.2.7.1.5 0 .9-.2 1.4-.2.5-.3.8-.7 1.1-.1.1-.2.2-.4.3-.2.1-.3.1-.5.2-.3.1-.5.2-.9.2-.3 0-.4 0-.7-.1-.3-.1-.4-.1-.6-.3l-.3-.3c-.1-.2-.2-.3-.2-.5-.1-.3 0-.5 0-.8 0 0 .1-.1.1 0 0 0 .1.2.2.3.1.1.2.1.3.1.3.1.5.1.8-.1.1-.1.2-.1.3-.2.1-.1.2-.2.3-.4.1-.2.1-.4.1-.7 0-.3-.1-.5-.3-.7-.2-.3-.5-.3-.8-.3h-.6c-.4.1-.6.2-1 .4-.2.1-.3.2-.5.4s-.2.3-.4.5-.2.4-.3.6c-.2.6-.3.9-.4 1.5v1.1c0 .4 0 .6.1 1s.1.6.2.9c.2.5.3.8.6 1.1h8.7s-.4-.2-.6-.4l-.5-.5c-.2-.2-.3-.3-.4-.5-.2-.3-.2-.5-.3-1v-.2s.2.1.3.1c.1.1.2.1.3.1.3.1.5.2.9.3.7.2 1.1.1 1.8 0 .3 0 .5-.1.8-.1.5-.1.8-.3 1.3-.5.6-.3.9-.6 1.5-.9 1.9-1.3 2.6-2.5 4.5-3.8 1-.7 1.6-1.2 2.7-1.8.6-.3.9-.5 1.5-.7 1.1-.5 1.9-.7 2.9-1.1-.1-.2-.3-.2-.5-.4-.1-.1-.2-.2-.3-.4-.2-.2-.2-.4-.3-.6-.1-.2-.1-.4-.1-.6v-.5c0-.2.1-.4.1-.6.1-.3.2-.5.4-.8.1-.1.2-.1.2-.2h.1s.2.4.4.7c.2.3.3.4.6.7.4.4.7.5 1.3.7.3.1.5.1.8.2.9.2 1.5.1 2.5.1h3.4c.8 0 1.3.1 2.1.2 1.1.2 1.9.3 2.9.6-.2-.5-.3-.9-.4-1.5-.1-.5-.1-.8 0-1.3 0-.3.1-.4.2-.7.2-.6.3-.9.6-1.4.2-.4.4-.6.7-.9.5-.4.8-.6 1.4-.8.4-.1.6-.2 1-.2.8-.1 1.3-.1 2 .3.5.2.7.4 1 .7.3.3.4.5.6.9.1.2.1.4.2.6v.7c-.1.4-.2.7-.5 1-.1.2-.2.2-.4.4-.1.1-.2.2-.4.2-.2.1-.3.1-.6.1h-.6c-.2 0-.3-.1-.5-.2l-.4-.2-.5-.5c-.1-.2-.2-.3-.2-.4-.1-.3-.1-.5-.1-.9 0-.3.1-.5.2-.8H83s-.4.3-.7.5l-.3.3c-.2.3-.2.4-.3.7-.1.4-.2.6-.2 1v.5c0 .2.1.4.1.6.1.3.2.4.3.7.2.3.3.5.5.8l.5.5c.3.2.4.4.7.6l1 .5c.4.2.6.2 1 .3.6.2 1 .2 1.6.3 1 .1 1.6.1 2.5-.2.7-.2 1.2-.4 1.7-.7v-.1s-.3-.2-.5-.3c-.2-.1-.2-.2-.4-.4-.2-.3-.3-.5-.3-.8-.1-.3-.1-.5 0-.8.1-.4.2-.6.4-.9l.3-.3.3.6c.2.2.2.3.4.5s.3.3.6.4l.6.3c.3.1.5.1.8.2.3 0 .5.1.9.1s.6 0 1-.1.6-.1.9-.3c.3-.1.4-.2.6-.3.3-.2.5-.3.8-.6.3-.3.5-.5.7-.9.1-.2.2-.4.3-.7.1-.3.2-.4.2-.7 0-.2 0-.4-.1-.5-.1 0-.6.4-1.2.4-.9 0-2.2-.5-2.2-2 0-1.6 1.6-2.2 2.7-2.2s1.9.5 1.9.5c.2.2.4.3.7.7l.1-.1c.4.1 1.9 3 1.6 2.4z"
      style={{
        fill: 'url(#SVGID_42_)',
      }}
    />
    <path
      className="st9"
      d="M192.2 46.4h1.8v1.8h-1.8zM203.9 62.6h1.8v1.8h-1.8zM34.9 46.4h1.8v1.8h-1.8zM23.3 62.7h1.8v1.8h-1.8z"
    />
  </Svg>
);
